import * as N from "react";
import K, { useEffect as Ce, useLayoutEffect as Sa, useRef as oe, useState as $e, forwardRef as jo, Fragment as Ge, isValidElement as kr, cloneElement as _r, createElement as Ra, createContext as Be, useContext as De, useMemo as se, useReducer as xn, createRef as Dn, useCallback as gt, Children as cd } from "react";
import { Tooltip as vr, IconButton as Eo, Badge as dd, Popover as fd } from "@mui/material";
import * as eu from "react-dom";
import vo, { createPortal as pd } from "react-dom";
import gd from "@emotion/styled";
import { keyframes as Ea } from "@emotion/react";
const Go = typeof window > "u" || typeof document > "u";
let Oe = Go ? Ce : Sa;
function lt(e) {
  let t = oe(e);
  return Oe(() => {
    t.current = e;
  }, [e]), t;
}
function Yr(e, t) {
  let [r, n] = $e(e), o = lt(e);
  return Oe(() => n(o.current), [o, n, ...t]), r;
}
function Kr(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function ht() {
  let e = [], t = [], r = { enqueue(n) {
    t.push(n);
  }, addEventListener(n, o, i, a) {
    return n.addEventListener(o, i, a), r.add(() => n.removeEventListener(o, i, a));
  }, requestAnimationFrame(...n) {
    let o = requestAnimationFrame(...n);
    return r.add(() => cancelAnimationFrame(o));
  }, nextFrame(...n) {
    return r.requestAnimationFrame(() => r.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let o = setTimeout(...n);
    return r.add(() => clearTimeout(o));
  }, microTask(...n) {
    let o = { current: !0 };
    return Kr(() => {
      o.current && n[0]();
    }), r.add(() => {
      o.current = !1;
    });
  }, add(n) {
    return e.push(n), () => {
      let o = e.indexOf(n);
      if (o >= 0) {
        let [i] = e.splice(o, 1);
        i();
      }
    };
  }, dispose() {
    for (let n of e.splice(0))
      n();
  }, async workQueue() {
    for (let n of t.splice(0))
      await n();
  } };
  return r;
}
function bt() {
  let [e] = $e(ht);
  return Ce(() => () => e.dispose(), [e]), e;
}
let V = function(e) {
  let t = lt(e);
  return K.useCallback((...r) => t.current(...r), [t]);
}, Oi = { serverHandoffComplete: !1 };
function mr() {
  let [e, t] = $e(Oi.serverHandoffComplete);
  return Ce(() => {
    e !== !0 && t(!0);
  }, [e]), Ce(() => {
    Oi.serverHandoffComplete === !1 && (Oi.serverHandoffComplete = !0);
  }, []), e;
}
var kl;
let vd = 0;
function _l() {
  return ++vd;
}
let Pe = (kl = K.useId) != null ? kl : function() {
  let e = mr(), [t, r] = K.useState(e ? _l : null);
  return Oe(() => {
    t === null && r(_l());
  }, [t]), t != null ? "" + t : void 0;
};
function me(e, t, ...r) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...r) : o;
  }
  let n = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, me), n;
}
function Yt(e) {
  return Go ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let Ji = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Ve = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Ve || {}), gn = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(gn || {}), md = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(md || {});
function Uo(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Ji)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Xr = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Xr || {});
function Jr(e, t = 0) {
  var r;
  return e === ((r = Yt(e)) == null ? void 0 : r.body) ? !1 : me(t, { [0]() {
    return e.matches(Ji);
  }, [1]() {
    let n = e;
    for (; n !== null; ) {
      if (n.matches(Ji))
        return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
function tu(e) {
  let t = Yt(e);
  ht().nextFrame(() => {
    t && !Jr(t.activeElement, 0) && mn(e);
  });
}
function mn(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let hd = ["textarea", "input"].join(",");
function bd(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, hd)) != null ? r : !1;
}
function Hn(e, t = (r) => r) {
  return e.slice().sort((r, n) => {
    let o = t(r), i = t(n);
    if (o === null || i === null)
      return 0;
    let a = o.compareDocumentPosition(i);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function yd(e, t) {
  return ot(Uo(), t, { relativeTo: e });
}
function ot(e, t, { sorted: r = !0, relativeTo: n = null, skipElements: o = [] } = {}) {
  let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, a = Array.isArray(e) ? r ? Hn(e) : e : Uo(e);
  o.length > 0 && (a = a.filter((v) => !o.includes(v))), n = n != null ? n : i.activeElement;
  let l = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), s = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, a.indexOf(n)) - 1;
    if (t & 4)
      return Math.max(0, a.indexOf(n)) + 1;
    if (t & 8)
      return a.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = t & 32 ? { preventScroll: !0 } : {}, c = 0, d = a.length, f;
  do {
    if (c >= d || c + d <= 0)
      return 0;
    let v = s + c;
    if (t & 16)
      v = (v + d) % d;
    else {
      if (v < 0)
        return 3;
      if (v >= d)
        return 1;
    }
    f = a[v], f == null || f.focus(u), c += l;
  } while (f !== i.activeElement);
  return t & 6 && bd(f) && f.select(), f.hasAttribute("tabindex") || f.setAttribute("tabindex", "0"), 2;
}
function Pi(e, t, r) {
  let n = lt(t);
  Ce(() => {
    function o(i) {
      n.current(i);
    }
    return document.addEventListener(e, o, r), () => document.removeEventListener(e, o, r);
  }, [e, r]);
}
function Qr(e, t, r = !0) {
  let n = oe(!1);
  Ce(() => {
    requestAnimationFrame(() => {
      n.current = r;
    });
  }, [r]);
  function o(a, l) {
    if (!n.current || a.defaultPrevented)
      return;
    let s = function c(d) {
      return typeof d == "function" ? c(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e), u = l(a);
    if (u !== null && !!u.getRootNode().contains(u)) {
      for (let c of s) {
        if (c === null)
          continue;
        let d = c instanceof HTMLElement ? c : c.current;
        if (d != null && d.contains(u) || a.composed && a.composedPath().includes(d))
          return;
      }
      return !Jr(u, Xr.Loose) && u.tabIndex !== -1 && a.preventDefault(), t(a, u);
    }
  }
  let i = oe(null);
  Pi("mousedown", (a) => {
    var l, s;
    n.current && (i.current = ((s = (l = a.composedPath) == null ? void 0 : l.call(a)) == null ? void 0 : s[0]) || a.target);
  }, !0), Pi("click", (a) => {
    !i.current || (o(a, () => i.current), i.current = null);
  }, !0), Pi("blur", (a) => o(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Fl(e) {
  var t;
  if (e.type)
    return e.type;
  let r = (t = e.as) != null ? t : "button";
  if (typeof r == "string" && r.toLowerCase() === "button")
    return "button";
}
function Un(e, t) {
  let [r, n] = $e(() => Fl(e));
  return Oe(() => {
    n(Fl(e));
  }, [e.type, e.as]), Oe(() => {
    r || !t.current || t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && n("button");
  }, [r, t]), r;
}
let nu = Symbol();
function Oa(e, t = !0) {
  return Object.assign(e, { [nu]: t });
}
function be(...e) {
  let t = oe(e);
  Ce(() => {
    t.current = e;
  }, [e]);
  let r = V((n) => {
    for (let o of t.current)
      o != null && (typeof o == "function" ? o(n) : o.current = n);
  });
  return e.every((n) => n == null || (n == null ? void 0 : n[nu])) ? void 0 : r;
}
function Pa({ container: e, accept: t, walk: r, enabled: n = !0 }) {
  let o = oe(t), i = oe(r);
  Ce(() => {
    o.current = t, i.current = r;
  }, [t, r]), Oe(() => {
    if (!e || !n)
      return;
    let a = Yt(e);
    if (!a)
      return;
    let l = o.current, s = i.current, u = Object.assign((d) => l(d), { acceptNode: l }), c = a.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, u, !1);
    for (; c.nextNode(); )
      s(c.currentNode);
  }, [e, n, o, i]);
}
function Cd(e) {
  throw new Error("Unexpected object: " + e);
}
var xe = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(xe || {});
function Ia(e, t) {
  let r = t.resolveItems();
  if (r.length <= 0)
    return null;
  let n = t.resolveActiveIndex(), o = n != null ? n : -1, i = (() => {
    switch (e.focus) {
      case 0:
        return r.findIndex((a) => !t.resolveDisabled(a));
      case 1: {
        let a = r.slice().reverse().findIndex((l, s, u) => o !== -1 && u.length - s - 1 >= o ? !1 : !t.resolveDisabled(l));
        return a === -1 ? a : r.length - 1 - a;
      }
      case 2:
        return r.findIndex((a, l) => l <= o ? !1 : !t.resolveDisabled(a));
      case 3: {
        let a = r.slice().reverse().findIndex((l) => !t.resolveDisabled(l));
        return a === -1 ? a : r.length - 1 - a;
      }
      case 4:
        return r.findIndex((a) => t.resolveId(a) === e.id);
      case 5:
        return null;
      default:
        Cd(e);
    }
  })();
  return i === -1 ? n : i;
}
var st = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(st || {}), en = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(en || {});
function ge({ ourProps: e, theirProps: t, slot: r, defaultTag: n, features: o, visible: i = !0, name: a }) {
  let l = ru(t, e);
  if (i)
    return mo(l, r, n, a);
  let s = o != null ? o : 0;
  if (s & 2) {
    let { static: u = !1, ...c } = l;
    if (u)
      return mo(c, r, n, a);
  }
  if (s & 1) {
    let { unmount: u = !0, ...c } = l;
    return me(u ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return mo({ ...c, hidden: !0, style: { display: "none" } }, r, n, a);
    } });
  }
  return mo(l, r, n, a);
}
function mo(e, t = {}, r, n) {
  let { as: o = r, children: i, refName: a = "ref", ...l } = Ii(e, ["unmount", "static"]), s = e.ref !== void 0 ? { [a]: e.ref } : {}, u = typeof i == "function" ? i(t) : i;
  l.className && typeof l.className == "function" && (l.className = l.className(t));
  let c = {};
  if (t) {
    let d = !1, f = [];
    for (let [v, h] of Object.entries(t))
      typeof h == "boolean" && (d = !0), h === !0 && f.push(v);
    d && (c["data-headlessui-state"] = f.join(" "));
  }
  if (o === Ge && Object.keys(lr(l)).length > 0) {
    if (!kr(u) || Array.isArray(u) && u.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${n} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(l).map((d) => `  - ${d}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((d) => `  - ${d}`).join(`
`)].join(`
`));
    return _r(u, Object.assign({}, ru(u.props, lr(Ii(l, ["ref"]))), c, s, xd(u.ref, s.ref)));
  }
  return Ra(o, Object.assign({}, Ii(l, ["ref"]), o !== Ge && s, o !== Ge && c), u);
}
function xd(...e) {
  return { ref: e.every((t) => t == null) ? void 0 : (t) => {
    for (let r of e)
      r != null && (typeof r == "function" ? r(t) : r.current = t);
  } };
}
function ru(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, r = {};
  for (let n of e)
    for (let o in n)
      o.startsWith("on") && typeof n[o] == "function" ? (r[o] != null || (r[o] = []), r[o].push(n[o])) : t[o] = n[o];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(r).map((n) => [n, void 0])));
  for (let n in r)
    Object.assign(t, { [n](o, ...i) {
      let a = r[n];
      for (let l of a) {
        if ((o instanceof Event || (o == null ? void 0 : o.nativeEvent) instanceof Event) && o.defaultPrevented)
          return;
        l(o, ...i);
      }
    } });
  return t;
}
function ve(e) {
  var t;
  return Object.assign(jo(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function lr(e) {
  let t = Object.assign({}, e);
  for (let r in t)
    t[r] === void 0 && delete t[r];
  return t;
}
function Ii(e, t = []) {
  let r = Object.assign({}, e);
  for (let n of t)
    n in r && delete r[n];
  return r;
}
function jt(e) {
  let t = e.parentElement, r = null;
  for (; t && !(t instanceof HTMLFieldSetElement); )
    t instanceof HTMLLegendElement && (r = t), t = t.parentElement;
  let n = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return n && wd(r) ? !1 : n;
}
function wd(e) {
  if (!e)
    return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement)
      return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
function Wo(e = {}, t = null, r = []) {
  for (let [n, o] of Object.entries(e))
    iu(r, ou(t, n), o);
  return r;
}
function ou(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function iu(e, t, r) {
  if (Array.isArray(r))
    for (let [n, o] of r.entries())
      iu(e, ou(t, n.toString()), o);
  else
    r instanceof Date ? e.push([t, r.toISOString()]) : typeof r == "boolean" ? e.push([t, r ? "1" : "0"]) : typeof r == "string" ? e.push([t, r]) : typeof r == "number" ? e.push([t, `${r}`]) : r == null ? e.push([t, ""]) : Wo(r, t, e);
}
function au(e) {
  var t;
  let r = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (r) {
    for (let n of r.elements)
      if (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image") {
        n.click();
        return;
      }
  }
}
let Sd = "div";
var Ot = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Ot || {});
let Pt = ve(function(e, t) {
  let { features: r = 1, ...n } = e, o = { ref: t, "aria-hidden": (r & 2) === 2 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return ge({ ourProps: o, theirProps: n, slot: {}, defaultTag: Sd, name: "Hidden" });
}), Ta = Be(null);
Ta.displayName = "OpenClosedContext";
var Ye = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ye || {});
function rn() {
  return De(Ta);
}
function hr({
  value: e,
  children: t
}) {
  return K.createElement(Ta.Provider, {
    value: e
  }, t);
}
var ne = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(ne || {});
function Zo(e, t, r) {
  let [n, o] = $e(r), i = e !== void 0, a = oe(i), l = oe(!1), s = oe(!1);
  return i && !a.current && !l.current ? (l.current = !0, a.current = i, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !i && a.current && !s.current && (s.current = !0, a.current = i, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [i ? e : n, V((u) => (i || o(u), t == null ? void 0 : t(u)))];
}
function $a(e, t) {
  let r = oe([]), n = V(e);
  Ce(() => {
    let o = [...r.current];
    for (let [i, a] of t.entries())
      if (r.current[i] !== a) {
        let l = n(t, o);
        return r.current = t, l;
      }
  }, [n, ...t]);
}
function Nl(e) {
  return [e.screenX, e.screenY];
}
function Ma() {
  let e = oe([-1, -1]);
  return { wasMoved(t) {
    let r = Nl(t);
    return e.current[0] === r[0] && e.current[1] === r[1] ? !1 : (e.current = r, !0);
  }, update(t) {
    e.current = Nl(t);
  } };
}
var qo = { exports: {} }, xr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vl;
function Rd() {
  if (Vl)
    return xr;
  Vl = 1;
  var e = K, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(l, s, u) {
    var c, d = {}, f = null, v = null;
    u !== void 0 && (f = "" + u), s.key !== void 0 && (f = "" + s.key), s.ref !== void 0 && (v = s.ref);
    for (c in s)
      n.call(s, c) && !i.hasOwnProperty(c) && (d[c] = s[c]);
    if (l && l.defaultProps)
      for (c in s = l.defaultProps, s)
        d[c] === void 0 && (d[c] = s[c]);
    return { $$typeof: t, type: l, key: f, ref: v, props: d, _owner: o.current };
  }
  return xr.Fragment = r, xr.jsx = a, xr.jsxs = a, xr;
}
var wr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dl;
function Ed() {
  return Dl || (Dl = 1, process.env.NODE_ENV !== "production" && function() {
    var e = K, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), l = Symbol.for("react.context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), h = Symbol.iterator, m = "@@iterator";
    function g(E) {
      if (E === null || typeof E != "object")
        return null;
      var Z = h && E[h] || E[m];
      return typeof Z == "function" ? Z : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(E) {
      {
        for (var Z = arguments.length, ie = new Array(Z > 1 ? Z - 1 : 0), fe = 1; fe < Z; fe++)
          ie[fe - 1] = arguments[fe];
        S("error", E, ie);
      }
    }
    function S(E, Z, ie) {
      {
        var fe = C.ReactDebugCurrentFrame, Te = fe.getStackAddendum();
        Te !== "" && (Z += "%s", ie = ie.concat([Te]));
        var He = ie.map(function(Re) {
          return String(Re);
        });
        He.unshift("Warning: " + Z), Function.prototype.apply.call(console[E], console, He);
      }
    }
    var w = !1, y = !1, O = !1, P = !1, M = !1, I;
    I = Symbol.for("react.module.reference");
    function k(E) {
      return !!(typeof E == "string" || typeof E == "function" || E === n || E === i || M || E === o || E === u || E === c || P || E === v || w || y || O || typeof E == "object" && E !== null && (E.$$typeof === f || E.$$typeof === d || E.$$typeof === a || E.$$typeof === l || E.$$typeof === s || E.$$typeof === I || E.getModuleId !== void 0));
    }
    function R(E, Z, ie) {
      var fe = E.displayName;
      if (fe)
        return fe;
      var Te = Z.displayName || Z.name || "";
      return Te !== "" ? ie + "(" + Te + ")" : ie;
    }
    function A(E) {
      return E.displayName || "Context";
    }
    function L(E) {
      if (E == null)
        return null;
      if (typeof E.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof E == "function")
        return E.displayName || E.name || null;
      if (typeof E == "string")
        return E;
      switch (E) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof E == "object")
        switch (E.$$typeof) {
          case l:
            var Z = E;
            return A(Z) + ".Consumer";
          case a:
            var ie = E;
            return A(ie._context) + ".Provider";
          case s:
            return R(E, E.render, "ForwardRef");
          case d:
            var fe = E.displayName || null;
            return fe !== null ? fe : L(E.type) || "Memo";
          case f: {
            var Te = E, He = Te._payload, Re = Te._init;
            try {
              return L(Re(He));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, W = 0, U, X, D, le, T, j, z;
    function _() {
    }
    _.__reactDisabledLog = !0;
    function H() {
      {
        if (W === 0) {
          U = console.log, X = console.info, D = console.warn, le = console.error, T = console.group, j = console.groupCollapsed, z = console.groupEnd;
          var E = {
            configurable: !0,
            enumerable: !0,
            value: _,
            writable: !0
          };
          Object.defineProperties(console, {
            info: E,
            log: E,
            warn: E,
            error: E,
            group: E,
            groupCollapsed: E,
            groupEnd: E
          });
        }
        W++;
      }
    }
    function te() {
      {
        if (W--, W === 0) {
          var E = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, E, {
              value: U
            }),
            info: B({}, E, {
              value: X
            }),
            warn: B({}, E, {
              value: D
            }),
            error: B({}, E, {
              value: le
            }),
            group: B({}, E, {
              value: T
            }),
            groupCollapsed: B({}, E, {
              value: j
            }),
            groupEnd: B({}, E, {
              value: z
            })
          });
        }
        W < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var re = C.ReactCurrentDispatcher, ue;
    function ce(E, Z, ie) {
      {
        if (ue === void 0)
          try {
            throw Error();
          } catch (Te) {
            var fe = Te.stack.trim().match(/\n( *(at )?)/);
            ue = fe && fe[1] || "";
          }
        return `
` + ue + E;
      }
    }
    var Y = !1, J;
    {
      var ye = typeof WeakMap == "function" ? WeakMap : Map;
      J = new ye();
    }
    function Q(E, Z) {
      if (!E || Y)
        return "";
      {
        var ie = J.get(E);
        if (ie !== void 0)
          return ie;
      }
      var fe;
      Y = !0;
      var Te = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var He;
      He = re.current, re.current = null, H();
      try {
        if (Z) {
          var Re = function() {
            throw Error();
          };
          if (Object.defineProperty(Re.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Re, []);
            } catch (Jt) {
              fe = Jt;
            }
            Reflect.construct(E, [], Re);
          } else {
            try {
              Re.call();
            } catch (Jt) {
              fe = Jt;
            }
            E.call(Re.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Jt) {
            fe = Jt;
          }
          E();
        }
      } catch (Jt) {
        if (Jt && fe && typeof Jt.stack == "string") {
          for (var we = Jt.stack.split(`
`), dt = fe.stack.split(`
`), tt = we.length - 1, rt = dt.length - 1; tt >= 1 && rt >= 0 && we[tt] !== dt[rt]; )
            rt--;
          for (; tt >= 1 && rt >= 0; tt--, rt--)
            if (we[tt] !== dt[rt]) {
              if (tt !== 1 || rt !== 1)
                do
                  if (tt--, rt--, rt < 0 || we[tt] !== dt[rt]) {
                    var St = `
` + we[tt].replace(" at new ", " at ");
                    return E.displayName && St.includes("<anonymous>") && (St = St.replace("<anonymous>", E.displayName)), typeof E == "function" && J.set(E, St), St;
                  }
                while (tt >= 1 && rt >= 0);
              break;
            }
        }
      } finally {
        Y = !1, re.current = He, te(), Error.prepareStackTrace = Te;
      }
      var qn = E ? E.displayName || E.name : "", Al = qn ? ce(qn) : "";
      return typeof E == "function" && J.set(E, Al), Al;
    }
    function Ue(E, Z, ie) {
      return Q(E, !1);
    }
    function F(E) {
      var Z = E.prototype;
      return !!(Z && Z.isReactComponent);
    }
    function Ke(E, Z, ie) {
      if (E == null)
        return "";
      if (typeof E == "function")
        return Q(E, F(E));
      if (typeof E == "string")
        return ce(E);
      switch (E) {
        case u:
          return ce("Suspense");
        case c:
          return ce("SuspenseList");
      }
      if (typeof E == "object")
        switch (E.$$typeof) {
          case s:
            return Ue(E.render);
          case d:
            return Ke(E.type, Z, ie);
          case f: {
            var fe = E, Te = fe._payload, He = fe._init;
            try {
              return Ke(He(Te), Z, ie);
            } catch {
            }
          }
        }
      return "";
    }
    var qe = Object.prototype.hasOwnProperty, ut = {}, ln = C.ReactDebugCurrentFrame;
    function Ee(E) {
      if (E) {
        var Z = E._owner, ie = Ke(E.type, E._source, Z ? Z.type : null);
        ln.setExtraStackFrame(ie);
      } else
        ln.setExtraStackFrame(null);
    }
    function Ie(E, Z, ie, fe, Te) {
      {
        var He = Function.call.bind(qe);
        for (var Re in E)
          if (He(E, Re)) {
            var we = void 0;
            try {
              if (typeof E[Re] != "function") {
                var dt = Error((fe || "React class") + ": " + ie + " type `" + Re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof E[Re] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw dt.name = "Invariant Violation", dt;
              }
              we = E[Re](Z, Re, fe, ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (tt) {
              we = tt;
            }
            we && !(we instanceof Error) && (Ee(Te), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", fe || "React class", ie, Re, typeof we), Ee(null)), we instanceof Error && !(we.message in ut) && (ut[we.message] = !0, Ee(Te), x("Failed %s type: %s", ie, we.message), Ee(null));
          }
      }
    }
    var Se = Array.isArray;
    function et(E) {
      return Se(E);
    }
    function je(E) {
      {
        var Z = typeof Symbol == "function" && Symbol.toStringTag, ie = Z && E[Symbol.toStringTag] || E.constructor.name || "Object";
        return ie;
      }
    }
    function nt(E) {
      try {
        return Xe(E), !1;
      } catch {
        return !0;
      }
    }
    function Xe(E) {
      return "" + E;
    }
    function it(E) {
      if (nt(E))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", je(E)), Xe(E);
    }
    var ct = C.ReactCurrentOwner, pt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, de, Ht, Xt;
    Xt = {};
    function In(E) {
      if (qe.call(E, "ref")) {
        var Z = Object.getOwnPropertyDescriptor(E, "ref").get;
        if (Z && Z.isReactWarning)
          return !1;
      }
      return E.ref !== void 0;
    }
    function go(E) {
      if (qe.call(E, "key")) {
        var Z = Object.getOwnPropertyDescriptor(E, "key").get;
        if (Z && Z.isReactWarning)
          return !1;
      }
      return E.key !== void 0;
    }
    function Cr(E, Z) {
      if (typeof E.ref == "string" && ct.current && Z && ct.current.stateNode !== Z) {
        var ie = L(ct.current.type);
        Xt[ie] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', L(ct.current.type), E.ref), Xt[ie] = !0);
      }
    }
    function Jc(E, Z) {
      {
        var ie = function() {
          de || (de = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Z));
        };
        ie.isReactWarning = !0, Object.defineProperty(E, "key", {
          get: ie,
          configurable: !0
        });
      }
    }
    function Qc(E, Z) {
      {
        var ie = function() {
          Ht || (Ht = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Z));
        };
        ie.isReactWarning = !0, Object.defineProperty(E, "ref", {
          get: ie,
          configurable: !0
        });
      }
    }
    var ed = function(E, Z, ie, fe, Te, He, Re) {
      var we = {
        $$typeof: t,
        type: E,
        key: Z,
        ref: ie,
        props: Re,
        _owner: He
      };
      return we._store = {}, Object.defineProperty(we._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(we, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: fe
      }), Object.defineProperty(we, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Te
      }), Object.freeze && (Object.freeze(we.props), Object.freeze(we)), we;
    };
    function td(E, Z, ie, fe, Te) {
      {
        var He, Re = {}, we = null, dt = null;
        ie !== void 0 && (it(ie), we = "" + ie), go(Z) && (it(Z.key), we = "" + Z.key), In(Z) && (dt = Z.ref, Cr(Z, Te));
        for (He in Z)
          qe.call(Z, He) && !pt.hasOwnProperty(He) && (Re[He] = Z[He]);
        if (E && E.defaultProps) {
          var tt = E.defaultProps;
          for (He in tt)
            Re[He] === void 0 && (Re[He] = tt[He]);
        }
        if (we || dt) {
          var rt = typeof E == "function" ? E.displayName || E.name || "Unknown" : E;
          we && Jc(Re, rt), dt && Qc(Re, rt);
        }
        return ed(E, we, dt, Te, fe, ct.current, Re);
      }
    }
    var Si = C.ReactCurrentOwner, Pl = C.ReactDebugCurrentFrame;
    function Zn(E) {
      if (E) {
        var Z = E._owner, ie = Ke(E.type, E._source, Z ? Z.type : null);
        Pl.setExtraStackFrame(ie);
      } else
        Pl.setExtraStackFrame(null);
    }
    var Ri;
    Ri = !1;
    function Ei(E) {
      return typeof E == "object" && E !== null && E.$$typeof === t;
    }
    function Il() {
      {
        if (Si.current) {
          var E = L(Si.current.type);
          if (E)
            return `

Check the render method of \`` + E + "`.";
        }
        return "";
      }
    }
    function nd(E) {
      {
        if (E !== void 0) {
          var Z = E.fileName.replace(/^.*[\\\/]/, ""), ie = E.lineNumber;
          return `

Check your code at ` + Z + ":" + ie + ".";
        }
        return "";
      }
    }
    var Tl = {};
    function rd(E) {
      {
        var Z = Il();
        if (!Z) {
          var ie = typeof E == "string" ? E : E.displayName || E.name;
          ie && (Z = `

Check the top-level render call using <` + ie + ">.");
        }
        return Z;
      }
    }
    function $l(E, Z) {
      {
        if (!E._store || E._store.validated || E.key != null)
          return;
        E._store.validated = !0;
        var ie = rd(Z);
        if (Tl[ie])
          return;
        Tl[ie] = !0;
        var fe = "";
        E && E._owner && E._owner !== Si.current && (fe = " It was passed a child from " + L(E._owner.type) + "."), Zn(E), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ie, fe), Zn(null);
      }
    }
    function Ml(E, Z) {
      {
        if (typeof E != "object")
          return;
        if (et(E))
          for (var ie = 0; ie < E.length; ie++) {
            var fe = E[ie];
            Ei(fe) && $l(fe, Z);
          }
        else if (Ei(E))
          E._store && (E._store.validated = !0);
        else if (E) {
          var Te = g(E);
          if (typeof Te == "function" && Te !== E.entries)
            for (var He = Te.call(E), Re; !(Re = He.next()).done; )
              Ei(Re.value) && $l(Re.value, Z);
        }
      }
    }
    function od(E) {
      {
        var Z = E.type;
        if (Z == null || typeof Z == "string")
          return;
        var ie;
        if (typeof Z == "function")
          ie = Z.propTypes;
        else if (typeof Z == "object" && (Z.$$typeof === s || Z.$$typeof === d))
          ie = Z.propTypes;
        else
          return;
        if (ie) {
          var fe = L(Z);
          Ie(ie, E.props, "prop", fe, E);
        } else if (Z.PropTypes !== void 0 && !Ri) {
          Ri = !0;
          var Te = L(Z);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Te || "Unknown");
        }
        typeof Z.getDefaultProps == "function" && !Z.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function id(E) {
      {
        for (var Z = Object.keys(E.props), ie = 0; ie < Z.length; ie++) {
          var fe = Z[ie];
          if (fe !== "children" && fe !== "key") {
            Zn(E), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", fe), Zn(null);
            break;
          }
        }
        E.ref !== null && (Zn(E), x("Invalid attribute `ref` supplied to `React.Fragment`."), Zn(null));
      }
    }
    function Ll(E, Z, ie, fe, Te, He) {
      {
        var Re = k(E);
        if (!Re) {
          var we = "";
          (E === void 0 || typeof E == "object" && E !== null && Object.keys(E).length === 0) && (we += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var dt = nd(Te);
          dt ? we += dt : we += Il();
          var tt;
          E === null ? tt = "null" : et(E) ? tt = "array" : E !== void 0 && E.$$typeof === t ? (tt = "<" + (L(E.type) || "Unknown") + " />", we = " Did you accidentally export a JSX literal instead of a component?") : tt = typeof E, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", tt, we);
        }
        var rt = td(E, Z, ie, Te, He);
        if (rt == null)
          return rt;
        if (Re) {
          var St = Z.children;
          if (St !== void 0)
            if (fe)
              if (et(St)) {
                for (var qn = 0; qn < St.length; qn++)
                  Ml(St[qn], E);
                Object.freeze && Object.freeze(St);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ml(St, E);
        }
        return E === n ? id(rt) : od(rt), rt;
      }
    }
    function ad(E, Z, ie) {
      return Ll(E, Z, ie, !0);
    }
    function ld(E, Z, ie) {
      return Ll(E, Z, ie, !1);
    }
    var sd = ld, ud = ad;
    wr.Fragment = n, wr.jsx = sd, wr.jsxs = ud;
  }()), wr;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Rd() : e.exports = Ed();
})(qo);
const It = qo.exports.Fragment, p = qo.exports.jsx, G = qo.exports.jsxs;
var Od = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Od || {}), Pd = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Pd || {}), Id = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Id || {}), Td = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.RegisterLabel = 5] = "RegisterLabel", e))(Td || {});
function Ti(e, t = (r) => r) {
  let r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, n = Hn(t(e.options.slice()), (i) => i.dataRef.current.domRef.current), o = r ? n.indexOf(r) : null;
  return o === -1 && (o = null), {
    options: n,
    activeOptionIndex: o
  };
}
let $d = {
  [1](e) {
    return e.dataRef.current.disabled || e.comboboxState === 1 ? e : {
      ...e,
      activeOptionIndex: null,
      comboboxState: 1
    };
  },
  [0](e) {
    if (e.dataRef.current.disabled || e.comboboxState === 0)
      return e;
    let t = e.activeOptionIndex, {
      isSelected: r
    } = e.dataRef.current, n = e.options.findIndex((o) => r(o.dataRef.current.value));
    return n !== -1 && (t = n), {
      ...e,
      comboboxState: 0,
      activeOptionIndex: t
    };
  },
  [2](e, t) {
    var r;
    if (e.dataRef.current.disabled || e.dataRef.current.optionsRef.current && !e.dataRef.current.optionsPropsRef.current.static && e.comboboxState === 1)
      return e;
    let n = Ti(e);
    if (n.activeOptionIndex === null) {
      let i = n.options.findIndex((a) => !a.dataRef.current.disabled);
      i !== -1 && (n.activeOptionIndex = i);
    }
    let o = Ia(t, {
      resolveItems: () => n.options,
      resolveActiveIndex: () => n.activeOptionIndex,
      resolveId: (i) => i.id,
      resolveDisabled: (i) => i.dataRef.current.disabled
    });
    return {
      ...e,
      ...n,
      activeOptionIndex: o,
      activationTrigger: (r = t.trigger) != null ? r : 1
    };
  },
  [3]: (e, t) => {
    let r = {
      id: t.id,
      dataRef: t.dataRef
    }, n = Ti(e, (i) => [...i, r]);
    e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (n.activeOptionIndex = n.options.indexOf(r));
    let o = {
      ...e,
      ...n,
      activationTrigger: 1
    };
    return e.dataRef.current.__demoMode && e.dataRef.current.value === void 0 && (o.activeOptionIndex = 0), o;
  },
  [4]: (e, t) => {
    let r = Ti(e, (n) => {
      let o = n.findIndex((i) => i.id === t.id);
      return o !== -1 && n.splice(o, 1), n;
    });
    return {
      ...e,
      ...r,
      activationTrigger: 1
    };
  },
  [5]: (e, t) => ({
    ...e,
    labelId: t.id
  })
}, La = Be(null);
La.displayName = "ComboboxActionsContext";
function eo(e) {
  let t = De(La);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, eo), r;
  }
  return t;
}
let Aa = Be(null);
Aa.displayName = "ComboboxDataContext";
function br(e) {
  let t = De(Aa);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, br), r;
  }
  return t;
}
function Md(e, t) {
  return me(t.type, $d, e, t);
}
let Ld = Ge;
function Ad(e, t) {
  let {
    value: r,
    defaultValue: n,
    onChange: o,
    name: i,
    by: a = (z, _) => z === _,
    disabled: l = !1,
    __demoMode: s = !1,
    nullable: u = !1,
    multiple: c = !1,
    ...d
  } = e, [f = c ? [] : void 0, v] = Zo(r, o, n), [h, m] = xn(Md, {
    dataRef: Dn(),
    comboboxState: s ? 0 : 1,
    options: [],
    activeOptionIndex: null,
    activationTrigger: 1,
    labelId: null
  }), g = oe(!1), C = oe({
    static: !1,
    hold: !1
  }), x = oe(null), S = oe(null), w = oe(null), y = oe(null), O = V(typeof a == "string" ? (z, _) => {
    let H = a;
    return (z == null ? void 0 : z[H]) === (_ == null ? void 0 : _[H]);
  } : a), P = gt((z) => me(M.mode, {
    [1]: () => f.some((_) => O(_, z)),
    [0]: () => O(f, z)
  }), [f]), M = se(() => ({
    ...h,
    optionsPropsRef: C,
    labelRef: x,
    inputRef: S,
    buttonRef: w,
    optionsRef: y,
    value: f,
    defaultValue: n,
    disabled: l,
    mode: c ? 1 : 0,
    get activeOptionIndex() {
      if (g.current && h.activeOptionIndex === null && h.options.length > 0) {
        let z = h.options.findIndex((_) => !_.dataRef.current.disabled);
        if (z !== -1)
          return z;
      }
      return h.activeOptionIndex;
    },
    compare: O,
    isSelected: P,
    nullable: u,
    __demoMode: s
  }), [f, n, l, c, u, s, h]);
  Oe(() => {
    h.dataRef.current = M;
  }, [M]), Qr([M.buttonRef, M.inputRef, M.optionsRef], () => D.closeCombobox(), M.comboboxState === 0);
  let I = se(() => ({
    open: M.comboboxState === 0,
    disabled: l,
    activeIndex: M.activeOptionIndex,
    activeOption: M.activeOptionIndex === null ? null : M.options[M.activeOptionIndex].dataRef.current.value,
    value: f
  }), [M, l, f]), k = V((z) => {
    let _ = M.options.find((H) => H.id === z);
    !_ || X(_.dataRef.current.value);
  }), R = V(() => {
    if (M.activeOptionIndex !== null) {
      let {
        dataRef: z,
        id: _
      } = M.options[M.activeOptionIndex];
      X(z.current.value), D.goToOption(xe.Specific, _);
    }
  }), A = V(() => {
    m({
      type: 0
    }), g.current = !0;
  }), L = V(() => {
    m({
      type: 1
    }), g.current = !1;
  }), B = V((z, _, H) => (g.current = !1, z === xe.Specific ? m({
    type: 2,
    focus: xe.Specific,
    id: _,
    trigger: H
  }) : m({
    type: 2,
    focus: z,
    trigger: H
  }))), W = V((z, _) => (m({
    type: 3,
    id: z,
    dataRef: _
  }), () => m({
    type: 4,
    id: z
  }))), U = V((z) => (m({
    type: 5,
    id: z
  }), () => m({
    type: 5,
    id: null
  }))), X = V((z) => me(M.mode, {
    [0]() {
      return v == null ? void 0 : v(z);
    },
    [1]() {
      let _ = M.value.slice(), H = _.findIndex((te) => O(te, z));
      return H === -1 ? _.push(z) : _.splice(H, 1), v == null ? void 0 : v(_);
    }
  })), D = se(() => ({
    onChange: X,
    registerOption: W,
    registerLabel: U,
    goToOption: B,
    closeCombobox: L,
    openCombobox: A,
    selectActiveOption: R,
    selectOption: k
  }), []), le = t === null ? {} : {
    ref: t
  }, T = oe(null), j = bt();
  return Ce(() => {
    !T.current || n !== void 0 && j.addEventListener(T.current, "reset", () => {
      X(n);
    });
  }, [T, X]), K.createElement(La.Provider, {
    value: D
  }, K.createElement(Aa.Provider, {
    value: M
  }, /* @__PURE__ */ G(hr, {
    value: me(M.comboboxState, {
      [0]: Ye.Open,
      [1]: Ye.Closed
    }),
    children: [i != null && f != null && Wo({
      [i]: f
    }).map(([z, _], H) => /* @__PURE__ */ p(Pt, {
      features: Ot.Hidden,
      ref: H === 0 ? (te) => {
        var re;
        T.current = (re = te == null ? void 0 : te.closest("form")) != null ? re : null;
      } : void 0,
      ...lr({
        key: z,
        as: "input",
        type: "hidden",
        hidden: !0,
        readOnly: !0,
        name: z,
        value: _
      })
    })), ge({
      ourProps: le,
      theirProps: d,
      slot: I,
      defaultTag: Ld,
      name: "Combobox"
    })]
  })));
}
let kd = ve(Ad), _d = "input", Fd = ve(function(e, t) {
  var r, n, o, i;
  let a = Pe(), {
    id: l = `headlessui-combobox-input-${a}`,
    onChange: s,
    displayValue: u,
    type: c = "text",
    ...d
  } = e, f = br("Combobox.Input"), v = eo("Combobox.Input"), h = be(f.inputRef, t), m = oe(!1), g = bt(), C = function() {
    var R;
    return typeof u == "function" && f.value !== void 0 ? (R = u(f.value)) != null ? R : "" : typeof f.value == "string" ? f.value : "";
  }();
  $a(([R, A], [L, B]) => {
    m.current || !f.inputRef.current || (B === 0 && A === 1 || R !== L) && (f.inputRef.current.value = R);
  }, [C, f.comboboxState]);
  let x = oe(!1), S = V(() => {
    x.current = !0;
  }), w = V(() => {
    setTimeout(() => {
      x.current = !1;
    });
  }), y = V((R) => {
    switch (m.current = !0, R.key) {
      case ne.Backspace:
      case ne.Delete:
        if (f.mode !== 0 || !f.nullable)
          return;
        let A = R.currentTarget;
        g.requestAnimationFrame(() => {
          A.value === "" && (v.onChange(null), f.optionsRef.current && (f.optionsRef.current.scrollTop = 0), v.goToOption(xe.Nothing));
        });
        break;
      case ne.Enter:
        if (m.current = !1, f.comboboxState !== 0 || x.current)
          return;
        if (R.preventDefault(), R.stopPropagation(), f.activeOptionIndex === null) {
          v.closeCombobox();
          return;
        }
        v.selectActiveOption(), f.mode === 0 && v.closeCombobox();
        break;
      case ne.ArrowDown:
        return m.current = !1, R.preventDefault(), R.stopPropagation(), me(f.comboboxState, {
          [0]: () => {
            v.goToOption(xe.Next);
          },
          [1]: () => {
            v.openCombobox();
          }
        });
      case ne.ArrowUp:
        return m.current = !1, R.preventDefault(), R.stopPropagation(), me(f.comboboxState, {
          [0]: () => {
            v.goToOption(xe.Previous);
          },
          [1]: () => {
            v.openCombobox(), g.nextFrame(() => {
              f.value || v.goToOption(xe.Last);
            });
          }
        });
      case ne.Home:
        if (R.shiftKey)
          break;
        return m.current = !1, R.preventDefault(), R.stopPropagation(), v.goToOption(xe.First);
      case ne.PageUp:
        return m.current = !1, R.preventDefault(), R.stopPropagation(), v.goToOption(xe.First);
      case ne.End:
        if (R.shiftKey)
          break;
        return m.current = !1, R.preventDefault(), R.stopPropagation(), v.goToOption(xe.Last);
      case ne.PageDown:
        return m.current = !1, R.preventDefault(), R.stopPropagation(), v.goToOption(xe.Last);
      case ne.Escape:
        return m.current = !1, f.comboboxState !== 0 ? void 0 : (R.preventDefault(), f.optionsRef.current && !f.optionsPropsRef.current.static && R.stopPropagation(), v.closeCombobox());
      case ne.Tab:
        if (m.current = !1, f.comboboxState !== 0)
          return;
        f.mode === 0 && v.selectActiveOption(), v.closeCombobox();
        break;
    }
  }), O = V((R) => {
    v.openCombobox(), s == null || s(R);
  }), P = V(() => {
    m.current = !1;
  }), M = Yr(() => {
    if (f.labelId)
      return [f.labelId].join(" ");
  }, [f.labelId]), I = se(() => ({
    open: f.comboboxState === 0,
    disabled: f.disabled
  }), [f]), k = {
    ref: h,
    id: l,
    role: "combobox",
    type: c,
    "aria-controls": (r = f.optionsRef.current) == null ? void 0 : r.id,
    "aria-expanded": f.disabled ? void 0 : f.comboboxState === 0,
    "aria-activedescendant": f.activeOptionIndex === null || (n = f.options[f.activeOptionIndex]) == null ? void 0 : n.id,
    "aria-multiselectable": f.mode === 1 ? !0 : void 0,
    "aria-labelledby": M,
    defaultValue: (i = (o = e.defaultValue) != null ? o : f.defaultValue !== void 0 ? u == null ? void 0 : u(f.defaultValue) : null) != null ? i : f.defaultValue,
    disabled: f.disabled,
    onCompositionStart: S,
    onCompositionEnd: w,
    onKeyDown: y,
    onChange: O,
    onBlur: P
  };
  return ge({
    ourProps: k,
    theirProps: d,
    slot: I,
    defaultTag: _d,
    name: "Combobox.Input"
  });
}), Nd = "button", Vd = ve(function(e, t) {
  var r;
  let n = br("Combobox.Button"), o = eo("Combobox.Button"), i = be(n.buttonRef, t), a = Pe(), {
    id: l = `headlessui-combobox-button-${a}`,
    ...s
  } = e, u = bt(), c = V((m) => {
    switch (m.key) {
      case ne.ArrowDown:
        return m.preventDefault(), m.stopPropagation(), n.comboboxState === 1 && o.openCombobox(), u.nextFrame(() => {
          var g;
          return (g = n.inputRef.current) == null ? void 0 : g.focus({
            preventScroll: !0
          });
        });
      case ne.ArrowUp:
        return m.preventDefault(), m.stopPropagation(), n.comboboxState === 1 && (o.openCombobox(), u.nextFrame(() => {
          n.value || o.goToOption(xe.Last);
        })), u.nextFrame(() => {
          var g;
          return (g = n.inputRef.current) == null ? void 0 : g.focus({
            preventScroll: !0
          });
        });
      case ne.Escape:
        return n.comboboxState !== 0 ? void 0 : (m.preventDefault(), n.optionsRef.current && !n.optionsPropsRef.current.static && m.stopPropagation(), o.closeCombobox(), u.nextFrame(() => {
          var g;
          return (g = n.inputRef.current) == null ? void 0 : g.focus({
            preventScroll: !0
          });
        }));
      default:
        return;
    }
  }), d = V((m) => {
    if (jt(m.currentTarget))
      return m.preventDefault();
    n.comboboxState === 0 ? o.closeCombobox() : (m.preventDefault(), o.openCombobox()), u.nextFrame(() => {
      var g;
      return (g = n.inputRef.current) == null ? void 0 : g.focus({
        preventScroll: !0
      });
    });
  }), f = Yr(() => {
    if (n.labelId)
      return [n.labelId, l].join(" ");
  }, [n.labelId, l]), v = se(() => ({
    open: n.comboboxState === 0,
    disabled: n.disabled,
    value: n.value
  }), [n]), h = {
    ref: i,
    id: l,
    type: Un(e, n.buttonRef),
    tabIndex: -1,
    "aria-haspopup": "listbox",
    "aria-controls": (r = n.optionsRef.current) == null ? void 0 : r.id,
    "aria-expanded": n.disabled ? void 0 : n.comboboxState === 0,
    "aria-labelledby": f,
    disabled: n.disabled,
    onClick: d,
    onKeyDown: c
  };
  return ge({
    ourProps: h,
    theirProps: s,
    slot: v,
    defaultTag: Nd,
    name: "Combobox.Button"
  });
}), Dd = "label", Hd = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-combobox-label-${r}`,
    ...o
  } = e, i = br("Combobox.Label"), a = eo("Combobox.Label"), l = be(i.labelRef, t);
  Oe(() => a.registerLabel(n), [n]);
  let s = V(() => {
    var c;
    return (c = i.inputRef.current) == null ? void 0 : c.focus({
      preventScroll: !0
    });
  }), u = se(() => ({
    open: i.comboboxState === 0,
    disabled: i.disabled
  }), [i]);
  return ge({
    ourProps: {
      ref: l,
      id: n,
      onClick: s
    },
    theirProps: o,
    slot: u,
    defaultTag: Dd,
    name: "Combobox.Label"
  });
}), zd = "ul", Bd = st.RenderStrategy | st.Static, jd = ve(function(e, t) {
  var r;
  let n = Pe(), {
    id: o = `headlessui-combobox-options-${n}`,
    hold: i = !1,
    ...a
  } = e, l = br("Combobox.Options"), s = be(l.optionsRef, t), u = rn(), c = (() => u !== null ? u === Ye.Open : l.comboboxState === 0)();
  Oe(() => {
    var h;
    l.optionsPropsRef.current.static = (h = e.static) != null ? h : !1;
  }, [l.optionsPropsRef, e.static]), Oe(() => {
    l.optionsPropsRef.current.hold = i;
  }, [l.optionsPropsRef, i]), Pa({
    container: l.optionsRef.current,
    enabled: l.comboboxState === 0,
    accept(h) {
      return h.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : h.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk(h) {
      h.setAttribute("role", "none");
    }
  });
  let d = Yr(() => {
    var h, m;
    return (m = l.labelId) != null ? m : (h = l.buttonRef.current) == null ? void 0 : h.id;
  }, [l.labelId, l.buttonRef.current]), f = se(() => ({
    open: l.comboboxState === 0
  }), [l]), v = {
    "aria-activedescendant": l.activeOptionIndex === null || (r = l.options[l.activeOptionIndex]) == null ? void 0 : r.id,
    "aria-labelledby": d,
    role: "listbox",
    id: o,
    ref: s
  };
  return ge({
    ourProps: v,
    theirProps: a,
    slot: f,
    defaultTag: zd,
    features: Bd,
    visible: c,
    name: "Combobox.Options"
  });
}), Gd = "li", Ud = ve(function(e, t) {
  var r, n;
  let o = Pe(), {
    id: i = `headlessui-combobox-option-${o}`,
    disabled: a = !1,
    value: l,
    ...s
  } = e, u = br("Combobox.Option"), c = eo("Combobox.Option"), d = u.activeOptionIndex !== null ? u.options[u.activeOptionIndex].id === i : !1, f = u.isSelected(l), v = oe(null), h = lt({
    disabled: a,
    value: l,
    domRef: v,
    textValue: (n = (r = v.current) == null ? void 0 : r.textContent) == null ? void 0 : n.toLowerCase()
  }), m = be(t, v), g = V(() => c.selectOption(i));
  Oe(() => c.registerOption(i, h), [h, i]);
  let C = oe(!u.__demoMode);
  Oe(() => {
    if (!u.__demoMode)
      return;
    let I = ht();
    return I.requestAnimationFrame(() => {
      C.current = !0;
    }), I.dispose;
  }, []), Oe(() => {
    if (u.comboboxState !== 0 || !d || !C.current || u.activationTrigger === 0)
      return;
    let I = ht();
    return I.requestAnimationFrame(() => {
      var k, R;
      (R = (k = v.current) == null ? void 0 : k.scrollIntoView) == null || R.call(k, {
        block: "nearest"
      });
    }), I.dispose;
  }, [v, d, u.comboboxState, u.activationTrigger, u.activeOptionIndex]);
  let x = V((I) => {
    if (a)
      return I.preventDefault();
    g(), u.mode === 0 && c.closeCombobox();
  }), S = V(() => {
    if (a)
      return c.goToOption(xe.Nothing);
    c.goToOption(xe.Specific, i);
  }), w = Ma(), y = V((I) => w.update(I)), O = V((I) => {
    !w.wasMoved(I) || a || d || c.goToOption(xe.Specific, i, 0);
  }), P = V((I) => {
    !w.wasMoved(I) || a || !d || u.optionsPropsRef.current.hold || c.goToOption(xe.Nothing);
  }), M = se(() => ({
    active: d,
    selected: f,
    disabled: a
  }), [d, f, a]);
  return ge({
    ourProps: {
      id: i,
      ref: m,
      role: "option",
      tabIndex: a === !0 ? void 0 : -1,
      "aria-disabled": a === !0 ? !0 : void 0,
      "aria-selected": f,
      disabled: void 0,
      onClick: x,
      onFocus: S,
      onPointerEnter: y,
      onMouseEnter: y,
      onPointerMove: O,
      onMouseMove: O,
      onPointerLeave: P,
      onMouseLeave: P
    },
    theirProps: s,
    slot: M,
    defaultTag: Gd,
    name: "Combobox.Option"
  });
}), yt = Object.assign(kd, {
  Input: Fd,
  Button: Vd,
  Label: Hd,
  Options: jd,
  Option: Ud
});
function Wd(e, t, r) {
  let n = lt(t);
  Ce(() => {
    function o(i) {
      n.current(i);
    }
    return window.addEventListener(e, o, r), () => window.removeEventListener(e, o, r);
  }, [e, r]);
}
var _t = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(_t || {});
function ka() {
  let e = oe(0);
  return Wd("keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function Yo() {
  let e = oe(!1);
  return Oe(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function wn(...e) {
  return se(() => Yt(...e), [...e]);
}
function Ko(e, t, r, n) {
  let o = lt(r);
  Ce(() => {
    e = e != null ? e : window;
    function i(a) {
      o.current(a);
    }
    return e.addEventListener(t, i, n), () => e.removeEventListener(t, i, n);
  }, [e, t, n]);
}
let Zd = "div";
var lu = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(lu || {});
let Sr = Object.assign(ve(function(e, t) {
  let r = oe(null), n = be(r, t), {
    initialFocus: o,
    containers: i,
    features: a = 30,
    ...l
  } = e;
  mr() || (a = 1);
  let s = wn(r);
  qd({
    ownerDocument: s
  }, Boolean(a & 16));
  let u = Yd({
    ownerDocument: s,
    container: r,
    initialFocus: o
  }, Boolean(a & 2));
  Kd({
    ownerDocument: s,
    container: r,
    containers: i,
    previousActiveElement: u
  }, Boolean(a & 8));
  let c = ka(), d = V((m) => {
    let g = r.current;
    !g || ((C) => C())(() => {
      me(c.current, {
        [_t.Forwards]: () => ot(g, Ve.First, {
          skipElements: [m.relatedTarget]
        }),
        [_t.Backwards]: () => ot(g, Ve.Last, {
          skipElements: [m.relatedTarget]
        })
      });
    });
  }), f = bt(), v = oe(!1), h = {
    ref: n,
    onKeyDown(m) {
      m.key == "Tab" && (v.current = !0, f.requestAnimationFrame(() => {
        v.current = !1;
      }));
    },
    onBlur(m) {
      let g = new Set(i == null ? void 0 : i.current);
      g.add(r);
      let C = m.relatedTarget;
      !C || C.dataset.headlessuiFocusGuard !== "true" && (su(g, C) || (v.current ? ot(r.current, me(c.current, {
        [_t.Forwards]: () => Ve.Next,
        [_t.Backwards]: () => Ve.Previous
      }) | Ve.WrapAround, {
        relativeTo: m.target
      }) : m.target instanceof HTMLElement && mn(m.target)));
    }
  };
  return K.createElement(K.Fragment, null, Boolean(a & 4) && K.createElement(Pt, {
    as: "button",
    type: "button",
    "data-headlessui-focus-guard": !0,
    onFocus: d,
    features: Ot.Focusable
  }), ge({
    ourProps: h,
    theirProps: l,
    defaultTag: Zd,
    name: "FocusTrap"
  }), Boolean(a & 4) && K.createElement(Pt, {
    as: "button",
    type: "button",
    "data-headlessui-focus-guard": !0,
    onFocus: d,
    features: Ot.Focusable
  }));
}), {
  features: lu
});
function qd({
  ownerDocument: e
}, t) {
  let r = oe(null);
  Ko(e == null ? void 0 : e.defaultView, "focusout", (o) => {
    !t || r.current || (r.current = o.target);
  }, !0), $a(() => {
    t || ((e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && mn(r.current), r.current = null);
  }, [t]);
  let n = oe(!1);
  Ce(() => (n.current = !1, () => {
    n.current = !0, Kr(() => {
      !n.current || (mn(r.current), r.current = null);
    });
  }), []);
}
function Yd({
  ownerDocument: e,
  container: t,
  initialFocus: r
}, n) {
  let o = oe(null), i = Yo();
  return $a(() => {
    if (!n)
      return;
    let a = t.current;
    !a || Kr(() => {
      if (!i.current)
        return;
      let l = e == null ? void 0 : e.activeElement;
      if (r != null && r.current) {
        if ((r == null ? void 0 : r.current) === l) {
          o.current = l;
          return;
        }
      } else if (a.contains(l)) {
        o.current = l;
        return;
      }
      r != null && r.current ? mn(r.current) : ot(a, Ve.First) === gn.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.current = e == null ? void 0 : e.activeElement;
    });
  }, [n]), o;
}
function Kd({
  ownerDocument: e,
  container: t,
  containers: r,
  previousActiveElement: n
}, o) {
  let i = Yo();
  Ko(e == null ? void 0 : e.defaultView, "focus", (a) => {
    if (!o || !i.current)
      return;
    let l = new Set(r == null ? void 0 : r.current);
    l.add(t);
    let s = n.current;
    if (!s)
      return;
    let u = a.target;
    u && u instanceof HTMLElement ? su(l, u) ? (n.current = u, mn(u)) : (a.preventDefault(), a.stopPropagation(), mn(s)) : mn(n.current);
  }, !0);
}
function su(e, t) {
  var r;
  for (let n of e)
    if ((r = n.current) != null && r.contains(t))
      return !0;
  return !1;
}
let Yn = /* @__PURE__ */ new Set(), cn = /* @__PURE__ */ new Map();
function Hl(e) {
  e.setAttribute("aria-hidden", "true"), e.inert = !0;
}
function zl(e) {
  let t = cn.get(e);
  !t || (t["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", t["aria-hidden"]), e.inert = t.inert);
}
function Xd(e, t = !0) {
  Oe(() => {
    if (!t || !e.current)
      return;
    let r = e.current, n = Yt(r);
    if (n) {
      Yn.add(r);
      for (let o of cn.keys())
        o.contains(r) && (zl(o), cn.delete(o));
      return n.querySelectorAll("body > *").forEach((o) => {
        if (o instanceof HTMLElement) {
          for (let i of Yn)
            if (o.contains(i))
              return;
          Yn.size === 1 && (cn.set(o, { "aria-hidden": o.getAttribute("aria-hidden"), inert: o.inert }), Hl(o));
        }
      }), () => {
        if (Yn.delete(r), Yn.size > 0)
          n.querySelectorAll("body > *").forEach((o) => {
            if (o instanceof HTMLElement && !cn.has(o)) {
              for (let i of Yn)
                if (o.contains(i))
                  return;
              cn.set(o, { "aria-hidden": o.getAttribute("aria-hidden"), inert: o.inert }), Hl(o);
            }
          });
        else
          for (let o of cn.keys())
            zl(o), cn.delete(o);
      };
    }
  }, [t]);
}
let uu = Be(!1);
function Jd() {
  return De(uu);
}
function Qi(e) {
  return K.createElement(uu.Provider, {
    value: e.force
  }, e.children);
}
function Qd(e) {
  let t = Jd(), r = De(cu), n = wn(e), [o, i] = $e(() => {
    if (!t && r !== null || Go)
      return null;
    let a = n == null ? void 0 : n.getElementById("headlessui-portal-root");
    if (a)
      return a;
    if (n === null)
      return null;
    let l = n.createElement("div");
    return l.setAttribute("id", "headlessui-portal-root"), n.body.appendChild(l);
  });
  return Ce(() => {
    o !== null && (n != null && n.body.contains(o) || n == null || n.body.appendChild(o));
  }, [o, n]), Ce(() => {
    t || r !== null && i(r.current);
  }, [r, i, t]), o;
}
let ef = Ge, tf = ve(function(e, t) {
  let r = e, n = oe(null), o = be(Oa((c) => {
    n.current = c;
  }), t), i = wn(n), a = Qd(n), [l] = $e(() => {
    var c;
    return Go ? null : (c = i == null ? void 0 : i.createElement("div")) != null ? c : null;
  }), s = mr(), u = oe(!1);
  return Oe(() => {
    if (u.current = !1, !(!a || !l))
      return a.contains(l) || (l.setAttribute("data-headlessui-portal", ""), a.appendChild(l)), () => {
        u.current = !0, Kr(() => {
          var c;
          !u.current || !a || !l || (a.removeChild(l), a.childNodes.length <= 0 && ((c = a.parentElement) == null || c.removeChild(a)));
        });
      };
  }, [a, l]), s ? !a || !l ? null : pd(ge({
    ourProps: {
      ref: o
    },
    theirProps: r,
    defaultTag: ef,
    name: "Portal"
  }), l) : null;
}), nf = Ge, cu = Be(null), rf = ve(function(e, t) {
  let {
    target: r,
    ...n
  } = e, o = {
    ref: be(t)
  };
  return /* @__PURE__ */ p(cu.Provider, {
    value: r,
    children: ge({
      ourProps: o,
      theirProps: n,
      defaultTag: nf,
      name: "Popover.Group"
    })
  });
}), ea = Object.assign(tf, {
  Group: rf
}), du = Be(null);
function fu() {
  let e = De(du);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, fu), t;
  }
  return e;
}
function Xo() {
  let [e, t] = $e([]);
  return [e.length > 0 ? e.join(" ") : void 0, se(() => function(r) {
    let n = V((i) => (t((a) => [...a, i]), () => t((a) => {
      let l = a.slice(), s = l.indexOf(i);
      return s !== -1 && l.splice(s, 1), l;
    }))), o = se(() => ({
      register: n,
      slot: r.slot,
      name: r.name,
      props: r.props
    }), [n, r.slot, r.name, r.props]);
    return K.createElement(du.Provider, {
      value: o
    }, r.children);
  }, [t])];
}
let of = "p", _a = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-description-${r}`,
    ...o
  } = e, i = fu(), a = be(t);
  Oe(() => i.register(n), [n, i.register]);
  let l = {
    ref: a,
    ...i.props,
    id: n
  };
  return ge({
    ourProps: l,
    theirProps: o,
    slot: i.slot || {},
    defaultTag: of,
    name: i.name || "Description"
  });
}), Fa = Be(() => {
});
Fa.displayName = "StackContext";
var ta = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(ta || {});
function af() {
  return De(Fa);
}
function lf({
  children: e,
  onUpdate: t,
  type: r,
  element: n,
  enabled: o
}) {
  let i = af(), a = V((...l) => {
    t == null || t(...l), i(...l);
  });
  return Oe(() => {
    let l = o === void 0 || o === !0;
    return l && a(0, r, n), () => {
      l && a(1, r, n);
    };
  }, [a, r, n, o]), K.createElement(Fa.Provider, {
    value: a
  }, e);
}
function sf() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
var uf = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(uf || {}), cf = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(cf || {});
let df = {
  [0](e, t) {
    return e.titleId === t.id ? e : {
      ...e,
      titleId: t.id
    };
  }
}, Oo = Be(null);
Oo.displayName = "DialogContext";
function to(e) {
  let t = De(Oo);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, to), r;
  }
  return t;
}
function ff(e, t, r = () => [document.body]) {
  Ce(() => {
    var n;
    if (!t || !e)
      return;
    let o = ht(), i = window.pageYOffset;
    function a(u, c, d) {
      let f = u.style.getPropertyValue(c);
      return Object.assign(u.style, {
        [c]: d
      }), o.add(() => {
        Object.assign(u.style, {
          [c]: f
        });
      });
    }
    let l = e.documentElement, s = ((n = e.defaultView) != null ? n : window).innerWidth - l.clientWidth;
    if (a(l, "overflow", "hidden"), s > 0) {
      let u = l.clientWidth - l.offsetWidth, c = s - u;
      a(l, "paddingRight", `${c}px`);
    }
    if (sf()) {
      a(e.body, "marginTop", `-${i}px`), window.scrollTo(0, 0);
      let u = null;
      o.addEventListener(e, "click", (c) => {
        if (c.target instanceof HTMLElement)
          try {
            let d = c.target.closest("a");
            if (!d)
              return;
            let {
              hash: f
            } = new URL(d.href), v = e.querySelector(f);
            v && !r().some((h) => h.contains(v)) && (u = v);
          } catch {
          }
      }, !0), o.addEventListener(e, "touchmove", (c) => {
        c.target instanceof HTMLElement && !r().some((d) => d.contains(c.target)) && c.preventDefault();
      }, {
        passive: !1
      }), o.add(() => {
        window.scrollTo(0, window.pageYOffset + i), u && u.isConnected && (u.scrollIntoView({
          block: "nearest"
        }), u = null);
      });
    }
    return o.dispose;
  }, [e, t]);
}
function pf(e, t) {
  return me(t.type, df, e, t);
}
let gf = "div", vf = st.RenderStrategy | st.Static, mf = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-dialog-${r}`,
    open: o,
    onClose: i,
    initialFocus: a,
    __demoMode: l = !1,
    ...s
  } = e, [u, c] = $e(0), d = rn();
  o === void 0 && d !== null && (o = me(d, {
    [Ye.Open]: !0,
    [Ye.Closed]: !1
  }));
  let f = oe(/* @__PURE__ */ new Set()), v = oe(null), h = be(v, t), m = oe(null), g = wn(v), C = e.hasOwnProperty("open") || d !== null, x = e.hasOwnProperty("onClose");
  if (!C && !x)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!C)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!x)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof o != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${o}`);
  if (typeof i != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${i}`);
  let S = o ? 0 : 1, [w, y] = xn(pf, {
    titleId: null,
    descriptionId: null,
    panelRef: Dn()
  }), O = V(() => i(!1)), P = V((D) => y({
    type: 0,
    id: D
  })), M = mr() ? l ? !1 : S === 0 : !1, I = u > 1, k = De(Oo) !== null, R = I ? "parent" : "leaf";
  Xd(v, I ? M : !1);
  let A = V(() => {
    var D, le;
    return [...Array.from((D = g == null ? void 0 : g.querySelectorAll("body > *, [data-headlessui-portal]")) != null ? D : []).filter((T) => !(!(T instanceof HTMLElement) || T.contains(m.current) || w.panelRef.current && T.contains(w.panelRef.current))), (le = w.panelRef.current) != null ? le : v.current];
  });
  Qr(() => A(), O, M && !I), Ko(g == null ? void 0 : g.defaultView, "keydown", (D) => {
    D.defaultPrevented || D.key === ne.Escape && S === 0 && (I || (D.preventDefault(), D.stopPropagation(), O()));
  }), ff(g, S === 0 && !k, A), Ce(() => {
    if (S !== 0 || !v.current)
      return;
    let D = new IntersectionObserver((le) => {
      for (let T of le)
        T.boundingClientRect.x === 0 && T.boundingClientRect.y === 0 && T.boundingClientRect.width === 0 && T.boundingClientRect.height === 0 && O();
    });
    return D.observe(v.current), () => D.disconnect();
  }, [S, v, O]);
  let [L, B] = Xo(), W = se(() => [{
    dialogState: S,
    close: O,
    setTitleId: P
  }, w], [S, w, O, P]), U = se(() => ({
    open: S === 0
  }), [S]), X = {
    ref: h,
    id: n,
    role: "dialog",
    "aria-modal": S === 0 ? !0 : void 0,
    "aria-labelledby": w.titleId,
    "aria-describedby": L
  };
  return K.createElement(lf, {
    type: "Dialog",
    enabled: S === 0,
    element: v,
    onUpdate: V((D, le, T) => {
      le === "Dialog" && me(D, {
        [ta.Add]() {
          f.current.add(T), c((j) => j + 1);
        },
        [ta.Remove]() {
          f.current.add(T), c((j) => j - 1);
        }
      });
    })
  }, K.createElement(Qi, {
    force: !0
  }, K.createElement(ea, null, K.createElement(Oo.Provider, {
    value: W
  }, K.createElement(ea.Group, {
    target: v
  }, K.createElement(Qi, {
    force: !1
  }, K.createElement(B, {
    slot: U,
    name: "Dialog.Description"
  }, /* @__PURE__ */ p(Sr, {
    initialFocus: a,
    containers: f,
    features: M ? me(R, {
      parent: Sr.features.RestoreFocus,
      leaf: Sr.features.All & ~Sr.features.FocusLock
    }) : Sr.features.None,
    children: ge({
      ourProps: X,
      theirProps: s,
      slot: U,
      defaultTag: gf,
      features: vf,
      visible: S === 0,
      name: "Dialog"
    })
  }))))))), K.createElement(Pt, {
    features: Ot.Hidden,
    ref: m
  }));
}), hf = "div", bf = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-dialog-overlay-${r}`,
    ...o
  } = e, [{
    dialogState: i,
    close: a
  }] = to("Dialog.Overlay"), l = be(t), s = V((c) => {
    if (c.target === c.currentTarget) {
      if (jt(c.currentTarget))
        return c.preventDefault();
      c.preventDefault(), c.stopPropagation(), a();
    }
  }), u = se(() => ({
    open: i === 0
  }), [i]);
  return ge({
    ourProps: {
      ref: l,
      id: n,
      "aria-hidden": !0,
      onClick: s
    },
    theirProps: o,
    slot: u,
    defaultTag: hf,
    name: "Dialog.Overlay"
  });
}), yf = "div", Cf = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-dialog-backdrop-${r}`,
    ...o
  } = e, [{
    dialogState: i
  }, a] = to("Dialog.Backdrop"), l = be(t);
  Ce(() => {
    if (a.panelRef.current === null)
      throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [a.panelRef]);
  let s = se(() => ({
    open: i === 0
  }), [i]);
  return /* @__PURE__ */ p(Qi, {
    force: !0,
    children: /* @__PURE__ */ p(ea, {
      children: ge({
        ourProps: {
          ref: l,
          id: n,
          "aria-hidden": !0
        },
        theirProps: o,
        slot: s,
        defaultTag: yf,
        name: "Dialog.Backdrop"
      })
    })
  });
}), xf = "div", wf = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-dialog-panel-${r}`,
    ...o
  } = e, [{
    dialogState: i
  }, a] = to("Dialog.Panel"), l = be(t, a.panelRef), s = se(() => ({
    open: i === 0
  }), [i]), u = V((c) => {
    c.stopPropagation();
  });
  return ge({
    ourProps: {
      ref: l,
      id: n,
      onClick: u
    },
    theirProps: o,
    slot: s,
    defaultTag: xf,
    name: "Dialog.Panel"
  });
}), Sf = "h2", Rf = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-dialog-title-${r}`,
    ...o
  } = e, [{
    dialogState: i,
    setTitleId: a
  }] = to("Dialog.Title"), l = be(t);
  Ce(() => (a(n), () => a(null)), [n, a]);
  let s = se(() => ({
    open: i === 0
  }), [i]);
  return ge({
    ourProps: {
      ref: l,
      id: n
    },
    theirProps: o,
    slot: s,
    defaultTag: Sf,
    name: "Dialog.Title"
  });
}), $i = Object.assign(mf, {
  Backdrop: Cf,
  Panel: wf,
  Overlay: bf,
  Title: Rf,
  Description: _a
});
var Ef = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ef || {}), Of = ((e) => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.LinkPanel = 4] = "LinkPanel", e[e.UnlinkPanel = 5] = "UnlinkPanel", e))(Of || {});
let Pf = {
  [0]: (e) => ({
    ...e,
    disclosureState: me(e.disclosureState, {
      [0]: 1,
      [1]: 0
    })
  }),
  [1]: (e) => e.disclosureState === 1 ? e : {
    ...e,
    disclosureState: 1
  },
  [4](e) {
    return e.linkedPanel === !0 ? e : {
      ...e,
      linkedPanel: !0
    };
  },
  [5](e) {
    return e.linkedPanel === !1 ? e : {
      ...e,
      linkedPanel: !1
    };
  },
  [2](e, t) {
    return e.buttonId === t.buttonId ? e : {
      ...e,
      buttonId: t.buttonId
    };
  },
  [3](e, t) {
    return e.panelId === t.panelId ? e : {
      ...e,
      panelId: t.panelId
    };
  }
}, Na = Be(null);
Na.displayName = "DisclosureContext";
function Va(e) {
  let t = De(Na);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Va), r;
  }
  return t;
}
let Da = Be(null);
Da.displayName = "DisclosureAPIContext";
function pu(e) {
  let t = De(Da);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, pu), r;
  }
  return t;
}
let Ha = Be(null);
Ha.displayName = "DisclosurePanelContext";
function If() {
  return De(Ha);
}
function Tf(e, t) {
  return me(t.type, Pf, e, t);
}
let $f = Ge, Mf = ve(function(e, t) {
  let {
    defaultOpen: r = !1,
    ...n
  } = e, o = oe(null), i = be(t, Oa((g) => {
    o.current = g;
  }, e.as === void 0 || e.as === Ge)), a = oe(null), l = oe(null), s = xn(Tf, {
    disclosureState: r ? 0 : 1,
    linkedPanel: !1,
    buttonRef: l,
    panelRef: a,
    buttonId: null,
    panelId: null
  }), [{
    disclosureState: u,
    buttonId: c
  }, d] = s, f = V((g) => {
    d({
      type: 1
    });
    let C = Yt(o);
    if (!C || !c)
      return;
    let x = (() => g ? g instanceof HTMLElement ? g : g.current instanceof HTMLElement ? g.current : C.getElementById(c) : C.getElementById(c))();
    x == null || x.focus();
  }), v = se(() => ({
    close: f
  }), [f]), h = se(() => ({
    open: u === 0,
    close: f
  }), [u, f]), m = {
    ref: i
  };
  return K.createElement(Na.Provider, {
    value: s
  }, K.createElement(Da.Provider, {
    value: v
  }, /* @__PURE__ */ p(hr, {
    value: me(u, {
      [0]: Ye.Open,
      [1]: Ye.Closed
    }),
    children: ge({
      ourProps: m,
      theirProps: n,
      slot: h,
      defaultTag: $f,
      name: "Disclosure"
    })
  })));
}), Lf = "button", Af = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-disclosure-button-${r}`,
    ...o
  } = e, [i, a] = Va("Disclosure.Button"), l = If(), s = l === null ? !1 : l === i.panelId, u = oe(null), c = be(u, t, s ? null : i.buttonRef);
  Ce(() => {
    if (!s)
      return a({
        type: 2,
        buttonId: n
      }), () => {
        a({
          type: 2,
          buttonId: null
        });
      };
  }, [n, a, s]);
  let d = V((C) => {
    var x;
    if (s) {
      if (i.disclosureState === 1)
        return;
      switch (C.key) {
        case ne.Space:
        case ne.Enter:
          C.preventDefault(), C.stopPropagation(), a({
            type: 0
          }), (x = i.buttonRef.current) == null || x.focus();
          break;
      }
    } else
      switch (C.key) {
        case ne.Space:
        case ne.Enter:
          C.preventDefault(), C.stopPropagation(), a({
            type: 0
          });
          break;
      }
  }), f = V((C) => {
    switch (C.key) {
      case ne.Space:
        C.preventDefault();
        break;
    }
  }), v = V((C) => {
    var x;
    jt(C.currentTarget) || e.disabled || (s ? (a({
      type: 0
    }), (x = i.buttonRef.current) == null || x.focus()) : a({
      type: 0
    }));
  }), h = se(() => ({
    open: i.disclosureState === 0
  }), [i]), m = Un(e, u), g = s ? {
    ref: c,
    type: m,
    onKeyDown: d,
    onClick: v
  } : {
    ref: c,
    id: n,
    type: m,
    "aria-expanded": e.disabled ? void 0 : i.disclosureState === 0,
    "aria-controls": i.linkedPanel ? i.panelId : void 0,
    onKeyDown: d,
    onKeyUp: f,
    onClick: v
  };
  return ge({
    ourProps: g,
    theirProps: o,
    slot: h,
    defaultTag: Lf,
    name: "Disclosure.Button"
  });
}), kf = "div", _f = st.RenderStrategy | st.Static, Ff = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-disclosure-panel-${r}`,
    ...o
  } = e, [i, a] = Va("Disclosure.Panel"), {
    close: l
  } = pu("Disclosure.Panel"), s = be(t, i.panelRef, (v) => {
    a({
      type: v ? 4 : 5
    });
  });
  Ce(() => (a({
    type: 3,
    panelId: n
  }), () => {
    a({
      type: 3,
      panelId: null
    });
  }), [n, a]);
  let u = rn(), c = (() => u !== null ? u === Ye.Open : i.disclosureState === 0)(), d = se(() => ({
    open: i.disclosureState === 0,
    close: l
  }), [i, l]), f = {
    ref: s,
    id: n
  };
  return /* @__PURE__ */ p(Ha.Provider, {
    value: i.panelId,
    children: ge({
      ourProps: f,
      theirProps: o,
      slot: d,
      defaultTag: kf,
      features: _f,
      visible: c,
      name: "Disclosure.Panel"
    })
  });
}), Mi = Object.assign(Mf, {
  Button: Af,
  Panel: Ff
});
var Nf = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Nf || {}), Vf = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Vf || {}), Df = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Df || {}), Hf = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.RegisterLabel = 7] = "RegisterLabel", e))(Hf || {});
function Li(e, t = (r) => r) {
  let r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, n = Hn(t(e.options.slice()), (i) => i.dataRef.current.domRef.current), o = r ? n.indexOf(r) : null;
  return o === -1 && (o = null), {
    options: n,
    activeOptionIndex: o
  };
}
let zf = {
  [1](e) {
    return e.dataRef.current.disabled || e.listboxState === 1 ? e : {
      ...e,
      activeOptionIndex: null,
      listboxState: 1
    };
  },
  [0](e) {
    if (e.dataRef.current.disabled || e.listboxState === 0)
      return e;
    let t = e.activeOptionIndex, {
      isSelected: r
    } = e.dataRef.current, n = e.options.findIndex((o) => r(o.dataRef.current.value));
    return n !== -1 && (t = n), {
      ...e,
      listboxState: 0,
      activeOptionIndex: t
    };
  },
  [2](e, t) {
    var r;
    if (e.dataRef.current.disabled || e.listboxState === 1)
      return e;
    let n = Li(e), o = Ia(t, {
      resolveItems: () => n.options,
      resolveActiveIndex: () => n.activeOptionIndex,
      resolveId: (i) => i.id,
      resolveDisabled: (i) => i.dataRef.current.disabled
    });
    return {
      ...e,
      ...n,
      searchQuery: "",
      activeOptionIndex: o,
      activationTrigger: (r = t.trigger) != null ? r : 1
    };
  },
  [3]: (e, t) => {
    if (e.dataRef.current.disabled || e.listboxState === 1)
      return e;
    let r = e.searchQuery !== "" ? 0 : 1, n = e.searchQuery + t.value.toLowerCase(), o = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find((a) => {
      var l;
      return !a.dataRef.current.disabled && ((l = a.dataRef.current.textValue) == null ? void 0 : l.startsWith(n));
    }), i = o ? e.options.indexOf(o) : -1;
    return i === -1 || i === e.activeOptionIndex ? {
      ...e,
      searchQuery: n
    } : {
      ...e,
      searchQuery: n,
      activeOptionIndex: i,
      activationTrigger: 1
    };
  },
  [4](e) {
    return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : {
      ...e,
      searchQuery: ""
    };
  },
  [5]: (e, t) => {
    let r = {
      id: t.id,
      dataRef: t.dataRef
    }, n = Li(e, (o) => [...o, r]);
    return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (n.activeOptionIndex = n.options.indexOf(r)), {
      ...e,
      ...n
    };
  },
  [6]: (e, t) => {
    let r = Li(e, (n) => {
      let o = n.findIndex((i) => i.id === t.id);
      return o !== -1 && n.splice(o, 1), n;
    });
    return {
      ...e,
      ...r,
      activationTrigger: 1
    };
  },
  [7]: (e, t) => ({
    ...e,
    labelId: t.id
  })
}, za = Be(null);
za.displayName = "ListboxActionsContext";
function no(e) {
  let t = De(za);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, no), r;
  }
  return t;
}
let Ba = Be(null);
Ba.displayName = "ListboxDataContext";
function ro(e) {
  let t = De(Ba);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, ro), r;
  }
  return t;
}
function Bf(e, t) {
  return me(t.type, zf, e, t);
}
let jf = Ge, Gf = ve(function(e, t) {
  let {
    value: r,
    defaultValue: n,
    name: o,
    onChange: i,
    by: a = (_, H) => _ === H,
    disabled: l = !1,
    horizontal: s = !1,
    multiple: u = !1,
    ...c
  } = e;
  const d = s ? "horizontal" : "vertical";
  let f = be(t), [v = u ? [] : void 0, h] = Zo(r, i, n), [m, g] = xn(Bf, {
    dataRef: Dn(),
    listboxState: 1,
    options: [],
    searchQuery: "",
    labelId: null,
    activeOptionIndex: null,
    activationTrigger: 1
  }), C = oe({
    static: !1,
    hold: !1
  }), x = oe(null), S = oe(null), w = oe(null), y = V(typeof a == "string" ? (_, H) => {
    let te = a;
    return (_ == null ? void 0 : _[te]) === (H == null ? void 0 : H[te]);
  } : a), O = gt((_) => me(P.mode, {
    [1]: () => v.some((H) => y(H, _)),
    [0]: () => y(v, _)
  }), [v]), P = se(() => ({
    ...m,
    value: v,
    disabled: l,
    mode: u ? 1 : 0,
    orientation: d,
    compare: y,
    isSelected: O,
    optionsPropsRef: C,
    labelRef: x,
    buttonRef: S,
    optionsRef: w
  }), [v, l, u, m]);
  Oe(() => {
    m.dataRef.current = P;
  }, [P]), Qr([P.buttonRef, P.optionsRef], (_, H) => {
    var te;
    g({
      type: 1
    }), Jr(H, Xr.Loose) || (_.preventDefault(), (te = P.buttonRef.current) == null || te.focus());
  }, P.listboxState === 0);
  let M = se(() => ({
    open: P.listboxState === 0,
    disabled: l,
    value: v
  }), [P, l, v]), I = V((_) => {
    let H = P.options.find((te) => te.id === _);
    !H || U(H.dataRef.current.value);
  }), k = V(() => {
    if (P.activeOptionIndex !== null) {
      let {
        dataRef: _,
        id: H
      } = P.options[P.activeOptionIndex];
      U(_.current.value), g({
        type: 2,
        focus: xe.Specific,
        id: H
      });
    }
  }), R = V(() => g({
    type: 0
  })), A = V(() => g({
    type: 1
  })), L = V((_, H, te) => _ === xe.Specific ? g({
    type: 2,
    focus: xe.Specific,
    id: H,
    trigger: te
  }) : g({
    type: 2,
    focus: _,
    trigger: te
  })), B = V((_, H) => (g({
    type: 5,
    id: _,
    dataRef: H
  }), () => g({
    type: 6,
    id: _
  }))), W = V((_) => (g({
    type: 7,
    id: _
  }), () => g({
    type: 7,
    id: null
  }))), U = V((_) => me(P.mode, {
    [0]() {
      return h == null ? void 0 : h(_);
    },
    [1]() {
      let H = P.value.slice(), te = H.findIndex((re) => y(re, _));
      return te === -1 ? H.push(_) : H.splice(te, 1), h == null ? void 0 : h(H);
    }
  })), X = V((_) => g({
    type: 3,
    value: _
  })), D = V(() => g({
    type: 4
  })), le = se(() => ({
    onChange: U,
    registerOption: B,
    registerLabel: W,
    goToOption: L,
    closeListbox: A,
    openListbox: R,
    selectActiveOption: k,
    selectOption: I,
    search: X,
    clearSearch: D
  }), []), T = {
    ref: f
  }, j = oe(null), z = bt();
  return Ce(() => {
    !j.current || n !== void 0 && z.addEventListener(j.current, "reset", () => {
      U(n);
    });
  }, [j, U]), /* @__PURE__ */ p(za.Provider, {
    value: le,
    children: /* @__PURE__ */ p(Ba.Provider, {
      value: P,
      children: /* @__PURE__ */ G(hr, {
        value: me(P.listboxState, {
          [0]: Ye.Open,
          [1]: Ye.Closed
        }),
        children: [o != null && v != null && Wo({
          [o]: v
        }).map(([_, H], te) => /* @__PURE__ */ p(Pt, {
          features: Ot.Hidden,
          ref: te === 0 ? (re) => {
            var ue;
            j.current = (ue = re == null ? void 0 : re.closest("form")) != null ? ue : null;
          } : void 0,
          ...lr({
            key: _,
            as: "input",
            type: "hidden",
            hidden: !0,
            readOnly: !0,
            name: _,
            value: H
          })
        })), ge({
          ourProps: T,
          theirProps: c,
          slot: M,
          defaultTag: jf,
          name: "Listbox"
        })]
      })
    })
  });
}), Uf = "button", Wf = ve(function(e, t) {
  var r;
  let n = Pe(), {
    id: o = `headlessui-listbox-button-${n}`,
    ...i
  } = e, a = ro("Listbox.Button"), l = no("Listbox.Button"), s = be(a.buttonRef, t), u = bt(), c = V((g) => {
    switch (g.key) {
      case ne.Space:
      case ne.Enter:
      case ne.ArrowDown:
        g.preventDefault(), l.openListbox(), u.nextFrame(() => {
          a.value || l.goToOption(xe.First);
        });
        break;
      case ne.ArrowUp:
        g.preventDefault(), l.openListbox(), u.nextFrame(() => {
          a.value || l.goToOption(xe.Last);
        });
        break;
    }
  }), d = V((g) => {
    switch (g.key) {
      case ne.Space:
        g.preventDefault();
        break;
    }
  }), f = V((g) => {
    if (jt(g.currentTarget))
      return g.preventDefault();
    a.listboxState === 0 ? (l.closeListbox(), u.nextFrame(() => {
      var C;
      return (C = a.buttonRef.current) == null ? void 0 : C.focus({
        preventScroll: !0
      });
    })) : (g.preventDefault(), l.openListbox());
  }), v = Yr(() => {
    if (a.labelId)
      return [a.labelId, o].join(" ");
  }, [a.labelId, o]), h = se(() => ({
    open: a.listboxState === 0,
    disabled: a.disabled,
    value: a.value
  }), [a]), m = {
    ref: s,
    id: o,
    type: Un(e, a.buttonRef),
    "aria-haspopup": "listbox",
    "aria-controls": (r = a.optionsRef.current) == null ? void 0 : r.id,
    "aria-expanded": a.disabled ? void 0 : a.listboxState === 0,
    "aria-labelledby": v,
    disabled: a.disabled,
    onKeyDown: c,
    onKeyUp: d,
    onClick: f
  };
  return ge({
    ourProps: m,
    theirProps: i,
    slot: h,
    defaultTag: Uf,
    name: "Listbox.Button"
  });
}), Zf = "label", qf = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-listbox-label-${r}`,
    ...o
  } = e, i = ro("Listbox.Label"), a = no("Listbox.Label"), l = be(i.labelRef, t);
  Oe(() => a.registerLabel(n), [n]);
  let s = V(() => {
    var c;
    return (c = i.buttonRef.current) == null ? void 0 : c.focus({
      preventScroll: !0
    });
  }), u = se(() => ({
    open: i.listboxState === 0,
    disabled: i.disabled
  }), [i]);
  return ge({
    ourProps: {
      ref: l,
      id: n,
      onClick: s
    },
    theirProps: o,
    slot: u,
    defaultTag: Zf,
    name: "Listbox.Label"
  });
}), Yf = "ul", Kf = st.RenderStrategy | st.Static, Xf = ve(function(e, t) {
  var r;
  let n = Pe(), {
    id: o = `headlessui-listbox-options-${n}`,
    ...i
  } = e, a = ro("Listbox.Options"), l = no("Listbox.Options"), s = be(a.optionsRef, t), u = bt(), c = bt(), d = rn(), f = (() => d !== null ? d === Ye.Open : a.listboxState === 0)();
  Ce(() => {
    var C;
    let x = a.optionsRef.current;
    !x || a.listboxState === 0 && x !== ((C = Yt(x)) == null ? void 0 : C.activeElement) && x.focus({
      preventScroll: !0
    });
  }, [a.listboxState, a.optionsRef]);
  let v = V((C) => {
    switch (c.dispose(), C.key) {
      case ne.Space:
        if (a.searchQuery !== "")
          return C.preventDefault(), C.stopPropagation(), l.search(C.key);
      case ne.Enter:
        if (C.preventDefault(), C.stopPropagation(), a.activeOptionIndex !== null) {
          let {
            dataRef: x
          } = a.options[a.activeOptionIndex];
          l.onChange(x.current.value);
        }
        a.mode === 0 && (l.closeListbox(), ht().nextFrame(() => {
          var x;
          return (x = a.buttonRef.current) == null ? void 0 : x.focus({
            preventScroll: !0
          });
        }));
        break;
      case me(a.orientation, {
        vertical: ne.ArrowDown,
        horizontal: ne.ArrowRight
      }):
        return C.preventDefault(), C.stopPropagation(), l.goToOption(xe.Next);
      case me(a.orientation, {
        vertical: ne.ArrowUp,
        horizontal: ne.ArrowLeft
      }):
        return C.preventDefault(), C.stopPropagation(), l.goToOption(xe.Previous);
      case ne.Home:
      case ne.PageUp:
        return C.preventDefault(), C.stopPropagation(), l.goToOption(xe.First);
      case ne.End:
      case ne.PageDown:
        return C.preventDefault(), C.stopPropagation(), l.goToOption(xe.Last);
      case ne.Escape:
        return C.preventDefault(), C.stopPropagation(), l.closeListbox(), u.nextFrame(() => {
          var x;
          return (x = a.buttonRef.current) == null ? void 0 : x.focus({
            preventScroll: !0
          });
        });
      case ne.Tab:
        C.preventDefault(), C.stopPropagation();
        break;
      default:
        C.key.length === 1 && (l.search(C.key), c.setTimeout(() => l.clearSearch(), 350));
        break;
    }
  }), h = Yr(() => {
    var C, x, S;
    return (S = (C = a.labelRef.current) == null ? void 0 : C.id) != null ? S : (x = a.buttonRef.current) == null ? void 0 : x.id;
  }, [a.labelRef.current, a.buttonRef.current]), m = se(() => ({
    open: a.listboxState === 0
  }), [a]), g = {
    "aria-activedescendant": a.activeOptionIndex === null || (r = a.options[a.activeOptionIndex]) == null ? void 0 : r.id,
    "aria-multiselectable": a.mode === 1 ? !0 : void 0,
    "aria-labelledby": h,
    "aria-orientation": a.orientation,
    id: o,
    onKeyDown: v,
    role: "listbox",
    tabIndex: 0,
    ref: s
  };
  return ge({
    ourProps: g,
    theirProps: i,
    slot: m,
    defaultTag: Yf,
    features: Kf,
    visible: f,
    name: "Listbox.Options"
  });
}), Jf = "li", Qf = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-listbox-option-${r}`,
    disabled: o = !1,
    value: i,
    ...a
  } = e, l = ro("Listbox.Option"), s = no("Listbox.Option"), u = l.activeOptionIndex !== null ? l.options[l.activeOptionIndex].id === n : !1, c = l.isSelected(i), d = oe(null), f = lt({
    disabled: o,
    value: i,
    domRef: d,
    get textValue() {
      var y, O;
      return (O = (y = d.current) == null ? void 0 : y.textContent) == null ? void 0 : O.toLowerCase();
    }
  }), v = be(t, d);
  Oe(() => {
    if (l.listboxState !== 0 || !u || l.activationTrigger === 0)
      return;
    let y = ht();
    return y.requestAnimationFrame(() => {
      var O, P;
      (P = (O = d.current) == null ? void 0 : O.scrollIntoView) == null || P.call(O, {
        block: "nearest"
      });
    }), y.dispose;
  }, [d, u, l.listboxState, l.activationTrigger, l.activeOptionIndex]), Oe(() => s.registerOption(n, f), [f, n]);
  let h = V((y) => {
    if (o)
      return y.preventDefault();
    s.onChange(i), l.mode === 0 && (s.closeListbox(), ht().nextFrame(() => {
      var O;
      return (O = l.buttonRef.current) == null ? void 0 : O.focus({
        preventScroll: !0
      });
    }));
  }), m = V(() => {
    if (o)
      return s.goToOption(xe.Nothing);
    s.goToOption(xe.Specific, n);
  }), g = Ma(), C = V((y) => g.update(y)), x = V((y) => {
    !g.wasMoved(y) || o || u || s.goToOption(xe.Specific, n, 0);
  }), S = V((y) => {
    !g.wasMoved(y) || o || !u || s.goToOption(xe.Nothing);
  }), w = se(() => ({
    active: u,
    selected: c,
    disabled: o
  }), [u, c, o]);
  return ge({
    ourProps: {
      id: n,
      ref: v,
      role: "option",
      tabIndex: o === !0 ? void 0 : -1,
      "aria-disabled": o === !0 ? !0 : void 0,
      "aria-selected": c,
      disabled: void 0,
      onClick: h,
      onFocus: m,
      onPointerEnter: C,
      onMouseEnter: C,
      onPointerMove: x,
      onMouseMove: x,
      onPointerLeave: S,
      onMouseLeave: S
    },
    theirProps: a,
    slot: w,
    defaultTag: Jf,
    name: "Listbox.Option"
  });
}), Rr = Object.assign(Gf, {
  Button: Wf,
  Label: qf,
  Options: Xf,
  Option: Qf
});
var e1 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(e1 || {}), t1 = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(t1 || {}), n1 = ((e) => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e))(n1 || {});
function Ai(e, t = (r) => r) {
  let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, n = Hn(t(e.items.slice()), (i) => i.dataRef.current.domRef.current), o = r ? n.indexOf(r) : null;
  return o === -1 && (o = null), {
    items: n,
    activeItemIndex: o
  };
}
let r1 = {
  [1](e) {
    return e.menuState === 1 ? e : {
      ...e,
      activeItemIndex: null,
      menuState: 1
    };
  },
  [0](e) {
    return e.menuState === 0 ? e : {
      ...e,
      menuState: 0
    };
  },
  [2]: (e, t) => {
    var r;
    let n = Ai(e), o = Ia(t, {
      resolveItems: () => n.items,
      resolveActiveIndex: () => n.activeItemIndex,
      resolveId: (i) => i.id,
      resolveDisabled: (i) => i.dataRef.current.disabled
    });
    return {
      ...e,
      ...n,
      searchQuery: "",
      activeItemIndex: o,
      activationTrigger: (r = t.trigger) != null ? r : 1
    };
  },
  [3]: (e, t) => {
    let r = e.searchQuery !== "" ? 0 : 1, n = e.searchQuery + t.value.toLowerCase(), o = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + r).concat(e.items.slice(0, e.activeItemIndex + r)) : e.items).find((a) => {
      var l;
      return ((l = a.dataRef.current.textValue) == null ? void 0 : l.startsWith(n)) && !a.dataRef.current.disabled;
    }), i = o ? e.items.indexOf(o) : -1;
    return i === -1 || i === e.activeItemIndex ? {
      ...e,
      searchQuery: n
    } : {
      ...e,
      searchQuery: n,
      activeItemIndex: i,
      activationTrigger: 1
    };
  },
  [4](e) {
    return e.searchQuery === "" ? e : {
      ...e,
      searchQuery: "",
      searchActiveItemIndex: null
    };
  },
  [5]: (e, t) => {
    let r = Ai(e, (n) => [...n, {
      id: t.id,
      dataRef: t.dataRef
    }]);
    return {
      ...e,
      ...r
    };
  },
  [6]: (e, t) => {
    let r = Ai(e, (n) => {
      let o = n.findIndex((i) => i.id === t.id);
      return o !== -1 && n.splice(o, 1), n;
    });
    return {
      ...e,
      ...r,
      activationTrigger: 1
    };
  }
}, ja = Be(null);
ja.displayName = "MenuContext";
function Jo(e) {
  let t = De(ja);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Jo), r;
  }
  return t;
}
function o1(e, t) {
  return me(t.type, r1, e, t);
}
let i1 = Ge, a1 = ve(function(e, t) {
  let r = xn(o1, {
    menuState: 1,
    buttonRef: Dn(),
    itemsRef: Dn(),
    items: [],
    searchQuery: "",
    activeItemIndex: null,
    activationTrigger: 1
  }), [{
    menuState: n,
    itemsRef: o,
    buttonRef: i
  }, a] = r, l = be(t);
  Qr([i, o], (f, v) => {
    var h;
    a({
      type: 1
    }), Jr(v, Xr.Loose) || (f.preventDefault(), (h = i.current) == null || h.focus());
  }, n === 0);
  let s = V(() => {
    a({
      type: 1
    });
  }), u = se(() => ({
    open: n === 0,
    close: s
  }), [n, s]), c = e, d = {
    ref: l
  };
  return K.createElement(ja.Provider, {
    value: r
  }, K.createElement(hr, {
    value: me(n, {
      [0]: Ye.Open,
      [1]: Ye.Closed
    })
  }, ge({
    ourProps: d,
    theirProps: c,
    slot: u,
    defaultTag: i1,
    name: "Menu"
  })));
}), l1 = "button", s1 = ve(function(e, t) {
  var r;
  let n = Pe(), {
    id: o = `headlessui-menu-button-${n}`,
    ...i
  } = e, [a, l] = Jo("Menu.Button"), s = be(a.buttonRef, t), u = bt(), c = V((m) => {
    switch (m.key) {
      case ne.Space:
      case ne.Enter:
      case ne.ArrowDown:
        m.preventDefault(), m.stopPropagation(), l({
          type: 0
        }), u.nextFrame(() => l({
          type: 2,
          focus: xe.First
        }));
        break;
      case ne.ArrowUp:
        m.preventDefault(), m.stopPropagation(), l({
          type: 0
        }), u.nextFrame(() => l({
          type: 2,
          focus: xe.Last
        }));
        break;
    }
  }), d = V((m) => {
    switch (m.key) {
      case ne.Space:
        m.preventDefault();
        break;
    }
  }), f = V((m) => {
    if (jt(m.currentTarget))
      return m.preventDefault();
    e.disabled || (a.menuState === 0 ? (l({
      type: 1
    }), u.nextFrame(() => {
      var g;
      return (g = a.buttonRef.current) == null ? void 0 : g.focus({
        preventScroll: !0
      });
    })) : (m.preventDefault(), l({
      type: 0
    })));
  }), v = se(() => ({
    open: a.menuState === 0
  }), [a]), h = {
    ref: s,
    id: o,
    type: Un(e, a.buttonRef),
    "aria-haspopup": "menu",
    "aria-controls": (r = a.itemsRef.current) == null ? void 0 : r.id,
    "aria-expanded": e.disabled ? void 0 : a.menuState === 0,
    onKeyDown: c,
    onKeyUp: d,
    onClick: f
  };
  return ge({
    ourProps: h,
    theirProps: i,
    slot: v,
    defaultTag: l1,
    name: "Menu.Button"
  });
}), u1 = "div", c1 = st.RenderStrategy | st.Static, d1 = ve(function(e, t) {
  var r, n;
  let o = Pe(), {
    id: i = `headlessui-menu-items-${o}`,
    ...a
  } = e, [l, s] = Jo("Menu.Items"), u = be(l.itemsRef, t), c = wn(l.itemsRef), d = bt(), f = rn(), v = (() => f !== null ? f === Ye.Open : l.menuState === 0)();
  Ce(() => {
    let x = l.itemsRef.current;
    !x || l.menuState === 0 && x !== (c == null ? void 0 : c.activeElement) && x.focus({
      preventScroll: !0
    });
  }, [l.menuState, l.itemsRef, c]), Pa({
    container: l.itemsRef.current,
    enabled: l.menuState === 0,
    accept(x) {
      return x.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : x.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk(x) {
      x.setAttribute("role", "none");
    }
  });
  let h = V((x) => {
    var S, w;
    switch (d.dispose(), x.key) {
      case ne.Space:
        if (l.searchQuery !== "")
          return x.preventDefault(), x.stopPropagation(), s({
            type: 3,
            value: x.key
          });
      case ne.Enter:
        if (x.preventDefault(), x.stopPropagation(), s({
          type: 1
        }), l.activeItemIndex !== null) {
          let {
            dataRef: y
          } = l.items[l.activeItemIndex];
          (w = (S = y.current) == null ? void 0 : S.domRef.current) == null || w.click();
        }
        tu(l.buttonRef.current);
        break;
      case ne.ArrowDown:
        return x.preventDefault(), x.stopPropagation(), s({
          type: 2,
          focus: xe.Next
        });
      case ne.ArrowUp:
        return x.preventDefault(), x.stopPropagation(), s({
          type: 2,
          focus: xe.Previous
        });
      case ne.Home:
      case ne.PageUp:
        return x.preventDefault(), x.stopPropagation(), s({
          type: 2,
          focus: xe.First
        });
      case ne.End:
      case ne.PageDown:
        return x.preventDefault(), x.stopPropagation(), s({
          type: 2,
          focus: xe.Last
        });
      case ne.Escape:
        x.preventDefault(), x.stopPropagation(), s({
          type: 1
        }), ht().nextFrame(() => {
          var y;
          return (y = l.buttonRef.current) == null ? void 0 : y.focus({
            preventScroll: !0
          });
        });
        break;
      case ne.Tab:
        x.preventDefault(), x.stopPropagation(), s({
          type: 1
        }), ht().nextFrame(() => {
          yd(l.buttonRef.current, x.shiftKey ? Ve.Previous : Ve.Next);
        });
        break;
      default:
        x.key.length === 1 && (s({
          type: 3,
          value: x.key
        }), d.setTimeout(() => s({
          type: 4
        }), 350));
        break;
    }
  }), m = V((x) => {
    switch (x.key) {
      case ne.Space:
        x.preventDefault();
        break;
    }
  }), g = se(() => ({
    open: l.menuState === 0
  }), [l]), C = {
    "aria-activedescendant": l.activeItemIndex === null || (r = l.items[l.activeItemIndex]) == null ? void 0 : r.id,
    "aria-labelledby": (n = l.buttonRef.current) == null ? void 0 : n.id,
    id: i,
    onKeyDown: h,
    onKeyUp: m,
    role: "menu",
    tabIndex: 0,
    ref: u
  };
  return ge({
    ourProps: C,
    theirProps: a,
    slot: g,
    defaultTag: u1,
    features: c1,
    visible: v,
    name: "Menu.Items"
  });
}), f1 = Ge, p1 = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-menu-item-${r}`,
    disabled: o = !1,
    ...i
  } = e, [a, l] = Jo("Menu.Item"), s = a.activeItemIndex !== null ? a.items[a.activeItemIndex].id === n : !1, u = oe(null), c = be(t, u);
  Oe(() => {
    if (a.menuState !== 0 || !s || a.activationTrigger === 0)
      return;
    let w = ht();
    return w.requestAnimationFrame(() => {
      var y, O;
      (O = (y = u.current) == null ? void 0 : y.scrollIntoView) == null || O.call(y, {
        block: "nearest"
      });
    }), w.dispose;
  }, [u, s, a.menuState, a.activationTrigger, a.activeItemIndex]);
  let d = oe({
    disabled: o,
    domRef: u
  });
  Oe(() => {
    d.current.disabled = o;
  }, [d, o]), Oe(() => {
    var w, y;
    d.current.textValue = (y = (w = u.current) == null ? void 0 : w.textContent) == null ? void 0 : y.toLowerCase();
  }, [d, u]), Oe(() => (l({
    type: 5,
    id: n,
    dataRef: d
  }), () => l({
    type: 6,
    id: n
  })), [d, n]);
  let f = V(() => {
    l({
      type: 1
    });
  }), v = V((w) => {
    if (o)
      return w.preventDefault();
    l({
      type: 1
    }), tu(a.buttonRef.current);
  }), h = V(() => {
    if (o)
      return l({
        type: 2,
        focus: xe.Nothing
      });
    l({
      type: 2,
      focus: xe.Specific,
      id: n
    });
  }), m = Ma(), g = V((w) => m.update(w)), C = V((w) => {
    !m.wasMoved(w) || o || s || l({
      type: 2,
      focus: xe.Specific,
      id: n,
      trigger: 0
    });
  }), x = V((w) => {
    !m.wasMoved(w) || o || !s || l({
      type: 2,
      focus: xe.Nothing
    });
  }), S = se(() => ({
    active: s,
    disabled: o,
    close: f
  }), [s, o, f]);
  return ge({
    ourProps: {
      id: n,
      ref: c,
      role: "menuitem",
      tabIndex: o === !0 ? void 0 : -1,
      "aria-disabled": o === !0 ? !0 : void 0,
      disabled: void 0,
      onClick: v,
      onFocus: h,
      onPointerEnter: g,
      onMouseEnter: g,
      onPointerMove: C,
      onMouseMove: C,
      onPointerLeave: x,
      onMouseLeave: x
    },
    theirProps: i,
    slot: S,
    defaultTag: f1,
    name: "Menu.Item"
  });
}), Fr = Object.assign(a1, {
  Button: s1,
  Items: d1,
  Item: p1
});
var g1 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(g1 || {}), v1 = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(v1 || {});
let m1 = {
  [0]: (e) => ({
    ...e,
    popoverState: me(e.popoverState, {
      [0]: 1,
      [1]: 0
    })
  }),
  [1](e) {
    return e.popoverState === 1 ? e : {
      ...e,
      popoverState: 1
    };
  },
  [2](e, t) {
    return e.button === t.button ? e : {
      ...e,
      button: t.button
    };
  },
  [3](e, t) {
    return e.buttonId === t.buttonId ? e : {
      ...e,
      buttonId: t.buttonId
    };
  },
  [4](e, t) {
    return e.panel === t.panel ? e : {
      ...e,
      panel: t.panel
    };
  },
  [5](e, t) {
    return e.panelId === t.panelId ? e : {
      ...e,
      panelId: t.panelId
    };
  }
}, Ga = Be(null);
Ga.displayName = "PopoverContext";
function Qo(e) {
  let t = De(Ga);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Qo), r;
  }
  return t;
}
let Ua = Be(null);
Ua.displayName = "PopoverAPIContext";
function Wa(e) {
  let t = De(Ua);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Wa), r;
  }
  return t;
}
let Za = Be(null);
Za.displayName = "PopoverGroupContext";
function gu() {
  return De(Za);
}
let qa = Be(null);
qa.displayName = "PopoverPanelContext";
function h1() {
  return De(qa);
}
function b1(e, t) {
  return me(t.type, m1, e, t);
}
let y1 = "div", C1 = ve(function(e, t) {
  var r;
  let n = oe(null), o = be(t, Oa((R) => {
    n.current = R;
  })), i = xn(b1, {
    popoverState: 1,
    buttons: [],
    button: null,
    buttonId: null,
    panel: null,
    panelId: null,
    beforePanelSentinel: Dn(),
    afterPanelSentinel: Dn()
  }), [{
    popoverState: a,
    button: l,
    buttonId: s,
    panel: u,
    panelId: c,
    beforePanelSentinel: d,
    afterPanelSentinel: f
  }, v] = i, h = wn((r = n.current) != null ? r : l), m = se(() => {
    if (!l || !u)
      return !1;
    for (let X of document.querySelectorAll("body > *"))
      if (Number(X == null ? void 0 : X.contains(l)) ^ Number(X == null ? void 0 : X.contains(u)))
        return !0;
    let R = Uo(), A = R.indexOf(l), L = (A + R.length - 1) % R.length, B = (A + 1) % R.length, W = R[L], U = R[B];
    return !u.contains(W) && !u.contains(U);
  }, [l, u]), g = lt(s), C = lt(c), x = se(() => ({
    buttonId: g,
    panelId: C,
    close: () => v({
      type: 1
    })
  }), [g, C, v]), S = gu(), w = S == null ? void 0 : S.registerPopover, y = V(() => {
    var R;
    return (R = S == null ? void 0 : S.isFocusWithinPopoverGroup()) != null ? R : (h == null ? void 0 : h.activeElement) && ((l == null ? void 0 : l.contains(h.activeElement)) || (u == null ? void 0 : u.contains(h.activeElement)));
  });
  Ce(() => w == null ? void 0 : w(x), [w, x]), Ko(h == null ? void 0 : h.defaultView, "focus", (R) => {
    var A, L, B, W;
    a === 0 && (y() || !l || !u || R.target !== window && ((L = (A = d.current) == null ? void 0 : A.contains) != null && L.call(A, R.target) || (W = (B = f.current) == null ? void 0 : B.contains) != null && W.call(B, R.target) || v({
      type: 1
    })));
  }, !0), Qr([l, u], (R, A) => {
    v({
      type: 1
    }), Jr(A, Xr.Loose) || (R.preventDefault(), l == null || l.focus());
  }, a === 0);
  let O = V((R) => {
    v({
      type: 1
    });
    let A = (() => R ? R instanceof HTMLElement ? R : "current" in R && R.current instanceof HTMLElement ? R.current : l : l)();
    A == null || A.focus();
  }), P = se(() => ({
    close: O,
    isPortalled: m
  }), [O, m]), M = se(() => ({
    open: a === 0,
    close: O
  }), [a, O]), I = e, k = {
    ref: o
  };
  return K.createElement(Ga.Provider, {
    value: i
  }, K.createElement(Ua.Provider, {
    value: P
  }, /* @__PURE__ */ p(hr, {
    value: me(a, {
      [0]: Ye.Open,
      [1]: Ye.Closed
    }),
    children: ge({
      ourProps: k,
      theirProps: I,
      slot: M,
      defaultTag: y1,
      name: "Popover"
    })
  })));
}), x1 = "button", w1 = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-popover-button-${r}`,
    ...o
  } = e, [i, a] = Qo("Popover.Button"), {
    isPortalled: l
  } = Wa("Popover.Button"), s = oe(null), u = `headlessui-focus-sentinel-${Pe()}`, c = gu(), d = c == null ? void 0 : c.closeOthers, f = h1(), v = f === null ? !1 : f === i.panelId;
  Ce(() => {
    if (!v)
      return a({
        type: 3,
        buttonId: n
      }), () => {
        a({
          type: 3,
          buttonId: null
        });
      };
  }, [n, a]);
  let h = be(s, t, v ? null : (R) => {
    if (R)
      i.buttons.push(n);
    else {
      let A = i.buttons.indexOf(n);
      A !== -1 && i.buttons.splice(A, 1);
    }
    i.buttons.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), R && a({
      type: 2,
      button: R
    });
  }), m = be(s, t), g = wn(s), C = V((R) => {
    var A, L, B;
    if (v) {
      if (i.popoverState === 1)
        return;
      switch (R.key) {
        case ne.Space:
        case ne.Enter:
          R.preventDefault(), (L = (A = R.target).click) == null || L.call(A), a({
            type: 1
          }), (B = i.button) == null || B.focus();
          break;
      }
    } else
      switch (R.key) {
        case ne.Space:
        case ne.Enter:
          R.preventDefault(), R.stopPropagation(), i.popoverState === 1 && (d == null || d(i.buttonId)), a({
            type: 0
          });
          break;
        case ne.Escape:
          if (i.popoverState !== 0)
            return d == null ? void 0 : d(i.buttonId);
          if (!s.current || (g == null ? void 0 : g.activeElement) && !s.current.contains(g.activeElement))
            return;
          R.preventDefault(), R.stopPropagation(), a({
            type: 1
          });
          break;
      }
  }), x = V((R) => {
    v || R.key === ne.Space && R.preventDefault();
  }), S = V((R) => {
    var A, L;
    jt(R.currentTarget) || e.disabled || (v ? (a({
      type: 1
    }), (A = i.button) == null || A.focus()) : (R.preventDefault(), R.stopPropagation(), i.popoverState === 1 && (d == null || d(i.buttonId)), a({
      type: 0
    }), (L = i.button) == null || L.focus()));
  }), w = V((R) => {
    R.preventDefault(), R.stopPropagation();
  }), y = i.popoverState === 0, O = se(() => ({
    open: y
  }), [y]), P = Un(e, s), M = v ? {
    ref: m,
    type: P,
    onKeyDown: C,
    onClick: S
  } : {
    ref: h,
    id: i.buttonId,
    type: P,
    "aria-expanded": e.disabled ? void 0 : i.popoverState === 0,
    "aria-controls": i.panel ? i.panelId : void 0,
    onKeyDown: C,
    onKeyUp: x,
    onClick: S,
    onMouseDown: w
  }, I = ka(), k = V(() => {
    let R = i.panel;
    if (!R)
      return;
    function A() {
      me(I.current, {
        [_t.Forwards]: () => ot(R, Ve.First),
        [_t.Backwards]: () => ot(R, Ve.Last)
      });
    }
    A();
  });
  return K.createElement(K.Fragment, null, ge({
    ourProps: M,
    theirProps: o,
    slot: O,
    defaultTag: x1,
    name: "Popover.Button"
  }), y && !v && l && K.createElement(Pt, {
    id: u,
    features: Ot.Focusable,
    as: "button",
    type: "button",
    onFocus: k
  }));
}), S1 = "div", R1 = st.RenderStrategy | st.Static, E1 = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-popover-overlay-${r}`,
    ...o
  } = e, [{
    popoverState: i
  }, a] = Qo("Popover.Overlay"), l = be(t), s = rn(), u = (() => s !== null ? s === Ye.Open : i === 0)(), c = V((f) => {
    if (jt(f.currentTarget))
      return f.preventDefault();
    a({
      type: 1
    });
  }), d = se(() => ({
    open: i === 0
  }), [i]);
  return ge({
    ourProps: {
      ref: l,
      id: n,
      "aria-hidden": !0,
      onClick: c
    },
    theirProps: o,
    slot: d,
    defaultTag: S1,
    features: R1,
    visible: u,
    name: "Popover.Overlay"
  });
}), O1 = "div", P1 = st.RenderStrategy | st.Static, I1 = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-popover-panel-${r}`,
    focus: o = !1,
    ...i
  } = e, [a, l] = Qo("Popover.Panel"), {
    close: s,
    isPortalled: u
  } = Wa("Popover.Panel"), c = `headlessui-focus-sentinel-before-${Pe()}`, d = `headlessui-focus-sentinel-after-${Pe()}`, f = oe(null), v = be(f, t, (P) => {
    l({
      type: 4,
      panel: P
    });
  }), h = wn(f);
  Ce(() => (l({
    type: 5,
    panelId: n
  }), () => {
    l({
      type: 5,
      panelId: null
    });
  }), [n, l]);
  let m = rn(), g = (() => m !== null ? m === Ye.Open : a.popoverState === 0)(), C = V((P) => {
    var M;
    switch (P.key) {
      case ne.Escape:
        if (a.popoverState !== 0 || !f.current || (h == null ? void 0 : h.activeElement) && !f.current.contains(h.activeElement))
          return;
        P.preventDefault(), P.stopPropagation(), l({
          type: 1
        }), (M = a.button) == null || M.focus();
        break;
    }
  });
  Ce(() => {
    var P;
    e.static || a.popoverState === 1 && ((P = e.unmount) != null ? P : !0) && l({
      type: 4,
      panel: null
    });
  }, [a.popoverState, e.unmount, e.static, l]), Ce(() => {
    if (!o || a.popoverState !== 0 || !f.current)
      return;
    let P = h == null ? void 0 : h.activeElement;
    f.current.contains(P) || ot(f.current, Ve.First);
  }, [o, f, a.popoverState]);
  let x = se(() => ({
    open: a.popoverState === 0,
    close: s
  }), [a, s]), S = {
    ref: v,
    id: a.panelId,
    onKeyDown: C,
    onBlur: o && a.popoverState === 0 ? (P) => {
      var M, I, k, R, A;
      let L = P.relatedTarget;
      !L || !f.current || (M = f.current) != null && M.contains(L) || (l({
        type: 1
      }), (((k = (I = a.beforePanelSentinel.current) == null ? void 0 : I.contains) == null ? void 0 : k.call(I, L)) || ((A = (R = a.afterPanelSentinel.current) == null ? void 0 : R.contains) == null ? void 0 : A.call(R, L))) && L.focus({
        preventScroll: !0
      }));
    } : void 0,
    tabIndex: -1
  }, w = ka(), y = V(() => {
    let P = f.current;
    if (!P)
      return;
    function M() {
      me(w.current, {
        [_t.Forwards]: () => {
          ot(P, Ve.First);
        },
        [_t.Backwards]: () => {
          var I;
          (I = a.button) == null || I.focus({
            preventScroll: !0
          });
        }
      });
    }
    M();
  }), O = V(() => {
    let P = f.current;
    if (!P)
      return;
    function M() {
      me(w.current, {
        [_t.Forwards]: () => {
          var I, k, R;
          if (!a.button)
            return;
          let A = Uo(), L = A.indexOf(a.button), B = A.slice(0, L + 1), W = [...A.slice(L + 1), ...B];
          for (let U of W.slice())
            if (((k = (I = U == null ? void 0 : U.id) == null ? void 0 : I.startsWith) == null ? void 0 : k.call(I, "headlessui-focus-sentinel-")) || ((R = a.panel) == null ? void 0 : R.contains(U))) {
              let X = W.indexOf(U);
              X !== -1 && W.splice(X, 1);
            }
          ot(W, Ve.First, {
            sorted: !1
          });
        },
        [_t.Backwards]: () => ot(P, Ve.Last)
      });
    }
    M();
  });
  return K.createElement(qa.Provider, {
    value: a.panelId
  }, g && u && K.createElement(Pt, {
    id: c,
    ref: a.beforePanelSentinel,
    features: Ot.Focusable,
    as: "button",
    type: "button",
    onFocus: y
  }), ge({
    ourProps: S,
    theirProps: i,
    slot: x,
    defaultTag: O1,
    features: P1,
    visible: g,
    name: "Popover.Panel"
  }), g && u && K.createElement(Pt, {
    id: d,
    ref: a.afterPanelSentinel,
    features: Ot.Focusable,
    as: "button",
    type: "button",
    onFocus: O
  }));
}), T1 = "div", $1 = ve(function(e, t) {
  let r = oe(null), n = be(r, t), [o, i] = $e([]), a = V((h) => {
    i((m) => {
      let g = m.indexOf(h);
      if (g !== -1) {
        let C = m.slice();
        return C.splice(g, 1), C;
      }
      return m;
    });
  }), l = V((h) => (i((m) => [...m, h]), () => a(h))), s = V(() => {
    var h;
    let m = Yt(r);
    if (!m)
      return !1;
    let g = m.activeElement;
    return (h = r.current) != null && h.contains(g) ? !0 : o.some((C) => {
      var x, S;
      return ((x = m.getElementById(C.buttonId.current)) == null ? void 0 : x.contains(g)) || ((S = m.getElementById(C.panelId.current)) == null ? void 0 : S.contains(g));
    });
  }), u = V((h) => {
    for (let m of o)
      m.buttonId.current !== h && m.close();
  }), c = se(() => ({
    registerPopover: l,
    unregisterPopover: a,
    isFocusWithinPopoverGroup: s,
    closeOthers: u
  }), [l, a, s, u]), d = se(() => ({}), []), f = e, v = {
    ref: n
  };
  return K.createElement(Za.Provider, {
    value: c
  }, ge({
    ourProps: v,
    theirProps: f,
    slot: d,
    defaultTag: T1,
    name: "Popover.Group"
  }));
}), ki = Object.assign(C1, {
  Button: w1,
  Overlay: E1,
  Panel: I1,
  Group: $1
});
function M1(e = 0) {
  let [t, r] = $e(e), n = gt((l) => r((s) => s | l), [t]), o = gt((l) => Boolean(t & l), [t]), i = gt((l) => r((s) => s & ~l), [r]), a = gt((l) => r((s) => s ^ l), [r]);
  return { addFlag: n, hasFlag: o, removeFlag: i, toggleFlag: a };
}
let vu = Be(null);
function mu() {
  let e = De(vu);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, mu), t;
  }
  return e;
}
function Ya() {
  let [e, t] = $e([]);
  return [e.length > 0 ? e.join(" ") : void 0, se(() => function(r) {
    let n = V((i) => (t((a) => [...a, i]), () => t((a) => {
      let l = a.slice(), s = l.indexOf(i);
      return s !== -1 && l.splice(s, 1), l;
    }))), o = se(() => ({
      register: n,
      slot: r.slot,
      name: r.name,
      props: r.props
    }), [n, r.slot, r.name, r.props]);
    return K.createElement(vu.Provider, {
      value: o
    }, r.children);
  }, [t])];
}
let L1 = "label", hu = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-label-${r}`,
    passive: o = !1,
    ...i
  } = e, a = mu(), l = be(t);
  Oe(() => a.register(n), [n, a.register]);
  let s = {
    ref: l,
    ...a.props,
    id: n
  };
  return o && ("onClick" in s && delete s.onClick, "onClick" in i && delete i.onClick), ge({
    ourProps: s,
    theirProps: i,
    slot: a.slot || {},
    defaultTag: L1,
    name: a.name || "Label"
  });
});
var A1 = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(A1 || {});
let k1 = {
  [0](e, t) {
    let r = [...e.options, {
      id: t.id,
      element: t.element,
      propsRef: t.propsRef
    }];
    return {
      ...e,
      options: Hn(r, (n) => n.element.current)
    };
  },
  [1](e, t) {
    let r = e.options.slice(), n = e.options.findIndex((o) => o.id === t.id);
    return n === -1 ? e : (r.splice(n, 1), {
      ...e,
      options: r
    });
  }
}, Ka = Be(null);
Ka.displayName = "RadioGroupDataContext";
function bu(e) {
  let t = De(Ka);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, bu), r;
  }
  return t;
}
let Xa = Be(null);
Xa.displayName = "RadioGroupActionsContext";
function yu(e) {
  let t = De(Xa);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, yu), r;
  }
  return t;
}
function _1(e, t) {
  return me(t.type, k1, e, t);
}
let F1 = "div", N1 = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-radiogroup-${r}`,
    value: o,
    defaultValue: i,
    name: a,
    onChange: l,
    by: s = (D, le) => D === le,
    disabled: u = !1,
    ...c
  } = e, d = V(typeof s == "string" ? (D, le) => {
    let T = s;
    return (D == null ? void 0 : D[T]) === (le == null ? void 0 : le[T]);
  } : s), [f, v] = xn(_1, {
    options: []
  }), h = f.options, [m, g] = Ya(), [C, x] = Xo(), S = oe(null), w = be(S, t), [y, O] = Zo(o, l, i), P = se(() => h.find((D) => !D.propsRef.current.disabled), [h]), M = se(() => h.some((D) => d(D.propsRef.current.value, y)), [h, y]), I = V((D) => {
    var le;
    if (u || d(D, y))
      return !1;
    let T = (le = h.find((j) => d(j.propsRef.current.value, D))) == null ? void 0 : le.propsRef.current;
    return T != null && T.disabled ? !1 : (O == null || O(D), !0);
  });
  Pa({
    container: S.current,
    accept(D) {
      return D.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : D.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk(D) {
      D.setAttribute("role", "none");
    }
  });
  let k = V((D) => {
    let le = S.current;
    if (!le)
      return;
    let T = Yt(le), j = h.filter((z) => z.propsRef.current.disabled === !1).map((z) => z.element.current);
    switch (D.key) {
      case ne.Enter:
        au(D.currentTarget);
        break;
      case ne.ArrowLeft:
      case ne.ArrowUp:
        if (D.preventDefault(), D.stopPropagation(), ot(j, Ve.Previous | Ve.WrapAround) === gn.Success) {
          let z = h.find((_) => _.element.current === (T == null ? void 0 : T.activeElement));
          z && I(z.propsRef.current.value);
        }
        break;
      case ne.ArrowRight:
      case ne.ArrowDown:
        if (D.preventDefault(), D.stopPropagation(), ot(j, Ve.Next | Ve.WrapAround) === gn.Success) {
          let z = h.find((_) => _.element.current === (T == null ? void 0 : T.activeElement));
          z && I(z.propsRef.current.value);
        }
        break;
      case ne.Space:
        {
          D.preventDefault(), D.stopPropagation();
          let z = h.find((_) => _.element.current === (T == null ? void 0 : T.activeElement));
          z && I(z.propsRef.current.value);
        }
        break;
    }
  }), R = V((D) => (v({
    type: 0,
    ...D
  }), () => v({
    type: 1,
    id: D.id
  }))), A = se(() => ({
    value: y,
    firstOption: P,
    containsCheckedOption: M,
    disabled: u,
    compare: d,
    ...f
  }), [y, P, M, u, d, f]), L = se(() => ({
    registerOption: R,
    change: I
  }), [R, I]), B = {
    ref: w,
    id: n,
    role: "radiogroup",
    "aria-labelledby": m,
    "aria-describedby": C,
    onKeyDown: k
  }, W = se(() => ({
    value: y
  }), [y]), U = oe(null), X = bt();
  return Ce(() => {
    !U.current || i !== void 0 && X.addEventListener(U.current, "reset", () => {
      I(i);
    });
  }, [U, I]), K.createElement(x, {
    name: "RadioGroup.Description"
  }, K.createElement(g, {
    name: "RadioGroup.Label"
  }, K.createElement(Xa.Provider, {
    value: L
  }, K.createElement(Ka.Provider, {
    value: A
  }, a != null && y != null && Wo({
    [a]: y
  }).map(([D, le], T) => K.createElement(Pt, {
    features: Ot.Hidden,
    ref: T === 0 ? (j) => {
      var z;
      U.current = (z = j == null ? void 0 : j.closest("form")) != null ? z : null;
    } : void 0,
    ...lr({
      key: D,
      as: "input",
      type: "radio",
      checked: le != null,
      hidden: !0,
      readOnly: !0,
      name: D,
      value: le
    })
  })), ge({
    ourProps: B,
    theirProps: c,
    slot: W,
    defaultTag: F1,
    name: "RadioGroup"
  })))));
});
var V1 = ((e) => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(V1 || {});
let D1 = "div", H1 = ve(function(e, t) {
  var r;
  let n = Pe(), {
    id: o = `headlessui-radiogroup-option-${n}`,
    value: i,
    disabled: a = !1,
    ...l
  } = e, s = oe(null), u = be(s, t), [c, d] = Ya(), [f, v] = Xo(), {
    addFlag: h,
    removeFlag: m,
    hasFlag: g
  } = M1(1), C = lt({
    value: i,
    disabled: a
  }), x = bu("RadioGroup.Option"), S = yu("RadioGroup.Option");
  Oe(() => S.registerOption({
    id: o,
    element: s,
    propsRef: C
  }), [o, S, s, e]);
  let w = V((A) => {
    var L;
    if (jt(A.currentTarget))
      return A.preventDefault();
    !S.change(i) || (h(2), (L = s.current) == null || L.focus());
  }), y = V((A) => {
    if (jt(A.currentTarget))
      return A.preventDefault();
    h(2);
  }), O = V(() => m(2)), P = ((r = x.firstOption) == null ? void 0 : r.id) === o, M = x.disabled || a, I = x.compare(x.value, i), k = {
    ref: u,
    id: o,
    role: "radio",
    "aria-checked": I ? "true" : "false",
    "aria-labelledby": c,
    "aria-describedby": f,
    "aria-disabled": M ? !0 : void 0,
    tabIndex: (() => M ? -1 : I || !x.containsCheckedOption && P ? 0 : -1)(),
    onClick: M ? void 0 : w,
    onFocus: M ? void 0 : y,
    onBlur: M ? void 0 : O
  }, R = se(() => ({
    checked: I,
    disabled: M,
    active: g(2)
  }), [I, M, g]);
  return K.createElement(v, {
    name: "RadioGroup.Description"
  }, /* @__PURE__ */ p(d, {
    name: "RadioGroup.Label",
    children: ge({
      ourProps: k,
      theirProps: l,
      slot: R,
      defaultTag: D1,
      name: "RadioGroup.Option"
    })
  }));
}), _i = Object.assign(N1, {
  Option: H1,
  Label: hu,
  Description: _a
}), Ja = Be(null);
Ja.displayName = "GroupContext";
let z1 = Ge;
function B1(e) {
  let [t, r] = $e(null), [n, o] = Ya(), [i, a] = Xo(), l = se(() => ({
    switch: t,
    setSwitch: r,
    labelledby: n,
    describedby: i
  }), [t, r, n, i]), s = {}, u = e;
  return K.createElement(a, {
    name: "Switch.Description"
  }, K.createElement(o, {
    name: "Switch.Label",
    props: {
      onClick() {
        !t || (t.click(), t.focus({
          preventScroll: !0
        }));
      }
    }
  }, K.createElement(Ja.Provider, {
    value: l
  }, ge({
    ourProps: s,
    theirProps: u,
    defaultTag: z1,
    name: "Switch.Group"
  }))));
}
let j1 = "button", G1 = ve(function(e, t) {
  let r = Pe(), {
    id: n = `headlessui-switch-${r}`,
    checked: o,
    defaultChecked: i = !1,
    onChange: a,
    name: l,
    value: s,
    ...u
  } = e, c = De(Ja), d = oe(null), f = be(d, t, c === null ? null : c.setSwitch), [v, h] = Zo(o, a, i), m = V(() => h == null ? void 0 : h(!v)), g = V((O) => {
    if (jt(O.currentTarget))
      return O.preventDefault();
    O.preventDefault(), m();
  }), C = V((O) => {
    O.key === ne.Space ? (O.preventDefault(), m()) : O.key === ne.Enter && au(O.currentTarget);
  }), x = V((O) => O.preventDefault()), S = se(() => ({
    checked: v
  }), [v]), w = {
    id: n,
    ref: f,
    role: "switch",
    type: Un(e, d),
    tabIndex: 0,
    "aria-checked": v,
    "aria-labelledby": c == null ? void 0 : c.labelledby,
    "aria-describedby": c == null ? void 0 : c.describedby,
    onClick: g,
    onKeyUp: C,
    onKeyPress: x
  }, y = bt();
  return Ce(() => {
    var O;
    let P = (O = d.current) == null ? void 0 : O.closest("form");
    !P || i !== void 0 && y.addEventListener(P, "reset", () => {
      h(i);
    });
  }, [d, h]), K.createElement(K.Fragment, null, l != null && v && K.createElement(Pt, {
    features: Ot.Hidden,
    ...lr({
      as: "input",
      type: "checkbox",
      hidden: !0,
      readOnly: !0,
      checked: v,
      name: l,
      value: s
    })
  }), ge({
    ourProps: w,
    theirProps: u,
    slot: S,
    defaultTag: j1,
    name: "Switch"
  }));
}), U1 = Object.assign(G1, {
  Group: B1,
  Label: hu,
  Description: _a
});
function W1({
  onFocus: e
}) {
  let [t, r] = $e(!0);
  return t ? K.createElement(Pt, {
    as: "button",
    type: "button",
    features: Ot.Focusable,
    onFocus: (n) => {
      n.preventDefault();
      let o, i = 50;
      function a() {
        if (i-- <= 0) {
          o && cancelAnimationFrame(o);
          return;
        }
        if (e()) {
          r(!1), cancelAnimationFrame(o);
          return;
        }
        o = requestAnimationFrame(a);
      }
      o = requestAnimationFrame(a);
    }
  }) : null;
}
var Z1 = ((e) => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(Z1 || {});
let q1 = {
  [0](e, t) {
    let r = e.tabs.filter((i) => {
      var a;
      return !((a = i.current) != null && a.hasAttribute("disabled"));
    });
    if (t.index < 0)
      return {
        ...e,
        selectedIndex: e.tabs.indexOf(r[0])
      };
    if (t.index > e.tabs.length)
      return {
        ...e,
        selectedIndex: e.tabs.indexOf(r[r.length - 1])
      };
    let n = e.tabs.slice(0, t.index), o = [...e.tabs.slice(t.index), ...n].find((i) => r.includes(i));
    return o ? {
      ...e,
      selectedIndex: e.tabs.indexOf(o)
    } : e;
  },
  [1](e, t) {
    var r;
    if (e.tabs.includes(t.tab))
      return e;
    let n = e.tabs[e.selectedIndex], o = Hn([...e.tabs, t.tab], (a) => a.current), i = (r = o.indexOf(n)) != null ? r : e.selectedIndex;
    return i === -1 && (i = e.selectedIndex), {
      ...e,
      tabs: o,
      selectedIndex: i
    };
  },
  [2](e, t) {
    return {
      ...e,
      tabs: e.tabs.filter((r) => r !== t.tab)
    };
  },
  [3](e, t) {
    return e.panels.includes(t.panel) ? e : {
      ...e,
      panels: Hn([...e.panels, t.panel], (r) => r.current)
    };
  },
  [4](e, t) {
    return {
      ...e,
      panels: e.panels.filter((r) => r !== t.panel)
    };
  }
}, Qa = Be(null);
Qa.displayName = "TabsSSRContext";
function el(e) {
  let t = De(Qa);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, el), r;
  }
  return t;
}
let tl = Be(null);
tl.displayName = "TabsDataContext";
function sr(e) {
  let t = De(tl);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, sr), r;
  }
  return t;
}
let nl = Be(null);
nl.displayName = "TabsActionsContext";
function rl(e) {
  let t = De(nl);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, rl), r;
  }
  return t;
}
function Y1(e, t) {
  return me(t.type, q1, e, t);
}
let K1 = Ge, X1 = ve(function(e, t) {
  let {
    defaultIndex: r = 0,
    vertical: n = !1,
    manual: o = !1,
    onChange: i,
    selectedIndex: a = null,
    ...l
  } = e;
  const s = n ? "vertical" : "horizontal", u = o ? "manual" : "auto";
  let c = a !== null, d = be(t), [f, v] = xn(Y1, {
    selectedIndex: a != null ? a : r,
    tabs: [],
    panels: []
  }), h = se(() => ({
    selectedIndex: f.selectedIndex
  }), [f.selectedIndex]), m = lt(i || (() => {
  })), g = lt(f.tabs), C = se(() => ({
    orientation: s,
    activation: u,
    ...f
  }), [s, u, f]), x = V((I) => (v({
    type: 1,
    tab: I
  }), () => v({
    type: 2,
    tab: I
  }))), S = V((I) => (v({
    type: 3,
    panel: I
  }), () => v({
    type: 4,
    panel: I
  }))), w = V((I) => {
    y.current !== I && m.current(I), c || v({
      type: 0,
      index: I
    });
  }), y = lt(c ? e.selectedIndex : f.selectedIndex), O = se(() => ({
    registerTab: x,
    registerPanel: S,
    change: w
  }), []);
  Oe(() => {
    v({
      type: 0,
      index: a != null ? a : r
    });
  }, [a]);
  let P = oe({
    tabs: [],
    panels: []
  }), M = {
    ref: d
  };
  return K.createElement(Qa.Provider, {
    value: P
  }, /* @__PURE__ */ p(nl.Provider, {
    value: O,
    children: /* @__PURE__ */ G(tl.Provider, {
      value: C,
      children: [C.tabs.length <= 0 && K.createElement(W1, {
        onFocus: () => {
          var I, k;
          for (let R of g.current)
            if (((I = R.current) == null ? void 0 : I.tabIndex) === 0)
              return (k = R.current) == null || k.focus(), !0;
          return !1;
        }
      }), ge({
        ourProps: M,
        theirProps: l,
        slot: h,
        defaultTag: K1,
        name: "Tabs"
      })]
    })
  }));
}), J1 = "div", Q1 = ve(function(e, t) {
  let {
    orientation: r,
    selectedIndex: n
  } = sr("Tab.List"), o = be(t);
  return ge({
    ourProps: {
      ref: o,
      role: "tablist",
      "aria-orientation": r
    },
    theirProps: e,
    slot: {
      selectedIndex: n
    },
    defaultTag: J1,
    name: "Tabs.List"
  });
}), ep = "button", tp = ve(function(e, t) {
  var r, n;
  let o = Pe(), {
    id: i = `headlessui-tabs-tab-${o}`,
    ...a
  } = e, {
    orientation: l,
    activation: s,
    selectedIndex: u,
    tabs: c,
    panels: d
  } = sr("Tab"), f = rl("Tab"), v = sr("Tab"), h = el("Tab"), m = oe(null), g = be(m, t);
  Oe(() => f.registerTab(m), [f, m]);
  let C = h.current.tabs.indexOf(i);
  C === -1 && (C = h.current.tabs.push(i) - 1);
  let x = c.indexOf(m);
  x === -1 && (x = C);
  let S = x === u, w = V((R) => {
    var A;
    let L = R();
    if (L === gn.Success && s === "auto") {
      let B = (A = Yt(m)) == null ? void 0 : A.activeElement, W = v.tabs.findIndex((U) => U.current === B);
      W !== -1 && f.change(W);
    }
    return L;
  }), y = V((R) => {
    let A = c.map((L) => L.current).filter(Boolean);
    if (R.key === ne.Space || R.key === ne.Enter) {
      R.preventDefault(), R.stopPropagation(), f.change(x);
      return;
    }
    switch (R.key) {
      case ne.Home:
      case ne.PageUp:
        return R.preventDefault(), R.stopPropagation(), w(() => ot(A, Ve.First));
      case ne.End:
      case ne.PageDown:
        return R.preventDefault(), R.stopPropagation(), w(() => ot(A, Ve.Last));
    }
    if (w(() => me(l, {
      vertical() {
        return R.key === ne.ArrowUp ? ot(A, Ve.Previous | Ve.WrapAround) : R.key === ne.ArrowDown ? ot(A, Ve.Next | Ve.WrapAround) : gn.Error;
      },
      horizontal() {
        return R.key === ne.ArrowLeft ? ot(A, Ve.Previous | Ve.WrapAround) : R.key === ne.ArrowRight ? ot(A, Ve.Next | Ve.WrapAround) : gn.Error;
      }
    })) === gn.Success)
      return R.preventDefault();
  }), O = oe(!1), P = V(() => {
    var R;
    O.current || (O.current = !0, (R = m.current) == null || R.focus(), f.change(x), Kr(() => {
      O.current = !1;
    }));
  }), M = V((R) => {
    R.preventDefault();
  }), I = se(() => ({
    selected: S
  }), [S]), k = {
    ref: g,
    onKeyDown: y,
    onMouseDown: M,
    onClick: P,
    id: i,
    role: "tab",
    type: Un(e, m),
    "aria-controls": (n = (r = d[x]) == null ? void 0 : r.current) == null ? void 0 : n.id,
    "aria-selected": S,
    tabIndex: S ? 0 : -1
  };
  return ge({
    ourProps: k,
    theirProps: a,
    slot: I,
    defaultTag: ep,
    name: "Tabs.Tab"
  });
}), np = "div", rp = ve(function(e, t) {
  let {
    selectedIndex: r
  } = sr("Tab.Panels"), n = be(t), o = se(() => ({
    selectedIndex: r
  }), [r]);
  return ge({
    ourProps: {
      ref: n
    },
    theirProps: e,
    slot: o,
    defaultTag: np,
    name: "Tabs.Panels"
  });
}), op = "div", ip = st.RenderStrategy | st.Static, ap = ve(function(e, t) {
  var r, n, o, i;
  let a = Pe(), {
    id: l = `headlessui-tabs-panel-${a}`,
    ...s
  } = e, {
    selectedIndex: u,
    tabs: c,
    panels: d
  } = sr("Tab.Panel"), f = rl("Tab.Panel"), v = el("Tab.Panel"), h = oe(null), m = be(h, t);
  Oe(() => f.registerPanel(h), [f, h]);
  let g = v.current.panels.indexOf(l);
  g === -1 && (g = v.current.panels.push(l) - 1);
  let C = d.indexOf(h);
  C === -1 && (C = g);
  let x = C === u, S = se(() => ({
    selected: x
  }), [x]), w = {
    ref: m,
    id: l,
    role: "tabpanel",
    "aria-labelledby": (n = (r = c[C]) == null ? void 0 : r.current) == null ? void 0 : n.id,
    tabIndex: x ? 0 : -1
  };
  return !x && ((o = s.unmount) != null ? o : !0) && !((i = s.static) != null && i) ? K.createElement(Pt, {
    as: "span",
    ...w
  }) : ge({
    ourProps: w,
    theirProps: s,
    slot: S,
    defaultTag: op,
    features: ip,
    visible: x,
    name: "Tabs.Panel"
  });
}), na = Object.assign(tp, {
  Group: X1,
  List: Q1,
  Panels: rp,
  Panel: ap
});
function lp(e) {
  let t = { called: !1 };
  return (...r) => {
    if (!t.called)
      return t.called = !0, e(...r);
  };
}
function Fi(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function Ni(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
function sp(e, t) {
  let r = ht();
  if (!e)
    return r.dispose;
  let { transitionDuration: n, transitionDelay: o } = getComputedStyle(e), [i, a] = [n, o].map((l) => {
    let [s = 0] = l.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, c) => c - u);
    return s;
  });
  if (i + a !== 0) {
    let l = r.addEventListener(e, "transitionend", (s) => {
      s.target === s.currentTarget && (t(), l());
    });
  } else
    t();
  return r.add(() => t()), r.dispose;
}
function up(e, t, r, n) {
  let o = r ? "enter" : "leave", i = ht(), a = n !== void 0 ? lp(n) : () => {
  };
  o === "enter" && (e.removeAttribute("hidden"), e.style.display = "");
  let l = me(o, { enter: () => t.enter, leave: () => t.leave }), s = me(o, { enter: () => t.enterTo, leave: () => t.leaveTo }), u = me(o, { enter: () => t.enterFrom, leave: () => t.leaveFrom });
  return Ni(e, ...t.enter, ...t.enterTo, ...t.enterFrom, ...t.leave, ...t.leaveFrom, ...t.leaveTo, ...t.entered), Fi(e, ...l, ...u), i.nextFrame(() => {
    Ni(e, ...u), Fi(e, ...s), sp(e, () => (Ni(e, ...l), Fi(e, ...t.entered), a()));
  }), i.dispose;
}
function cp({ container: e, direction: t, classes: r, onStart: n, onStop: o }) {
  let i = Yo(), a = bt(), l = lt(t);
  Oe(() => {
    let s = ht();
    a.add(s.dispose);
    let u = e.current;
    if (!!u && l.current !== "idle" && !!i.current)
      return s.dispose(), n.current(l.current), s.add(up(u, r.current, l.current === "enter", () => {
        s.dispose(), o.current(l.current);
      })), s.dispose;
  }, [t]);
}
function dp(...e) {
  return e.filter(Boolean).join(" ");
}
function Tn(e = "") {
  return e.split(" ").filter((t) => t.trim().length > 1);
}
let ei = Be(null);
ei.displayName = "TransitionContext";
var fp = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(fp || {});
function pp() {
  let e = De(ei);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function gp() {
  let e = De(ti);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let ti = Be(null);
ti.displayName = "NestingContext";
function ni(e) {
  return "children" in e ? ni(e.children) : e.current.filter(({
    el: t
  }) => t.current !== null).filter(({
    state: t
  }) => t === "visible").length > 0;
}
function Cu(e, t) {
  let r = lt(e), n = oe([]), o = Yo(), i = bt(), a = V((v, h = en.Hidden) => {
    let m = n.current.findIndex(({
      el: g
    }) => g === v);
    m !== -1 && (me(h, {
      [en.Unmount]() {
        n.current.splice(m, 1);
      },
      [en.Hidden]() {
        n.current[m].state = "hidden";
      }
    }), i.microTask(() => {
      var g;
      !ni(n) && o.current && ((g = r.current) == null || g.call(r));
    }));
  }), l = V((v) => {
    let h = n.current.find(({
      el: m
    }) => m === v);
    return h ? h.state !== "visible" && (h.state = "visible") : n.current.push({
      el: v,
      state: "visible"
    }), () => a(v, en.Unmount);
  }), s = oe([]), u = oe(Promise.resolve()), c = oe({
    enter: [],
    leave: [],
    idle: []
  }), d = V((v, h, m) => {
    s.current.splice(0), t && (t.chains.current[h] = t.chains.current[h].filter(([g]) => g !== v)), t == null || t.chains.current[h].push([v, new Promise((g) => {
      s.current.push(g);
    })]), t == null || t.chains.current[h].push([v, new Promise((g) => {
      Promise.all(c.current[h].map(([C, x]) => x)).then(() => g());
    })]), h === "enter" ? u.current = u.current.then(() => t == null ? void 0 : t.wait.current).then(() => m(h)) : m(h);
  }), f = V((v, h, m) => {
    Promise.all(c.current[h].splice(0).map(([g, C]) => C)).then(() => {
      var g;
      (g = s.current.shift()) == null || g();
    }).then(() => m(h));
  });
  return se(() => ({
    children: n,
    register: l,
    unregister: a,
    onStart: d,
    onStop: f,
    wait: u,
    chains: c
  }), [l, a, n, d, f, c, u]);
}
function vp() {
}
let mp = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function Bl(e) {
  var t;
  let r = {};
  for (let n of mp)
    r[n] = (t = e[n]) != null ? t : vp;
  return r;
}
function hp(e) {
  let t = oe(Bl(e));
  return Ce(() => {
    t.current = Bl(e);
  }, [e]), t;
}
let bp = "div", xu = st.RenderStrategy, wu = ve(function(e, t) {
  let {
    beforeEnter: r,
    afterEnter: n,
    beforeLeave: o,
    afterLeave: i,
    enter: a,
    enterFrom: l,
    enterTo: s,
    entered: u,
    leave: c,
    leaveFrom: d,
    leaveTo: f,
    ...v
  } = e, h = oe(null), m = be(h, t), g = v.unmount ? en.Unmount : en.Hidden, {
    show: C,
    appear: x,
    initial: S
  } = pp(), [w, y] = $e(C ? "visible" : "hidden"), O = gp(), {
    register: P,
    unregister: M
  } = O, I = oe(null);
  Ce(() => P(h), [P, h]), Ce(() => {
    if (g === en.Hidden && !!h.current) {
      if (C && w !== "visible") {
        y("visible");
        return;
      }
      return me(w, {
        hidden: () => M(h),
        visible: () => P(h)
      });
    }
  }, [w, h, P, M, C, g]);
  let k = lt({
    enter: Tn(a),
    enterFrom: Tn(l),
    enterTo: Tn(s),
    entered: Tn(u),
    leave: Tn(c),
    leaveFrom: Tn(d),
    leaveTo: Tn(f)
  }), R = hp({
    beforeEnter: r,
    afterEnter: n,
    beforeLeave: o,
    afterLeave: i
  }), A = mr();
  Ce(() => {
    if (A && w === "visible" && h.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [h, w, A]);
  let L = S && !x, B = (() => !A || L || I.current === C ? "idle" : C ? "enter" : "leave")(), W = V((T) => me(T, {
    enter: () => R.current.beforeEnter(),
    leave: () => R.current.beforeLeave(),
    idle: () => {
    }
  })), U = V((T) => me(T, {
    enter: () => R.current.afterEnter(),
    leave: () => R.current.afterLeave(),
    idle: () => {
    }
  })), X = Cu(() => {
    y("hidden"), M(h);
  }, O);
  cp({
    container: h,
    classes: k,
    direction: B,
    onStart: lt((T) => {
      X.onStart(h, T, W);
    }),
    onStop: lt((T) => {
      X.onStop(h, T, U), T === "leave" && !ni(X) && (y("hidden"), M(h));
    })
  }), Ce(() => {
    !L || (g === en.Hidden ? I.current = null : I.current = C);
  }, [C, L, w]);
  let D = v, le = {
    ref: m
  };
  return x && C && (typeof window > "u" || typeof document > "u") && (D = {
    ...D,
    className: dp(v.className, ...k.current.enter, ...k.current.enterFrom)
  }), /* @__PURE__ */ p(ti.Provider, {
    value: X,
    children: /* @__PURE__ */ p(hr, {
      value: me(w, {
        visible: Ye.Open,
        hidden: Ye.Closed
      }),
      children: ge({
        ourProps: le,
        theirProps: D,
        defaultTag: bp,
        features: xu,
        visible: w === "visible",
        name: "Transition.Child"
      })
    })
  });
}), ra = ve(function(e, t) {
  let {
    show: r,
    appear: n = !1,
    unmount: o,
    ...i
  } = e, a = oe(null), l = be(a, t);
  mr();
  let s = rn();
  if (r === void 0 && s !== null && (r = me(s, {
    [Ye.Open]: !0,
    [Ye.Closed]: !1
  })), ![!0, !1].includes(r))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [u, c] = $e(r ? "visible" : "hidden"), d = Cu(() => {
    c("hidden");
  }), [f, v] = $e(!0), h = oe([r]);
  Oe(() => {
    f !== !1 && h.current[h.current.length - 1] !== r && (h.current.push(r), v(!1));
  }, [h, r]);
  let m = se(() => ({
    show: r,
    appear: n,
    initial: f
  }), [r, n, f]);
  Ce(() => {
    if (r)
      c("visible");
    else if (!ni(d))
      c("hidden");
    else {
      let C = a.current;
      if (!C)
        return;
      let x = C.getBoundingClientRect();
      x.x === 0 && x.y === 0 && x.width === 0 && x.height === 0 && c("hidden");
    }
  }, [r, d]);
  let g = {
    unmount: o
  };
  return /* @__PURE__ */ p(ti.Provider, {
    value: d,
    children: /* @__PURE__ */ p(ei.Provider, {
      value: m,
      children: ge({
        ourProps: {
          ...g,
          as: Ge,
          children: K.createElement(wu, {
            ref: l,
            ...g,
            ...i
          })
        },
        theirProps: {},
        defaultTag: Ge,
        features: xu,
        visible: u === "visible",
        name: "Transition"
      })
    })
  });
}), yp = ve(function(e, t) {
  let r = De(ei) !== null, n = rn() !== null;
  return /* @__PURE__ */ p(It, {
    children: !r && n ? /* @__PURE__ */ p(ra, {
      ref: t,
      ...e
    }) : K.createElement(wu, {
      ref: t,
      ...e
    })
  });
}), hn = Object.assign(ra, {
  Child: yp,
  Root: ra
});
function Su(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (r = Su(e[t])) && (n && (n += " "), n += r);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function q() {
  for (var e, t, r = 0, n = ""; r < arguments.length; )
    (e = arguments[r++]) && (t = Su(e)) && (n && (n += " "), n += t);
  return n;
}
const Vt = Symbol("@ts-pattern/matcher"), Po = "@ts-pattern/anonymous-select-key", oa = (e) => Boolean(e && typeof e == "object"), xo = (e) => e && !!e[Vt], Ft = (e, t, r) => {
  if (oa(e)) {
    if (xo(e)) {
      const n = e[Vt](), { matched: o, selections: i } = n.match(t);
      return o && i && Object.keys(i).forEach((a) => r(a, i[a])), o;
    }
    if (!oa(t))
      return !1;
    if (Array.isArray(e))
      return !!Array.isArray(t) && e.length === t.length && e.every((n, o) => Ft(n, t[o], r));
    if (e instanceof Map)
      return t instanceof Map && Array.from(e.keys()).every((n) => Ft(e.get(n), t.get(n), r));
    if (e instanceof Set) {
      if (!(t instanceof Set))
        return !1;
      if (e.size === 0)
        return t.size === 0;
      if (e.size === 1) {
        const [n] = Array.from(e.values());
        return xo(n) ? Array.from(t.values()).every((o) => Ft(n, o, r)) : t.has(n);
      }
      return Array.from(e.values()).every((n) => t.has(n));
    }
    return Object.keys(e).every((n) => {
      const o = e[n];
      return (n in t || xo(i = o) && i[Vt]().matcherType === "optional") && Ft(o, t[n], r);
      var i;
    });
  }
  return Object.is(t, e);
}, Gt = (e) => {
  var t, r, n;
  return oa(e) ? xo(e) ? (t = (r = (n = e[Vt]()).getSelectionKeys) == null ? void 0 : r.call(n)) != null ? t : [] : Array.isArray(e) ? Br(e, Gt) : Br(Object.values(e), Gt) : [];
}, Br = (e, t) => e.reduce((r, n) => r.concat(t(n)), []);
function jl(e) {
  return { [Vt]: () => ({ match: (t) => {
    let r = {};
    const n = (o, i) => {
      r[o] = i;
    };
    return t === void 0 ? (Gt(e).forEach((o) => n(o, void 0)), { matched: !0, selections: r }) : { matched: Ft(e, t, n), selections: r };
  }, getSelectionKeys: () => Gt(e), matcherType: "optional" }) };
}
function Gl(e) {
  return { [Vt]: () => ({ match: (t) => {
    if (!Array.isArray(t))
      return { matched: !1 };
    let r = {};
    if (t.length === 0)
      return Gt(e).forEach((o) => {
        r[o] = [];
      }), { matched: !0, selections: r };
    const n = (o, i) => {
      r[o] = (r[o] || []).concat([i]);
    };
    return { matched: t.every((o) => Ft(e, o, n)), selections: r };
  }, getSelectionKeys: () => Gt(e) }) };
}
function Ul(...e) {
  return { [Vt]: () => ({ match: (t) => {
    let r = {};
    const n = (o, i) => {
      r[o] = i;
    };
    return { matched: e.every((o) => Ft(o, t, n)), selections: r };
  }, getSelectionKeys: () => Br(e, Gt), matcherType: "and" }) };
}
function Wl(...e) {
  return { [Vt]: () => ({ match: (t) => {
    let r = {};
    const n = (o, i) => {
      r[o] = i;
    };
    return Br(e, Gt).forEach((o) => n(o, void 0)), { matched: e.some((o) => Ft(o, t, n)), selections: r };
  }, getSelectionKeys: () => Br(e, Gt), matcherType: "or" }) };
}
function Zl(e) {
  return { [Vt]: () => ({ match: (t) => ({ matched: !Ft(e, t, () => {
  }) }), getSelectionKeys: () => [], matcherType: "not" }) };
}
function Bt(e) {
  return { [Vt]: () => ({ match: (t) => ({ matched: Boolean(e(t)) }) }) };
}
function ql(...e) {
  const t = typeof e[0] == "string" ? e[0] : void 0, r = e.length === 2 ? e[1] : typeof e[0] == "string" ? void 0 : e[0];
  return { [Vt]: () => ({ match: (n) => {
    let o = { [t != null ? t : Po]: n };
    return { matched: r === void 0 || Ft(r, n, (i, a) => {
      o[i] = a;
    }), selections: o };
  }, getSelectionKeys: () => [t != null ? t : Po].concat(r === void 0 ? [] : Gt(r)) }) };
}
const Ru = Bt(function(e) {
  return !0;
}), Cp = Ru, xp = Bt(function(e) {
  return typeof e == "string";
}), wp = Bt(function(e) {
  return typeof e == "number";
}), Sp = Bt(function(e) {
  return typeof e == "boolean";
}), Rp = Bt(function(e) {
  return typeof e == "bigint";
}), Ep = Bt(function(e) {
  return typeof e == "symbol";
}), Op = Bt(function(e) {
  return e == null;
});
var Qt = { __proto__: null, optional: jl, array: Gl, intersection: Ul, union: Wl, not: Zl, when: Bt, select: ql, any: Ru, _: Cp, string: xp, number: wp, boolean: Sp, bigint: Rp, symbol: Ep, nullish: Op, instanceOf: function(e) {
  return Bt(function(t) {
    return (r) => r instanceof t;
  }(e));
}, typed: function() {
  return { array: Gl, optional: jl, intersection: Ul, union: Wl, not: Zl, select: ql, when: Bt };
} };
const Mr = (e) => new Nr(e, []);
class Nr {
  constructor(t, r) {
    this.value = void 0, this.cases = void 0, this.value = t, this.cases = r;
  }
  with(...t) {
    const r = t[t.length - 1], n = [t[0]], o = [];
    return t.length === 3 && typeof t[1] == "function" ? (n.push(t[0]), o.push(t[1])) : t.length > 2 && n.push(...t.slice(1, t.length - 1)), new Nr(this.value, this.cases.concat([{ match: (i) => {
      let a = {};
      const l = Boolean(n.some((s) => Ft(s, i, (u, c) => {
        a[u] = c;
      })) && o.every((s) => s(i)));
      return { matched: l, value: l && Object.keys(a).length ? Po in a ? a[Po] : a : i };
    }, handler: r }]));
  }
  when(t, r) {
    return new Nr(this.value, this.cases.concat([{ match: (n) => ({ matched: Boolean(t(n)), value: n }), handler: r }]));
  }
  otherwise(t) {
    return new Nr(this.value, this.cases.concat([{ match: (r) => ({ matched: !0, value: r }), handler: t }])).run();
  }
  exhaustive() {
    return this.run();
  }
  run() {
    let t, r = this.value;
    for (let n = 0; n < this.cases.length; n++) {
      const o = this.cases[n], i = o.match(this.value);
      if (i.matched) {
        r = i.value, t = o.handler;
        break;
      }
    }
    if (!t) {
      let n;
      try {
        n = JSON.stringify(this.value);
      } catch {
        n = this.value;
      }
      throw new Error(`Pattern matching error: no pattern matches value ${n}`);
    }
    return t(r, this.value);
  }
}
const C3 = {
  m: "1rem"
}, ee = (e) => (t) => e ? t : "", $ = (e, ...t) => {
  let r = "";
  return e.forEach((n, o) => {
    r += n + (t[o] || "");
  }), r;
}, kt = {
  normalize: $`outline-none`,
  layout: $`relative inline-block break-all`,
  size: (e, t, r) => Mr([e, t, r]).with([!0, "small", Qt._], () => $`text-sm w-6 py-2 h-max`).with([!0, "normal", Qt._], () => $`text-base w-8 py-3 h-max`).with([!0, "large", Qt._], () => $`text-xl w-12 py-5 h-max`).with([!1, "small", !1], () => $`text-sm h-6 px-2`).with([!1, "small", !0], () => $`text-sm h-6 w-6 px-1`).with([!1, "normal", !1], () => $`text-base h-8 px-3`).with([!1, "normal", !0], () => $`text-base h-8 w-8 px-2`).with([!1, "large", !1], () => $`text-xl h-12 px-5`).with([!1, "large", !0], () => $`text-xl h-12 w-12 px-4`).exhaustive(),
  bg: (e, t) => q(
    ee(t === "normal" && e === "primary")($`bg-primary`),
    ee(t === "danger" && e === "primary")($`bg-error`),
    ee(t === "gray" && e === "primary")($`bg-grey`),
    ee(e === "secondary")($`bg-disabled-grey`),
    ee(e === "text")($`bg-transparent`)
  ),
  border: () => q($`rounded`),
  text: (e, t) => q(
    $`transition-[filter]`,
    ee(e === "primary")($`text-white`),
    ee(e !== "primary")($`text-primary`),
    ee(t === "danger" && e !== "primary")($`text-error`),
    ee(t === "gray" && e !== "primary")($`text-grey`)
  ),
  hover: (e, t) => Mr([e, t]).with(
    ["primary", "normal"],
    () => $`hover:bg-primary-filled-hover focus-visible:ring-4`
  ).with(
    ["primary", "danger"],
    () => $`hover:bg-secondary-filled-hover focus-visible:ring-4`
  ).with(
    ["primary", "gray"],
    () => $`hover:bg-grey-filled-hover focus-visible:ring-4`
  ).with(
    [Qt._, "normal"],
    () => $`hover:bg-primary-hover focus-visible:ring-4`
  ).with(
    [Qt._, "danger"],
    () => $`hover:bg-secondary-hover focus-visible:ring-4`
  ).with([Qt._, "gray"], () => $`hover:bg-grey-hover focus-visible:ring-4`).exhaustive(),
  interaction: (e, t) => Mr([e, t]).with(["primary", "normal"], () => $`active:bg-primary-filled-active`).with(["primary", "danger"], () => $`active:bg-secondary-filled-active`).with(["primary", "gray"], () => $`active:bg-grey-filled-active`).with([Qt._, "normal"], () => $`active:bg-primary-active`).with([Qt._, "danger"], () => $`active:bg-secondary-active`).with([Qt._, "gray"], () => $`active:bg-grey-active`).exhaustive(),
  disabled: (e) => q(
    $`cursor-not-allowed`,
    Mr(e).with("primary", () => $`bg-disabled-dark-grey text-disabled-grey`).with("secondary", () => $`bg-disabled-grey text-disabled-dark-grey`).with("text", () => $`text-disabled-dark-grey`).exhaustive()
  )
}, on = (e) => (...t) => {
  const r = t.join("-");
  return e ? `${e}-${r}` : r;
}, x3 = ({
  className: e,
  testId: t,
  items: r,
  fullWidth: n = !1,
  ...o
}) => /* @__PURE__ */ p("div", {
  className: q("w-full", e),
  "data-testid": t,
  ...o,
  children: /* @__PURE__ */ p("div", {
    className: q("mx-auto w-full rounded-2xl bg-white p-2", !n && $`max-w-md`),
    children: r.map((i, a) => /* @__PURE__ */ p(Mi, {
      defaultOpen: i.defaultOpen,
      children: ({
        open: l
      }) => /* @__PURE__ */ G(It, {
        children: [/* @__PURE__ */ G(Mi.Button, {
          className: "flex w-full justify-between items-center rounded-lg px-4 py-2 text-left text-sm hover:bg-slate-100 focus:outline-none focus-visible:ring-4",
          children: [/* @__PURE__ */ G("div", {
            children: [/* @__PURE__ */ p("div", {
              className: "text-xl",
              children: i.title
            }), i.subtitle !== void 0 && /* @__PURE__ */ p("div", {
              children: i.subtitle
            })]
          }), /* @__PURE__ */ p(Fp, {
            color: "gray",
            className: `${l ? "rotate-180 transform" : ""} h-6 w-6`
          })]
        }), /* @__PURE__ */ p(hn, {
          show: l,
          enter: "transition duration-100 ease-out",
          enterFrom: "transform scale-95 opacity-0",
          enterTo: "transform scale-100 opacity-100",
          leave: "transition duration-75 ease-out",
          leaveFrom: "transform scale-100 opacity-100",
          leaveTo: "transform scale-95 opacity-0",
          children: /* @__PURE__ */ p(Mi.Panel, {
            static: !0,
            className: "px-4 pt-4 pb-2 text-sm text-gray-500",
            children: i.contents
          })
        })]
      })
    }, a))
  })
}), ze = ({
  className: e,
  scale: t = 1,
  icon: r,
  testId: n,
  ...o
}) => /* @__PURE__ */ p("span", {
  className: e,
  "data-testid": n != null ? n : r.name,
  ...o,
  children: Ra(r, {
    width: t.toString() + "em",
    height: t.toString() + "em"
  })
}), Yl = $`h-2 w-auto absolute top-0 left-0 bottom-0 transition-transform bg-light`, ri = ({
  isLoading: e = !0,
  className: t,
  testId: r,
  kind: n = "bar"
}) => n === "bar" ? /* @__PURE__ */ G("div", {
  className: q("bg-light bg-opacity-40 relative h-2 overflow-hidden", e ? "opacity-1" : "opacity-0", "transition-opacity", t),
  "data-testid": r,
  children: [/* @__PURE__ */ p("div", {
    className: q(Yl, "animate-loader-primary")
  }), /* @__PURE__ */ p("div", {
    className: q(Yl, "animate-loader-secondary")
  })]
}) : /* @__PURE__ */ p("div", {
  className: t,
  "data-testid": r,
  children: /* @__PURE__ */ G("svg", {
    role: "status",
    className: "w-6 h-6 text-white animate-spin fill-gray",
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ p("path", {
      d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
      fill: "currentColor"
    }), /* @__PURE__ */ p("path", {
      d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
      fill: "currentFill"
    })]
  })
}), ft = jo(({
  color: e = "normal",
  vertical: t = !1,
  disabled: r = !1,
  disabledTooltip: n,
  variant: o = "primary",
  label: i,
  children: a,
  size: l = "normal",
  icon: s,
  iconPosition: u = "right",
  className: c,
  testId: d,
  loading: f,
  ...v
}, h) => {
  const [m, g] = $e(!1);
  return /* @__PURE__ */ p(vr, {
    title: n,
    open: m,
    onClose: () => {
      g(!1);
    },
    onOpen: () => {
      r && n && g(!0);
    },
    children: /* @__PURE__ */ p("button", {
      className: q(kt.normalize, kt.layout, kt.size(t, l, i === void 0 && s !== void 0), kt.border(), ee(!r)(kt.text(o, e)), ee(!r)(kt.bg(o, e)), ee(!r)(kt.hover(o, e)), ee(!r)(kt.interaction(o, e)), ee(r)(kt.disabled(o)), ee(e === "normal")($`focus-visible:ring-primary focus-visible:ring-1`), ee(e === "danger")($`focus-visible:ring-error focus-visible:ring-1`), ee(e === "gray")($`focus-visible:ring-dark focus-visible:ring-1`), c),
      disabled: r,
      ref: h,
      type: "button",
      "data-testid": d,
      ...v,
      children: /* @__PURE__ */ G("div", {
        className: q("inline-flex items-center justify-center w-full", ee(t)($`[writing-mode:vertical-lr] h-max`), ee(!t)($`h-full`)),
        children: [s && u === "left" && /* @__PURE__ */ p(ze, {
          className: q($`left-0`, ee(i !== void 0 && !t)($`mr-2`), ee(i !== void 0 && t)($`mb-2`), ee(i === void 0)($`py-2`)),
          icon: s
        }), i && /* @__PURE__ */ p("span", {
          children: i
        }), s && u === "right" && /* @__PURE__ */ p(ze, {
          className: q($`right-0`, ee(i !== void 0 && !t)($`ml-2`), ee(i !== void 0 && t)($`mt-2`), ee(i === void 0)($`py-2`)),
          icon: s
        }), f !== void 0 && /* @__PURE__ */ p("div", {
          className: q(f ? "opacity-100 w-[32px]" : "opacity-0 w-0", "overflow-hidden", "transition-all"),
          children: /* @__PURE__ */ p(ri, {
            kind: "spinner",
            className: "pl-4"
          })
        }), a]
      })
    })
  });
});
ft.displayName = "Button";
const ia = jo(({
  checked: e = !1,
  disabled: t = !1,
  disabledTooltip: r,
  label: n,
  className: o,
  setChecked: i,
  testId: a,
  indeterminate: l,
  children: s,
  ...u
}, c) => {
  const d = gt(() => {
    i && !t && i(!e);
  }, [e, t, i]), [f, v] = $e(!1), h = () => {
    t && r && v(!0);
  }, m = () => {
    v(!1);
  };
  return /* @__PURE__ */ p("label", {
    className: q(kt.normalize, $`relative inline-flex items-center break-all`, kt.bg("text", "gray"), "relative gap-2", "group", "text-black", ee(t)($`text-disabled-dark-grey`), ee(t && !r)($`cursor-not-allowed`), o),
    children: /* @__PURE__ */ p(vr, {
      title: r,
      open: f,
      onOpen: h,
      onClose: m,
      children: /* @__PURE__ */ G("span", {
        style: {
          display: "inline-flex",
          alignItems: "center",
          gap: 5
        },
        children: [/* @__PURE__ */ p("input", {
          onChange: d,
          type: "checkbox",
          "data-testid": a,
          checked: e,
          className: "peer sr-only",
          ref: c,
          ...u
        }), l && /* @__PURE__ */ p("div", {
          className: q("inline-block rounded-md relative peer-focus-visible:ring-4"),
          children: /* @__PURE__ */ G("div", {
            className: $`flex items-center justify-center`,
            children: [/* @__PURE__ */ p("div", {
              className: q($`w-3/4 h-3/4 rounded-full absolute`, ee(!t)($`bg-white`), ee(t)($`bg-disabled-dark-grey`))
            }), /* @__PURE__ */ p(ze, {
              className: q($`z-10`, ee(!t)($`text-primary group-hover:text-primary-filled-active`), ee(t)($`text-disabled-grey`)),
              scale: 1.6,
              icon: Ap
            })]
          })
        }), !l && !e && /* @__PURE__ */ p("div", {
          className: q("inline-block rounded-md relative", ee(!t)("group-hover:bg-light peer-focus-visible:ring-4"), ee(t)("bg-disabled-grey")),
          children: /* @__PURE__ */ p(ze, {
            className: q(ee(!t)("text-light"), ee(t)($`text-disabled-grey`)),
            scale: 1.6,
            icon: Io
          })
        }), !l && e && /* @__PURE__ */ p("div", {
          className: q("inline-block rounded-md relative peer-focus-visible:ring-4"),
          children: /* @__PURE__ */ G("div", {
            className: $`grid place-items-center`,
            children: [/* @__PURE__ */ p("div", {
              className: q($`w-3/4 h-3/4 rounded-full absolute`, ee(!t)($`bg-white`), ee(t)($`bg-disabled-dark-grey`))
            }), /* @__PURE__ */ p(ze, {
              className: q($`z-10`, ee(!t)($`text-primary group-hover:text-primary-filled-active`), ee(t)($`text-disabled-grey`)),
              scale: 1.6,
              icon: To
            })]
          })
        }), s, n]
      })
    })
  });
});
ia.displayName = "Checkbox";
const w3 = ({
  label: e,
  className: t,
  testId: r,
  ...n
}) => /* @__PURE__ */ p("div", {
  className: q("inline-block border border-primary rounded-full px-4 py-1 leading-4 bg-primary-hover text-primary", t),
  "data-testid": r,
  ...n,
  children: e
}), S3 = ({
  selected: e,
  onValueChange: t,
  items: r,
  filterHandler: n,
  label: o,
  placeholder: i,
  emptySetLabel: a,
  loading: l = !1,
  width: s,
  className: u,
  testId: c,
  disabled: d = !1,
  disabledTooltip: f
}) => {
  const v = on(c), h = (y) => {
    n !== void 0 && n(y);
  }, m = (y) => {
    t(y);
  }, g = (y, O) => (y == null ? void 0 : y.key) === (O == null ? void 0 : O.key), [C, x] = $e(!1), S = () => {
    d && f && x(!0);
  }, w = () => {
    x(!1);
  };
  return /* @__PURE__ */ p("div", {
    style: {
      width: s === void 0 ? "100%" : s
    },
    children: /* @__PURE__ */ G(yt, {
      value: e,
      onChange: m,
      by: g,
      nullable: !0,
      disabled: d,
      children: [o !== void 0 && /* @__PURE__ */ p(yt.Label, {
        className: "text-dark mb-1",
        children: o
      }), /* @__PURE__ */ p(vr, {
        title: f,
        open: C,
        onClose: w,
        onOpen: S,
        children: /* @__PURE__ */ G("div", {
          children: [/* @__PURE__ */ G("div", {
            className: "relative w-full items-center cursor-default overflow-hidden rounded-md inline-flex pl-3 pr-1 py-1 mb-1  bg-grey-active focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300",
            children: [/* @__PURE__ */ p(yt.Input, {
              "data-testid": v("filter-input"),
              placeholder: i != null ? i : "",
              className: "w-full border-none bg-transparent text-gray-900 focus:outline-none focus:ring-0",
              displayValue: (y) => y ? y.label : "",
              onChange: (y) => h(y.target.value)
            }), e && /* @__PURE__ */ p(ft, {
              icon: Iu,
              variant: "text",
              color: "gray",
              onClick: () => m(null),
              testId: v("clear-button"),
              disabled: d
            }), /* @__PURE__ */ p(yt.Button, {
              as: Ge,
              children: /* @__PURE__ */ p(ft, {
                color: "gray",
                variant: "text",
                icon: oi,
                "data-testid": v("open-dropdown")
              })
            })]
          }), /* @__PURE__ */ p(hn, {
            as: Ge,
            enter: "transition duration-100 ease-out",
            enterFrom: "transform scale-95 opacity-0",
            enterTo: "transform scale-100 opacity-100",
            children: /* @__PURE__ */ G(yt.Options, {
              className: "relative w-full z-50",
              children: [/* @__PURE__ */ G("div", {
                className: "overflow-y-auto w-full max-h-64 absolute shadow-lg rounded-md border py-2 px-2 bg-white border-grey-hover z-50",
                children: [a !== void 0 && /* @__PURE__ */ p("div", {
                  className: "relative cursor-default select-none py-2 px-4 text-gray-700",
                  children: a
                }), r.map((y, O) => /* @__PURE__ */ p(yt.Option, {
                  value: y,
                  children: ({
                    active: P,
                    selected: M
                  }) => /* @__PURE__ */ G("div", {
                    className: q("inline-flex w-full items-center pl-3 py-2 rounded-md", ee(P)("bg-primary-active")),
                    children: [/* @__PURE__ */ p(ze, {
                      className: q("pr-2", ee(M)("text-primary"), ee(!M)("text-transparent")),
                      scale: 1.2,
                      icon: ol
                    }), /* @__PURE__ */ p("span", {
                      children: y.label
                    })]
                  })
                }, O))]
              }), l && /* @__PURE__ */ p(ri, {})]
            })
          })]
        })
      })]
    })
  });
}, Eu = ({
  isOpen: e,
  closeModal: t,
  className: r,
  title: n,
  children: o,
  actions: i,
  testId: a,
  width: l,
  loading: s = !1
}) => /* @__PURE__ */ p(It, {
  children: /* @__PURE__ */ p(hn, {
    show: e,
    as: Ge,
    children: /* @__PURE__ */ p($i, {
      onClose: t,
      className: $`fixed z-[100] inset-0 overflow-y-auto`,
      "data-testid": a,
      children: /* @__PURE__ */ G("div", {
        className: $`flex items-center justify-center min-h-screen`,
        children: [/* @__PURE__ */ p(hn.Child, {
          as: Ge,
          enter: $`ease-out duration-300`,
          enterFrom: $`opacity-0`,
          enterTo: $`opacity-100`,
          leave: $`ease-in duration-300`,
          leaveFrom: $`opacity-100`,
          leaveTo: $`opacity-0`,
          children: /* @__PURE__ */ p($i.Overlay, {
            className: $`fixed inset-0 bg-black bg-opacity-20`
          })
        }), /* @__PURE__ */ p(hn.Child, {
          as: Ge,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0 scale-95",
          enterTo: "opacity-100 scale-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100 scale-100",
          leaveTo: "opacity-0 scale-95",
          children: /* @__PURE__ */ G("div", {
            className: q($`w-full my-8 relative bg-white rounded-lg mx-auto drop-shadow-xl`, r),
            style: {
              maxWidth: l !== void 0 ? l : "36rem"
            },
            children: [/* @__PURE__ */ p(ri, {
              isLoading: s,
              kind: "bar"
            }), /* @__PURE__ */ G("section", {
              className: $`p-8 box-border flex flex-col w-full gap-8`,
              children: [n && /* @__PURE__ */ p($i.Title, {
                className: $`text-3xl`,
                children: n
              }), o]
            }), /* @__PURE__ */ p("div", {
              className: $`flex rounded-b-inherit flex-row bg-slate-100 py-4 px-8 justify-end gap-4`,
              children: i
            })]
          })
        })]
      })
    })
  })
}), R3 = ({
  onConfirm: e,
  title: t,
  prompt: r,
  buttonText: n,
  buttonProps: o,
  cancelText: i,
  confirmText: a,
  className: l,
  testId: s
}) => {
  const [u, c] = $e(!1), d = () => c(!0), f = () => c(!1), v = () => {
    f(), e !== void 0 && e();
  }, h = on(s), m = /* @__PURE__ */ G(It, {
    children: [/* @__PURE__ */ p(ft, {
      onClick: f,
      variant: "text",
      label: i || "Cancel",
      testId: h("cancel-action")
    }), /* @__PURE__ */ p(ft, {
      onClick: v,
      label: a || "Confirm",
      testId: h("confirm-action")
    })]
  });
  return /* @__PURE__ */ G(It, {
    children: [/* @__PURE__ */ p(ft, {
      onClick: d,
      testId: h("open-confirmation"),
      className: l,
      ...o,
      children: n || "Open Dialog"
    }), /* @__PURE__ */ p(Eu, {
      isOpen: u,
      closeModal: f,
      actions: m,
      title: t,
      testId: h("confirmation-modal"),
      children: r && /* @__PURE__ */ p("p", {
        children: r
      })
    })]
  });
}, Pp = ({
  buttonLabel: e,
  dragDropLabel: t,
  files: r,
  onFilesChanged: n,
  className: o,
  testId: i
}) => {
  const a = on(i), l = (c) => {
    c.target.files !== null && n([...r, ...c.target.files]);
  }, s = (c) => {
    n([...r.slice(0, c), ...r.slice(c + 1)]);
  }, u = (c) => {
    n([...r, ...c.dataTransfer.files]), c.preventDefault();
  };
  return /* @__PURE__ */ G("div", {
    className: q(["bg-white p-4 rounded-md border-light border border-dashed", o]),
    "data-testid": a("drop-zone"),
    onDrop: u,
    onDragOver: (c) => c.preventDefault(),
    children: [/* @__PURE__ */ p("input", {
      id: "file-select-input",
      type: "file",
      onChange: l,
      multiple: !0,
      hidden: !0
    }), /* @__PURE__ */ p("label", {
      tabIndex: 0,
      htmlFor: "file-select-input",
      "data-testid": a("input-label"),
      className: q(["inline-block text-primary cursor-pointer bg-slate mr-4 py-2 px-4 rounded-md select-none", "hover:bg-primary-active"]),
      children: /* @__PURE__ */ p("span", {
        children: e
      })
    }), /* @__PURE__ */ G("span", {
      className: "inline text-dark ml-3 mr-6",
      children: [/* @__PURE__ */ p(ze, {
        className: "inline-block -mb-1 mr-2",
        scale: 1.3,
        icon: Np
      }), t]
    }), /* @__PURE__ */ p("div", {
      className: "divide-y divide-light mt-1",
      children: r.map((c, d) => /* @__PURE__ */ G("div", {
        className: "py-2 flex w-full",
        children: [/* @__PURE__ */ p(ze, {
          className: "mr-1 text-primary",
          scale: 1.5,
          icon: ol
        }), /* @__PURE__ */ p("span", {
          children: c.name
        }), /* @__PURE__ */ p(ze, {
          className: "ml-auto text-gray hover:text-secondary-filled-hover active:text-secondary-filled-active",
          tabIndex: 0,
          scale: 1.5,
          onClick: () => s(d),
          icon: Tu,
          testId: a(`${c.name}-remove`)
        })]
      }, d))
    })]
  });
}, Ou = ({
  title: e,
  children: t,
  titleSize: r = "large",
  className: n,
  testId: o,
  ...i
}) => /* @__PURE__ */ G("div", {
  className: q(ee(r === "large")($`pb-8`), ee(r === "medium")($`pb-4`), ee(r === "small")($`pb-2`), n),
  "data-testid": o,
  ...i,
  children: [e && /* @__PURE__ */ p("h1", {
    className: q(ee(r === "large")($`py-8 text-4xl`), ee(r === "medium")($`py-2 text-2xl`), ee(r === "small")($`py-0 text-xl`)),
    children: e
  }), t]
}), E3 = ({
  title: e,
  description: t,
  confirmLabel: r,
  cancelLabel: n,
  browseButtonLabel: o,
  dragDropLabel: i,
  files: a,
  isOpen: l,
  isLoading: s,
  onClose: u,
  onConfirm: c,
  onFilesChange: d,
  className: f,
  testId: v
}) => /* @__PURE__ */ G(Eu, {
  isOpen: l,
  closeModal: u,
  title: e,
  actions: /* @__PURE__ */ G("div", {
    className: "ml-auto flex gap-2",
    children: [/* @__PURE__ */ p(ft, {
      variant: "text",
      label: n,
      onClick: u
    }), /* @__PURE__ */ p(ft, {
      label: r,
      onClick: c,
      loading: s
    })]
  }),
  className: q("box-border p-3", f),
  testId: v,
  children: [/* @__PURE__ */ p(Ou, {
    children: t && /* @__PURE__ */ p("p", {
      children: t
    })
  }), /* @__PURE__ */ p(Pp, {
    buttonLabel: o,
    dragDropLabel: i,
    files: a,
    onFilesChanged: d,
    className: "w-full box-border"
  })]
}), Pu = jo(({
  label: e,
  className: t,
  inputClassName: r,
  testId: n,
  ...o
}, i) => /* @__PURE__ */ G("span", {
  className: q("inline-flex flex-col gap-1", t),
  children: [e && /* @__PURE__ */ p("label", {
    children: e
  }), /* @__PURE__ */ p("input", {
    className: q(
      "outline-none",
      "border border-light rounded box-border",
      "h-8 p-1",
      "hover:shadow focus-within:blue-500 focus-within:hover:shadow-none",
      r
    ),
    "data-testid": n,
    ref: i,
    ...o
  })]
}));
Pu.displayName = "Input";
const O3 = ({
  children: e,
  className: t,
  testId: r,
  ...n
}) => /* @__PURE__ */ p("a", {
  className: q("select-none", "text-primary", "cursor-pointer", "hover:opacity-75 outline-none focus-visible:ring-4 active:opacity-50", t),
  tabIndex: 0,
  "data-testid": r,
  ...n,
  children: e
}), fn = ({
  buttonProps: e,
  menuPosition: t = "left",
  children: r,
  className: n,
  testId: o,
  ...i
}) => {
  const a = on(o);
  return /* @__PURE__ */ G(Fr, {
    as: "div",
    className: q("relative inline-block text-left z-50", n),
    "data-testid": o,
    ...i,
    children: [/* @__PURE__ */ p(Fr.Button, {
      as: Ge,
      children: /* @__PURE__ */ p(ft, {
        ...e,
        "data-testid": a("open-menu")
      })
    }), /* @__PURE__ */ p(hn, {
      enter: "transition duration-100 ease-out",
      enterFrom: "transform scale-95 opacity-0",
      enterTo: "transform scale-100 opacity-100",
      leave: "transition duration-75 ease-out",
      leaveFrom: "transform scale-100 opacity-100",
      leaveTo: "transform scale-95 opacity-0",
      children: /* @__PURE__ */ p(Fr.Items, {
        className: q($`absolute w-64 mt-2 bg-white divide-y divide-light rounded-md drop-shadow-md focus:outline-none`, ee(t === "left")($`left-0`), ee(t === "right")($`right-0`)),
        children: r
      })
    })]
  });
}, Ip = ({
  children: e,
  heading: t
}) => /* @__PURE__ */ G("div", {
  className: $`py-1`,
  children: [t && /* @__PURE__ */ p("div", {
    className: "px-4 py-2 text-dark",
    children: t
  }), e]
});
fn.Section = Ip;
const Tp = ({
  label: e,
  icon: t,
  onClick: r,
  testId: n
}) => /* @__PURE__ */ p(Fr.Item, {
  children: ({
    active: o
  }) => /* @__PURE__ */ G("button", {
    onClick: () => r(e),
    className: q($`group inline-flex items-center w-full px-4 py-2 box-border`, ee(o)($`bg-primary-active`)),
    "data-testid": n,
    children: [t !== void 0 && /* @__PURE__ */ p(ze, {
      scale: 1,
      icon: t,
      className: "mr-2"
    }), /* @__PURE__ */ p("span", {
      children: e
    })]
  })
}), $p = ({
  label: e,
  checked: t,
  setChecked: r,
  testId: n
}) => {
  const o = gt((a) => {
    a.stopPropagation();
  }, []), i = gt(() => r && r(!t), [t, r]);
  return /* @__PURE__ */ p(Fr.Item, {
    children: ({
      active: a
    }) => /* @__PURE__ */ p("div", {
      children: /* @__PURE__ */ G("label", {
        onClick: o,
        className: q("relative gap-2", "group flex py-2 px-4 box-border select-none", ee(a)($`bg-primary-active`)),
        children: [/* @__PURE__ */ p("input", {
          onChange: i,
          type: "checkbox",
          "data-testid": n,
          checked: t,
          className: "peer sr-only"
        }), !t && /* @__PURE__ */ p("div", {
          className: q("inline-block rounded-md relative", "peer-focus-visible:ring-4", ee(a)($`bg-light`)),
          children: /* @__PURE__ */ p(ze, {
            className: "text-light",
            scale: 1.6,
            icon: Io
          })
        }), t && /* @__PURE__ */ p("div", {
          className: q("inline-block rounded-md relative peer-focus-visible:ring-4"),
          children: /* @__PURE__ */ p(ze, {
            className: q("text-primary", ee(a)($`text-primary-filled-active`)),
            scale: 1.6,
            icon: To
          })
        }), e]
      })
    })
  });
};
fn.Item = Tp;
fn.Checkbox = $p;
const P3 = (e) => /* @__PURE__ */ G("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ...e,
  children: [/* @__PURE__ */ p("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2a7.2 7.2 0 0 1-6-3.22c.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08a7.2 7.2 0 0 1-6 3.22z",
    fill: "currentColor"
  }), /* @__PURE__ */ p("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })]
}), I3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      fill: "currentColor",
      d: "M11.833 6.833h-5v5H5.167v-5h-5V5.167h5v-5h1.666v5h5z"
    }), /* @__PURE__ */ p("path", {
      d: "M-4-4h20v20H-4z"
    })]
  })
}), T3 = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "m5.12 5 .81-1h12l.94 1M12 17.5 6.5 12H10v-2h4v2h3.5L12 17.5m8.54-12.27-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6 3 6.5V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.5c0-.5-.17-.93-.46-1.27Z"
  })
}), $3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M.5 12V1h7.886v5H12.5v6H.5Z",
    stroke: "currentColor"
  })
}), M3 = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "m12 4-8 8 8 8 1.4-1.4L7.8 13H20v-2H7.8l5.6-5.6z",
    transform: "rotate(-90 8 12)",
    style: {
      fill: "#000"
    }
  })
}), L3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M16 7H3.8l5.6-5.6L8 0 0 8l8 8 1.4-1.4L3.8 9H16z"
  })
}), A3 = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M13.4 5.4 12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2H7.8z",
    transform: "rotate(180 10 10)",
    style: {
      fill: "#000"
    }
  })
}), k3 = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "m7.8 11 5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z",
    transform: "rotate(90 12 8)",
    style: {
      fill: "#000"
    }
  })
}), _3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M2.868 17.444 1.46 1.998l12.672 8.942-7.022.393-.253.014-.138.211-3.851 5.886Z",
    stroke: "currentColor",
    fill: "transparent"
  })
}), F3 = (e) => /* @__PURE__ */ G("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: [/* @__PURE__ */ p("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2.2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "4.4,2.2",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M.016 1.11h24"
  }), /* @__PURE__ */ p("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2.1991,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "4.39821,2.1991",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M.015 22.917h24"
  }), /* @__PURE__ */ p("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "4,2",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M1.016.05v23.954M23.016.04v23.858"
  })]
}), Mp = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M0 6h15v3H0V6ZM0 0h15v3H0V0ZM0 12h15v3H0v-3Z",
    fill: "currentColor"
  })
}), ol = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
  })
}), N3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M12 .5C5.4.5 0 5.9 0 12.5s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12Zm-1.35 17.55-6.3-6.15 2.1-2.1 4.05 4.05L18 6.5l2.1 2.1-9.45 9.45Z",
    fill: "currentColor"
  })
}), V3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M10.667 0H1.333C.6 0 0 .6 0 1.333v9.334C0 11.4.6 12 1.333 12h9.334C11.4 12 12 11.4 12 10.667V1.333C12 .6 11.4 0 10.667 0ZM1 6.154l1-1.077 2.571 2.77L10 2l1 1.077L4.571 10 1 6.154Z"
  })
}), D3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M-1-1h18v18H-1z"
    }), /* @__PURE__ */ p("path", {
      d: "M8 .5C3.86.5.5 3.86.5 8c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5C15.5 3.86 12.14.5 8 .5ZM6.5 11.75 2.75 8l1.058-1.058L6.5 9.627l5.693-5.692L13.25 5 6.5 11.75Z",
      fill: "currentColor"
    })]
  })
}), H3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M-1-1h18v18H-1z"
    }), /* @__PURE__ */ p("path", {
      d: "M8 .5C3.86.5.5 3.86.5 8c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5C15.5 3.86 12.14.5 8 .5ZM6.5 11.75 2.75 8l1.058-1.058L6.5 9.627l5.693-5.692L13.25 5 6.5 11.75Z",
      fill: "currentColor"
    })]
  })
}), Lp = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M4 0C1.784 0 0 1.784 0 4v10c0 2.216 1.784 4 4 4h10c2.216 0 4-1.784 4-4V4c0-2.216-1.784-4-4-4H4zm.22 8.22H13.78c.44 0 .78.34.78.78s-.34.78-.78.78H4.22A.769.769 0 0 1 3.44 9c0-.44.34-.78.78-.78z"
  })
}), Ap = Lp, kp = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 3.5,
    stroke: "currentColor"
  })
}), Io = kp, z3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M10.667 0H1.333C.6 0 0 .6 0 1.333v9.334C0 11.4.6 12 1.333 12h9.334C11.4 12 12 11.4 12 10.667V1.333C12 .6 11.4 0 10.667 0ZM1 6.154l1-1.077 2.571 2.77L10 2l1 1.077L4.571 10 1 6.154Z"
  })
}), B3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M10.667 0H1.333C.6 0 0 .6 0 1.333v9.334C0 11.4.6 12 1.333 12h9.334C11.4 12 12 11.4 12 10.667V1.333C12 .6 11.4 0 10.667 0ZM1 6.154l1-1.077 2.571 2.77L10 2l1 1.077L4.571 10 1 6.154Z"
  })
}), _p = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 7 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.456 6.664.63 1.355l.76-.691 5.455 6-5.454 6-.761-.692 4.826-5.308Z",
    fill: "currentColor"
  })
}), oi = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  width: "1em",
  viewBox: "0 0 10 10",
  ...e,
  children: /* @__PURE__ */ p("g", {
    transform: "matrix(1 0 0 -1 0 10)",
    children: /* @__PURE__ */ p("path", {
      fill: "currentColor",
      d: "M.025 6.807 5 2.093l4.975 4.714-1.16 1.1L5 4.293 1.186 7.907z"
    })
  })
}), Fp = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "m1.186 7.907-1.16-1.1L5 2.093l4.975 4.714-1.16 1.1L5 4.293z"
  })
}), Iu = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  })
}), Tu = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  })
}), j3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M-2-2h24v24H-2z"
    }), /* @__PURE__ */ p("path", {
      d: "M2 4H0v14c0 1.1.9 2 2 2h14v-2H2V4Zm16-4H6C4.9 0 4 .9 4 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Zm-1 9h-4v4h-2V9H7V7h4V3h2v4h4v2Z",
      fill: "currentColor"
    })]
  })
}), G3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })
}), U3 = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  ...e,
  children: /* @__PURE__ */ p("circle", {
    cx: 12.127,
    cy: 12.178,
    r: 7.153,
    style: {
      fill: "#000",
      strokeWidth: 1.78813565
    }
  })
}), W3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    fill: "currentColor"
  })
}), Z3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 13 13",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "m7.572 1.133-1.6 1.6H2.733a1 1 0 0 0-1 1v6.534a1 1 0 0 0 1 1h6.534a1 1 0 0 0 1-1v-3.24l1.6-1.6v5.44a2 2 0 0 1-2 2H2.133a2 2 0 0 1-2-2V3.133a2 2 0 0 1 2-2h5.44Z",
      fillRule: "nonzero"
    }), /* @__PURE__ */ p("path", {
      d: "M3.867 7.243v1.89h1.89l5.576-5.576-1.89-1.89-5.576 5.576Zm8.934-5.34a.452.452 0 0 0 0-.64L11.738.198a.452.452 0 0 0-.64 0l-.831.831 1.703 1.703.83-.83Z"
    })]
  })
}), q3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 13 13",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "m7.572 1.133-1.6 1.6H2.733a1 1 0 0 0-1 1v6.534a1 1 0 0 0 1 1h6.534a1 1 0 0 0 1-1v-3.24l1.6-1.6v5.44a2 2 0 0 1-2 2H2.133a2 2 0 0 1-2-2V3.133a2 2 0 0 1 2-2h5.44Z",
      fillRule: "nonzero"
    }), /* @__PURE__ */ p("path", {
      d: "M3.867 7.243v1.89h1.89l5.576-5.576-1.89-1.89-5.576 5.576Zm8.934-5.34a.452.452 0 0 0 0-.64L11.738.198a.452.452 0 0 0-.64 0l-.831.831 1.703 1.703.83-.83Z"
    })]
  })
}), Y3 = (e) => /* @__PURE__ */ G("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: [/* @__PURE__ */ p("path", {
    d: "M12 2c5.85 0 10.5 4.65 10.5 10.5S17.85 23 12 23 1.5 18.35 1.5 12.5 6.15 2 12 2Zm0-1.5C5.4.5 0 5.9 0 12.5s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12Z",
    fill: "currentColor"
  }), /* @__PURE__ */ p("path", {
    d: "M10.5 5h3v10.5h-3V5ZM10.5 17h3v3h-3v-3Z",
    fill: "currentColor"
  })]
}), K3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M13.65 2.35A7.958 7.958 0 0 0 8 0C3.58 0 .01 3.58.01 8S3.58 16 8 16c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L9 7h7V0l-2.35 2.35Z",
      fill: "currentColor"
    }), /* @__PURE__ */ p("path", {
      d: "M-4-4h24v24H-4z"
    })]
  })
}), X3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 15",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M11.833 5.5H8.5v-5h-5v5H.167L6 11.333 11.833 5.5ZM.167 13v1.667h11.666V13H.167Z",
      fill: "currentColor"
    }), /* @__PURE__ */ p("path", {
      d: "M-4-2h20v20H-4z"
    })]
  })
}), Np = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 15",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M-4-2h20v20H-4z"
    }), /* @__PURE__ */ p("path", {
      d: "M3.5 11.333h5v-5h3.333L6 .5.167 6.333H3.5v5ZM.167 13h11.666v1.667H.167V13Z",
      fill: "currentColor"
    })]
  })
}), J3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M6.333 10h3.334V8.333H6.333V10ZM.5 0v1.667h15V0H.5ZM3 5.833h10V4.167H3v1.666Z",
      fill: "currentColor"
    }), /* @__PURE__ */ p("path", {
      d: "M-2-5h20v20H-2z"
    })]
  })
}), Q3 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 13",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M-3-3h18v18H-3z"
    }), /* @__PURE__ */ p("path", {
      fill: "currentColor",
      d: "M7.8 1.5 7.5 0H.75v12.75h1.5V7.5h4.2l.3 1.5H12V1.5z"
    })]
  })
}), e4 = (e) => /* @__PURE__ */ G("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ...e,
  children: [/* @__PURE__ */ p("path", {
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z",
    fill: "currentColor"
  }), /* @__PURE__ */ p("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })]
}), t4 = (e) => /* @__PURE__ */ G("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ...e,
  children: [/* @__PURE__ */ p("path", {
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z",
    fill: "currentColor"
  }), /* @__PURE__ */ p("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })]
}), n4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 6 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M0 1.167 1.104 0l4.73 5-4.73 5L0 8.833 3.626 5z"
  })
}), r4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 6 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M0 1.167 1.104 0l4.73 5-4.73 5L0 8.833 3.626 5z"
  })
}), o4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M3 1.167 4.104 0l4.73 5-4.73 5L3 8.833 6.626 5z"
  })
}), i4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 6 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M0 1.167 1.104 0l4.73 5-4.73 5L0 8.833 3.626 5z"
  })
}), Vp = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "silver",
    d: "M3 1.167 4.104 0l4.73 5-4.73 5L3 8.833 6.626 5z"
  })
}), a4 = (e) => /* @__PURE__ */ G("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 24 24",
  width: "1em",
  fill: "#FFF",
  ...e,
  children: [/* @__PURE__ */ p("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /* @__PURE__ */ p("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
  })]
}), l4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 20",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M-4-3h24v24H-4z"
    }), /* @__PURE__ */ p("path", {
      d: "M10 0H2C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6Zm2 16H4v-2h8v2Zm0-4H4v-2h8v2ZM9 7V1.5L14.5 7H9Z",
      fill: "currentColor"
    })]
  })
}), s4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    stroke: "currentColor",
    d: "m1.146 11.646 11-11"
  })
}), u4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M-3-3h24v24H-3z"
    }), /* @__PURE__ */ p("path", {
      d: "M10 0H8v10h2V0Zm4.83 2.17-1.42 1.42A6.92 6.92 0 0 1 16 9c0 3.87-3.13 7-7 7A6.995 6.995 0 0 1 4.58 3.58L3.17 2.17A8.932 8.932 0 0 0 0 9a9 9 0 0 0 18 0c0-2.74-1.23-5.18-3.17-6.83Z",
      fill: "currentColor"
    })]
  })
}), c4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M7.842 1.175 6.667 0l-5 5 5 5 1.175-1.175L4.025 5z",
    fillRule: "evenodd"
  })
}), d4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "silver",
    d: "M7.842 1.175 6.667 0l-5 5 5 5 1.175-1.175L4.025 5z",
    fillRule: "evenodd"
  })
}), f4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M-2-5h20v20H-2z"
    }), /* @__PURE__ */ p("path", {
      d: "M.5 10h15V8.333H.5V10Zm0-4.167h15V4.167H.5v1.666ZM.5 0v1.667h15V0H.5Z",
      fill: "currentColor"
    })]
  })
}), p4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M8.94.003a.546.546 0 0 0-.323.154L6.162 2.61a.545.545 0 1 0 .767.776l1.526-1.526v6.597H1.858l1.526-1.525a.546.546 0 1 0-.767-.776L.162 8.612a.546.546 0 0 0 0 .775l2.455 2.455a.546.546 0 1 0 .767-.776L1.858 9.55h6.597v6.589l-1.526-1.526a.546.546 0 1 0-.767.776l2.455 2.454a.545.545 0 0 0 .767 0l2.455-2.454a.545.545 0 1 0-.768-.776l-1.525 1.526V9.549h6.597l-1.526 1.518a.546.546 0 1 0 .767.775l2.455-2.455a.547.547 0 0 0 0-.775l-2.455-2.455a.546.546 0 1 0-.767.776l1.526 1.525H9.546V1.861l1.526 1.526a.546.546 0 1 0 .767-.776L9.384.157a.546.546 0 0 0-.443-.154Z",
    fill: "#363636"
  })
}), g4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 13 15",
  stroke: "currentColor",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "m.5 14 12-12v12",
    fill: "transparent"
  })
}), v4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    stroke: "currentColor",
    d: "M1 .5h12v12H1z"
  })
}), m4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M3.9 8.9C5.25 5.75 8.4 3.5 12 3.5c4.5 0 8.1 3.3 8.85 7.5h3C23.1 5.15 18.15.5 12 .5 7.5.5 3.6 2.9 1.65 6.65L0 5v6h6L3.9 8.9ZM24 14h-6.15l2.25 2.1a8.942 8.942 0 0 1-8.25 5.4C7.5 21.5 3.75 18.2 3 14H0c.75 5.85 5.85 10.5 11.85 10.5 4.5 0 8.4-2.55 10.5-6.15L24 20v-6Z",
    fill: "currentColor"
  })
}), Dp = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M8 0C5 0 2.4 1.6 1.1 4.1L0 3v4h4L2.5 5.5C3.5 3.5 5.6 2 8 2c3.3 0 6 2.7 6 6s-2.7 6-6 6c-1.8 0-3.4-.8-4.5-2.1L2 13.2C3.4 14.9 5.6 16 8 16c4.4 0 8-3.6 8-8s-3.6-8-8-8Z",
    fill: "currentColor"
  })
}), h4 = (e) => /* @__PURE__ */ G("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 24 24",
  width: "1em",
  ...e,
  children: [/* @__PURE__ */ p("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /* @__PURE__ */ p("path", {
    d: "M7.34 6.41.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26A8.95 8.95 0 0 0 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05a7.007 7.007 0 0 1 0 9.9 6.973 6.973 0 0 1-7.79 1.44l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64a8.98 8.98 0 0 0 0-12.72z"
  })]
}), b4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M7.148 6.289h-.454l-.158-.157c.558-.65.897-1.492.897-2.416a3.716 3.716 0 1 0-1.3 2.821l.157.157v.453L9.148 10 10 9.148l-2.852-2.86Zm-3.432 0a2.572 2.572 0 1 1 0-5.145 2.572 2.572 0 0 1 0 5.145Z",
    fill: "currentColor"
  })
}), Hp = (e) => /* @__PURE__ */ G("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: [/* @__PURE__ */ p("path", {
    d: "M8 4H2l3-4 3 4Z",
    fill: "currentColor"
  }), /* @__PURE__ */ p("path", {
    d: "M2 6h6l-3 4-3-4Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })]
}), zp = (e) => /* @__PURE__ */ G("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: [/* @__PURE__ */ p("path", {
    d: "M2 6h6l-3 4-3-4Z",
    fill: "currentColor"
  }), /* @__PURE__ */ p("path", {
    d: "M8 4H2l3-4 3 4Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })]
}), Bp = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M8 4H2l3-4 3 4ZM2 6h6l-3 4-3-4Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })
}), y4 = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 18",
  ...e,
  children: /* @__PURE__ */ G("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    },
    children: [/* @__PURE__ */ p("path", {
      style: {
        fill: "#2284f0"
      },
      d: "M14 10v7.01h-3L15 21l4-3.99h-3V10z",
      transform: "rotate(180 9.5 10.5)"
    }), /* @__PURE__ */ p("path", {
      style: {
        fill: "#cdcdcd"
      },
      d: "M8 6.99V14h2V6.99h3L9 3 5 6.99z",
      transform: "rotate(180 9.5 10.5)"
    }), /* @__PURE__ */ p("path", {
      d: "M-5-3h24v24H-5z"
    })]
  })
}), C4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 18",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      fill: "currentColor",
      d: "M11 14.01V7H9v7.01H6L10 18l4-3.99h-3z"
    }), /* @__PURE__ */ p("path", {
      fill: "#cdcdcd",
      d: "M4 0 0 3.99h3V11h2V3.99h3z"
    }), /* @__PURE__ */ p("path", {
      d: "M-5-3h24v24H-5z"
    })]
  })
}), x4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 18",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      fill: "#cdcdcd",
      d: "M11 14.01V7H9v7.01H6L10 18l4-3.99h-3zM4 0 0 3.99h3V11h2V3.99h3z"
    }), /* @__PURE__ */ p("path", {
      d: "M-5-3h24v24H-5z"
    })]
  })
}), w4 = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12",
  height: "1em",
  width: "1em",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fillRule: "evenodd",
    fill: "none",
    children: [/* @__PURE__ */ p("path", {
      d: "M15.833 10.833H4.167V9.167h11.666z",
      style: {
        fill: "#2284f0"
      },
      transform: "translate(-4 -4)"
    }), /* @__PURE__ */ p("path", {
      d: "M-4-4h20v20H-4z"
    })]
  })
}), S4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ G("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/* @__PURE__ */ p("path", {
      d: "M0 6h14V4H0v2Zm0 4h14V8H0v2Zm0 4h14v-2H0v2Zm16 0h2v-2h-2v2Zm0-10v2h2V4h-2Zm0 6h2V8h-2v2Z",
      fill: "currentColor"
    }), /* @__PURE__ */ p("path", {
      d: "M-3-3h24v24H-3z"
    })]
  })
}), R4 = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 10",
  style: {
    fill: "none"
  },
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M5 8 2 2h6z",
    style: {
      fill: "#000",
      strokeWidth: 0.42426404
    }
  })
}), E4 = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M20.54 5.23c.29.34.46.77.46 1.27V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6.5c0-.5.17-.93.46-1.27l1.38-1.68C5.12 3.21 5.53 3 6 3h12c.47 0 .88.21 1.15.55l1.39 1.68M5.12 5h13.75l-.94-1h-12l-.81 1M12 9.5 6.5 15H10v2h4v-2h3.5L12 9.5Z"
  })
}), O4 = (e) => /* @__PURE__ */ p("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 18",
  height: "1em",
  width: "1em",
  ...e,
  children: /* @__PURE__ */ G("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    },
    children: [/* @__PURE__ */ p("path", {
      style: {
        fill: "#2284f0"
      },
      d: "M11 17.01 15 21l4-3.99h-3V10h-2v7.01z",
      transform: "rotate(-135 8.883 11.536) scale(1 .9991)"
    }), /* @__PURE__ */ p("path", {
      style: {
        fill: "#cdcdcd"
      },
      d: "M10 14V6.99h3L9 3 5 6.99h3V14z",
      transform: "rotate(-135 8.883 11.536) scale(1 .9991)"
    }), /* @__PURE__ */ p("path", {
      d: "M7.008 25.974-9.963 9.004 6.992-7.953l16.971 16.97z"
    })]
  })
}), jp = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    fill: "currentColor",
    d: "M4 0C1.784 0 0 1.784 0 4v10c0 2.216 1.784 4 4 4h10c2.216 0 4-1.784 4-4V4c0-2.216-1.784-4-4-4H4zm9.916 4.834a.749.749 0 0 1 .531 1.28l-6.445 6.445a.75.75 0 0 1-1.06 0L4.218 9.836a.75.75 0 1 1 1.062-1.06l2.192 2.19 5.914-5.913a.744.744 0 0 1 .529-.219z"
  })
}), To = jp, P4 = (e) => /* @__PURE__ */ p("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 11 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M9.9 0H1.1C.492 0 .005.492.005 1.1L0 11l2.2-2.2h7.7A1.1 1.1 0 0 0 11 7.7V1.1A1.1 1.1 0 0 0 9.9 0ZM8.8 6.6H2.2V5.5h6.6v1.1Zm0-1.65H2.2v-1.1h6.6v1.1Zm0-1.65H2.2V2.2h6.6v1.1Z",
    fill: "currentColor"
  })
}), I4 = (e) => /* @__PURE__ */ p("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M12 14C15.31 14 18 11.31 18 8C18 4.69 15.31 2 12 2C8.69002 2 6.00002 4.69 6.00002 8C6.00002 11.31 8.69002 14 12 14ZM12 4C14.21 4 16 5.79 16 8C16 10.21 14.21 12 12 12C9.79002 12 8.00002 10.21 8.00002 8C8.00002 5.79 9.79002 4 12 4ZM21.87 21.6L20.14 22.6C18.46 19.7 15.34 17.9 12.01 17.9C8.68003 17.9 5.56002 19.7 3.88002 22.6L2.15002 21.6C4.19002 18.08 7.97003 15.9 12.02 15.9C16.07 15.9 19.85 18.08 21.89 21.6H21.87Z",
    fill: "#3C4B4C"
  })
}), T4 = (e) => /* @__PURE__ */ G("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: [/* @__PURE__ */ G("g", {
    clipPath: "url(#clip0_1_120)",
    children: [/* @__PURE__ */ p("path", {
      d: "M6.82556 0H2.06333C0.923786 0 0 0.923786 0 2.06333V6.82556C0 7.9651 0.923786 8.88889 2.06333 8.88889H6.82556C7.9651 8.88889 8.88889 7.9651 8.88889 6.82556V2.06333C8.88889 0.923786 7.9651 0 6.82556 0Z",
      fill: "#3E3F3E"
    }), /* @__PURE__ */ p("path", {
      d: "M17.9367 0H13.1744C12.0349 0 11.1111 0.923786 11.1111 2.06333V6.82556C11.1111 7.9651 12.0349 8.88889 13.1744 8.88889H17.9367C19.0762 8.88889 20 7.9651 20 6.82556V2.06333C20 0.923786 19.0762 0 17.9367 0Z",
      fill: "#3E3F3E"
    }), /* @__PURE__ */ p("path", {
      d: "M6.82556 11.1111H2.06333C0.923786 11.1111 0 12.0349 0 13.1744V17.9367C0 19.0762 0.923786 20 2.06333 20H6.82556C7.9651 20 8.88889 19.0762 8.88889 17.9367V13.1744C8.88889 12.0349 7.9651 11.1111 6.82556 11.1111Z",
      fill: "#3E3F3E"
    }), /* @__PURE__ */ p("path", {
      d: "M17.9367 11.1111H13.1744C12.0349 11.1111 11.1111 12.0349 11.1111 13.1744V17.9367C11.1111 19.0762 12.0349 20 13.1744 20H17.9367C19.0762 20 20 19.0762 20 17.9367V13.1744C20 12.0349 19.0762 11.1111 17.9367 11.1111Z",
      fill: "#3E3F3E"
    })]
  }), /* @__PURE__ */ p("defs", {
    children: /* @__PURE__ */ p("clipPath", {
      id: "clip0_1_120",
      children: /* @__PURE__ */ p("rect", {
        width: "20",
        height: "20",
        fill: "white"
      })
    })
  })]
}), $4 = (e) => /* @__PURE__ */ p("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M13 1.995H11V-0.00500488H13V1.995ZM12 21.995C11.16 21.995 10.41 21.455 10.13 20.665L8.25 21.335C8.82 22.925 10.33 24.005 12.01 24.005C13.69 24.005 15.2 22.935 15.77 21.335L13.89 20.665C13.61 21.465 12.85 21.995 12.02 21.995H12ZM20 16.585C20 17.915 18.92 18.995 17.59 18.995H6.41C5.08 18.995 4 17.915 4 16.585C4 15.945 4.26 15.325 4.71 14.875L5.71 13.875C5.9 13.685 6 13.435 6 13.165V8.995C6 5.685 8.69 2.995 12 2.995C15.31 2.995 18 5.685 18 8.995V13.165C18 13.425 18.11 13.685 18.29 13.875L19.29 14.875C19.74 15.325 20 15.945 20 16.585ZM18 16.585C18 16.475 17.96 16.365 17.88 16.295L16.88 15.295C16.31 14.725 16 13.975 16 13.175V9.00499C16 6.79499 14.21 5.005 12 5.005C9.79 5.005 8 6.79499 8 9.00499V13.175C8 13.975 7.69 14.725 7.12 15.295L6.12 16.295C6.04 16.375 6 16.475 6 16.585C6 16.815 6.19 16.995 6.41 16.995H17.58C17.81 16.995 17.99 16.805 17.99 16.585H18Z",
    fill: "#3C4B4C"
  })
}), M4 = (e) => /* @__PURE__ */ p("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 16.75C9.31 16.75 8.75 16.19 8.75 15.5C8.75 14.81 9.31 14.25 10 14.25C10.69 14.25 11.25 14.81 11.25 15.5C11.25 16.19 10.69 16.75 10 16.75ZM13.91 8.68C13.74 9.06 13.53 9.39 13.27 9.66C13.01 9.93 12.73 10.17 12.44 10.38C12.15 10.59 11.87 10.78 11.61 10.97C11.35 11.16 11.13 11.36 10.97 11.59C10.8 11.81 10.72 12.07 10.72 12.37V12.78H9.12V12.34C9.12 11.9 9.2 11.53 9.36 11.22C9.52 10.91 9.73 10.63 9.98 10.38C10.23 10.13 10.5 9.91 10.79 9.7C11.08 9.49 11.35 9.27 11.6 9.04C11.85 8.81 12.06 8.56 12.22 8.27C12.38 7.98 12.47 7.65 12.47 7.27C12.47 6.89 12.37 6.51 12.18 6.17C11.99 5.83 11.7 5.56 11.33 5.35C10.96 5.14 10.51 5.04 9.98 5.04C9.49 5.04 9.05 5.13 8.66 5.32C8.27 5.51 7.97 5.77 7.74 6.11C7.52 6.45 7.4 6.85 7.4 7.31C7.4 7.48 7.42 7.65 7.45 7.81C7.49 7.98 7.54 8.15 7.62 8.33L6.06 8.88C5.95 8.62 5.86 8.36 5.81 8.09C5.76 7.83 5.73 7.57 5.73 7.3C5.73 6.53 5.92 5.86 6.3 5.28C6.68 4.71 7.19 4.26 7.83 3.94C8.47 3.62 9.19 3.46 9.98 3.46C10.86 3.46 11.6 3.63 12.23 3.97C12.85 4.31 13.33 4.77 13.67 5.35C14.01 5.93 14.17 6.57 14.17 7.28C14.17 7.83 14.09 8.29 13.92 8.67L13.91 8.68Z",
    fill: "#3C4B4C"
  })
}), L4 = (e) => /* @__PURE__ */ p("svg", {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    children: /* @__PURE__ */ p("path", {
      d: "M20.9 7.84002L19.49 9.25002L18.08 7.84002L19.49 6.43002L18.08 5.02002L16.67 6.43002L15.26 5.02002L16.67 3.61002C17.45 2.83002 18.72 2.83002 19.5 3.61002L20.91 5.02002C21.69 5.80002 21.69 7.07002 20.91 7.85002L20.9 7.84002ZM6.21997 19.69L4.09997 20.4L4.80997 18.28L15.24 7.84002L13.83 6.43002L3.21997 17.04C3.10997 17.15 3.02997 17.28 2.97997 17.43L1.56997 21.67C1.44997 22.03 1.53997 22.43 1.80997 22.69C1.99997 22.88 2.25997 22.98 2.51997 22.98C2.62997 22.98 2.72997 22.96 2.83997 22.93L7.07997 21.52C7.22997 21.47 7.35997 21.39 7.46997 21.28L18.08 10.67L16.67 9.26002L6.22997 19.7L6.21997 19.69Z",
      fillRule: "nonzero"
    })
  })
}), A4 = (e) => /* @__PURE__ */ p("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M12 24C11.11 24 10.21 23.66 9.53 22.98L8.5 21.95C8.22 21.67 7.84 21.51 7.44 21.51H5.98C4.05 21.51 2.49 19.94 2.49 18.02V16.56C2.49 16.16 2.33 15.79 2.05 15.5L1.02 14.47C-0.34 13.11 -0.34 10.89 1.02 9.53L2.05 8.5C2.33 8.22 2.49 7.84 2.49 7.44V5.98C2.49 4.05 4.06 2.49 5.98 2.49H7.44C7.84 2.49 8.21 2.33 8.5 2.05L9.53 1.02C10.89 -0.34 13.11 -0.34 14.47 1.02L15.5 2.05C15.78 2.33 16.16 2.49 16.56 2.49H18.02C19.95 2.49 21.51 4.06 21.51 5.98V7.44C21.51 7.84 21.67 8.21 21.95 8.5L22.98 9.53C24.34 10.89 24.34 13.11 22.98 14.47L21.95 15.5C21.67 15.78 21.51 16.16 21.51 16.56V18.02C21.51 19.95 19.94 21.51 18.02 21.51H16.56C16.16 21.51 15.79 21.67 15.5 21.95L14.47 22.98C13.79 23.66 12.89 24 12 24ZM5.98 4.49C5.16 4.49 4.49 5.16 4.49 5.98V7.44C4.49 8.37 4.13 9.25 3.47 9.91L2.44 10.94C2.16 11.22 2 11.6 2 12C2 12.4 2.16 12.77 2.44 13.06L3.47 14.09C4.13 14.75 4.49 15.63 4.49 16.56V18.02C4.49 18.84 5.16 19.51 5.98 19.51H7.44C8.37 19.51 9.25 19.87 9.91 20.53L10.94 21.56C11.5 22.12 12.49 22.12 13.05 21.56L14.08 20.53C14.74 19.87 15.62 19.51 16.55 19.51H18.01C18.83 19.51 19.5 18.84 19.5 18.02V16.56C19.5 15.63 19.86 14.75 20.52 14.09L21.55 13.06C21.83 12.78 21.99 12.4 21.99 12C21.99 11.6 21.83 11.23 21.55 10.94L20.52 9.91C19.86 9.25 19.5 8.37 19.5 7.44V5.98C19.5 5.16 18.83 4.49 18.01 4.49H16.55C15.62 4.49 14.74 4.13 14.08 3.47L13.05 2.44C12.49 1.88 11.5 1.88 10.94 2.44L9.91 3.47C9.25 4.13 8.37 4.49 7.44 4.49H5.98ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.35 9 9 10.35 9 12C9 13.65 10.35 15 12 15C13.65 15 15 13.65 15 12C15 10.35 13.65 9 12 9Z",
    fill: "#77828F"
  })
}), k4 = (e) => /* @__PURE__ */ p("svg", {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M3.93 17.25C3.56 16.88 2.97 16.86 2.57 17.2C1.03 18.52 0 20.86 0 23.01C0 23.56 0.45 24.01 1 24.01C3.15 24.01 5.49 22.98 6.81 21.44C7.15 21.04 7.13 20.45 6.76 20.08L3.93 17.25ZM2.12 21.89C2.32 20.91 2.76 20.04 3.25 19.39L4.62 20.76C3.97 21.25 3.1 21.69 2.12 21.89ZM23 2.52001C23 2.12001 22.84 1.73001 22.56 1.45001C22.27 1.16001 21.89 1.01001 21.49 1.01001C16.62 1.04001 12.05 2.95001 8.61 6.38001C8.38 6.61001 8.16 6.85001 7.94 7.09001C7.63 7.05001 7.32 7.02001 7 7.02001C3.14 7.02001 0 10.16 0 14.02C0 14.57 0.45 15.02 1 15.02H4.51L9 19.51V23.02C9 23.57 9.45 24.02 10 24.02C13.86 24.02 17 20.88 17 17.02C17 16.7 16.97 16.39 16.93 16.08C17.17 15.86 17.41 15.64 17.64 15.41C21.08 11.97 22.99 7.40001 23.01 2.53001L23 2.52001ZM6.39 9.06001C5.57 10.28 4.9 11.6 4.38 13.01H2.1C2.52 10.93 4.25 9.33001 6.39 9.06001ZM10.02 7.79001C12.97 4.84001 16.85 3.16001 21 3.01001C20.85 7.16001 19.17 11.04 16.22 13.99C14.5 15.71 12.46 17 10.15 17.81L6.2 13.86C7.02 11.55 8.3 9.51001 10.02 7.79001ZM11 21.91V19.63C12.41 19.12 13.73 18.44 14.95 17.62C14.69 19.76 13.09 21.48 11 21.91ZM12.96 11.05C12.33 10.42 12.33 9.40001 12.96 8.77001C13.59 8.14001 14.61 8.14001 15.24 8.77001C15.87 9.40001 15.87 10.42 15.24 11.05C14.61 11.68 13.59 11.68 12.96 11.05Z",
    fill: "#77828F"
  })
}), _4 = (e) => /* @__PURE__ */ p("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M23.7125 12.7099L19.7125 16.7099L18.3025 15.2999L20.5925 13.0099H10.0025V11.0099H20.5925L18.3025 8.71995L19.7125 7.30995L23.7125 11.3099C24.1025 11.6999 24.1025 12.3299 23.7125 12.7199V12.7099ZM4.0525 16.9499C1.3225 14.2199 1.3225 9.77995 4.0525 7.04995C6.7825 4.31995 11.2225 4.31995 13.9525 7.04995L15.3625 5.63995C11.8525 2.12995 6.1425 2.12995 2.6325 5.63995C-0.8775 9.14995 -0.8775 14.8599 2.6325 18.3699C4.3825 20.1199 6.6925 20.9999 8.9925 20.9999C11.2925 20.9999 13.6025 20.1199 15.3525 18.3699L13.9425 16.9599C11.2125 19.6899 6.7725 19.6899 4.0425 16.9599L4.0525 16.9499Z",
    fill: "#77828F"
  })
}), F4 = (e) => /* @__PURE__ */ p("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C18.62 24 24 18.62 24 12C24 5.38 18.62 0 12 0ZM21.95 11H19.47C19.33 8.1 18.57 5.52 17.39 3.59C19.89 5.2 21.64 7.89 21.95 11ZM11 2.18V11H6.53C6.78 6.63 8.66 3 11 2.18ZM11 13V21.82C8.65 21 6.78 17.37 6.53 13H11ZM13 21.82V13H17.47C17.22 17.37 15.34 21 13 21.82ZM13 11V2.18C15.35 3 17.22 6.63 17.47 11H13ZM6.61 3.59C5.44 5.52 4.68 8.1 4.53 11H2.05C2.36 7.89 4.1 5.2 6.61 3.59ZM2.05 13H4.53C4.67 15.9 5.43 18.48 6.61 20.41C4.11 18.8 2.36 16.11 2.05 13ZM17.39 20.41C18.56 18.48 19.32 15.9 19.47 13H21.95C21.64 16.11 19.9 18.8 17.39 20.41Z",
    fill: "#3C4B4C"
  })
}), N4 = (e) => /* @__PURE__ */ p("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    children: /* @__PURE__ */ p("path", {
      d: "M18.7667 9.29168L3.76667 0.12501C3.50833 -0.0333238 3.19167 -0.0333238 2.925 0.108343C2.65833 0.258343 2.5 0.533343 2.5 0.833343V19.1667C2.5 19.4667 2.66667 19.75 2.925 19.8917C3.05 19.9583 3.19167 20 3.33333 20C3.48333 20 3.63333 19.9583 3.76667 19.875L18.7667 10.7083C19.0167 10.5583 19.1667 10.2917 19.1667 10C19.1667 9.70834 19.0167 9.44168 18.7667 9.29168ZM4.16667 17.6833V2.31668L16.7333 10L4.16667 17.6833Z",
      fillRule: "nonzero"
    })
  })
}), V4 = (e) => /* @__PURE__ */ p("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ p("path", {
    d: "M17.5 2.49999V17.5C17.5 18.4167 16.75 19.1667 15.8333 19.1667H11.6667V17.5H15.8333V2.49999H4.16667V17.5H8.33333V19.1667H4.16667C3.25 19.1667 2.5 18.4167 2.5 17.5V2.49999C2.5 1.58333 3.25 0.833328 4.16667 0.833328H15.8333C16.75 0.833328 17.5 1.58333 17.5 2.49999ZM14.1667 4.16666H12.5V6.66666H14.1667V4.16666ZM9.16667 6.66666H10.8333V4.16666H9.16667V6.66666ZM7.5 4.16666H5.83333V6.66666H7.5V4.16666ZM12.5 10.8333H14.1667V8.33333H12.5V10.8333ZM9.16667 10.8333H10.8333V8.33333H9.16667V10.8333ZM7.5 8.33333H5.83333V10.8333H7.5V8.33333ZM12.5 15H14.1667V12.5H12.5V15ZM9.16667 15H10.8333V12.5H9.16667V15ZM5.83333 15H7.5V12.5H5.83333V15Z",
    fill: "currentColor"
  })
}), D4 = ({
  logoUrl: e,
  crumbs: t,
  navbarActions: r,
  userInitials: n,
  className: o,
  testId: i
}) => /* @__PURE__ */ G("div", {
  className: q("flex flex-row items-center bg-neutral-50 border border-light h-12 w-full", o),
  children: [r && /* @__PURE__ */ p("div", {
    className: "h-full flex items-center border-r border-light w-12",
    children: /* @__PURE__ */ p("div", {
      className: "mx-auto",
      children: r
    })
  }), e && /* @__PURE__ */ p("div", {
    className: "px-4",
    children: /* @__PURE__ */ p("img", {
      alt: "textLogo",
      src: e
    })
  }), t && /* @__PURE__ */ p("div", {
    className: q("mx-4 block"),
    children: t.map((a, l) => /* @__PURE__ */ G("div", {
      className: q("inline-block"),
      children: [a, l < t.length - 1 && /* @__PURE__ */ p(ze, {
        icon: _p,
        className: q("inline-block text-light px-2")
      })]
    }, l))
  }), n && /* @__PURE__ */ p("div", {
    className: "flex items-center h-full border-l border-light ml-auto px-2",
    children: /* @__PURE__ */ p("div", {
      className: "flex flex-row items-center h-8 w-8 bg-orange-400 rounded-full text-center text-white font-bold px-auto",
      children: /* @__PURE__ */ p("span", {
        className: "mx-auto",
        children: n
      })
    })
  })]
}), H4 = ({
  title: e,
  description: t,
  type: r,
  icon: n,
  onCloseFn: o,
  className: i,
  testId: a,
  ...l
}) => /* @__PURE__ */ G("div", {
  className: q("inline-flex flex-row items-center p-4 rounded shadow", ee(r === "success")("bg-white text-success border border-light"), ee(r === "info")("bg-white text-primary border border-light"), ee(r === "error")("bg-error text-white border border-error"), i),
  "data-testid": a,
  ...l,
  children: [/* @__PURE__ */ p("div", {
    className: "inline-block min-w-[1px] h-full",
    children: /* @__PURE__ */ p(ze, {
      scale: 2,
      icon: n
    })
  }), /* @__PURE__ */ G("div", {
    className: "inline-block align-top ml-4",
    children: [/* @__PURE__ */ p("h2", {
      className: "text-xl font-bold mb-1",
      children: e
    }), /* @__PURE__ */ p("span", {
      className: q(ee(r !== "error")("text-dark")),
      children: t
    })]
  }), /* @__PURE__ */ p("div", {
    className: q("flex ml-4", ee(r !== "error")("text-dark")),
    children: /* @__PURE__ */ p(ft, {
      variant: "text",
      color: "gray",
      size: "large",
      className: "text-4xl",
      onClick: o,
      icon: () => Tu({
        color: ee(r === "error")("white")
      })
    })
  })]
}), jr = Math.min, or = Math.max, $o = Math.round, bn = (e) => ({
  x: e,
  y: e
}), Gp = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Up = {
  start: "end",
  end: "start"
};
function aa(e, t, r) {
  return or(e, jr(t, r));
}
function oo(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function zn(e) {
  return e.split("-")[0];
}
function io(e) {
  return e.split("-")[1];
}
function $u(e) {
  return e === "x" ? "y" : "x";
}
function il(e) {
  return e === "y" ? "height" : "width";
}
function ii(e) {
  return ["top", "bottom"].includes(zn(e)) ? "y" : "x";
}
function al(e) {
  return $u(ii(e));
}
function Wp(e, t, r) {
  r === void 0 && (r = !1);
  const n = io(e), o = al(e), i = il(o);
  let a = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Mo(a)), [a, Mo(a)];
}
function Zp(e) {
  const t = Mo(e);
  return [la(e), t, la(t)];
}
function la(e) {
  return e.replace(/start|end/g, (t) => Up[t]);
}
function qp(e, t, r) {
  const n = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? o : n : t ? n : o;
    case "left":
    case "right":
      return t ? i : a;
    default:
      return [];
  }
}
function Yp(e, t, r, n) {
  const o = io(e);
  let i = qp(zn(e), r === "start", n);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(la)))), i;
}
function Mo(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Gp[t]);
}
function Kp(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Mu(e) {
  return typeof e != "number" ? Kp(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Lo(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Kl(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const i = ii(t), a = al(t), l = il(a), s = zn(t), u = i === "y", c = n.x + n.width / 2 - o.width / 2, d = n.y + n.height / 2 - o.height / 2, f = n[l] / 2 - o[l] / 2;
  let v;
  switch (s) {
    case "top":
      v = {
        x: c,
        y: n.y - o.height
      };
      break;
    case "bottom":
      v = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      v = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      v = {
        x: n.x - o.width,
        y: d
      };
      break;
    default:
      v = {
        x: n.x,
        y: n.y
      };
  }
  switch (io(t)) {
    case "start":
      v[a] -= f * (r && u ? -1 : 1);
      break;
    case "end":
      v[a] += f * (r && u ? -1 : 1);
      break;
  }
  return v;
}
const Xp = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = r, l = i.filter(Boolean), s = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: c,
    y: d
  } = Kl(u, n, s), f = n, v = {}, h = 0;
  for (let m = 0; m < l.length; m++) {
    const {
      name: g,
      fn: C
    } = l[m], {
      x,
      y: S,
      data: w,
      reset: y
    } = await C({
      x: c,
      y: d,
      initialPlacement: n,
      placement: f,
      strategy: o,
      middlewareData: v,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = x != null ? x : c, d = S != null ? S : d, v = {
      ...v,
      [g]: {
        ...v[g],
        ...w
      }
    }, y && h <= 50 && (h++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (u = y.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : y.rects), {
      x: c,
      y: d
    } = Kl(u, f, s)), m = -1);
  }
  return {
    x: c,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: v
  };
};
async function Lu(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: i,
    rects: a,
    elements: l,
    strategy: s
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: v = 0
  } = oo(t, e), h = Mu(v), g = l[f ? d === "floating" ? "reference" : "floating" : d], C = Lo(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(g))) == null || r ? g : g.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: s
  })), x = d === "floating" ? {
    ...a.floating,
    x: n,
    y: o
  } : a.reference, S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), w = await (i.isElement == null ? void 0 : i.isElement(S)) ? await (i.getScale == null ? void 0 : i.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = Lo(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: x,
    offsetParent: S,
    strategy: s
  }) : x);
  return {
    top: (C.top - y.top + h.top) / w.y,
    bottom: (y.bottom - C.bottom + h.bottom) / w.y,
    left: (C.left - y.left + h.left) / w.x,
    right: (y.right - C.right + h.right) / w.x
  };
}
const Jp = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: o,
      rects: i,
      platform: a,
      elements: l,
      middlewareData: s
    } = t, {
      element: u,
      padding: c = 0
    } = oo(e, t) || {};
    if (u == null)
      return {};
    const d = Mu(c), f = {
      x: r,
      y: n
    }, v = al(o), h = il(v), m = await a.getDimensions(u), g = v === "y", C = g ? "top" : "left", x = g ? "bottom" : "right", S = g ? "clientHeight" : "clientWidth", w = i.reference[h] + i.reference[v] - f[v] - i.floating[h], y = f[v] - i.reference[v], O = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let P = O ? O[S] : 0;
    (!P || !await (a.isElement == null ? void 0 : a.isElement(O))) && (P = l.floating[S] || i.floating[h]);
    const M = w / 2 - y / 2, I = P / 2 - m[h] / 2 - 1, k = jr(d[C], I), R = jr(d[x], I), A = k, L = P - m[h] - R, B = P / 2 - m[h] / 2 + M, W = aa(A, B, L), U = !s.arrow && io(o) != null && B !== W && i.reference[h] / 2 - (B < A ? k : R) - m[h] / 2 < 0, X = U ? B < A ? B - A : B - L : 0;
    return {
      [v]: f[v] + X,
      data: {
        [v]: W,
        centerOffset: B - W - X,
        ...U && {
          alignmentOffset: X
        }
      },
      reset: U
    };
  }
}), Qp = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: l,
        platform: s,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: m = !0,
        ...g
      } = oo(e, t);
      if ((r = i.arrow) != null && r.alignmentOffset)
        return {};
      const C = zn(o), x = zn(l) === l, S = await (s.isRTL == null ? void 0 : s.isRTL(u.floating)), w = f || (x || !m ? [Mo(l)] : Zp(l));
      !f && h !== "none" && w.push(...Yp(l, m, h, S));
      const y = [l, ...w], O = await Lu(t, g), P = [];
      let M = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (c && P.push(O[C]), d) {
        const A = Wp(o, a, S);
        P.push(O[A[0]], O[A[1]]);
      }
      if (M = [...M, {
        placement: o,
        overflows: P
      }], !P.every((A) => A <= 0)) {
        var I, k;
        const A = (((I = i.flip) == null ? void 0 : I.index) || 0) + 1, L = y[A];
        if (L)
          return {
            data: {
              index: A,
              overflows: M
            },
            reset: {
              placement: L
            }
          };
        let B = (k = M.filter((W) => W.overflows[0] <= 0).sort((W, U) => W.overflows[1] - U.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!B)
          switch (v) {
            case "bestFit": {
              var R;
              const W = (R = M.map((U) => [U.placement, U.overflows.filter((X) => X > 0).reduce((X, D) => X + D, 0)]).sort((U, X) => U[1] - X[1])[0]) == null ? void 0 : R[0];
              W && (B = W);
              break;
            }
            case "initialPlacement":
              B = l;
              break;
          }
        if (o !== B)
          return {
            reset: {
              placement: B
            }
          };
      }
      return {};
    }
  };
};
async function e0(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), a = zn(r), l = io(r), s = ii(r) === "y", u = ["left", "top"].includes(a) ? -1 : 1, c = i && s ? -1 : 1, d = oo(t, e);
  let {
    mainAxis: f,
    crossAxis: v,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return l && typeof h == "number" && (v = l === "end" ? h * -1 : h), s ? {
    x: v * c,
    y: f * u
  } : {
    x: f * u,
    y: v * c
  };
}
const t0 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: l
      } = t, s = await e0(t, e);
      return a === ((r = l.offset) == null ? void 0 : r.placement) && (n = l.arrow) != null && n.alignmentOffset ? {} : {
        x: o + s.x,
        y: i + s.y,
        data: {
          ...s,
          placement: a
        }
      };
    }
  };
}, n0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (g) => {
            let {
              x: C,
              y: x
            } = g;
            return {
              x: C,
              y: x
            };
          }
        },
        ...s
      } = oo(e, t), u = {
        x: r,
        y: n
      }, c = await Lu(t, s), d = ii(zn(o)), f = $u(d);
      let v = u[f], h = u[d];
      if (i) {
        const g = f === "y" ? "top" : "left", C = f === "y" ? "bottom" : "right", x = v + c[g], S = v - c[C];
        v = aa(x, v, S);
      }
      if (a) {
        const g = d === "y" ? "top" : "left", C = d === "y" ? "bottom" : "right", x = h + c[g], S = h - c[C];
        h = aa(x, h, S);
      }
      const m = l.fn({
        ...t,
        [f]: v,
        [d]: h
      });
      return {
        ...m,
        data: {
          x: m.x - r,
          y: m.y - n
        }
      };
    }
  };
};
function yn(e) {
  return Au(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function xt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Sn(e) {
  var t;
  return (t = (Au(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Au(e) {
  return e instanceof Node || e instanceof xt(e).Node;
}
function nn(e) {
  return e instanceof Element || e instanceof xt(e).Element;
}
function Ut(e) {
  return e instanceof HTMLElement || e instanceof xt(e).HTMLElement;
}
function Xl(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof xt(e).ShadowRoot;
}
function ao(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = Tt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(o);
}
function r0(e) {
  return ["table", "td", "th"].includes(yn(e));
}
function ll(e) {
  const t = sl(), r = Tt(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function ku(e) {
  let t = ur(e);
  for (; Ut(t) && !ai(t); ) {
    if (ll(t))
      return t;
    t = ur(t);
  }
  return null;
}
function sl() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ai(e) {
  return ["html", "body", "#document"].includes(yn(e));
}
function Tt(e) {
  return xt(e).getComputedStyle(e);
}
function li(e) {
  return nn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ur(e) {
  if (yn(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || Xl(e) && e.host || Sn(e);
  return Xl(t) ? t.host : t;
}
function _u(e) {
  const t = ur(e);
  return ai(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ut(t) && ao(t) ? t : _u(t);
}
function sa(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = _u(e), i = o === ((n = e.ownerDocument) == null ? void 0 : n.body), a = xt(o);
  return i ? t.concat(a, a.visualViewport || [], ao(o) ? o : [], a.frameElement && r ? sa(a.frameElement) : []) : t.concat(o, sa(o, [], r));
}
function Fu(e) {
  const t = Tt(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = Ut(e), i = o ? e.offsetWidth : r, a = o ? e.offsetHeight : n, l = $o(r) !== i || $o(n) !== a;
  return l && (r = i, n = a), {
    width: r,
    height: n,
    $: l
  };
}
function Nu(e) {
  return nn(e) ? e : e.contextElement;
}
function ir(e) {
  const t = Nu(e);
  if (!Ut(t))
    return bn(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: i
  } = Fu(t);
  let a = (i ? $o(r.width) : r.width) / n, l = (i ? $o(r.height) : r.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: a,
    y: l
  };
}
const o0 = /* @__PURE__ */ bn(0);
function Vu(e) {
  const t = xt(e);
  return !sl() || !t.visualViewport ? o0 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function i0(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== xt(e) ? !1 : t;
}
function Gr(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), i = Nu(e);
  let a = bn(1);
  t && (n ? nn(n) && (a = ir(n)) : a = ir(e));
  const l = i0(i, r, n) ? Vu(i) : bn(0);
  let s = (o.left + l.x) / a.x, u = (o.top + l.y) / a.y, c = o.width / a.x, d = o.height / a.y;
  if (i) {
    const f = xt(i), v = n && nn(n) ? xt(n) : n;
    let h = f.frameElement;
    for (; h && n && v !== f; ) {
      const m = ir(h), g = h.getBoundingClientRect(), C = Tt(h), x = g.left + (h.clientLeft + parseFloat(C.paddingLeft)) * m.x, S = g.top + (h.clientTop + parseFloat(C.paddingTop)) * m.y;
      s *= m.x, u *= m.y, c *= m.x, d *= m.y, s += x, u += S, h = xt(h).frameElement;
    }
  }
  return Lo({
    width: c,
    height: d,
    x: s,
    y: u
  });
}
const a0 = [":popover-open", ":modal"];
function Du(e) {
  let t = !1, r = 0, n = 0;
  function o(i) {
    try {
      t = t || e.matches(i);
    } catch {
    }
  }
  if (a0.forEach((i) => {
    o(i);
  }), t) {
    const i = ku(e);
    if (i) {
      const a = i.getBoundingClientRect();
      r = a.x, n = a.y;
    }
  }
  return [t, r, n];
}
function l0(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const i = Sn(n), [a] = t ? Du(t.floating) : [!1];
  if (n === i || a)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = bn(1);
  const u = bn(0), c = Ut(n);
  if ((c || !c && o !== "fixed") && ((yn(n) !== "body" || ao(i)) && (l = li(n)), Ut(n))) {
    const d = Gr(n);
    s = ir(n), u.x = d.x + n.clientLeft, u.y = d.y + n.clientTop;
  }
  return {
    width: r.width * s.x,
    height: r.height * s.y,
    x: r.x * s.x - l.scrollLeft * s.x + u.x,
    y: r.y * s.y - l.scrollTop * s.y + u.y
  };
}
function s0(e) {
  return Array.from(e.getClientRects());
}
function Hu(e) {
  return Gr(Sn(e)).left + li(e).scrollLeft;
}
function u0(e) {
  const t = Sn(e), r = li(e), n = e.ownerDocument.body, o = or(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = or(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let a = -r.scrollLeft + Hu(e);
  const l = -r.scrollTop;
  return Tt(n).direction === "rtl" && (a += or(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: l
  };
}
function c0(e, t) {
  const r = xt(e), n = Sn(e), o = r.visualViewport;
  let i = n.clientWidth, a = n.clientHeight, l = 0, s = 0;
  if (o) {
    i = o.width, a = o.height;
    const u = sl();
    (!u || u && t === "fixed") && (l = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l,
    y: s
  };
}
function d0(e, t) {
  const r = Gr(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, i = Ut(e) ? ir(e) : bn(1), a = e.clientWidth * i.x, l = e.clientHeight * i.y, s = o * i.x, u = n * i.y;
  return {
    width: a,
    height: l,
    x: s,
    y: u
  };
}
function Jl(e, t, r) {
  let n;
  if (t === "viewport")
    n = c0(e, r);
  else if (t === "document")
    n = u0(Sn(e));
  else if (nn(t))
    n = d0(t, r);
  else {
    const o = Vu(e);
    n = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Lo(n);
}
function zu(e, t) {
  const r = ur(e);
  return r === t || !nn(r) || ai(r) ? !1 : Tt(r).position === "fixed" || zu(r, t);
}
function f0(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = sa(e, [], !1).filter((l) => nn(l) && yn(l) !== "body"), o = null;
  const i = Tt(e).position === "fixed";
  let a = i ? ur(e) : e;
  for (; nn(a) && !ai(a); ) {
    const l = Tt(a), s = ll(a);
    !s && l.position === "fixed" && (o = null), (i ? !s && !o : !s && l.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || ao(a) && !s && zu(e, a)) ? n = n.filter((c) => c !== a) : o = l, a = ur(a);
  }
  return t.set(e, n), n;
}
function p0(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const a = [...r === "clippingAncestors" ? f0(t, this._c) : [].concat(r), n], l = a[0], s = a.reduce((u, c) => {
    const d = Jl(t, c, o);
    return u.top = or(d.top, u.top), u.right = jr(d.right, u.right), u.bottom = jr(d.bottom, u.bottom), u.left = or(d.left, u.left), u;
  }, Jl(t, l, o));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function g0(e) {
  const {
    width: t,
    height: r
  } = Fu(e);
  return {
    width: t,
    height: r
  };
}
function v0(e, t, r, n) {
  const o = Ut(t), i = Sn(t), a = r === "fixed", l = Gr(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = bn(0);
  if (o || !o && !a)
    if ((yn(t) !== "body" || ao(i)) && (s = li(t)), o) {
      const m = Gr(t, !0, a, t);
      u.x = m.x + t.clientLeft, u.y = m.y + t.clientTop;
    } else
      i && (u.x = Hu(i));
  let c = l.left + s.scrollLeft - u.x, d = l.top + s.scrollTop - u.y;
  const [f, v, h] = Du(n);
  return f && (c += v, d += h, o && (c += t.clientLeft, d += t.clientTop)), {
    x: c,
    y: d,
    width: l.width,
    height: l.height
  };
}
function Ql(e, t) {
  return !Ut(e) || Tt(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Bu(e, t) {
  const r = xt(e);
  if (!Ut(e))
    return r;
  let n = Ql(e, t);
  for (; n && r0(n) && Tt(n).position === "static"; )
    n = Ql(n, t);
  return n && (yn(n) === "html" || yn(n) === "body" && Tt(n).position === "static" && !ll(n)) ? r : n || ku(e) || r;
}
const m0 = async function(e) {
  const t = this.getOffsetParent || Bu, r = this.getDimensions;
  return {
    reference: v0(e.reference, await t(e.floating), e.strategy, e.floating),
    floating: {
      x: 0,
      y: 0,
      ...await r(e.floating)
    }
  };
};
function h0(e) {
  return Tt(e).direction === "rtl";
}
const b0 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: l0,
  getDocumentElement: Sn,
  getClippingRect: p0,
  getOffsetParent: Bu,
  getElementRects: m0,
  getClientRects: s0,
  getDimensions: g0,
  getScale: ir,
  isElement: nn,
  isRTL: h0
}, y0 = n0, C0 = Qp, es = Jp, x0 = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: b0,
    ...r
  }, i = {
    ...o.platform,
    _c: n
  };
  return Xp(e, t, {
    ...o,
    platform: i
  });
};
var ua = typeof document < "u" ? Sa : Ce;
function Ao(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length)
        return !1;
      for (n = r; n-- !== 0; )
        if (!Ao(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), r = o.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = o[n];
      if (!(i === "_owner" && e.$$typeof) && !Ao(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function w0(e) {
  const t = N.useRef(e);
  return ua(() => {
    t.current = e;
  }), t;
}
function S0(e) {
  let {
    middleware: t,
    placement: r = "bottom",
    strategy: n = "absolute",
    whileElementsMounted: o
  } = e === void 0 ? {} : e;
  const [i, a] = N.useState({
    x: null,
    y: null,
    strategy: n,
    placement: r,
    middlewareData: {}
  }), [l, s] = N.useState(t);
  Ao(l == null ? void 0 : l.map((w) => {
    let {
      name: y,
      options: O
    } = w;
    return {
      name: y,
      options: O
    };
  }), t == null ? void 0 : t.map((w) => {
    let {
      name: y,
      options: O
    } = w;
    return {
      name: y,
      options: O
    };
  })) || s(t);
  const u = N.useRef(null), c = N.useRef(null), d = N.useRef(null), f = N.useRef(i), v = w0(o), h = N.useCallback(() => {
    !u.current || !c.current || x0(u.current, c.current, {
      middleware: l,
      placement: r,
      strategy: n
    }).then((w) => {
      m.current && !Ao(f.current, w) && (f.current = w, eu.flushSync(() => {
        a(w);
      }));
    });
  }, [l, r, n]);
  ua(() => {
    m.current && h();
  }, [h]);
  const m = N.useRef(!1);
  ua(() => (m.current = !0, () => {
    m.current = !1;
  }), []);
  const g = N.useCallback(() => {
    if (typeof d.current == "function" && (d.current(), d.current = null), u.current && c.current)
      if (v.current) {
        const w = v.current(u.current, c.current, h);
        d.current = w;
      } else
        h();
  }, [h, v]), C = N.useCallback((w) => {
    u.current = w, g();
  }, [g]), x = N.useCallback((w) => {
    c.current = w, g();
  }, [g]), S = N.useMemo(() => ({
    reference: u,
    floating: c
  }), []);
  return N.useMemo(() => ({
    ...i,
    update: h,
    refs: S,
    reference: C,
    floating: x
  }), [i, h, S, C, x]);
}
const R0 = (e) => {
  const {
    element: t,
    padding: r
  } = e;
  function n(o) {
    return Object.prototype.hasOwnProperty.call(o, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(o) {
      return n(t) ? t.current != null ? es({
        element: t.current,
        padding: r
      }).fn(o) : {} : t ? es({
        element: t,
        padding: r
      }).fn(o) : {};
    }
  };
}, z4 = ({
  buttonProps: e,
  placement: t,
  content: r,
  width: n
}) => {
  const o = oe(null), {
    x: i,
    y: a,
    reference: l,
    floating: s,
    strategy: u,
    middlewareData: {
      arrow: {
        x: c,
        y: d
      } = {}
    }
  } = S0({
    placement: t,
    strategy: "absolute",
    middleware: [t0(20), C0(), y0(), R0({
      element: o
    })]
  }), f = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }[t];
  return /* @__PURE__ */ p(ki, {
    children: /* @__PURE__ */ G(It, {
      children: [/* @__PURE__ */ p(ki.Button, {
        as: ft,
        ...e,
        ref: l
      }), /* @__PURE__ */ G(ki.Panel, {
        ref: s,
        className: "drop-shadow-[0_5px_8px_rgba(0,0,0,0.25)]",
        style: {
          position: u,
          top: a || 0,
          left: i || 0,
          width: n
        },
        children: [/* @__PURE__ */ p("div", {
          id: "arrow",
          ref: o,
          className: "bg-white absolute w-4 h-4 rotate-45 shadow",
          style: {
            left: c,
            top: d,
            right: "",
            bottom: "",
            [f]: "-4px"
          }
        }), /* @__PURE__ */ p("div", {
          className: "p-4 bg-white relative",
          children: r
        })]
      })]
    })
  });
}, B4 = ({
  selected: e,
  onValueChange: t,
  items: r,
  label: n,
  noValueLabel: o,
  className: i,
  width: a,
  testId: l
}) => {
  const s = on(l);
  return /* @__PURE__ */ p("div", {
    className: i,
    style: {
      width: a === void 0 ? "100%" : a
    },
    children: /* @__PURE__ */ G(Rr, {
      value: e,
      onChange: (c) => {
        t(c);
      },
      children: [/* @__PURE__ */ p(Rr.Label, {
        children: n !== void 0 && /* @__PURE__ */ p("div", {
          className: "mb-1",
          children: /* @__PURE__ */ p("span", {
            className: "text-dark",
            children: n
          })
        })
      }), /* @__PURE__ */ G(Rr.Button, {
        "data-testid": s("open-dropdown"),
        className: "relative inline-flex pl-3 py-2 mb-1 items-center bg-grey-active w-full text-left rounded-md hover:bg-grey-hover active:bg-grey-filled-active focus:outline-none",
        children: [e !== void 0 && /* @__PURE__ */ p("span", {
          children: e.label
        }), e === void 0 && /* @__PURE__ */ p("span", {
          className: "text-gray",
          children: o != null ? o : "Choose value"
        }), /* @__PURE__ */ p(ze, {
          icon: oi,
          className: "text-gray ml-auto mr-3"
        })]
      }), /* @__PURE__ */ p(hn, {
        as: Ge,
        enter: "transition duration-100 ease-out",
        enterFrom: "transform scale-95 opacity-0",
        enterTo: "transform scale-100 opacity-100",
        leave: "transition duration-75 ease-out",
        leaveFrom: "transform scale-100 opacity-100",
        leaveTo: "transform scale-95 opacity-0",
        children: /* @__PURE__ */ p(Rr.Options, {
          className: "relative w-full z-50",
          children: /* @__PURE__ */ p("div", {
            className: "absolute z-50 bg-white shadow-lg rounded-md border w-full py-2 px-2 border-grey-hover focus:outline-none",
            children: r.map((c, d) => /* @__PURE__ */ p(Rr.Option, {
              value: c,
              children: ({
                active: f,
                selected: v
              }) => /* @__PURE__ */ G("div", {
                className: q("inline-flex w-full items-center pl-3 py-2 rounded-md", ee(f)("bg-primary-active")),
                children: [/* @__PURE__ */ p(ze, {
                  className: q("pr-2", ee(v)("text-primary"), ee(!v)("text-transparent")),
                  scale: 1.2,
                  icon: ol
                }), /* @__PURE__ */ p("span", {
                  children: c.label
                })]
              })
            }, d))
          })
        })
      })]
    })
  });
}, j4 = ({
  className: e,
  testId: t,
  checked: r,
  setChecked: n,
  title: o,
  disabled: i = !1,
  disabledTooltip: a
}) => {
  const l = gt(() => {
    n && !i && n(!r);
  }, [r, i, n]), [s, u] = $e(!1), c = () => {
    i && a && u(!0);
  }, d = () => {
    u(!1);
  };
  return /* @__PURE__ */ p(vr, {
    title: a,
    open: s,
    onClose: d,
    onOpen: c,
    children: /* @__PURE__ */ p("div", {
      onMouseEnter: c,
      onMouseLeave: d,
      children: /* @__PURE__ */ G(U1, {
        checked: r,
        className: q(ee(!i)(r ? "bg-primary" : "bg-gray"), ee(i)($`bg-dark`), $`relative inline-flex h-6 w-12 shrink-0 rounded-full border border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-4 focus-visible:ring-opacity-75`, ee(!i)($`cursor-pointer`), ee(i)($`cursor-not-allowed`), e),
        "data-testid": t,
        disabled: i,
        onChange: l,
        title: o,
        children: [o && /* @__PURE__ */ p("span", {
          className: "sr-only",
          children: o
        }), /* @__PURE__ */ p("span", {
          "aria-hidden": "true",
          className: q(r ? "translate-x-[17px]" : "translate-x-0", $`pointer-events-none inline-block h-[17px] w-[17px] transform rounded-full shadow-lg ring-0 transition duration-200 ease-in-out`, ee(!i)($`bg-white`), ee(i)($`bg-light`))
        })]
      })
    })
  });
};
/**
 * table-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function pe() {
  return pe = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pe.apply(this, arguments);
}
function ju(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function E0(e, t) {
  if (!!e) {
    if (typeof e == "string")
      return ts(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return ts(e, t);
  }
}
function ts(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function lo(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = E0(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O0(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Gu(e) {
  var t = O0(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function vn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function $t(e, t) {
  return function(r) {
    t.setState(function(n) {
      var o;
      return pe({}, n, (o = {}, o[e] = vn(r, n[e]), o));
    });
  };
}
function ko(e) {
  return e instanceof Function;
}
function P0(e, t) {
  var r = [], n = function o(i) {
    i.forEach(function(a) {
      r.push(a);
      var l = t(a);
      l != null && l.length && o(l);
    });
  };
  return n(e), r;
}
function he(e, t, r) {
  var n = [], o;
  return function() {
    var i;
    r.key && r.debug && (i = Date.now());
    var a = e(), l = a.length !== n.length || a.some(function(h, m) {
      return n[m] !== h;
    });
    if (l) {
      var s = o, u;
      if (r.key && r.debug && (u = Date.now()), o = t.apply(void 0, a), n = a, r == null || r.onChange == null || r.onChange(o, s), r.key && r.debug && r != null && r.debug()) {
        var c = Math.round((Date.now() - i) * 100) / 100, d = Math.round((Date.now() - u) * 100) / 100, f = d / 16, v = function(m, g) {
          for (m = String(m); m.length < g; )
            m = " " + m;
          return m;
        };
        console.info("%c\u23F1 " + v(d, 5) + " /" + v(c, 5) + " ms", `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(` + Math.max(0, Math.min(120 - 120 * f, 120)) + "deg 100% 31%);", r == null ? void 0 : r.key, pe({
          length: n.length + " -> " + a.length
        }, a.map(function(h, m) {
          return n[m] !== a[m] ? [m, n[m], a[m]] : !1;
        }).filter(Boolean).reduce(function(h, m) {
          var g, C = m[0], x = m[1];
          return pe({}, h, (g = {}, g[C] = x, g));
        }, {}), {
          parent
        }));
      }
      s = void 0;
    }
    return o;
  };
}
var I0 = {
  createInstance: function(t) {
    return {
      getDefaultColumn: he(function() {
        return [t.options.defaultColumn];
      }, function(r) {
        var n;
        return r = (n = r) != null ? n : {}, pe({
          header: function(i) {
            return i.header.column.id;
          },
          footer: function(i) {
            return i.header.column.id;
          },
          cell: function(i) {
            var a = i.value, l = a === void 0 ? "" : a;
            return typeof l == "boolean" ? l.toString() : l;
          }
        }, t._features.reduce(function(o, i) {
          return Object.assign(o, i.getDefaultColumn == null ? void 0 : i.getDefaultColumn());
        }, {}), r);
      }, {
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugColumns;
        },
        key: "getDefaultColumn"
      }),
      getColumnDefs: function() {
        return t.options.columns;
      },
      createColumn: function(n, o, i) {
        var a, l, s = t.getDefaultColumn(), u = (a = (l = n.id) != null ? l : n.accessorKey) != null ? a : typeof n.header == "string" ? n.header : void 0, c;
        if (n.accessorFn ? c = n.accessorFn : n.accessorKey && (c = function(v) {
          return v[n.accessorKey];
        }), !u)
          throw process.env.NODE_ENV !== "production" ? new Error(n.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
        var d = pe({}, s, n, {
          id: "" + u,
          accessorFn: c,
          parent: i,
          depth: o,
          columnDef: n,
          columnDefType: n.columnDefType,
          columns: [],
          getFlatColumns: he(function() {
            return [!0];
          }, function() {
            var f;
            return [d].concat((f = d.columns) == null ? void 0 : f.flatMap(function(v) {
              return v.getFlatColumns();
            }));
          }, {
            key: "column.getFlatColumns",
            debug: function() {
              var v;
              return (v = t.options.debugAll) != null ? v : t.options.debugColumns;
            }
          }),
          getLeafColumns: he(function() {
            return [t._getOrderColumnsFn()];
          }, function(f) {
            var v;
            if ((v = d.columns) != null && v.length) {
              var h = d.columns.flatMap(function(m) {
                return m.getLeafColumns();
              });
              return f(h);
            }
            return [d];
          }, {
            key: "column.getLeafColumns",
            debug: function() {
              var v;
              return (v = t.options.debugAll) != null ? v : t.options.debugColumns;
            }
          })
        });
        return d = t._features.reduce(function(f, v) {
          return Object.assign(f, v.createColumn == null ? void 0 : v.createColumn(d, t));
        }, d), d;
      },
      getAllColumns: he(function() {
        return [t.getColumnDefs()];
      }, function(r) {
        var n = function o(i, a, l) {
          return l === void 0 && (l = 0), i.map(function(s) {
            var u = t.createColumn(s, l, a);
            return u.columns = s.columns ? o(s.columns, u, l + 1) : [], u;
          });
        };
        return n(r);
      }, {
        key: "getAllColumns",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugColumns;
        }
      }),
      getAllFlatColumns: he(function() {
        return [t.getAllColumns()];
      }, function(r) {
        return r.flatMap(function(n) {
          return n.getFlatColumns();
        });
      }, {
        key: "getAllFlatColumns",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugColumns;
        }
      }),
      getAllFlatColumnsById: he(function() {
        return [t.getAllFlatColumns()];
      }, function(r) {
        return r.reduce(function(n, o) {
          return n[o.id] = o, n;
        }, {});
      }, {
        key: "getAllFlatColumnsById",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugColumns;
        }
      }),
      getAllLeafColumns: he(function() {
        return [t.getAllColumns(), t._getOrderColumnsFn()];
      }, function(r, n) {
        var o = r.flatMap(function(i) {
          return i.getLeafColumns();
        });
        return n(o);
      }, {
        key: "getAllLeafColumns",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugColumns;
        }
      }),
      getColumn: function(n) {
        var o = t.getAllFlatColumnsById()[n];
        if (!o)
          throw process.env.NODE_ENV !== "production" && console.warn("[Table] Column with id " + n + " does not exist."), new Error();
        return o;
      }
    };
  }
}, T0 = {
  createInstance: function(t) {
    return {
      getRowId: function(n, o, i) {
        var a;
        return (a = t.options.getRowId == null ? void 0 : t.options.getRowId(n, o, i)) != null ? a : "" + (i ? [i.id, o].join(".") : o);
      },
      createRow: function(n, o, i, a, l) {
        for (var s = {
          id: n,
          index: i,
          original: o,
          depth: a,
          values: l,
          subRows: [],
          getLeafRows: function() {
            return P0(s.subRows, function(f) {
              return f.subRows;
            });
          }
        }, u = 0; u < t._features.length; u++) {
          var c = t._features[u];
          Object.assign(s, c.createRow == null ? void 0 : c.createRow(s, t));
        }
        return s;
      },
      getCoreRowModel: function() {
        return t._getCoreRowModel || (t._getCoreRowModel = t.options.getCoreRowModel(t)), t._getCoreRowModel();
      },
      getRowModel: function() {
        return t.getPaginationRowModel();
      },
      getRow: function(n) {
        var o = t.getRowModel().rowsById[n];
        if (!o)
          throw process.env.NODE_ENV !== "production" ? new Error("getRow expected an ID, but got " + n) : new Error();
        return o;
      }
    };
  }
}, $0 = {
  createRow: function(t, r) {
    return {
      getAllCells: he(function() {
        return [r.getAllLeafColumns()];
      }, function(n) {
        return n.map(function(o) {
          return r.createCell(t, o, t.values[o.id]);
        });
      }, {
        key: process.env.NODE_ENV !== "production" ? "row.getAllCells" : "",
        debug: function() {
          var o;
          return (o = r.options.debugAll) != null ? o : r.options.debugRows;
        }
      }),
      getAllCellsByColumnId: he(function() {
        return [t.getAllCells()];
      }, function(n) {
        return n.reduce(function(o, i) {
          return o[i.columnId] = i, o;
        }, {});
      }, {
        key: "row.getAllCellsByColumnId",
        debug: function() {
          var o;
          return (o = r.options.debugAll) != null ? o : r.options.debugRows;
        }
      })
    };
  },
  createInstance: function(t) {
    return {
      createCell: function(n, o, i) {
        var a = {
          id: n.id + "_" + o.id,
          rowId: n.id,
          columnId: o.id,
          row: n,
          column: o,
          value: i,
          renderCell: function() {
            return o.cell ? t.render(o.cell, {
              instance: t,
              column: o,
              row: n,
              cell: a,
              value: i
            }) : null;
          }
        };
        return t._features.forEach(function(l) {
          Object.assign(a, l.createCell == null ? void 0 : l.createCell(a, o, n, t));
        }, {}), a;
      },
      getCell: function(n, o) {
        var i = t.getRow(n);
        if (!i)
          throw process.env.NODE_ENV !== "production" ? new Error("[Table] could not find row with id " + n) : new Error();
        var a = i.getAllCellsByColumnId()[o];
        if (!a)
          throw process.env.NODE_ENV !== "production" ? new Error("[Table] could not find cell " + o + " in row " + n) : new Error();
        return a;
      }
    };
  }
}, kn = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, M0 = {
  getDefaultColumn: function() {
    return kn;
  },
  getInitialState: function(t) {
    return pe({
      columnSizing: {},
      columnSizingInfo: {
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: !1,
        columnSizingStart: []
      }
    }, t);
  },
  getDefaultOptions: function(t) {
    return {
      columnResizeMode: "onEnd",
      onColumnSizingChange: $t("columnSizing", t),
      onColumnSizingInfoChange: $t("columnSizingInfo", t)
    };
  },
  createColumn: function(t, r) {
    return {
      getSize: function() {
        return r.getColumnSize(t.id);
      },
      getStart: function(o) {
        return r.getColumnStart(t.id, o);
      },
      getIsResizing: function() {
        return r.getColumnIsResizing(t.id);
      },
      getCanResize: function() {
        return r.getColumnCanResize(t.id);
      },
      resetSize: function() {
        return r.resetColumnSize(t.id);
      }
    };
  },
  createHeader: function(t, r) {
    return {
      getIsResizing: function() {
        return r.getColumnIsResizing(t.column.id);
      },
      getCanResize: function() {
        return r.getColumnCanResize(t.column.id);
      },
      resetSize: function() {
        return r.resetColumnSize(t.column.id);
      },
      getResizeHandler: function() {
        return r.getResizeHandler(t.id);
      }
    };
  },
  createInstance: function(t) {
    return {
      getColumnSize: function(n) {
        var o, i, a, l = t.getColumn(n);
        if (!l)
          throw new Error();
        var s = t.getState().columnSizing[l.id];
        return Math.min(Math.max((o = l.minSize) != null ? o : kn.minSize, (i = s != null ? s : l.size) != null ? i : kn.size), (a = l.maxSize) != null ? a : kn.maxSize);
      },
      getColumnStart: function(n, o) {
        var i = t.getColumn(n);
        if (!i)
          throw new Error();
        var a = o ? o === "left" ? t.getLeftVisibleLeafColumns() : t.getRightVisibleLeafColumns() : t.getVisibleLeafColumns(), l = a.findIndex(function(u) {
          return u.id === n;
        });
        if (l > 0) {
          var s = a[l - 1];
          return t.getColumnStart(s.id, o) + s.getSize();
        }
        return 0;
      },
      setColumnSizing: function(n) {
        return t.options.onColumnSizingChange == null ? void 0 : t.options.onColumnSizingChange(n);
      },
      setColumnSizingInfo: function(n) {
        return t.options.onColumnSizingInfoChange == null ? void 0 : t.options.onColumnSizingInfoChange(n);
      },
      resetColumnSizing: function() {
        var n;
        t.setColumnSizing((n = t.initialState.columnSizing) != null ? n : {});
      },
      resetHeaderSizeInfo: function() {
        var n;
        t.setColumnSizingInfo((n = t.initialState.columnSizingInfo) != null ? n : {});
      },
      resetColumnSize: function(n) {
        t.setColumnSizing(function(o) {
          o[n];
          var i = ju(o, [n].map(Gu));
          return i;
        });
      },
      resetHeaderSize: function(n) {
        var o = t.getHeader(n);
        return t.resetColumnSize(o.column.id);
      },
      getHeaderCanResize: function(n) {
        var o = t.getHeader(n);
        if (!o)
          throw new Error();
        return t.getColumnCanResize(o.column.id);
      },
      getColumnCanResize: function(n) {
        var o, i, a, l = t.getColumn(n);
        if (!l)
          throw new Error();
        return (o = (i = (a = l.enableResizing) != null ? a : t.options.enableColumnResizing) != null ? i : l.defaultCanResize) != null ? o : !0;
      },
      getColumnIsResizing: function(n) {
        var o = t.getColumn(n);
        if (!o)
          throw new Error();
        return t.getState().columnSizingInfo.isResizingColumn === n;
      },
      getHeaderIsResizing: function(n) {
        var o = t.getHeader(n);
        if (!o)
          throw new Error();
        return t.getColumnIsResizing(o.column.id);
      },
      getResizeHandler: function(n) {
        var o = t.getHeader(n), i = t.getColumn(o.column.id), a = i.getCanResize();
        return function(l) {
          if (!!a && (l.persist == null || l.persist(), !(Vi(l) && l.touches && l.touches.length > 1))) {
            var s = n ? t.getHeader(n) : void 0, u = s ? s.getSize() : i.getSize(), c = s ? s.getLeafHeaders().map(function(x) {
              return [x.column.id, x.getSize()];
            }) : [[i.id, i.getSize()]], d = Vi(l) ? Math.round(l.touches[0].clientX) : l.clientX, f = function(S, w) {
              if (typeof w == "number") {
                var y = {};
                t.setColumnSizingInfo(function(O) {
                  var P, M, I = w - ((P = O == null ? void 0 : O.startOffset) != null ? P : 0), k = Math.max(I / ((M = O == null ? void 0 : O.startSize) != null ? M : 0), -0.999999);
                  return O.columnSizingStart.forEach(function(R) {
                    var A = R[0], L = R[1];
                    y[A] = Math.round(Math.max(L + L * k, 0) * 100) / 100;
                  }), pe({}, O, {
                    deltaOffset: I,
                    deltaPercentage: k
                  });
                }), (t.options.columnResizeMode === "onChange" || S === "end") && t.setColumnSizing(function(O) {
                  return pe({}, O, y);
                });
              }
            }, v = function(S) {
              return f("move", S);
            }, h = function(S) {
              f("end", S), t.setColumnSizingInfo(function(w) {
                return pe({}, w, {
                  isResizingColumn: !1,
                  startOffset: null,
                  startSize: null,
                  deltaOffset: null,
                  deltaPercentage: null,
                  columnSizingStart: []
                });
              });
            }, m = {
              moveHandler: function(S) {
                return v(S.clientX);
              },
              upHandler: function(S) {
                document.removeEventListener("mousemove", m.moveHandler), document.removeEventListener("mouseup", m.upHandler), h(S.clientX);
              }
            }, g = {
              moveHandler: function(S) {
                return S.cancelable && (S.preventDefault(), S.stopPropagation()), v(S.touches[0].clientX), !1;
              },
              upHandler: function(S) {
                document.removeEventListener("touchmove", g.moveHandler), document.removeEventListener("touchend", g.upHandler), S.cancelable && (S.preventDefault(), S.stopPropagation()), h(S.touches[0].clientX);
              }
            }, C = L0() ? {
              passive: !1
            } : !1;
            Vi(l) ? (document.addEventListener("touchmove", g.moveHandler, C), document.addEventListener("touchend", g.upHandler, C)) : (document.addEventListener("mousemove", m.moveHandler, C), document.addEventListener("mouseup", m.upHandler, C)), t.setColumnSizingInfo(function(x) {
              return pe({}, x, {
                startOffset: d,
                startSize: u,
                deltaOffset: 0,
                deltaPercentage: 0,
                columnSizingStart: c,
                isResizingColumn: i.id
              });
            });
          }
        };
      },
      getTotalSize: function() {
        var n, o;
        return (n = (o = t.getHeaderGroups()[0]) == null ? void 0 : o.headers.reduce(function(i, a) {
          return i + a.getSize();
        }, 0)) != null ? n : 0;
      },
      getLeftTotalSize: function() {
        var n, o;
        return (n = (o = t.getLeftHeaderGroups()[0]) == null ? void 0 : o.headers.reduce(function(i, a) {
          return i + a.getSize();
        }, 0)) != null ? n : 0;
      },
      getCenterTotalSize: function() {
        var n, o;
        return (n = (o = t.getCenterHeaderGroups()[0]) == null ? void 0 : o.headers.reduce(function(i, a) {
          return i + a.getSize();
        }, 0)) != null ? n : 0;
      },
      getRightTotalSize: function() {
        var n, o;
        return (n = (o = t.getRightHeaderGroups()[0]) == null ? void 0 : o.headers.reduce(function(i, a) {
          return i + a.getSize();
        }, 0)) != null ? n : 0;
      }
    };
  }
}, ho = null;
function L0() {
  if (typeof ho == "boolean")
    return ho;
  var e = !1;
  try {
    var t = {
      get passive() {
        return e = !0, !1;
      }
    }, r = function() {
    };
    window.addEventListener("test", r, t), window.removeEventListener("test", r);
  } catch {
    e = !1;
  }
  return ho = e, ho;
}
function Vi(e) {
  return e.type === "touchstart";
}
var A0 = {
  getInitialState: function(t) {
    return pe({
      expanded: {}
    }, t);
  },
  getDefaultOptions: function(t) {
    return {
      onExpandedChange: $t("expanded", t),
      autoResetExpanded: !0,
      expandSubRows: !0,
      paginateExpandedRows: !0
    };
  },
  createInstance: function(t) {
    var r = !1;
    return {
      _autoResetExpanded: function() {
        if (!r) {
          r = !0;
          return;
        }
        t.options.autoResetAll !== !1 && (t.options.autoResetAll === !0 || t.options.autoResetExpanded) && t.resetExpanded();
      },
      setExpanded: function(o) {
        return t.options.onExpandedChange == null ? void 0 : t.options.onExpandedChange(o);
      },
      toggleRowExpanded: function(o, i) {
        !o || t.setExpanded(function(a) {
          var l, s = a === !0 ? !0 : !!(a != null && a[o]), u = {};
          if (a === !0 ? Object.keys(t.getRowModel().rowsById).forEach(function(v) {
            u[v] = !0;
          }) : u = a, i = (l = i) != null ? l : !s, !s && i) {
            var c;
            return pe({}, u, (c = {}, c[o] = !0, c));
          }
          if (s && !i) {
            var d = u;
            d[o];
            var f = ju(d, [o].map(Gu));
            return f;
          }
          return a;
        });
      },
      toggleAllRowsExpanded: function(o) {
        (o != null ? o : !t.getIsAllRowsExpanded()) ? t.setExpanded(!0) : t.setExpanded({});
      },
      resetExpanded: function() {
        var o, i;
        t.setExpanded((o = (i = t.initialState) == null ? void 0 : i.expanded) != null ? o : {});
      },
      getIsRowExpanded: function(o) {
        var i, a = t.getPreExpandedRowModel().rowsById[o];
        if (!a)
          throw process.env.NODE_ENV !== "production" && console.warn("[Table] getIsRowExpanded: no row found with id " + o), new Error();
        var l = t.getState().expanded;
        return !!((i = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(a)) != null ? i : l === !0 || (l == null ? void 0 : l[o]));
      },
      getRowCanExpand: function(o) {
        var i, a, l, s, u = t.getRow(o);
        if (!u)
          throw process.env.NODE_ENV !== "production" && console.warn("[Table] getRowCanExpand: no row found with id " + o), new Error();
        return (i = (a = (l = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(u)) != null ? l : t.options.enableExpanded) != null ? a : t.options.defaultCanExpand) != null ? i : !!((s = u.subRows) != null && s.length);
      },
      getCanSomeRowsExpand: function() {
        return Object.keys(t.getRowModel().rowsById).some(function(o) {
          return t.getRowCanExpand(o);
        });
      },
      getToggleExpandedHandler: function(o) {
        var i = t.getRow(o);
        if (!!i) {
          var a = t.getRowCanExpand(o);
          return function() {
            !a || t.toggleRowExpanded(o);
          };
        }
      },
      getToggleAllRowsExpandedHandler: function() {
        return function(o) {
          o.persist == null || o.persist(), t.toggleAllRowsExpanded();
        };
      },
      getIsSomeRowsExpanded: function() {
        var o = t.getState().expanded;
        return o === !0 || Object.values(o).some(Boolean);
      },
      getIsAllRowsExpanded: function() {
        var o = t.getState().expanded;
        return o === !0 ? !0 : !Object.keys(t.getRowModel().rowsById).some(function(i) {
          return !t.getIsRowExpanded(i);
        });
      },
      getExpandedDepth: function() {
        var o = 0, i = t.getState().expanded === !0 ? Object.keys(t.getRowModel().rowsById) : Object.keys(t.getState().expanded);
        return i.forEach(function(a) {
          var l = a.split(".");
          o = Math.max(o, l.length);
        }), o;
      },
      getPreExpandedRowModel: function() {
        return t.getGroupedRowModel();
      },
      getExpandedRowModel: function() {
        return !t._getExpandedRowModel && t.options.getExpandedRowModel && (t._getExpandedRowModel = t.options.getExpandedRowModel(t)), t.options.manualExpanding || !t._getExpandedRowModel ? t.getPreExpandedRowModel() : t._getExpandedRowModel();
      }
    };
  },
  createRow: function(t, r) {
    return {
      toggleExpanded: function(o) {
        return void r.toggleRowExpanded(t.id, o);
      },
      getIsExpanded: function() {
        return r.getIsRowExpanded(t.id);
      },
      getCanExpand: function() {
        return t.subRows && !!t.subRows.length;
      },
      getToggleExpandedHandler: function() {
        return r.getToggleExpandedHandler(t.id);
      }
    };
  }
}, sn = {
  includesString: Uu,
  includesStringSensitive: Wu,
  equalsString: Zu,
  equalsStringSensitive: qu,
  arrIncludes: Yu,
  arrIncludesAll: Ku,
  arrIncludesSome: Xu,
  equals: Ju,
  weakEquals: Qu,
  betweenNumberRange: ec
};
function Uu(e, t, r) {
  var n = String(r).toLowerCase();
  return e = e.filter(function(o) {
    return t.some(function(i) {
      return String(o.values[i]).toLowerCase().includes(n);
    });
  }), e;
}
Uu.autoRemove = function(e) {
  return Et(e);
};
function Wu(e, t, r) {
  var n = String(r);
  return e = e.filter(function(o) {
    return t.some(function(i) {
      return String(o.values[i]).includes(n);
    });
  }), e;
}
Wu.autoRemove = function(e) {
  return Et(e);
};
function Zu(e, t, r) {
  var n = String(r).toLowerCase();
  return e.filter(function(o) {
    return t.some(function(i) {
      var a = o.values[i];
      return a !== void 0 ? String(a).toLowerCase() === n : !0;
    });
  });
}
Zu.autoRemove = function(e) {
  return Et(e);
};
function qu(e, t, r) {
  var n = String(r);
  return e.filter(function(o) {
    return t.some(function(i) {
      var a = o.values[i];
      return a !== void 0 ? String(a) === n : !0;
    });
  });
}
qu.autoRemove = function(e) {
  return Et(e);
};
function Yu(e, t, r) {
  return e.filter(function(n) {
    return t.some(function(o) {
      var i = n.values[o];
      return i.includes(r);
    });
  });
}
Yu.autoRemove = function(e) {
  return Et(e) || !(e != null && e.length);
};
function Ku(e, t, r) {
  return e.filter(function(n) {
    return t.some(function(o) {
      var i = n.values[o];
      return i && i.length && r.every(function(a) {
        return i.includes(a);
      });
    });
  });
}
Ku.autoRemove = function(e) {
  return Et(e) || !(e != null && e.length);
};
function Xu(e, t, r) {
  return e.filter(function(n) {
    return t.some(function(o) {
      var i = n.values[o];
      return i && i.length && r.some(function(a) {
        return i.includes(a);
      });
    });
  });
}
Xu.autoRemove = function(e) {
  return Et(e) || !(e != null && e.length);
};
function Ju(e, t, r) {
  return e.filter(function(n) {
    return t.some(function(o) {
      var i = n.values[o];
      return i === r;
    });
  });
}
Ju.autoRemove = function(e) {
  return Et(e);
};
function Qu(e, t, r) {
  return e.filter(function(n) {
    return t.some(function(o) {
      var i = n.values[o];
      return i == r;
    });
  });
}
Qu.autoRemove = function(e) {
  return Et(e);
};
function ec(e, t, r) {
  var n = r || [], o = n[0], i = n[1], a = typeof o != "number" ? parseFloat(o) : o, l = typeof i != "number" ? parseFloat(i) : i, s = o === null || Number.isNaN(a) ? -1 / 0 : a, u = i === null || Number.isNaN(l) ? 1 / 0 : l;
  if (s > u) {
    var c = s;
    s = u, u = c;
  }
  return e.filter(function(d) {
    return t.some(function(f) {
      var v = d.values[f];
      return v >= s && v <= u;
    });
  });
}
ec.autoRemove = function(e) {
  return Et(e) || Et(e[0]) && Et(e[1]);
};
function Et(e) {
  return e == null || e === "";
}
var k0 = {
  getDefaultColumn: function() {
    return {
      filterFn: "auto"
    };
  },
  getInitialState: function(t) {
    return pe({
      columnFilters: [],
      globalFilter: void 0,
      columnFiltersProgress: 1,
      globalFilterProgress: 1
    }, t);
  },
  getDefaultOptions: function(t) {
    return {
      onColumnFiltersChange: $t("columnFilters", t),
      onGlobalFilterChange: $t("globalFilter", t),
      filterFromLeafRows: !0,
      globalFilterFn: "auto",
      getColumnCanGlobalFilter: function(n) {
        var o, i, a = (o = t.getCoreRowModel().flatRows[0]) == null || (i = o.getAllCellsByColumnId()[n.id]) == null ? void 0 : i.value;
        return typeof a == "string";
      }
    };
  },
  createColumn: function(t, r) {
    var n = he(function() {
      return [t.getPreFilteredRows()];
    }, function(o) {
      var i, a, l, s;
      o === void 0 && (o = []);
      for (var u = /* @__PURE__ */ new Map(), c = [(i = (a = o[0]) == null ? void 0 : a.values[t.id]) != null ? i : null, (l = (s = o[0]) == null ? void 0 : s.values[t.id]) != null ? l : null], d = 0; d < o.length; d++) {
        var f, v = (f = o[d]) == null ? void 0 : f.values[t.id];
        if (u.has(v)) {
          var h;
          u.set(v, ((h = u.get(v)) != null ? h : 0) + 1);
        } else
          u.set(v, 1);
        v < c[0] ? c[0] = v : v > c[1] && (c[1] = v);
      }
      return {
        preFilteredUniqueValues: u,
        preFilteredMinMaxValues: c
      };
    }, {
      key: "column.getFacetInfo",
      debug: function() {
        var i;
        return (i = r.options.debugAll) != null ? i : r.options.debugColumns;
      }
    });
    return {
      filterFn: t.filterFn,
      getCanColumnFilter: function() {
        return r.getColumnCanColumnFilter(t.id);
      },
      getCanGlobalFilter: function() {
        return r.getColumnCanGlobalFilter(t.id);
      },
      getColumnFilterIndex: function() {
        return r.getColumnFilterIndex(t.id);
      },
      getColumnIsFiltered: function() {
        return r.getColumnIsFiltered(t.id);
      },
      getColumnFilterValue: function() {
        return r.getColumnFilterValue(t.id);
      },
      setColumnFilterValue: function(i) {
        return r.setColumnFilterValue(t.id, i);
      },
      getPreFilteredUniqueValues: function() {
        return n().preFilteredUniqueValues;
      },
      getPreFilteredMinMaxValues: function() {
        return n().preFilteredMinMaxValues;
      },
      getPreFilteredRows: function() {
      }
    };
  },
  createInstance: function(t) {
    return {
      getColumnAutoFilterFn: function(n) {
        var o = t.getCoreRowModel().flatRows[0], i = o == null ? void 0 : o.values[n];
        return typeof i == "string" ? sn.includesString : typeof i == "number" ? sn.betweenNumberRange : i !== null && typeof i == "object" ? sn.equals : Array.isArray(i) ? sn.arrIncludes : sn.weakEquals;
      },
      getGlobalAutoFilterFn: function() {
        return sn.includesString;
      },
      getColumnFilterFn: function(n) {
        var o, i = t.getColumn(n), a = t.options.filterFns;
        if (!i)
          throw new Error();
        return ko(i.filterFn) ? i.filterFn : i.filterFn === "auto" ? t.getColumnAutoFilterFn(n) : (o = a == null ? void 0 : a[i.filterFn]) != null ? o : sn[i.filterFn];
      },
      getGlobalFilterFn: function() {
        var n, o = t.options, i = o.filterFns, a = o.globalFilterFn;
        debugger;
        return ko(a) ? a : a === "auto" ? t.getGlobalAutoFilterFn() : (n = i == null ? void 0 : i[a]) != null ? n : sn[a];
      },
      setColumnFilters: function(n) {
        var o = t.getAllLeafColumns(), i = function(l) {
          var s;
          return (s = vn(n, l)) == null ? void 0 : s.filter(function(u) {
            var c = o.find(function(f) {
              return f.id === u.id;
            });
            if (c) {
              var d = t.getColumnFilterFn(c.id);
              if (ns(d, u.value, c))
                return !1;
            }
            return !0;
          });
        };
        t.options.onColumnFiltersChange == null || t.options.onColumnFiltersChange(i);
      },
      setGlobalFilter: function(n) {
        t.options.onGlobalFilterChange == null || t.options.onGlobalFilterChange(n);
      },
      resetGlobalFilter: function() {
        t.setGlobalFilter(t.initialState.globalFilter);
      },
      getColumnCanColumnFilter: function(n) {
        var o, i, a = t.getColumn(n);
        if (!a)
          throw new Error();
        return ((o = a.enableColumnFilter) != null ? o : !0) && ((i = t.options.enableColumnFilters) != null ? i : !0) && !!a.accessorFn;
      },
      getColumnCanGlobalFilter: function(n) {
        var o, i, a, l = t.getColumn(n);
        if (!l)
          throw new Error();
        return ((o = l.enableGlobalFilter) != null ? o : !0) && ((i = t.options.enableGlobalFilter) != null ? i : !0) && ((a = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(l)) != null ? a : !0) && !!l.accessorFn;
      },
      getColumnIsFiltered: function(n) {
        return t.getColumnFilterIndex(n) > -1;
      },
      getColumnFilterValue: function(n) {
        var o, i;
        return (o = t.getState().columnFilters) == null || (i = o.find(function(a) {
          return a.id === n;
        })) == null ? void 0 : i.value;
      },
      getColumnFilterIndex: function(n) {
        var o, i;
        return (o = (i = t.getState().columnFilters) == null ? void 0 : i.findIndex(function(a) {
          return a.id === n;
        })) != null ? o : -1;
      },
      setColumnFilterValue: function(n, o) {
        !n || t.setColumnFilters(function(i) {
          var a = t.getColumn(n);
          if (!a)
            throw process.env.NODE_ENV !== "production" && console.warn("Table: Could not find a column with id: " + n), new Error();
          var l = t.getColumnFilterFn(a.id), s = i == null ? void 0 : i.find(function(v) {
            return v.id === n;
          }), u = vn(o, s ? s.value : void 0);
          if (ns(l, u, a)) {
            var c;
            return (c = i == null ? void 0 : i.filter(function(v) {
              return v.id !== n;
            })) != null ? c : [];
          }
          var d = {
            id: n,
            value: u
          };
          if (s) {
            var f;
            return (f = i == null ? void 0 : i.map(function(v) {
              return v.id === n ? d : v;
            })) != null ? f : [];
          }
          return i != null && i.length ? [].concat(i, [d]) : [d];
        });
      },
      resetColumnFilters: function() {
        var n, o;
        t.setColumnFilters((n = (o = t.initialState) == null ? void 0 : o.columnFilters) != null ? n : []);
      },
      getPreColumnFilteredRowModel: function() {
        return t.getCoreRowModel();
      },
      getColumnFilteredRowModel: function() {
        return !t._getColumnFilteredRowModel && t.options.getColumnFilteredRowModel && (t._getColumnFilteredRowModel = t.options.getColumnFilteredRowModel(t)), t.options.manualColumnFiltering || !t._getColumnFilteredRowModel ? t.getPreColumnFilteredRowModel() : t._getColumnFilteredRowModel();
      },
      getPreGlobalFilteredRowModel: function() {
        return t.getColumnFilteredRowModel();
      },
      getGlobalFilteredRowModel: function() {
        return !t._getGlobalFilteredRowModel && t.options.getGlobalFilteredRowModel && (t._getGlobalFilteredRowModel = t.options.getGlobalFilteredRowModel(t)), t.options.manualGlobalFiltering || !t._getGlobalFilteredRowModel ? t.getPreGlobalFilteredRowModel() : t._getGlobalFilteredRowModel();
      }
    };
  }
};
function ns(e, t, r) {
  return (e && e.autoRemove ? e.autoRemove(t, r) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
var bo = {
  sum: _0,
  min: F0,
  max: N0,
  extent: V0,
  mean: tc,
  median: D0,
  unique: H0,
  uniqueCount: z0,
  count: B0
};
function _0(e, t) {
  return t().reduce(function(r, n) {
    return r + (typeof n == "number" ? n : 0);
  }, 0);
}
function F0(e, t) {
  for (var r, n = lo(t()), o; !(o = n()).done; ) {
    var i = o.value;
    i != null && (r > i || r === void 0 && i >= i) && (r = i);
  }
  return r;
}
function N0(e, t) {
  for (var r, n = lo(t()), o; !(o = n()).done; ) {
    var i = o.value;
    i != null && (r < i || r === void 0 && i >= i) && (r = i);
  }
  return r;
}
function V0(e, t) {
  for (var r, n, o = lo(t()), i; !(i = o()).done; ) {
    var a = i.value;
    a != null && (r === void 0 ? a >= a && (r = n = a) : (r > a && (r = a), n < a && (n = a)));
  }
  return [r, n];
}
function tc(e) {
  for (var t = 0, r = 0, n = lo(e()), o; !(o = n()).done; ) {
    var i = o.value;
    i != null && (i = +i) >= i && (++t, r += i);
  }
  if (t)
    return r / t;
}
function D0(e) {
  var t = e();
  if (!!t.length) {
    var r = 0, n = 0;
    return t.forEach(function(o) {
      typeof o == "number" && (r = Math.min(r, o), n = Math.max(n, o));
    }), (r + n) / 2;
  }
}
function H0(e) {
  return Array.from(new Set(e()).values());
}
function z0(e) {
  return new Set(e()).size;
}
function B0(e) {
  return e().length;
}
var j0 = {
  getDefaultColumn: function() {
    return {
      aggregationFn: "auto"
    };
  },
  getInitialState: function(t) {
    return pe({
      grouping: []
    }, t);
  },
  getDefaultOptions: function(t) {
    return {
      onGroupingChange: $t("grouping", t),
      groupedColumnMode: "reorder"
    };
  },
  createColumn: function(t, r) {
    return {
      aggregationFn: t.aggregationFn,
      getCanGroup: function() {
        return r.getColumnCanGroup(t.id);
      },
      getGroupedIndex: function() {
        return r.getColumnGroupedIndex(t.id);
      },
      getIsGrouped: function() {
        return r.getColumnIsGrouped(t.id);
      },
      toggleGrouping: function() {
        return r.toggleColumnGrouping(t.id);
      },
      getToggleGroupingHandler: function() {
        return r.getToggleGroupingHandler(t.id);
      }
    };
  },
  createInstance: function(t) {
    return {
      getColumnAutoAggregationFn: function(n) {
        var o = t.getCoreRowModel().flatRows[0], i = o == null ? void 0 : o.values[n];
        return typeof i == "number" ? bo.sum : Object.prototype.toString.call(i) === "[object Date]" ? bo.extent : bo.count;
      },
      getColumnAggregationFn: function(n) {
        var o, i = t.getColumn(n), a = t.options.aggregationFns;
        if (!i)
          throw new Error();
        return ko(i.aggregationFn) ? i.aggregationFn : i.aggregationFn === "auto" ? t.getColumnAutoAggregationFn(n) : (o = a == null ? void 0 : a[i.aggregationFn]) != null ? o : bo[i.aggregationFn];
      },
      setGrouping: function(n) {
        return t.options.onGroupingChange == null ? void 0 : t.options.onGroupingChange(n);
      },
      toggleColumnGrouping: function(n) {
        t.setGrouping(function(o) {
          return o != null && o.includes(n) ? o.filter(function(i) {
            return i !== n;
          }) : [].concat(o != null ? o : [], [n]);
        });
      },
      getColumnCanGroup: function(n) {
        var o, i, a, l = t.getColumn(n);
        if (!l)
          throw new Error();
        return (o = (i = (a = l.enableGrouping) != null ? a : t.options.enableGrouping) != null ? i : l.defaultCanGroup) != null ? o : !!l.accessorFn;
      },
      getColumnIsGrouped: function(n) {
        var o;
        return (o = t.getState().grouping) == null ? void 0 : o.includes(n);
      },
      getColumnGroupedIndex: function(n) {
        var o;
        return (o = t.getState().grouping) == null ? void 0 : o.indexOf(n);
      },
      resetGrouping: function() {
        var n, o;
        t.setGrouping((n = (o = t.initialState) == null ? void 0 : o.grouping) != null ? n : []);
      },
      getToggleGroupingHandler: function(n) {
        var o = t.getColumn(n), i = o.getCanGroup();
        return function() {
          !i || o.toggleGrouping == null || o.toggleGrouping();
        };
      },
      getRowIsGrouped: function(n) {
        var o;
        return !!((o = t.getRow(n)) != null && o.groupingColumnId);
      },
      getPreGroupedRowModel: function() {
        return t.getSortedRowModel();
      },
      getGroupedRowModel: function() {
        return !t._getGroupedRowModel && t.options.getGroupedRowModel && (t._getGroupedRowModel = t.options.getGroupedRowModel(t)), t.options.manualGrouping || !t._getGroupedRowModel ? t.getPreGroupedRowModel() : t._getGroupedRowModel();
      }
    };
  },
  createRow: function(t, r) {
    return {
      getIsGrouped: function() {
        return r.getRowIsGrouped(t.id);
      }
    };
  },
  createCell: function(t, r, n, o) {
    return {
      getIsGrouped: function() {
        return r.getIsGrouped() && r.id === n.groupingColumnId;
      },
      getIsPlaceholder: function() {
        return !t.getIsGrouped() && r.getIsGrouped();
      },
      getIsAggregated: function() {
        var a;
        return !t.getIsGrouped() && !t.getIsPlaceholder() && ((a = n.subRows) == null ? void 0 : a.length) > 1;
      },
      renderAggregatedCell: function() {
        var a, l = (a = r.aggregatedCell) != null ? a : r.cell;
        return l ? o.render(l, {
          instance: o,
          column: r,
          row: n,
          cell: t,
          value: t.value
        }) : null;
      }
    };
  }
};
function G0(e, t, r) {
  if (!(t != null && t.length) || !r)
    return e;
  var n = e.filter(function(i) {
    return !t.includes(i.id);
  });
  if (r === "remove")
    return n;
  var o = t.map(function(i) {
    return e.find(function(a) {
      return a.id === i;
    });
  }).filter(Boolean);
  return [].concat(o, n);
}
var U0 = {
  getInitialState: function(t) {
    return pe({
      columnOrder: []
    }, t);
  },
  getDefaultOptions: function(t) {
    return {
      onColumnOrderChange: $t("columnOrder", t)
    };
  },
  createInstance: function(t) {
    return {
      setColumnOrder: function(n) {
        return t.options.onColumnOrderChange == null ? void 0 : t.options.onColumnOrderChange(n);
      },
      resetColumnOrder: function() {
        var n;
        t.setColumnOrder((n = t.initialState.columnOrder) != null ? n : []);
      },
      _getOrderColumnsFn: he(function() {
        return [t.getState().columnOrder, t.getState().grouping, t.options.groupedColumnMode];
      }, function(r, n, o) {
        return function(i) {
          var a = [];
          if (!(r != null && r.length))
            a = i;
          else {
            for (var l = [].concat(r), s = [].concat(i), u = function() {
              var d = l.shift(), f = s.findIndex(function(v) {
                return v.id === d;
              });
              f > -1 && a.push(s.splice(f, 1)[0]);
            }; s.length && l.length; )
              u();
            a = [].concat(a, s);
          }
          return G0(a, n, o);
        };
      }, {
        key: "getOrderColumnsFn"
      })
    };
  }
}, W0 = {
  getInitialState: function(t) {
    return pe({}, t, {
      pagination: pe({
        pageCount: -1,
        pageIndex: 0,
        pageSize: 10
      }, t == null ? void 0 : t.pagination)
    });
  },
  getDefaultOptions: function(t) {
    return {
      onPaginationChange: $t("pagination", t),
      autoResetPageIndex: !0
    };
  },
  createInstance: function(t) {
    var r = !1;
    return {
      _autoResetPageIndex: function() {
        if (!r) {
          r = !0;
          return;
        }
        t.options.autoResetAll !== !1 && (t.options.autoResetAll === !0 || t.options.autoResetPageIndex) && t.resetPageIndex();
      },
      setPagination: function(o) {
        var i = function(l) {
          var s = vn(o, l);
          return s;
        };
        return t.options.onPaginationChange == null ? void 0 : t.options.onPaginationChange(i);
      },
      resetPagination: function() {
        var o;
        t.setPagination((o = t.initialState.pagination) != null ? o : {
          pageIndex: 0,
          pageSize: 10,
          pageCount: -1
        });
      },
      setPageIndex: function(o) {
        t.setPagination(function(i) {
          var a = vn(o, i.pageIndex), l = i.pageCount && i.pageCount > 0 ? i.pageCount - 1 : Number.MAX_SAFE_INTEGER;
          return a = Math.min(Math.max(0, a), l), pe({}, i, {
            pageIndex: a
          });
        });
      },
      resetPageIndex: function() {
        t.setPageIndex(0);
      },
      resetPageSize: function() {
        var o, i, a;
        t.setPageSize((o = (i = t.initialState) == null || (a = i.pagination) == null ? void 0 : a.pageSize) != null ? o : 10);
      },
      setPageSize: function(o) {
        t.setPagination(function(i) {
          var a = Math.max(1, vn(o, i.pageSize)), l = i.pageSize * i.pageIndex, s = Math.floor(l / a);
          return pe({}, i, {
            pageIndex: s,
            pageSize: a
          });
        });
      },
      setPageCount: function(o) {
        return t.setPagination(function(i) {
          var a = vn(o, i.pageCount);
          return typeof a == "number" && (a = Math.max(-1, a)), pe({}, i, {
            pageCount: a
          });
        });
      },
      getPageOptions: he(function() {
        return [t.getState().pagination.pageSize, t.getState().pagination.pageCount];
      }, function(n, o) {
        var i = [];
        return o && o > 0 && (i = [].concat(new Array(o)).fill(null).map(function(a, l) {
          return l;
        })), i;
      }, {
        key: "getPageOptions",
        debug: function() {
          var o;
          return (o = t.options.debugAll) != null ? o : t.options.debugTable;
        }
      }),
      getCanPreviousPage: function() {
        return t.getState().pagination.pageIndex > 0;
      },
      getCanNextPage: function() {
        var o = t.getState().pagination.pageIndex, i = t.getPageCount();
        return i === -1 ? !0 : i === 0 ? !1 : o < i - 1;
      },
      previousPage: function() {
        return t.setPageIndex(function(o) {
          return o - 1;
        });
      },
      nextPage: function() {
        return t.setPageIndex(function(o) {
          return o + 1;
        });
      },
      getPrePaginationRowModel: function() {
        return t.getExpandedRowModel();
      },
      getPaginationRowModel: function() {
        return !t._getPaginationRowModel && t.options.getPaginationRowModel && (t._getPaginationRowModel = t.options.getPaginationRowModel(t)), t.options.manualPagination || !t._getPaginationRowModel ? t.getPrePaginationRowModel() : t._getPaginationRowModel();
      },
      getPageCount: function() {
        var o = t.getState().pagination.pageCount;
        return o > 0 ? o : Math.ceil(t.getPrePaginationRowModel().rows.length / t.getState().pagination.pageSize);
      }
    };
  }
}, Z0 = {
  getInitialState: function(t) {
    return pe({
      columnPinning: {
        left: [],
        right: []
      }
    }, t);
  },
  getDefaultOptions: function(t) {
    return {
      onColumnPinningChange: $t("columnPinning", t)
    };
  },
  createColumn: function(t, r) {
    return {
      getCanPin: function() {
        return r.getColumnCanPin(t.id);
      },
      getPinnedIndex: function() {
        return r.getColumnPinnedIndex(t.id);
      },
      getIsPinned: function() {
        return r.getColumnIsPinned(t.id);
      },
      pin: function(o) {
        return r.pinColumn(t.id, o);
      }
    };
  },
  createRow: function(t, r) {
    return {
      getCenterVisibleCells: he(function() {
        return [t._getAllVisibleCells(), r.getState().columnPinning.left, r.getState().columnPinning.right];
      }, function(n, o, i) {
        var a = [].concat(o != null ? o : [], i != null ? i : []);
        return n.filter(function(l) {
          return !a.includes(l.columnId);
        });
      }, {
        key: "row.getCenterVisibleCells",
        debug: function() {
          var o;
          return (o = r.options.debugAll) != null ? o : r.options.debugRows;
        }
      }),
      getLeftVisibleCells: he(function() {
        return [t._getAllVisibleCells(), r.getState().columnPinning.left, ,];
      }, function(n, o) {
        var i = (o != null ? o : []).map(function(a) {
          return n.find(function(l) {
            return l.columnId === a;
          });
        }).filter(Boolean).map(function(a) {
          return pe({}, a, {
            position: "left"
          });
        });
        return i;
      }, {
        key: "row.getLeftVisibleCells",
        debug: function() {
          var o;
          return (o = r.options.debugAll) != null ? o : r.options.debugRows;
        }
      }),
      getRightVisibleCells: he(function() {
        return [t._getAllVisibleCells(), r.getState().columnPinning.right];
      }, function(n, o) {
        var i = (o != null ? o : []).map(function(a) {
          return n.find(function(l) {
            return l.columnId === a;
          });
        }).filter(Boolean).map(function(a) {
          return pe({}, a, {
            position: "left"
          });
        });
        return i;
      }, {
        key: "row.getRightVisibleCells",
        debug: function() {
          var o;
          return (o = r.options.debugAll) != null ? o : r.options.debugRows;
        }
      })
    };
  },
  createInstance: function(t) {
    return {
      setColumnPinning: function(n) {
        return t.options.onColumnPinningChange == null ? void 0 : t.options.onColumnPinningChange(n);
      },
      resetColumnPinning: function() {
        var n, o;
        return t.setColumnPinning((n = (o = t.initialState) == null ? void 0 : o.columnPinning) != null ? n : {});
      },
      pinColumn: function(n, o) {
        var i = t.getColumn(n), a = i == null ? void 0 : i.getLeafColumns().map(function(l) {
          return l.id;
        }).filter(Boolean);
        t.setColumnPinning(function(l) {
          var s, u;
          if (o === "right") {
            var c, d;
            return {
              left: ((c = l == null ? void 0 : l.left) != null ? c : []).filter(function(h) {
                return !(a != null && a.includes(h));
              }),
              right: [].concat(((d = l == null ? void 0 : l.right) != null ? d : []).filter(function(h) {
                return !(a != null && a.includes(h));
              }), a)
            };
          }
          if (o === "left") {
            var f, v;
            return {
              left: [].concat(((f = l == null ? void 0 : l.left) != null ? f : []).filter(function(h) {
                return !(a != null && a.includes(h));
              }), a),
              right: ((v = l == null ? void 0 : l.right) != null ? v : []).filter(function(h) {
                return !(a != null && a.includes(h));
              })
            };
          }
          return {
            left: ((s = l == null ? void 0 : l.left) != null ? s : []).filter(function(h) {
              return !(a != null && a.includes(h));
            }),
            right: ((u = l == null ? void 0 : l.right) != null ? u : []).filter(function(h) {
              return !(a != null && a.includes(h));
            })
          };
        });
      },
      getColumnCanPin: function(n) {
        var o = t.getColumn(n);
        if (!o)
          throw new Error();
        var i = o.getLeafColumns();
        return i.some(function(a) {
          var l, s;
          return ((l = a.enablePinning) != null ? l : !0) && ((s = t.options.enablePinning) != null ? s : !0);
        });
      },
      getColumnIsPinned: function(n) {
        var o = t.getColumn(n);
        if (!o)
          throw new Error();
        var i = o.getLeafColumns().map(function(d) {
          return d.id;
        }), a = t.getState().columnPinning, l = a.left, s = a.right, u = i.some(function(d) {
          return l == null ? void 0 : l.includes(d);
        }), c = i.some(function(d) {
          return s == null ? void 0 : s.includes(d);
        });
        return u ? "left" : c ? "right" : !1;
      },
      getColumnPinnedIndex: function(n) {
        var o, i, a, l = t.getColumnIsPinned(n);
        return l ? (o = (i = t.getState().columnPinning) == null || (a = i[l]) == null ? void 0 : a.indexOf(n)) != null ? o : -1 : 0;
      },
      getIsSomeColumnsPinned: function() {
        var n = t.getState().columnPinning, o = n.left, i = n.right;
        return Boolean((o == null ? void 0 : o.length) || (i == null ? void 0 : i.length));
      },
      getLeftLeafColumns: he(function() {
        return [t.getAllLeafColumns(), t.getState().columnPinning.left];
      }, function(r, n) {
        return (n != null ? n : []).map(function(o) {
          return r.find(function(i) {
            return i.id === o;
          });
        }).filter(Boolean);
      }, {
        key: "getLeftLeafColumns",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugColumns;
        }
      }),
      getRightLeafColumns: he(function() {
        return [t.getAllLeafColumns(), t.getState().columnPinning.right];
      }, function(r, n) {
        return (n != null ? n : []).map(function(o) {
          return r.find(function(i) {
            return i.id === o;
          });
        }).filter(Boolean);
      }, {
        key: "getRightLeafColumns",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugColumns;
        }
      }),
      getCenterLeafColumns: he(function() {
        return [t.getAllLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right];
      }, function(r, n, o) {
        var i = [].concat(n != null ? n : [], o != null ? o : []);
        return r.filter(function(a) {
          return !i.includes(a.id);
        });
      }, {
        key: "getCenterLeafColumns",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugColumns;
        }
      })
    };
  }
}, q0 = {
  getInitialState: function(t) {
    return pe({
      rowSelection: {}
    }, t);
  },
  getDefaultOptions: function(t) {
    return {
      onRowSelectionChange: $t("rowSelection", t),
      enableRowSelection: !0,
      enableMultiRowSelection: !0,
      enableSubRowSelection: !0
    };
  },
  createInstance: function(t) {
    return {
      setRowSelection: function(n) {
        return t.options.onRowSelectionChange == null ? void 0 : t.options.onRowSelectionChange(n);
      },
      resetRowSelection: function() {
        var n;
        return t.setRowSelection((n = t.initialState.rowSelection) != null ? n : {});
      },
      toggleAllRowsSelected: function(n) {
        t.setRowSelection(function(o) {
          n = typeof n < "u" ? n : !t.getIsAllRowsSelected();
          var i = pe({}, o), a = t.getPreGroupedRowModel().flatRows;
          return n ? a.forEach(function(l) {
            i[l.id] = !0;
          }) : a.forEach(function(l) {
            delete i[l.id];
          }), i;
        });
      },
      toggleAllPageRowsSelected: function(n) {
        return t.setRowSelection(function(o) {
          typeof n < "u" || t.getIsAllPageRowsSelected();
          var i = pe({}, o);
          return t.getRowModel().rows.forEach(function(a) {
            rs(i, a.id, n, t);
          }), i;
        });
      },
      toggleRowSelected: function(n, o) {
        var i = t.getRow(n), a = i.getIsSelected();
        t.setRowSelection(function(l) {
          if (o = typeof o < "u" ? o : !a, a === o)
            return l;
          var s = pe({}, l);
          return rs(s, n, o, t), s;
        });
      },
      getPreSelectedRowModel: function() {
        return t.getCoreRowModel();
      },
      getSelectedRowModel: he(function() {
        return [t.getState().rowSelection, t.getCoreRowModel()];
      }, function(r, n) {
        return Object.keys(r).length ? Di(t, n) : {
          rows: [],
          flatRows: [],
          rowsById: {}
        };
      }, {
        key: "getSelectedRowModel",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugTable;
        }
      }),
      getFilteredSelectedRowModel: he(function() {
        return [t.getState().rowSelection, t.getGlobalFilteredRowModel()];
      }, function(r, n) {
        return Object.keys(r).length ? Di(t, n) : {
          rows: [],
          flatRows: [],
          rowsById: {}
        };
      }, {
        key: "getFilteredSelectedRowModel",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugTable;
        }
      }),
      getGroupedSelectedRowModel: he(function() {
        return [t.getState().rowSelection, t.getGroupedRowModel()];
      }, function(r, n) {
        return Object.keys(r).length ? Di(t, n) : {
          rows: [],
          flatRows: [],
          rowsById: {}
        };
      }, {
        key: "getGroupedSelectedRowModel",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugTable;
        }
      }),
      getRowIsSelected: function(n) {
        var o = t.getState(), i = o.rowSelection, a = t.getRow(n);
        if (!a)
          throw new Error();
        return _o(a, i) === !0;
      },
      getRowIsSomeSelected: function(n) {
        var o = t.getState(), i = o.rowSelection, a = t.getRow(n);
        if (!a)
          throw new Error();
        return _o(a, i) === "some";
      },
      getRowCanSelect: function(n) {
        var o, i = t.getRow(n);
        if (!i)
          throw new Error();
        return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(i) : (o = t.options.enableRowSelection) != null ? o : !0;
      },
      getRowCanSelectSubRows: function(n) {
        var o, i = t.getRow(n);
        if (!i)
          throw new Error();
        return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(i) : (o = t.options.enableSubRowSelection) != null ? o : !0;
      },
      getRowCanMultiSelect: function(n) {
        var o, i = t.getRow(n);
        if (!i)
          throw new Error();
        return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(i) : (o = t.options.enableMultiRowSelection) != null ? o : !0;
      },
      getIsAllRowsSelected: function() {
        var n = t.getPreGlobalFilteredRowModel().flatRows, o = t.getState(), i = o.rowSelection, a = Boolean(n.length && Object.keys(i).length);
        return a && n.some(function(l) {
          return !i[l.id];
        }) && (a = !1), a;
      },
      getIsAllPageRowsSelected: function() {
        var n = t.getPaginationRowModel().flatRows, o = t.getState(), i = o.rowSelection, a = !!n.length;
        return a && n.some(function(l) {
          return !i[l.id];
        }) && (a = !1), a;
      },
      getIsSomeRowsSelected: function() {
        var n;
        return !t.getIsAllRowsSelected() && !!Object.keys((n = t.getState().rowSelection) != null ? n : {}).length;
      },
      getIsSomePageRowsSelected: function() {
        var n = t.getPaginationRowModel().flatRows;
        return t.getIsAllPageRowsSelected() ? !1 : !!(n != null && n.length);
      },
      getToggleRowSelectedHandler: function(n) {
        var o = t.getRow(n);
        o.getIsSelected(), o.getIsSomeSelected();
        var i = o.getCanSelect();
        return function(a) {
          var l;
          !i || o.toggleSelected((l = a.target) == null ? void 0 : l.checked);
        };
      },
      getToggleAllRowsSelectedHandler: function() {
        return function(n) {
          t.toggleAllRowsSelected(n.target.checked);
        };
      },
      getToggleAllPageRowsSelectedHandler: function() {
        return function(n) {
          t.toggleAllPageRowsSelected(n.target.checked);
        };
      }
    };
  },
  createRow: function(t, r) {
    return {
      getIsSelected: function() {
        return r.getRowIsSelected(t.id);
      },
      getIsSomeSelected: function() {
        return r.getRowIsSomeSelected(t.id);
      },
      toggleSelected: function(o) {
        return r.toggleRowSelected(t.id, o);
      },
      getToggleSelectedHandler: function() {
        return r.getToggleRowSelectedHandler(t.id);
      },
      getCanMultiSelect: function() {
        return r.getRowCanMultiSelect(t.id);
      },
      getCanSelect: function() {
        return r.getRowCanSelect(t.id);
      }
    };
  }
}, rs = function e(t, r, n, o) {
  var i, a = o.getRow(r);
  a.getIsGrouped(), n ? t[r] = !0 : delete t[r], (i = a.subRows) != null && i.length && o.getRowCanSelectSubRows(a.id) && a.subRows.forEach(function(l) {
    return e(t, l.id, n, o);
  });
};
function Di(e, t) {
  var r = e.getState().rowSelection, n = [], o = {}, i = function a(l, s) {
    return l.map(function(u) {
      var c, d = _o(u, r) === !0;
      if (d && (n.push(u), o[u.id] = u), (c = u.subRows) != null && c.length && (u = pe({}, u, {
        subRows: a(u.subRows)
      })), d)
        return u;
    }).filter(Boolean);
  };
  return {
    rows: i(t.rows),
    flatRows: n,
    rowsById: o
  };
}
function _o(e, t, r) {
  if (t[e.id])
    return !0;
  if (e.subRows && e.subRows.length) {
    var n = !0, o = !1;
    return e.subRows.forEach(function(i) {
      o && !n || (_o(i, t) ? o = !0 : n = !1);
    }), n ? !0 : o ? "some" : !1;
  }
  return !1;
}
var ca = /([0-9]+)/gm, Er = {
  alphanumeric: Y0,
  alphanumericCaseSensitive: K0,
  text: X0,
  textCaseSensitive: J0,
  datetime: Q0,
  basic: eg
};
function Y0(e, t, r) {
  return nc(Cn(e.values[r]).toLowerCase(), Cn(t.values[r]).toLowerCase());
}
function K0(e, t, r) {
  return nc(Cn(e.values[r]), Cn(t.values[r]));
}
function nc(e, t) {
  for (var r = e.split(ca).filter(Boolean), n = t.split(ca).filter(Boolean); r.length && n.length; ) {
    var o = r.shift(), i = n.shift(), a = parseInt(o, 10), l = parseInt(i, 10), s = [a, l].sort();
    if (isNaN(s[0])) {
      if (o > i)
        return 1;
      if (i > o)
        return -1;
      continue;
    }
    if (isNaN(s[1]))
      return isNaN(a) ? -1 : 1;
    if (a > l)
      return 1;
    if (l > a)
      return -1;
  }
  return r.length - n.length;
}
function X0(e, t, r) {
  return si(Cn(e.values[r]).toLowerCase(), Cn(t.values[r]).toLowerCase());
}
function J0(e, t, r) {
  return si(Cn(e.values[r]), Cn(t.values[r]));
}
function Q0(e, t, r) {
  return si(e.values[r].getTime(), t.values[r].getTime());
}
function eg(e, t, r) {
  return si(e.values[r], t.values[r]);
}
function si(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function Cn(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
var tg = {
  getInitialState: function(t) {
    return pe({
      sorting: []
    }, t);
  },
  getDefaultColumn: function() {
    return {
      sortingFn: "auto"
    };
  },
  getDefaultOptions: function(t) {
    return {
      onSortingChange: $t("sorting", t),
      isMultiSortEvent: function(n) {
        return n.shiftKey;
      }
    };
  },
  createColumn: function(t, r) {
    return {
      sortingFn: t.sortingFn,
      getCanSort: function() {
        return r.getColumnCanSort(t.id);
      },
      getCanMultiSort: function() {
        return r.getColumnCanMultiSort(t.id);
      },
      getSortIndex: function() {
        return r.getColumnSortIndex(t.id);
      },
      getIsSorted: function() {
        return r.getColumnIsSorted(t.id);
      },
      resetSorting: function() {
        return r.resetSorting(t.id);
      },
      toggleSorting: function(o, i) {
        return r.toggleColumnSorting(t.id, o, i);
      },
      getToggleSortingHandler: function() {
        return r.getToggleSortingHandler(t.id);
      }
    };
  },
  createInstance: function(t) {
    return {
      getColumnAutoSortingFn: function(n) {
        for (var o = t.getGlobalFilteredRowModel().flatRows.slice(100), i = !1, a = lo(o), l; !(l = a()).done; ) {
          var s = l.value, u = s == null ? void 0 : s.values[n];
          if (Object.prototype.toString.call(u) === "[object Date]")
            return Er.datetime;
          if (typeof u == "string" && (i = !0, u.split(ca).length > 1))
            return Er.alphanumeric;
        }
        return i ? Er.text : Er.basic;
      },
      getColumnAutoSortDir: function(n) {
        var o = t.getGlobalFilteredRowModel().flatRows[0], i = o == null ? void 0 : o.values[n];
        return typeof i == "string" ? "asc" : "desc";
      },
      getColumnSortingFn: function(n) {
        var o, i = t.getColumn(n), a = t.options.sortingFns;
        if (!i)
          throw new Error();
        return ko(i.sortingFn) ? i.sortingFn : i.sortingFn === "auto" ? t.getColumnAutoSortingFn(n) : (o = a == null ? void 0 : a[i.sortingFn]) != null ? o : Er[i.sortingFn];
      },
      setSorting: function(n) {
        return t.options.onSortingChange == null ? void 0 : t.options.onSortingChange(n);
      },
      toggleColumnSorting: function(n, o, i) {
        var a = t.getColumn(n);
        if (!a)
          throw new Error();
        t.setSorting(function(l) {
          var s, u, c, d, f = l == null ? void 0 : l.find(function(S) {
            return S.id === n;
          }), v = l == null ? void 0 : l.findIndex(function(S) {
            return S.id === n;
          }), h = typeof o < "u" && o !== null, m = [], g;
          a.getCanMultiSort() && i ? f ? g = "toggle" : g = "add" : l != null && l.length && v !== l.length - 1 ? g = "replace" : f ? g = "toggle" : g = "replace";
          var C = (s = (u = a.sortDescFirst) != null ? u : t.options.sortDescFirst) != null ? s : t.getColumnAutoSortDir(n) === "desc";
          if (g === "toggle" && ((c = t.options.enableSortingRemoval) != null ? c : !0) && !h && (i && (d = t.options.enableMultiRemove) != null ? d : !0) && (f != null && f.desc ? !C : C) && (g = "remove"), g === "replace")
            m = [{
              id: n,
              desc: h ? o : !!C
            }];
          else if (g === "add" && l != null && l.length) {
            var x;
            m = [].concat(l, [{
              id: n,
              desc: h ? o : !!C
            }]), m.splice(0, m.length - ((x = t.options.maxMultiSortColCount) != null ? x : Number.MAX_SAFE_INTEGER));
          } else
            g === "toggle" && l != null && l.length ? m = l.map(function(S) {
              return S.id === n ? pe({}, S, {
                desc: h ? o : !(f != null && f.desc)
              }) : S;
            }) : g === "remove" && l != null && l.length && (m = l.filter(function(S) {
              return S.id !== n;
            }));
          return m;
        });
      },
      getColumnCanSort: function(n) {
        var o, i, a, l = t.getColumn(n);
        if (!l)
          throw new Error();
        return (o = (i = (a = l.enableSorting) != null ? a : t.options.enableSorting) != null ? i : l.defaultCanSort) != null ? o : !!l.accessorFn;
      },
      getColumnCanMultiSort: function(n) {
        var o, i, a = t.getColumn(n);
        if (!a)
          throw new Error();
        return (o = (i = a.enableMultiSort) != null ? i : t.options.enableMultiSort) != null ? o : !!a.accessorFn;
      },
      getColumnIsSorted: function(n) {
        var o, i = (o = t.getState().sorting) == null ? void 0 : o.find(function(a) {
          return a.id === n;
        });
        return i ? i.desc ? "desc" : "asc" : !1;
      },
      getColumnSortIndex: function(n) {
        var o, i;
        return (o = (i = t.getState().sorting) == null ? void 0 : i.findIndex(function(a) {
          return a.id === n;
        })) != null ? o : -1;
      },
      resetSorting: function(n) {
        if (n)
          t.setSorting(function(a) {
            return a != null && a.length ? a.filter(function(l) {
              return l.id !== n;
            }) : [];
          });
        else {
          var o, i;
          t.setSorting((o = (i = t.initialState) == null ? void 0 : i.sorting) != null ? o : []);
        }
      },
      getToggleSortingHandler: function(n) {
        var o = t.getColumn(n);
        if (!o)
          throw new Error();
        var i = o.getCanSort();
        return function(a) {
          !i || (a.persist == null || a.persist(), o.toggleSorting == null || o.toggleSorting(void 0, o.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(a) : !1));
        };
      },
      getPreSortedRowModel: function() {
        return t.getGlobalFilteredRowModel();
      },
      getSortedRowModel: function() {
        return !t._getSortedRowModel && t.options.getSortedRowModel && (t._getSortedRowModel = t.options.getSortedRowModel(t)), t.options.manualSorting || !t._getSortedRowModel ? t.getPreSortedRowModel() : t._getSortedRowModel();
      }
    };
  }
}, ng = {
  getInitialState: function(t) {
    return pe({
      columnVisibility: {}
    }, t);
  },
  getDefaultOptions: function(t) {
    return {
      onColumnVisibilityChange: $t("columnVisibility", t)
    };
  },
  getDefaultColumn: function() {
    return {
      defaultIsVisible: !0
    };
  },
  createColumn: function(t, r) {
    return {
      getCanHide: function() {
        return r.getColumnCanHide(t.id);
      },
      getIsVisible: function() {
        return r.getColumnIsVisible(t.id);
      },
      toggleVisibility: function(o) {
        return r.toggleColumnVisibility(t.id, o);
      },
      getToggleVisibilityHandler: function() {
        return function(o) {
          t.toggleVisibility == null || t.toggleVisibility(o.target.checked);
        };
      }
    };
  },
  createRow: function(t, r) {
    return {
      _getAllVisibleCells: he(function() {
        return [t.getAllCells().filter(function(n) {
          return n.column.getIsVisible();
        }).map(function(n) {
          return n.id;
        }).join("_")];
      }, function(n) {
        return t.getAllCells().filter(function(o) {
          return o.column.getIsVisible();
        });
      }, {
        key: "row._getAllVisibleCells",
        debug: function() {
          var o;
          return (o = r.options.debugAll) != null ? o : r.options.debugRows;
        }
      }),
      getVisibleCells: he(function() {
        return [t.getLeftVisibleCells(), t.getCenterVisibleCells(), t.getRightVisibleCells()];
      }, function(n, o, i) {
        return [].concat(n, o, i);
      }, {
        key: "row.getVisibleCells",
        debug: function() {
          var o;
          return (o = r.options.debugAll) != null ? o : r.options.debugRows;
        }
      })
    };
  },
  createInstance: function(t) {
    var r = function(o, i) {
      return he(function() {
        return [i(), i().filter(function(a) {
          return a.getIsVisible();
        }).map(function(a) {
          return a.id;
        }).join("_")];
      }, function(a) {
        return a.filter(function(l) {
          return l.getIsVisible == null ? void 0 : l.getIsVisible();
        });
      }, {
        key: o,
        debug: function() {
          var l;
          return (l = t.options.debugAll) != null ? l : t.options.debugColumns;
        }
      });
    };
    return {
      getVisibleFlatColumns: r("getVisibleFlatColumns", function() {
        return t.getAllFlatColumns();
      }),
      getVisibleLeafColumns: r("getVisibleLeafColumns", function() {
        return t.getAllLeafColumns();
      }),
      getLeftVisibleLeafColumns: r("getLeftVisibleLeafColumns", function() {
        return t.getLeftLeafColumns();
      }),
      getRightVisibleLeafColumns: r("getRightVisibleLeafColumns", function() {
        return t.getRightLeafColumns();
      }),
      getCenterVisibleLeafColumns: r("getCenterVisibleLeafColumns", function() {
        return t.getCenterLeafColumns();
      }),
      setColumnVisibility: function(o) {
        return t.options.onColumnVisibilityChange == null ? void 0 : t.options.onColumnVisibilityChange(o);
      },
      toggleColumnVisibility: function(o, i) {
        !o || t.getColumnCanHide(o) && t.setColumnVisibility(function(a) {
          var l;
          return pe({}, a, (l = {}, l[o] = i != null ? i : !t.getColumnIsVisible(o), l));
        });
      },
      toggleAllColumnsVisible: function(o) {
        var i;
        o = (i = o) != null ? i : !t.getIsAllColumnsVisible(), t.setColumnVisibility(t.getAllLeafColumns().reduce(function(a, l) {
          var s;
          return pe({}, a, (s = {}, s[l.id] = o || !(l.getCanHide != null && l.getCanHide()), s));
        }, {}));
      },
      getColumnIsVisible: function(o) {
        var i, a, l, s = t.getColumn(o);
        if (!s)
          throw new Error();
        return (i = (a = (l = t.getState().columnVisibility) == null ? void 0 : l[o]) != null ? a : s.defaultIsVisible) != null ? i : !0;
      },
      getColumnCanHide: function(o) {
        var i, a, l, s = t.getColumn(o);
        if (!s)
          throw new Error();
        return (i = (a = (l = t.options.enableHiding) != null ? l : s.enableHiding) != null ? a : s.defaultCanHide) != null ? i : !0;
      },
      getIsAllColumnsVisible: function() {
        return !t.getAllLeafColumns().some(function(o) {
          return !(o.getIsVisible != null && o.getIsVisible());
        });
      },
      getIsSomeColumnsVisible: function() {
        return t.getAllLeafColumns().some(function(o) {
          return o.getIsVisible == null ? void 0 : o.getIsVisible();
        });
      },
      getToggleAllColumnsVisibilityHandler: function() {
        return function(o) {
          var i;
          t.toggleAllColumnsVisible((i = o.target) == null ? void 0 : i.checked);
        };
      }
    };
  }
}, rg = {
  createInstance: function(t) {
    return {
      createHeader: function(n, o) {
        var i, a = (i = o.id) != null ? i : n.id, l = {
          id: a,
          column: n,
          index: o.index,
          isPlaceholder: o.isPlaceholder,
          placeholderId: o.placeholderId,
          depth: o.depth,
          subHeaders: [],
          colSpan: 0,
          rowSpan: 0,
          headerGroup: null,
          getSize: function() {
            var u = 0, c = function d(f) {
              if (f.subHeaders.length)
                f.subHeaders.forEach(d);
              else {
                var v;
                u += (v = f.column.getSize()) != null ? v : 0;
              }
            };
            return c(l), u;
          },
          getStart: function() {
            if (l.index > 0) {
              var u = l.headerGroup.headers[l.index - 1];
              return u.getStart() + u.getSize();
            }
            return 0;
          },
          getLeafHeaders: function() {
            var u = [], c = function d(f) {
              f.subHeaders && f.subHeaders.length && f.subHeaders.map(d), u.push(f);
            };
            return c(l), u;
          },
          renderHeader: function() {
            return n.header ? t.render(n.header, {
              instance: t,
              header: l,
              column: n
            }) : null;
          },
          renderFooter: function() {
            return n.footer ? t.render(n.footer, {
              instance: t,
              header: l,
              column: n
            }) : null;
          }
        };
        return t._features.forEach(function(s) {
          Object.assign(l, s.createHeader == null ? void 0 : s.createHeader(l, t));
        }), l;
      },
      getHeaderGroups: he(function() {
        return [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right];
      }, function(r, n, o, i) {
        var a = n.filter(function(c) {
          return o == null ? void 0 : o.includes(c.id);
        }), l = n.filter(function(c) {
          return i == null ? void 0 : i.includes(c.id);
        }), s = n.filter(function(c) {
          return !(o != null && o.includes(c.id)) && !(i != null && i.includes(c.id));
        }), u = yo(r, [].concat(a, s, l), t);
        return u;
      }, {
        key: "getHeaderGroups",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getCenterHeaderGroups: he(function() {
        return [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right];
      }, function(r, n, o, i) {
        return n = n.filter(function(a) {
          return !(o != null && o.includes(a.id)) && !(i != null && i.includes(a.id));
        }), yo(r, n, t, "center");
      }, {
        key: "getCenterHeaderGroups",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getLeftHeaderGroups: he(function() {
        return [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left];
      }, function(r, n, o) {
        return n = n.filter(function(i) {
          return o == null ? void 0 : o.includes(i.id);
        }), yo(r, n, t, "left");
      }, {
        key: "getLeftHeaderGroups",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getRightHeaderGroups: he(function() {
        return [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.right];
      }, function(r, n, o) {
        return n = n.filter(function(i) {
          return o == null ? void 0 : o.includes(i.id);
        }), yo(r, n, t, "right");
      }, {
        key: "getRightHeaderGroups",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getFooterGroups: he(function() {
        return [t.getHeaderGroups()];
      }, function(r) {
        return [].concat(r).reverse();
      }, {
        key: "getFooterGroups",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getLeftFooterGroups: he(function() {
        return [t.getLeftHeaderGroups()];
      }, function(r) {
        return [].concat(r).reverse();
      }, {
        key: "getLeftFooterGroups",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getCenterFooterGroups: he(function() {
        return [t.getCenterHeaderGroups()];
      }, function(r) {
        return [].concat(r).reverse();
      }, {
        key: "getCenterFooterGroups",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getRightFooterGroups: he(function() {
        return [t.getRightHeaderGroups()];
      }, function(r) {
        return [].concat(r).reverse();
      }, {
        key: "getRightFooterGroups",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getFlatHeaders: he(function() {
        return [t.getHeaderGroups()];
      }, function(r) {
        return r.map(function(n) {
          return n.headers;
        }).flat();
      }, {
        key: "getFlatHeaders",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getLeftFlatHeaders: he(function() {
        return [t.getLeftHeaderGroups()];
      }, function(r) {
        return r.map(function(n) {
          return n.headers;
        }).flat();
      }, {
        key: "getLeftFlatHeaders",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getCenterFlatHeaders: he(function() {
        return [t.getCenterHeaderGroups()];
      }, function(r) {
        return r.map(function(n) {
          return n.headers;
        }).flat();
      }, {
        key: "getCenterFlatHeaders",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getRightFlatHeaders: he(function() {
        return [t.getRightHeaderGroups()];
      }, function(r) {
        return r.map(function(n) {
          return n.headers;
        }).flat();
      }, {
        key: "getRightFlatHeaders",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getCenterLeafHeaders: he(function() {
        return [t.getCenterFlatHeaders()];
      }, function(r) {
        return r.filter(function(n) {
          var o;
          return !((o = n.subHeaders) != null && o.length);
        });
      }, {
        key: "getCenterLeafHeaders",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getLeftLeafHeaders: he(function() {
        return [t.getLeftFlatHeaders()];
      }, function(r) {
        return r.filter(function(n) {
          var o;
          return !((o = n.subHeaders) != null && o.length);
        });
      }, {
        key: "getLeftLeafHeaders",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getRightLeafHeaders: he(function() {
        return [t.getRightFlatHeaders()];
      }, function(r) {
        return r.filter(function(n) {
          var o;
          return !((o = n.subHeaders) != null && o.length);
        });
      }, {
        key: "getRightLeafHeaders",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getLeafHeaders: he(function() {
        return [t.getLeftHeaderGroups(), t.getCenterHeaderGroups(), t.getRightHeaderGroups()];
      }, function(r, n, o) {
        var i, a, l, s, u, c;
        return [].concat((i = (a = r[0]) == null ? void 0 : a.headers) != null ? i : [], (l = (s = n[0]) == null ? void 0 : s.headers) != null ? l : [], (u = (c = o[0]) == null ? void 0 : c.headers) != null ? u : []).map(function(d) {
          return d.getLeafHeaders();
        }).flat();
      }, {
        key: "getLeafHeaders",
        debug: function() {
          var n;
          return (n = t.options.debugAll) != null ? n : t.options.debugHeaders;
        }
      }),
      getHeader: function(n) {
        var o = [].concat(t.getFlatHeaders(), t.getCenterFlatHeaders(), t.getLeftFlatHeaders(), t.getRightFlatHeaders()).find(function(i) {
          return i.id === n;
        });
        if (!o)
          throw process.env.NODE_ENV !== "production" && console.warn("Could not find header with id: " + n), new Error();
        return o;
      }
    };
  }
};
function yo(e, t, r, n) {
  var o, i, a = 0, l = function f(v, h) {
    h === void 0 && (h = 1), a = Math.max(a, h), v.filter(function(m) {
      return m.getIsVisible();
    }).forEach(function(m) {
      var g;
      (g = m.columns) != null && g.length && f(m.columns, h + 1);
    }, 0);
  };
  l(e);
  var s = [], u = function f(v, h) {
    var m = {
      depth: h,
      id: [n, "" + h].filter(Boolean).join("_"),
      headers: []
    }, g = [];
    v.forEach(function(C) {
      var x = [].concat(g).reverse()[0], S = C.column.depth === m.depth, w, y = !1;
      if (S && C.column.parent ? w = C.column.parent : (w = C.column, y = !0), (x == null ? void 0 : x.column) === w)
        x.subHeaders.push(C);
      else {
        var O = r.createHeader(w, {
          id: [n, h, w.id, C == null ? void 0 : C.id].filter(Boolean).join("_"),
          isPlaceholder: y,
          placeholderId: y ? "" + g.filter(function(P) {
            return P.column === w;
          }).length : void 0,
          depth: h,
          index: g.length
        });
        O.subHeaders.push(C), g.push(O);
      }
      m.headers.push(C), C.headerGroup = m;
    }), s.push(m), h > 0 && f(g, h - 1);
  }, c = t.map(function(f, v) {
    return r.createHeader(f, {
      depth: a,
      index: v
    });
  });
  u(c, a - 1), s.reverse();
  var d = function f(v) {
    var h = v.filter(function(m) {
      return m.column.getIsVisible();
    });
    return h.map(function(m) {
      var g = 0, C = 0, x = [0];
      m.subHeaders && m.subHeaders.length ? (x = [], f(m.subHeaders).forEach(function(w) {
        var y = w.colSpan, O = w.rowSpan;
        g += y, x.push(O);
      })) : g = 1;
      var S = Math.min.apply(Math, x);
      return C = C + S, m.colSpan = g > 0 ? g : void 0, m.rowSpan = C > 0 ? C : void 0, {
        colSpan: g,
        rowSpan: C
      };
    });
  };
  return d((o = (i = s[0]) == null ? void 0 : i.headers) != null ? o : []), s;
}
function og(e) {
  var t;
  (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  var r = {};
  r._features = [I0, T0, $0, rg, ng, U0, Z0, k0, tg, j0, A0, W0, q0, M0];
  var n = r._features.reduce(function(c, d) {
    return Object.assign(c, d.getDefaultOptions == null ? void 0 : d.getDefaultOptions(r));
  }, {}), o = function(d) {
    return r.options.mergeOptions ? r.options.mergeOptions(n, d) : pe({}, n, d);
  };
  r.options = pe({}, n, e);
  var i = {
    coreProgress: 1
  }, a = pe({}, i, (t = e.initialState) != null ? t : {});
  r._features.forEach(function(c) {
    var d;
    a = (d = c.getInitialState == null ? void 0 : c.getInitialState(a)) != null ? d : a;
  });
  var l = [], s = !1, u = pe({}, r, r._features.reduce(function(c, d) {
    return Object.assign(c, d.createInstance == null ? void 0 : d.createInstance(r));
  }, {}), {
    queue: function(d) {
      l.push(d), s || (s = !0, Promise.resolve().then(function() {
        for (; l.length; )
          l.shift()();
        s = !1;
      }).catch(function(f) {
        return setTimeout(function() {
          throw f;
        });
      }));
    },
    initialState: a,
    reset: function() {
      r.setState(r.initialState);
    },
    setOptions: function(d) {
      var f = vn(d, r.options);
      r.options = o(f);
    },
    render: function(d, f) {
      return typeof r.options.render == "function" ? r.options.render(d, f) : typeof d == "function" ? d(f) : d;
    },
    getState: function() {
      return r.options.state;
    },
    setState: function(d) {
      r.options.onStateChange == null || r.options.onStateChange(d);
    },
    getOverallProgress: function() {
      var d = r.getState(), f = d.coreProgress, v = d.columnFiltersProgress, h = d.globalFilterProgress;
      return tc(function() {
        return [f, v, h].filter(function(m) {
          return m < 1;
        });
      });
    }
  });
  return r = Object.assign(r, u), r;
}
function ig(e) {
  return function() {
    return rc(void 0, void 0, e);
  };
}
function rc(e, t, r) {
  var n = {
    generics: void 0,
    options: r != null ? r : {
      render: function() {
        throw new Error("");
      }()
    },
    setGenerics: function() {
      return n;
    },
    setRowType: function() {
      return n;
    },
    setTableMetaType: function() {
      return n;
    },
    setColumnMetaType: function() {
      return n;
    },
    setOptions: function(i) {
      return rc(e, t, pe({}, r, i));
    },
    createDisplayColumn: function(i) {
      return pe({}, i, {
        columnDefType: "display"
      });
    },
    createGroup: function(i) {
      return pe({}, i, {
        columnDefType: "group"
      });
    },
    createDataColumn: function(i, a) {
      if (a = pe({}, a, {
        columnDefType: "data",
        id: a.id
      }), typeof i == "string") {
        var l;
        return pe({}, a, {
          id: (l = a.id) != null ? l : i,
          accessorKey: i
        });
      }
      if (typeof i == "function")
        return pe({}, a, {
          accessorFn: i
        });
      throw new Error("Invalid accessor");
    }
  };
  return n;
}
function ag() {
  return function(e) {
    return he(function() {
      return [e.options.data];
    }, function(t) {
      for (var r = [], n = [], o = {}, i = e.getAllLeafColumns(), a = function s(u, c, d, f, v) {
        d === void 0 && (d = 0);
        var h = e.getRowId(u, c, v);
        if (!h && process.env.NODE_ENV !== "production")
          throw new Error("getRowId expected an ID, but got " + h);
        for (var m = {}, g = 0; g < i.length; g++) {
          var C = i[g];
          C && C.accessorFn && (m[C.id] = C.accessorFn(u, c));
        }
        var x = e.createRow(h, u, c, d, m);
        if (f.push(x), n.push(x), o[h] = x, e.options.getSubRows) {
          var S = e.options.getSubRows(u, c);
          if (S != null && S.length) {
            x.originalSubRows = S;
            for (var w = [], y = 0; y < x.originalSubRows.length; y++)
              s(x.originalSubRows[y], y, d + 1, w, x);
            x.subRows = w;
          }
        }
      }, l = 0; l < t.length; l++)
        a(t[l], l, 0, r);
      return {
        rows: r,
        flatRows: n,
        rowsById: o
      };
    }, {
      key: "getRowModel",
      debug: function() {
        var r;
        return (r = e.options.debugAll) != null ? r : e.options.debugTable;
      },
      onChange: function() {
        e.queue(function() {
          e._autoResetPageIndex();
        });
      }
    });
  };
}
function lg(e, t, r) {
  var n = [], o = {}, i = function a(l, s) {
    s === void 0 && (s = 0), l = l.slice();
    for (var u = 0; u < l.length; u++) {
      var c, d = l[u];
      !((c = d.subRows) != null && c.length) || (l[u] = r.createRow(d.id, d.original, d.index, d.depth, d.values), l[u].subRows = a(d.subRows, s + 1), l[u].subRows.length || (l.splice(u, 1), u--));
    }
    return l = t(l, s), l.forEach(function(f) {
      n.push(f), o[f.id] = f;
    }), l;
  };
  return {
    rows: i(e),
    flatRows: n,
    rowsById: o
  };
}
function sg(e, t, r) {
  var n = [], o = {}, i = function a(l, s) {
    s === void 0 && (s = 0), l = t(l, s);
    for (var u = 0; u < l.length; u++) {
      var c, d = l[u];
      if (n.push(d), o[d.id] = d, !((c = d.subRows) != null && c.length)) {
        l.splice(u, 1), u--;
        continue;
      }
      l[u] = r.createRow(d.id, d.original, d.index, d.depth, d.values), l[u].subRows = a(d.subRows, s + 1);
    }
    return l;
  };
  return {
    rows: i(e),
    flatRows: n,
    rowsById: o
  };
}
function ug() {
  return function(e) {
    return he(function() {
      return [e.getState().columnFilters, e.getPreColumnFilteredRowModel()];
    }, function(t, r) {
      var n = function() {
        if (!r.rows.length || !(t != null && t.length))
          return r;
        var i = e.options.filterFromLeafRows, a = function(s, u) {
          for (var c = 0; c < t.length; c++) {
            var d = t[c], f = d.id, v = d.value, h = e.getColumn(f);
            if (!h)
              throw process.env.NODE_ENV !== "production" && console.warn("Table: Could not find a column with id: " + f), new Error();
            u === 0 && function() {
              var g = [].concat(s);
              h.getPreFilteredRows = function() {
                return g;
              };
            }();
            var m = e.getColumnFilterFn(h.id);
            if (!m) {
              process.env.NODE_ENV !== "production" && console.warn("Could not find a valid 'column.filterFn' for column with the ID: " + h.id + ".");
              continue;
            }
            s = m(s, [f], v);
          }
          return s;
        };
        return i ? lg(r.rows, a, e) : sg(r.rows, a, e);
      }(), o = e.getAllLeafColumns().filter(function(i) {
        var a;
        return !((a = e.getState().columnFilters) != null && a.find(function(l) {
          return l.id === i.id;
        }));
      });
      return o.forEach(function(i) {
        i.getPreFilteredRows = function() {
          return n.rows;
        };
      }), n;
    }, {
      key: "getColumnFilteredRowModelSync",
      debug: function() {
        var r;
        return (r = e.options.debugAll) != null ? r : e.options.debugTable;
      },
      onChange: function() {
        e.queue(function() {
          e._autoResetPageIndex();
        });
      }
    });
  };
}
function cg() {
  return function(e) {
    return he(function() {
      return [e.getState().sorting, e.getPreSortedRowModel()];
    }, function(t, r) {
      if (!r.rows.length || !(t != null && t.length))
        return r;
      var n = e.getState().sorting, o = [], i = n.filter(function(s) {
        return e.getColumnCanSort(s.id);
      }), a = {};
      i.forEach(function(s) {
        var u = e.getColumn(s.id);
        a[s.id] = {
          sortUndefined: u.sortUndefined,
          invertSorting: u.invertSorting,
          sortingFn: e.getColumnSortingFn(s.id)
        };
      });
      var l = function s(u) {
        var c = u.slice();
        return c.sort(function(d, f) {
          for (var v = 0; v < i.length; v += 1) {
            var h, m = i[v], g = a[m.id], C = (h = m == null ? void 0 : m.desc) != null ? h : !1;
            if (g.sortUndefined) {
              var x = d.values[m.id], S = f.values[m.id], w = typeof x > "u", y = typeof S > "u";
              if (w || y)
                return w && y ? 0 : w ? g.sortUndefined : -g.sortUndefined;
            }
            var O = g.sortingFn(d, f, m.id);
            if (O !== 0)
              return C && (O *= -1), g.invertSorting && (O *= -1), O;
          }
          return d.index - f.index;
        }), c.forEach(function(d) {
          o.push(d), !(!d.subRows || d.subRows.length <= 1) && (d.subRows = s(d.subRows));
        }), c;
      };
      return {
        rows: l(r.rows),
        flatRows: o,
        rowsById: r.rowsById
      };
    }, {
      key: "getSortedRowModel",
      debug: function() {
        var r;
        return (r = e.options.debugAll) != null ? r : e.options.debugTable;
      },
      onChange: function() {
        e.queue(function() {
          e._autoResetPageIndex();
        });
      }
    });
  };
}
/**
 * react-table
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Vr() {
  return Vr = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vr.apply(this, arguments);
}
var oc = function(t, r) {
  return t ? dg(t) ? /* @__PURE__ */ p(t, {
    ...r
  }) : t : null;
};
function dg(e) {
  return fg(e) || typeof e == "function" || pg(e);
}
function fg(e) {
  return typeof e == "function" && function() {
    var t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  }();
}
function pg(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
var G4 = ig({
  render: oc
});
function gg(e, t) {
  var r = Vr({}, e.options, {
    state: {},
    onStateChange: function() {
    },
    render: oc
  }, t), n = N.useState(function() {
    return og(r);
  }), o = n[0], i = N.useState(function() {
    return o.initialState;
  }), a = i[0], l = i[1];
  return o.setOptions(function(s) {
    return Vr({}, s, t, {
      state: Vr({}, a, t.state),
      onStateChange: function(c) {
        l(c), t.onStateChange == null || t.onStateChange(c);
      }
    });
  }), o;
}
function An() {
  return An = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, An.apply(this, arguments);
}
function vg(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
var mg = ["bottom", "height", "left", "right", "top", "width"], hg = function(t, r) {
  return t === void 0 && (t = {}), r === void 0 && (r = {}), mg.some(function(n) {
    return t[n] !== r[n];
  });
}, dn = /* @__PURE__ */ new Map(), ic, bg = function e() {
  var t = [];
  dn.forEach(function(r, n) {
    var o = n.getBoundingClientRect();
    hg(o, r.rect) && (r.rect = o, t.push(r));
  }), t.forEach(function(r) {
    r.callbacks.forEach(function(n) {
      return n(r.rect);
    });
  }), ic = window.requestAnimationFrame(e);
};
function yg(e, t) {
  return {
    observe: function() {
      var n = dn.size === 0;
      dn.has(e) ? dn.get(e).callbacks.push(t) : dn.set(e, {
        rect: void 0,
        hasRectChanged: !1,
        callbacks: [t]
      }), n && bg();
    },
    unobserve: function() {
      var n = dn.get(e);
      if (n) {
        var o = n.callbacks.indexOf(t);
        o >= 0 && n.callbacks.splice(o, 1), n.callbacks.length || dn.delete(e), dn.size || cancelAnimationFrame(ic);
      }
    }
  };
}
var Fo = typeof window < "u" ? K.useLayoutEffect : K.useEffect;
function Cg(e, t) {
  t === void 0 && (t = {
    width: 0,
    height: 0
  });
  var r = K.useState(e.current), n = r[0], o = r[1], i = K.useReducer(xg, t), a = i[0], l = i[1], s = K.useRef(!1);
  return Fo(function() {
    e.current !== n && o(e.current);
  }), Fo(function() {
    if (n && !s.current) {
      s.current = !0;
      var u = n.getBoundingClientRect();
      l({
        rect: u
      });
    }
  }, [n]), K.useEffect(function() {
    if (!!n) {
      var u = yg(n, function(c) {
        l({
          rect: c
        });
      });
      return u.observe(), function() {
        u.unobserve();
      };
    }
  }, [n]), a;
}
function xg(e, t) {
  var r = t.rect;
  return e.height !== r.height || e.width !== r.width ? r : e;
}
var wg = function() {
  return 50;
}, Sg = function(t) {
  return t;
}, Rg = function(t, r) {
  var n = r ? "offsetWidth" : "offsetHeight";
  return t[n];
}, Eg = function(t) {
  for (var r = Math.max(t.start - t.overscan, 0), n = Math.min(t.end + t.overscan, t.size - 1), o = [], i = r; i <= n; i++)
    o.push(i);
  return o;
};
function ac(e) {
  var t, r = e.size, n = r === void 0 ? 0 : r, o = e.estimateSize, i = o === void 0 ? wg : o, a = e.overscan, l = a === void 0 ? 1 : a, s = e.paddingStart, u = s === void 0 ? 0 : s, c = e.paddingEnd, d = c === void 0 ? 0 : c, f = e.parentRef, v = e.horizontal, h = e.scrollToFn, m = e.useObserver, g = e.initialRect, C = e.onScrollElement, x = e.scrollOffsetFn, S = e.keyExtractor, w = S === void 0 ? Sg : S, y = e.measureSize, O = y === void 0 ? Rg : y, P = e.rangeExtractor, M = P === void 0 ? Eg : P, I = v ? "width" : "height", k = v ? "scrollLeft" : "scrollTop", R = K.useRef({
    scrollOffset: 0,
    measurements: []
  }), A = K.useState(0), L = A[0], B = A[1];
  R.current.scrollOffset = L;
  var W = m || Cg, U = W(f, g), X = U[I];
  R.current.outerSize = X;
  var D = K.useCallback(function(Ee) {
    f.current && (f.current[k] = Ee);
  }, [f, k]), le = h || D;
  h = K.useCallback(function(Ee) {
    le(Ee, D);
  }, [D, le]);
  var T = K.useState({}), j = T[0], z = T[1], _ = K.useCallback(function() {
    return z({});
  }, []), H = K.useRef([]), te = K.useMemo(function() {
    var Ee = H.current.length > 0 ? Math.min.apply(Math, H.current) : 0;
    H.current = [];
    for (var Ie = R.current.measurements.slice(0, Ee), Se = Ee; Se < n; Se++) {
      var et = w(Se), je = j[et], nt = Ie[Se - 1] ? Ie[Se - 1].end : u, Xe = typeof je == "number" ? je : i(Se), it = nt + Xe;
      Ie[Se] = {
        index: Se,
        start: nt,
        size: Xe,
        end: it,
        key: et
      };
    }
    return Ie;
  }, [i, j, u, n, w]), re = (((t = te[n - 1]) == null ? void 0 : t.end) || u) + d;
  R.current.measurements = te, R.current.totalSize = re;
  var ue = C ? C.current : f.current, ce = K.useRef(x);
  ce.current = x, Fo(function() {
    if (!ue) {
      B(0);
      return;
    }
    var Ee = function(Se) {
      var et = ce.current ? ce.current(Se) : ue[k];
      B(et);
    };
    return Ee(), ue.addEventListener("scroll", Ee, {
      capture: !1,
      passive: !0
    }), function() {
      ue.removeEventListener("scroll", Ee);
    };
  }, [ue, k]);
  var Y = Pg(R.current), J = Y.start, ye = Y.end, Q = K.useMemo(function() {
    return M({
      start: J,
      end: ye,
      overscan: l,
      size: te.length
    });
  }, [J, ye, l, te.length, M]), Ue = K.useRef(O);
  Ue.current = O;
  var F = K.useMemo(function() {
    for (var Ee = [], Ie = function(nt, Xe) {
      var it = Q[nt], ct = te[it], pt = An(An({}, ct), {}, {
        measureRef: function(Ht) {
          if (Ht) {
            var Xt = Ue.current(Ht, v);
            if (Xt !== pt.size) {
              var In = R.current.scrollOffset;
              pt.start < In && D(In + (Xt - pt.size)), H.current.push(it), z(function(go) {
                var Cr;
                return An(An({}, go), {}, (Cr = {}, Cr[pt.key] = Xt, Cr));
              });
            }
          }
        }
      });
      Ee.push(pt);
    }, Se = 0, et = Q.length; Se < et; Se++)
      Ie(Se);
    return Ee;
  }, [Q, D, v, te]), Ke = K.useRef(!1);
  Fo(function() {
    Ke.current && z({}), Ke.current = !0;
  }, [i]);
  var qe = K.useCallback(function(Ee, Ie) {
    var Se = Ie === void 0 ? {} : Ie, et = Se.align, je = et === void 0 ? "start" : et, nt = R.current, Xe = nt.scrollOffset, it = nt.outerSize;
    je === "auto" && (Ee <= Xe ? je = "start" : Ee >= Xe + it ? je = "end" : je = "start"), je === "start" ? h(Ee) : je === "end" ? h(Ee - it) : je === "center" && h(Ee - it / 2);
  }, [h]), ut = K.useCallback(function(Ee, Ie) {
    var Se = Ie === void 0 ? {} : Ie, et = Se.align, je = et === void 0 ? "auto" : et, nt = vg(Se, ["align"]), Xe = R.current, it = Xe.measurements, ct = Xe.scrollOffset, pt = Xe.outerSize, de = it[Math.max(0, Math.min(Ee, n - 1))];
    if (!!de) {
      if (je === "auto")
        if (de.end >= ct + pt)
          je = "end";
        else if (de.start <= ct)
          je = "start";
        else
          return;
      var Ht = je === "center" ? de.start + de.size / 2 : je === "end" ? de.end : de.start;
      qe(Ht, An({
        align: je
      }, nt));
    }
  }, [qe, n]), ln = K.useCallback(function() {
    for (var Ee = arguments.length, Ie = new Array(Ee), Se = 0; Se < Ee; Se++)
      Ie[Se] = arguments[Se];
    ut.apply(void 0, Ie), requestAnimationFrame(function() {
      ut.apply(void 0, Ie);
    });
  }, [ut]);
  return {
    virtualItems: F,
    totalSize: re,
    scrollToOffset: qe,
    scrollToIndex: ln,
    measure: _
  };
}
var Og = function(t, r, n, o) {
  for (; t <= r; ) {
    var i = (t + r) / 2 | 0, a = n(i);
    if (a < o)
      t = i + 1;
    else if (a > o)
      r = i - 1;
    else
      return i;
  }
  return t > 0 ? t - 1 : 0;
};
function Pg(e) {
  for (var t = e.measurements, r = e.outerSize, n = e.scrollOffset, o = t.length - 1, i = function(u) {
    return t[u].start;
  }, a = Og(0, o, i, n), l = a; l < o && t[l].end < n + r; )
    l++;
  return {
    start: a,
    end: l
  };
}
const Ig = (e, t) => Array.from(Array(e)).map(() => t), lc = ({
  items: e,
  loadMoreItems: t,
  virtualItems: r,
  emptyRow: n,
  sorting: o,
  columnFilters: i
}) => {
  const a = oe(e.hash), l = oe({
    startIndex: -1,
    stopIndex: -1
  }), s = Ig(e.count, n), u = oe(s);
  let c = !1;
  if (a.current !== e.hash && (a.current = e.hash, u.current = s, c = !0), e && (l.current.startIndex !== e.params.startIndex || l.current.stopIndex !== e.params.stopIndex || c)) {
    for (let d = e.params.startIndex; d <= e.params.stopIndex; d++) {
      const f = d - e.params.startIndex;
      e.data[f] === void 0 ? u.current[0] = n : u.current[d] = e.data[f];
    }
    u.current = [...u.current], l.current = e.params;
  }
  return Sa(() => {
    var h, m;
    if (t === void 0)
      return;
    const d = r, f = (h = d[0]) == null ? void 0 : h.index, v = (m = d[d.length - 1]) == null ? void 0 : m.index;
    t(f != null ? f : 0, v != null ? v : 0, i, o);
  }, [t, r, i, o]), u;
}, U4 = (e) => {
  const {
    items: t,
    children: r,
    loadMoreItems: n,
    rowSize: o,
    sorting: i,
    columnFilters: a
  } = e, l = oe(null), s = ac({
    size: t.count,
    parentRef: l,
    estimateSize: gt(() => o, [o])
  }), u = lc({
    items: t,
    loadMoreItems: n,
    virtualItems: s.virtualItems,
    emptyRow: void 0,
    sorting: i,
    columnFilters: a
  }), c = (d) => {
    const f = u.current[d.index];
    return /* @__PURE__ */ p("div", {
      className: d.className,
      style: d.style,
      children: f !== void 0 ? r({
        item: f
      }) : `Loading index ${d.index}`
    });
  };
  return /* @__PURE__ */ p("div", {
    ref: l,
    className: "h-full w-full overflow-auto",
    children: /* @__PURE__ */ p("div", {
      className: "w-full relative",
      style: {
        height: `${s.totalSize}px`
      },
      children: s.virtualItems.map((d) => /* @__PURE__ */ p(c, {
        className: "absolute top-0 left-0 w-full",
        style: {
          height: `${d.size}px`,
          transform: `translateY(${d.start}px)`
        },
        index: d.index
      }, d.index))
    })
  });
}, Tg = (e, t) => {
  let r = 0, n = 0;
  return e.forEach((o) => {
    o.enableResizing === !1 || o.size !== void 0 ? r += o.size !== void 0 ? o.size : kn.size : o.defaultIsVisible !== !1 && n++;
  }), n > 0 ? (t - r) / n : kn.size;
}, wo = (e, t) => {
  const r = Tg(e, t), n = {}, o = {};
  return e.forEach((i) => {
    n[i.id] = i.defaultIsVisible !== void 0 ? i.defaultIsVisible : !0, o[i.id] = i.size !== void 0 ? i.size : i.enableResizing === !1 ? kn.size : r;
  }), {
    columnVisibility: n,
    columnWidth: o,
    isValid: !0
  };
}, $g = (e, t, r, n) => {
  if (e !== void 0) {
    const o = localStorage.getItem([n, e].join("-")), i = o !== null ? JSON.parse(o) : wo(t, r);
    let a = !0;
    return Object.entries(i.columnVisibility).length !== t.length ? a = !1 : Object.entries(i.columnVisibility).forEach(([l]) => {
      t.find(({
        id: u
      }) => u === l) === void 0 && (a = !1);
    }), a || console.error(`Stored configuration does not match table structure with tableId "${e}". Are you sure tableId is unique? Disabling tableConfiguration saving for "${e}"`), a ? {
      ...i,
      isValid: a
    } : {
      ...wo(t, r),
      isValid: !1
    };
  } else
    return {
      ...wo(t, r),
      isValid: !1
    };
}, Mg = (e, t, r, n) => $e(() => $g(e, t, r, n)), Lg = (e, t) => {
  const r = Object.fromEntries(e.getLeafHeaders().map((o) => [o.id, o.getSize()])), n = oe(r);
  Object.entries(r).forEach(([o, i]) => {
    n.current[o] !== i && (t(o, i), n.current = r);
  });
}, Ag = (e) => {
  const t = !(e instanceof Array), r = se(() => e instanceof Array ? {
    data: e,
    count: e.length,
    params: {
      startIndex: 0,
      stopIndex: e.length - 1
    },
    hash: BigInt(Math.floor(Math.random() * 1e8))
  } : e, [e]);
  return [t, r];
}, kg = (e, t, r, n, o, i, a, l, s) => se(() => e !== void 0 || t !== void 0 ? [r.createDisplayColumn({
  id: "select",
  enableResizing: !1,
  size: 36,
  header: ({
    instance: u,
    column: c
  }) => /* @__PURE__ */ p(ia, {
    testId: o("select-all-checkbox"),
    className: q($`h-[36px] w-[36px] pt-[2px] pl-3 border-light border-t`),
    checked: i === a,
    indeterminate: u.getIsSomeRowsSelected(),
    onChange: l !== void 0 ? s : u.getToggleAllRowsSelectedHandler()
  }),
  cell: ({
    row: u,
    column: c
  }) => /* @__PURE__ */ p(ia, {
    testId: o(c.id, u.id, "checkbox"),
    className: "h-[36px] w-[36px] pl-3",
    checked: u.getIsSelected(),
    indeterminate: u.getIsSomeSelected(),
    onChange: u.getToggleSelectedHandler()
  })
}), ...n] : n, [e, t, r, n, o, i, a, l, s]), _g = (e, t) => {
  const r = se(() => Object.fromEntries((e != null ? e : []).map((o) => [o, !0])), [e]), n = se(() => {
    if (t !== void 0)
      return (i) => {
        const a = Object.entries(i(r)).filter(([, l]) => l === !0).map(([l]) => l);
        t(a);
      };
  }, [t, r]);
  return [r, n];
};
function Fg({
  tableId: e,
  className: t,
  columns: r,
  data: n,
  table: o,
  rowId: i,
  tableActions: a,
  selectedRows: l,
  onSelectedRowsChange: s,
  onToggleSelectAllRows: u,
  initialSortingState: c = [],
  initialColumnFiltersState: d = [],
  pinnedColumn: f,
  loadMoreItems: v,
  localStoragePrefix: h = "table-configuration",
  tableResetLabel: m = "Reset table",
  tableColumnVisibilityLabel: g = "Visible columns",
  testId: C,
  rootEl: x,
  ...S
}) {
  const [w, y] = $e(c), [O, P] = $e(d), M = gt((Y, J) => i === void 0 ? J.toString() : i(Y, J), [i]), I = se(() => on(C), [C]), k = x.clientWidth - 2, [R, A] = _g(l, s), [L, B] = Ag(n), W = oe(null), U = 36, X = ac({
    size: B.count,
    parentRef: W,
    estimateSize: gt(() => U, [U]),
    overscan: 1
  });
  lc({
    items: B,
    loadMoreItems: v,
    virtualItems: X.virtualItems,
    columnFilters: O,
    emptyRow: void 0,
    sorting: w
  });
  const D = (l != null ? l : []).length, le = gt(() => {
    if (u === void 0)
      return;
    const Y = D !== B.count;
    u(Y);
  }, [B, u, D]), T = kg(l, s, o, r, I, D, B.count, u, le), [j, z] = Mg(e, T, k, h), _ = () => {
    const Y = wo(T, k);
    localStorage.removeItem([h, e].join("-")), z(Y), te(Y.columnVisibility), y(c), P(d), re.setColumnSizing(Y.columnWidth);
  }, [H, te] = $e(() => j.columnVisibility);
  Ce(() => {
    e !== void 0 && j.isValid && localStorage.setItem([h, e].join("-"), JSON.stringify(j));
  }, [h, e, j]), Ce(() => {
    z((Y) => ({
      ...Y,
      columnVisibility: H
    }));
  }, [H, z]);
  const re = gg(o, {
    data: B.data,
    defaultColumn: {
      size: 150,
      minSize: 30,
      maxSize: 2e3
    },
    state: {
      columnVisibility: H,
      rowSelection: R,
      columnPinning: {
        right: f !== void 0 ? [f] : []
      },
      columnFilters: O,
      sorting: w
    },
    initialState: {
      columnSizing: j.columnWidth
    },
    onColumnVisibilityChange: te,
    onRowSelectionChange: A,
    getCoreRowModel: ag(),
    onColumnFiltersChange: P,
    onSortingChange: y,
    getColumnFilteredRowModel: L ? void 0 : ug(),
    getSortedRowModel: L ? void 0 : cg(),
    getRowId: M,
    columns: T,
    columnResizeMode: "onChange"
  }), ue = re.getRowModel().rows, ce = re.getTotalSize() < k;
  return Lg(re, (Y, J) => {
    j.isValid && z((ye) => ({
      ...ye,
      columnWidth: {
        ...ye.columnWidth,
        [Y]: J
      }
    }));
  }), /* @__PURE__ */ G(It, {
    children: [/* @__PURE__ */ p("div", {
      className: "flex",
      children: /* @__PURE__ */ G(fn, {
        className: "ml-auto",
        menuPosition: "right",
        buttonProps: {
          icon: Mp,
          variant: "text",
          color: "gray"
        },
        testId: I("burger-menu"),
        children: [/* @__PURE__ */ p(fn.Section, {
          children: /* @__PURE__ */ p(fn.Item, {
            label: m,
            icon: Dp,
            onClick: _,
            testId: I("reset-table-button")
          })
        }), /* @__PURE__ */ p(fn.Section, {
          heading: g,
          children: re.getAllLeafColumns().filter((Y) => Y.getCanHide()).filter((Y) => Y.id !== "select").map((Y) => /* @__PURE__ */ p(fn.Checkbox, {
            label: typeof Y.header == "function" ? Y.header({
              instance: re,
              column: Y,
              header: {}
            }) : Y.header,
            checked: Y.getIsVisible(),
            setChecked: Y.toggleVisibility,
            testId: I("visibility-toggle", Y.id)
          }, Y.id))
        })]
      })
    }), /* @__PURE__ */ p("div", {
      ref: W,
      role: "table",
      className: "flex-1 relative overflow-auto overflow-y-scroll w-full flex flex-col border border-light",
      children: /* @__PURE__ */ G("div", {
        style: {
          height: `${X.totalSize}px`,
          width: `${re.getTotalSize()}px`
        },
        className: q("relative border-light box-content", ee(ce)("border-r")),
        children: [/* @__PURE__ */ p("div", {
          role: "rowgroup",
          className: "bg-white sticky top-0 z-10",
          children: re.getHeaderGroups().map((Y) => /* @__PURE__ */ p("div", {
            role: "row",
            className: "box-border m-0 whitespace-nowrap w-fit flex border-light border-b",
            children: Y.headers.map((J, ye) => /* @__PURE__ */ p("div", {
              role: "columnheader",
              style: {
                width: J.getSize()
              },
              className: q($`relative p-0`, ee(J.column.id === "select")($`mt-auto`), ee(J.column.getIsPinned() === "right")($`sticky right-0 border-l border-light bg-white`)),
              "data-testid": I(J.column.id, "column-header"),
              children: J.isPlaceholder ? null : /* @__PURE__ */ G(It, {
                children: [/* @__PURE__ */ G("span", {
                  className: q($`flex items-center font-normal bg-white box-border h-12 w-full`, ee(J.column.id !== "select")($`p-3`), ee(J.column.getCanSort())($`cursor-pointer select-none`)),
                  onClick: J.column.getToggleSortingHandler(),
                  "data-testid": I(J.column.id, "sort-toggle"),
                  children: [/* @__PURE__ */ p("span", {
                    children: J.renderHeader()
                  }, "header"), J.column.getCanSort() && /* @__PURE__ */ p(ze, {
                    className: "ml-2 h-4",
                    icon: J.column.getIsSorted() === !1 ? Bp : J.column.getIsSorted() === "desc" ? zp : Hp,
                    testId: I(J.column.id, "sort-indicator")
                  }, "sort-icon")]
                }, "sort"), Y.headers.find((Q) => Q.column.getCanColumnFilter()) !== void 0 && J.column.id !== "select" && /* @__PURE__ */ p("div", {
                  className: "bg-white font-normal text-left box-border items-center p-2 h-12 w-full border-light border-t",
                  children: J.column.getCanColumnFilter() && /* @__PURE__ */ p(Ng, {
                    column: J.column,
                    testId: I(J.column.id, "filter-input")
                  }, "filter")
                }), J.column.id !== "select" && J.column.getCanResize() && /* @__PURE__ */ p("span", {
                  onMouseDown: J.getResizeHandler(),
                  onTouchStart: J.getResizeHandler(),
                  className: q($`opacity-0 hover:opacity-100 transition-all`, $`absolute top-0 z-10 h-full w-3 cursor-col-resize select-none touch-none`, ee(Y.headers.length !== ye + 1)($`-right-[5px]`), ee(Y.headers.length === ye + 1)($`right-0`), J.column.getIsResizing() ? $`bg-primary opacity-100` : $`bg-light`),
                  role: "separator",
                  "data-testid": I(J.column.id, "resize-handle")
                }, "select")]
              })
            }, J.id))
          }, Y.id))
        }), /* @__PURE__ */ p("div", {
          role: "rowgroup",
          className: "relative overflow-visible divide-y w-full flex-1",
          style: {
            height: `${L ? X.totalSize : ue.length * U}px`
          },
          children: X.virtualItems.map((Y) => {
            const J = ue[Y.index - B.params.startIndex];
            return J === void 0 ? null : /* @__PURE__ */ p("div", {
              role: "row",
              className: q("group flex flex-row items-center box-border m-0 whitespace-nowrap border-light w-fit last:border-b-0", "absolute top-0 left-0 h-12"),
              style: {
                transform: `translateY(${Y.start}px)`
              },
              "data-testid": I("row", J.id),
              children: J.getVisibleCells().map((ye) => /* @__PURE__ */ p("div", {
                role: "gridcell",
                style: {
                  width: ye.column.getSize()
                },
                className: q($`p-0 font-normal text-left box-border relative inline-flex items-center h-full overflow-clip whitespace-normal w-full bg-white group-hover:bg-slate-100`, ee(ye.column.id !== "select")($`px-3`), $`max-h-12`, ee(ye.column.getIsPinned() === "right")($`sticky right-0 border-l border-light`)),
                "data-testid": I("row", J.id, "column", ye.column.id),
                children: /* @__PURE__ */ p("span", {
                  className: q($`whitespace-nowrap text-ellipsis inline-block w-full overflow-hidden`),
                  children: ye.renderCell()
                })
              }, ye.id))
            }, J.id);
          })
        })]
      })
    }), a && /* @__PURE__ */ p("div", {
      className: "bg-slate-100 p-4 flex flex-row-reverse border-light border-l border-r border-b",
      children: a
    })]
  });
}
function Ng({
  column: e,
  testId: t
}) {
  var r;
  return /* @__PURE__ */ p(Pu, {
    className: "w-full",
    inputClassName: "bg-neutral-50",
    onChange: (n) => e.setColumnFilterValue(n.currentTarget.value),
    value: (r = e.getColumnFilterValue()) != null ? r : "",
    testId: t
  });
}
function W4({
  testId: e,
  className: t,
  ...r
}) {
  const n = se(() => on(e), [e]), [o, i] = $e(null);
  return /* @__PURE__ */ p("div", {
    className: q("flex flex-col translate-y-0", t),
    "data-testid": n("table-container"),
    ref: i,
    children: o !== null && /* @__PURE__ */ p(Fg, {
      rootEl: o,
      testId: e,
      ...r
    })
  });
}
const Z4 = ({
  tabs: e,
  selectedTab: t,
  onTabChange: r,
  matchParentWidth: n,
  className: o,
  testId: i,
  ...a
}) => {
  const l = e.findIndex((c) => c.id === t), s = (c) => {
    r(e[c].id);
  }, u = on(i);
  return /* @__PURE__ */ p("div", {
    className: q("flex flex-row", o),
    ...a,
    children: /* @__PURE__ */ G(na.Group, {
      selectedIndex: l,
      onChange: s,
      children: [/* @__PURE__ */ p(na.List, {
        children: /* @__PURE__ */ p("div", {
          className: q("flex flex-row"),
          children: e.map((c) => /* @__PURE__ */ p(Dg, {
            color: c.color,
            label: c.label,
            testId: u(`tab-${c.id}`)
          }, c.id))
        })
      }), n && /* @__PURE__ */ p("div", {
        className: "border-b-3 border-light w-full"
      })]
    })
  });
}, Vg = (e) => Mr(e).with("elements", () => $`border-elements text-elements`).with("components", () => $`border-components text-components`).with("resources", () => $`border-resources text-resources`).exhaustive(), Dg = ({
  color: e,
  label: t,
  testId: r
}) => /* @__PURE__ */ p(na, {
  as: Ge,
  children: ({
    selected: n
  }) => /* @__PURE__ */ p("button", {
    className: q("outline-none", "px-7 pt-2 pb-[calc(0.5rem-1px)]", "text-xl", "cursor-pointer", "w-max", "hover:opacity-75 focus-visible:ring-4", "active:opacity-50", "border-b-3", ee(n)($`font-bold shrink-0`), ee(n)(Vg(e)), ee(!n)("border-light text-dark")),
    type: "button",
    "data-testid": r,
    children: t
  })
}), q4 = ({
  text: e,
  className: t,
  testId: r,
  ...n
}) => /* @__PURE__ */ p("div", {
  className: t,
  "data-testid": r,
  ...n,
  children: e
}), Y4 = ({
  selected: e,
  horizontal: t,
  label: r,
  items: n,
  onValueChange: o
}) => {
  const [i, a] = $e(null);
  return /* @__PURE__ */ G(_i, {
    value: e,
    onChange: o,
    children: [r && /* @__PURE__ */ p(_i.Label, {
      children: r
    }), n.map((l) => {
      const s = () => {
        l.disabled && l.disabledTooltip && a(l.value);
      }, u = () => {
        a(null);
      };
      return /* @__PURE__ */ p(_i.Option, {
        value: l,
        disabled: l.disabled,
        className: $`focus:outline-none`,
        children: ({
          checked: c
        }) => /* @__PURE__ */ p(vr, {
          placement: "bottom-start",
          title: l.disabledTooltip,
          open: i === l.value,
          onOpen: s,
          onClose: u,
          children: /* @__PURE__ */ G("div", {
            className: q($`flex items-center`, t && $`float-left mr-5`, l.disabled && $`cursor-not-allowed text-disabled-dark-grey`),
            onMouseEnter: s,
            onMouseLeave: u,
            children: [/* @__PURE__ */ p("div", {
              className: $`float-left`,
              children: /* @__PURE__ */ p("div", {
                className: $`flex align-center justify-center`,
                children: /* @__PURE__ */ p("div", {
                  className: q($`rounded-full w-5 h-5 flex justify-center self-center mt-3 mb-3`, !c && $`bg-light`, c && l.disabled && $`bg-light`, c && !l.disabled && $`bg-primary`),
                  children: /* @__PURE__ */ p("div", {
                    className: $`flex content-center justify-center`,
                    children: /* @__PURE__ */ p("div", {
                      className: q($`w-2 h-2 rounded-full justify-center self-center`, c && !l.disabled && $`bg-white`, c && l.disabled && $`bg-disabled-dark-grey`)
                    })
                  })
                })
              })
            }), /* @__PURE__ */ p("div", {
              className: q($`float-left pl-2`, l.disabled && $`text-gray`),
              children: l.label || l.value
            })]
          })
        })
      }, l.value);
    }), t && /* @__PURE__ */ p("div", {
      className: $`clear-left`
    })]
  });
};
function Ze(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function ae() {
  return ae = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ae.apply(this, arguments);
}
var b = { exports: {} }, Hi = { exports: {} }, Me = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var os;
function Hg() {
  if (os)
    return Me;
  os = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function S(y) {
    if (typeof y == "object" && y !== null) {
      var O = y.$$typeof;
      switch (O) {
        case t:
          switch (y = y.type, y) {
            case s:
            case u:
            case n:
            case i:
            case o:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case l:
                case c:
                case h:
                case v:
                case a:
                  return y;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  function w(y) {
    return S(y) === u;
  }
  return Me.AsyncMode = s, Me.ConcurrentMode = u, Me.ContextConsumer = l, Me.ContextProvider = a, Me.Element = t, Me.ForwardRef = c, Me.Fragment = n, Me.Lazy = h, Me.Memo = v, Me.Portal = r, Me.Profiler = i, Me.StrictMode = o, Me.Suspense = d, Me.isAsyncMode = function(y) {
    return w(y) || S(y) === s;
  }, Me.isConcurrentMode = w, Me.isContextConsumer = function(y) {
    return S(y) === l;
  }, Me.isContextProvider = function(y) {
    return S(y) === a;
  }, Me.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, Me.isForwardRef = function(y) {
    return S(y) === c;
  }, Me.isFragment = function(y) {
    return S(y) === n;
  }, Me.isLazy = function(y) {
    return S(y) === h;
  }, Me.isMemo = function(y) {
    return S(y) === v;
  }, Me.isPortal = function(y) {
    return S(y) === r;
  }, Me.isProfiler = function(y) {
    return S(y) === i;
  }, Me.isStrictMode = function(y) {
    return S(y) === o;
  }, Me.isSuspense = function(y) {
    return S(y) === d;
  }, Me.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === u || y === i || y === o || y === d || y === f || typeof y == "object" && y !== null && (y.$$typeof === h || y.$$typeof === v || y.$$typeof === a || y.$$typeof === l || y.$$typeof === c || y.$$typeof === g || y.$$typeof === C || y.$$typeof === x || y.$$typeof === m);
  }, Me.typeOf = S, Me;
}
var Le = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var is;
function zg() {
  return is || (is = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function S(Q) {
      return typeof Q == "string" || typeof Q == "function" || Q === n || Q === u || Q === i || Q === o || Q === d || Q === f || typeof Q == "object" && Q !== null && (Q.$$typeof === h || Q.$$typeof === v || Q.$$typeof === a || Q.$$typeof === l || Q.$$typeof === c || Q.$$typeof === g || Q.$$typeof === C || Q.$$typeof === x || Q.$$typeof === m);
    }
    function w(Q) {
      if (typeof Q == "object" && Q !== null) {
        var Ue = Q.$$typeof;
        switch (Ue) {
          case t:
            var F = Q.type;
            switch (F) {
              case s:
              case u:
              case n:
              case i:
              case o:
              case d:
                return F;
              default:
                var Ke = F && F.$$typeof;
                switch (Ke) {
                  case l:
                  case c:
                  case h:
                  case v:
                  case a:
                    return Ke;
                  default:
                    return Ue;
                }
            }
          case r:
            return Ue;
        }
      }
    }
    var y = s, O = u, P = l, M = a, I = t, k = c, R = n, A = h, L = v, B = r, W = i, U = o, X = d, D = !1;
    function le(Q) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), T(Q) || w(Q) === s;
    }
    function T(Q) {
      return w(Q) === u;
    }
    function j(Q) {
      return w(Q) === l;
    }
    function z(Q) {
      return w(Q) === a;
    }
    function _(Q) {
      return typeof Q == "object" && Q !== null && Q.$$typeof === t;
    }
    function H(Q) {
      return w(Q) === c;
    }
    function te(Q) {
      return w(Q) === n;
    }
    function re(Q) {
      return w(Q) === h;
    }
    function ue(Q) {
      return w(Q) === v;
    }
    function ce(Q) {
      return w(Q) === r;
    }
    function Y(Q) {
      return w(Q) === i;
    }
    function J(Q) {
      return w(Q) === o;
    }
    function ye(Q) {
      return w(Q) === d;
    }
    Le.AsyncMode = y, Le.ConcurrentMode = O, Le.ContextConsumer = P, Le.ContextProvider = M, Le.Element = I, Le.ForwardRef = k, Le.Fragment = R, Le.Lazy = A, Le.Memo = L, Le.Portal = B, Le.Profiler = W, Le.StrictMode = U, Le.Suspense = X, Le.isAsyncMode = le, Le.isConcurrentMode = T, Le.isContextConsumer = j, Le.isContextProvider = z, Le.isElement = _, Le.isForwardRef = H, Le.isFragment = te, Le.isLazy = re, Le.isMemo = ue, Le.isPortal = ce, Le.isProfiler = Y, Le.isStrictMode = J, Le.isSuspense = ye, Le.isValidElementType = S, Le.typeOf = w;
  }()), Le;
}
var as;
function sc() {
  return as || (as = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = Hg() : e.exports = zg();
  }(Hi)), Hi.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var zi, ls;
function Bg() {
  if (ls)
    return zi;
  ls = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, l = 0; l < 10; l++)
        a["_" + String.fromCharCode(l)] = l;
      var s = Object.getOwnPropertyNames(a).map(function(c) {
        return a[c];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return zi = o() ? Object.assign : function(i, a) {
    for (var l, s = n(i), u, c = 1; c < arguments.length; c++) {
      l = Object(arguments[c]);
      for (var d in l)
        t.call(l, d) && (s[d] = l[d]);
      if (e) {
        u = e(l);
        for (var f = 0; f < u.length; f++)
          r.call(l, u[f]) && (s[u[f]] = l[u[f]]);
      }
    }
    return s;
  }, zi;
}
var Bi, ss;
function ul() {
  if (ss)
    return Bi;
  ss = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Bi = e, Bi;
}
var ji, us;
function uc() {
  return us || (us = 1, ji = Function.call.bind(Object.prototype.hasOwnProperty)), ji;
}
var Gi, cs;
function jg() {
  if (cs)
    return Gi;
  cs = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = ul(), r = {}, n = uc();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, l, s, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in i)
        if (n(i, c)) {
          var d;
          try {
            if (typeof i[c] != "function") {
              var f = Error(
                (s || "React class") + ": " + l + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[c](a, c, s, l, null, t);
          } catch (h) {
            d = h;
          }
          if (d && !(d instanceof Error) && e(
            (s || "React class") + ": type specification of " + l + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in r)) {
            r[d.message] = !0;
            var v = u ? u() : "";
            e(
              "Failed " + l + " type: " + d.message + (v != null ? v : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Gi = o, Gi;
}
var Ui, ds;
function Gg() {
  if (ds)
    return Ui;
  ds = 1;
  var e = sc(), t = Bg(), r = ul(), n = uc(), o = jg(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var s = "Warning: " + l;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Ui = function(l, s) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(T) {
      var j = T && (u && T[u] || T[c]);
      if (typeof j == "function")
        return j;
    }
    var f = "<<anonymous>>", v = {
      array: C("array"),
      bigint: C("bigint"),
      bool: C("boolean"),
      func: C("function"),
      number: C("number"),
      object: C("object"),
      string: C("string"),
      symbol: C("symbol"),
      any: x(),
      arrayOf: S,
      element: w(),
      elementType: y(),
      instanceOf: O,
      node: k(),
      objectOf: M,
      oneOf: P,
      oneOfType: I,
      shape: A,
      exact: L
    };
    function h(T, j) {
      return T === j ? T !== 0 || 1 / T === 1 / j : T !== T && j !== j;
    }
    function m(T, j) {
      this.message = T, this.data = j && typeof j == "object" ? j : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function g(T) {
      if (process.env.NODE_ENV !== "production")
        var j = {}, z = 0;
      function _(te, re, ue, ce, Y, J, ye) {
        if (ce = ce || f, J = J || ue, ye !== r) {
          if (s) {
            var Q = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Q.name = "Invariant Violation", Q;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ue = ce + ":" + ue;
            !j[Ue] && z < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + J + "` prop on `" + ce + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), j[Ue] = !0, z++);
          }
        }
        return re[ue] == null ? te ? re[ue] === null ? new m("The " + Y + " `" + J + "` is marked as required " + ("in `" + ce + "`, but its value is `null`.")) : new m("The " + Y + " `" + J + "` is marked as required in " + ("`" + ce + "`, but its value is `undefined`.")) : null : T(re, ue, ce, Y, J);
      }
      var H = _.bind(null, !1);
      return H.isRequired = _.bind(null, !0), H;
    }
    function C(T) {
      function j(z, _, H, te, re, ue) {
        var ce = z[_], Y = U(ce);
        if (Y !== T) {
          var J = X(ce);
          return new m(
            "Invalid " + te + " `" + re + "` of type " + ("`" + J + "` supplied to `" + H + "`, expected ") + ("`" + T + "`."),
            { expectedType: T }
          );
        }
        return null;
      }
      return g(j);
    }
    function x() {
      return g(a);
    }
    function S(T) {
      function j(z, _, H, te, re) {
        if (typeof T != "function")
          return new m("Property `" + re + "` of component `" + H + "` has invalid PropType notation inside arrayOf.");
        var ue = z[_];
        if (!Array.isArray(ue)) {
          var ce = U(ue);
          return new m("Invalid " + te + " `" + re + "` of type " + ("`" + ce + "` supplied to `" + H + "`, expected an array."));
        }
        for (var Y = 0; Y < ue.length; Y++) {
          var J = T(ue, Y, H, te, re + "[" + Y + "]", r);
          if (J instanceof Error)
            return J;
        }
        return null;
      }
      return g(j);
    }
    function w() {
      function T(j, z, _, H, te) {
        var re = j[z];
        if (!l(re)) {
          var ue = U(re);
          return new m("Invalid " + H + " `" + te + "` of type " + ("`" + ue + "` supplied to `" + _ + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(T);
    }
    function y() {
      function T(j, z, _, H, te) {
        var re = j[z];
        if (!e.isValidElementType(re)) {
          var ue = U(re);
          return new m("Invalid " + H + " `" + te + "` of type " + ("`" + ue + "` supplied to `" + _ + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(T);
    }
    function O(T) {
      function j(z, _, H, te, re) {
        if (!(z[_] instanceof T)) {
          var ue = T.name || f, ce = le(z[_]);
          return new m("Invalid " + te + " `" + re + "` of type " + ("`" + ce + "` supplied to `" + H + "`, expected ") + ("instance of `" + ue + "`."));
        }
        return null;
      }
      return g(j);
    }
    function P(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function j(z, _, H, te, re) {
        for (var ue = z[_], ce = 0; ce < T.length; ce++)
          if (h(ue, T[ce]))
            return null;
        var Y = JSON.stringify(T, function(ye, Q) {
          var Ue = X(Q);
          return Ue === "symbol" ? String(Q) : Q;
        });
        return new m("Invalid " + te + " `" + re + "` of value `" + String(ue) + "` " + ("supplied to `" + H + "`, expected one of " + Y + "."));
      }
      return g(j);
    }
    function M(T) {
      function j(z, _, H, te, re) {
        if (typeof T != "function")
          return new m("Property `" + re + "` of component `" + H + "` has invalid PropType notation inside objectOf.");
        var ue = z[_], ce = U(ue);
        if (ce !== "object")
          return new m("Invalid " + te + " `" + re + "` of type " + ("`" + ce + "` supplied to `" + H + "`, expected an object."));
        for (var Y in ue)
          if (n(ue, Y)) {
            var J = T(ue, Y, H, te, re + "." + Y, r);
            if (J instanceof Error)
              return J;
          }
        return null;
      }
      return g(j);
    }
    function I(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var j = 0; j < T.length; j++) {
        var z = T[j];
        if (typeof z != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + D(z) + " at index " + j + "."
          ), a;
      }
      function _(H, te, re, ue, ce) {
        for (var Y = [], J = 0; J < T.length; J++) {
          var ye = T[J], Q = ye(H, te, re, ue, ce, r);
          if (Q == null)
            return null;
          Q.data && n(Q.data, "expectedType") && Y.push(Q.data.expectedType);
        }
        var Ue = Y.length > 0 ? ", expected one of type [" + Y.join(", ") + "]" : "";
        return new m("Invalid " + ue + " `" + ce + "` supplied to " + ("`" + re + "`" + Ue + "."));
      }
      return g(_);
    }
    function k() {
      function T(j, z, _, H, te) {
        return B(j[z]) ? null : new m("Invalid " + H + " `" + te + "` supplied to " + ("`" + _ + "`, expected a ReactNode."));
      }
      return g(T);
    }
    function R(T, j, z, _, H) {
      return new m(
        (T || "React class") + ": " + j + " type `" + z + "." + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + H + "`."
      );
    }
    function A(T) {
      function j(z, _, H, te, re) {
        var ue = z[_], ce = U(ue);
        if (ce !== "object")
          return new m("Invalid " + te + " `" + re + "` of type `" + ce + "` " + ("supplied to `" + H + "`, expected `object`."));
        for (var Y in T) {
          var J = T[Y];
          if (typeof J != "function")
            return R(H, te, re, Y, X(J));
          var ye = J(ue, Y, H, te, re + "." + Y, r);
          if (ye)
            return ye;
        }
        return null;
      }
      return g(j);
    }
    function L(T) {
      function j(z, _, H, te, re) {
        var ue = z[_], ce = U(ue);
        if (ce !== "object")
          return new m("Invalid " + te + " `" + re + "` of type `" + ce + "` " + ("supplied to `" + H + "`, expected `object`."));
        var Y = t({}, z[_], T);
        for (var J in Y) {
          var ye = T[J];
          if (n(T, J) && typeof ye != "function")
            return R(H, te, re, J, X(ye));
          if (!ye)
            return new m(
              "Invalid " + te + " `" + re + "` key `" + J + "` supplied to `" + H + "`.\nBad object: " + JSON.stringify(z[_], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(T), null, "  ")
            );
          var Q = ye(ue, J, H, te, re + "." + J, r);
          if (Q)
            return Q;
        }
        return null;
      }
      return g(j);
    }
    function B(T) {
      switch (typeof T) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !T;
        case "object":
          if (Array.isArray(T))
            return T.every(B);
          if (T === null || l(T))
            return !0;
          var j = d(T);
          if (j) {
            var z = j.call(T), _;
            if (j !== T.entries) {
              for (; !(_ = z.next()).done; )
                if (!B(_.value))
                  return !1;
            } else
              for (; !(_ = z.next()).done; ) {
                var H = _.value;
                if (H && !B(H[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function W(T, j) {
      return T === "symbol" ? !0 : j ? j["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && j instanceof Symbol : !1;
    }
    function U(T) {
      var j = typeof T;
      return Array.isArray(T) ? "array" : T instanceof RegExp ? "object" : W(j, T) ? "symbol" : j;
    }
    function X(T) {
      if (typeof T > "u" || T === null)
        return "" + T;
      var j = U(T);
      if (j === "object") {
        if (T instanceof Date)
          return "date";
        if (T instanceof RegExp)
          return "regexp";
      }
      return j;
    }
    function D(T) {
      var j = X(T);
      switch (j) {
        case "array":
        case "object":
          return "an " + j;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + j;
        default:
          return j;
      }
    }
    function le(T) {
      return !T.constructor || !T.constructor.name ? f : T.constructor.name;
    }
    return v.checkPropTypes = o, v.resetWarningCache = o.resetWarningCache, v.PropTypes = v, v;
  }, Ui;
}
var Wi, fs;
function Ug() {
  if (fs)
    return Wi;
  fs = 1;
  var e = ul();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Wi = function() {
    function n(a, l, s, u, c, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Wi;
}
if (process.env.NODE_ENV !== "production") {
  var Wg = sc(), Zg = !0;
  b.exports = Gg()(Wg.isElement, Zg);
} else
  b.exports = Ug()();
function qg(e) {
  return typeof e == "string";
}
function Yg(e, t, r) {
  return e === void 0 || qg(e) ? t : ae({}, t, {
    ownerState: ae({}, t.ownerState, r)
  });
}
const Kg = {
  disableDefaultClasses: !1
}, Xg = /* @__PURE__ */ N.createContext(Kg);
function Jg(e) {
  const {
    disableDefaultClasses: t
  } = N.useContext(Xg);
  return (r) => t ? "" : e(r);
}
function Qg(e, t = []) {
  if (e === void 0)
    return {};
  const r = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !t.includes(n)).forEach((n) => {
    r[n] = e[n];
  }), r;
}
function ev(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function so(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return e(...n) || t(...n);
  };
}
function nr(e) {
  return e !== null && typeof e == "object" && e.constructor === Object;
}
function cc(e) {
  if (!nr(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((r) => {
    t[r] = cc(e[r]);
  }), t;
}
function tn(e, t, r = {
  clone: !0
}) {
  const n = r.clone ? ae({}, e) : e;
  return nr(e) && nr(t) && Object.keys(t).forEach((o) => {
    o !== "__proto__" && (nr(t[o]) && o in e && nr(e[o]) ? n[o] = tn(e[o], t[o], r) : r.clone ? n[o] = nr(t[o]) ? cc(t[o]) : t[o] : n[o] = t[o]);
  }), n;
}
function tv(e) {
  const {
    prototype: t = {}
  } = e;
  return Boolean(t.isReactComponent);
}
function dc(e, t, r, n, o) {
  const i = e[t], a = o || t;
  if (i == null || typeof window > "u")
    return null;
  let l;
  const s = i.type;
  return typeof s == "function" && !tv(s) && (l = "Did you accidentally use a plain function component for an element instead?"), l !== void 0 ? new Error(`Invalid ${n} \`${a}\` supplied to \`${r}\`. Expected an element that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const fc = so(b.exports.element, dc);
fc.isRequired = so(b.exports.element.isRequired, dc);
const pc = fc;
function nv(e) {
  const {
    prototype: t = {}
  } = e;
  return Boolean(t.isReactComponent);
}
function rv(e, t, r, n, o) {
  const i = e[t], a = o || t;
  if (i == null || typeof window > "u")
    return null;
  let l;
  return typeof i == "function" && !nv(i) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${n} \`${a}\` supplied to \`${r}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const ov = so(b.exports.elementType, rv), iv = "exact-prop: \u200B";
function gc(e) {
  return process.env.NODE_ENV === "production" ? e : ae({}, e, {
    [iv]: (t) => {
      const r = Object.keys(t).filter((n) => !e.hasOwnProperty(n));
      return r.length > 0 ? new Error(`The following props are not supported: ${r.map((n) => `\`${n}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function cr(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let r = 1; r < arguments.length; r += 1)
    t += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
var da = { exports: {} }, Ae = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ps;
function av() {
  if (ps)
    return Ae;
  ps = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), h;
  h = Symbol.for("react.module.reference");
  function m(g) {
    if (typeof g == "object" && g !== null) {
      var C = g.$$typeof;
      switch (C) {
        case e:
          switch (g = g.type, g) {
            case r:
            case o:
            case n:
            case u:
            case c:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case l:
                case a:
                case s:
                case f:
                case d:
                case i:
                  return g;
                default:
                  return C;
              }
          }
        case t:
          return C;
      }
    }
  }
  return Ae.ContextConsumer = a, Ae.ContextProvider = i, Ae.Element = e, Ae.ForwardRef = s, Ae.Fragment = r, Ae.Lazy = f, Ae.Memo = d, Ae.Portal = t, Ae.Profiler = o, Ae.StrictMode = n, Ae.Suspense = u, Ae.SuspenseList = c, Ae.isAsyncMode = function() {
    return !1;
  }, Ae.isConcurrentMode = function() {
    return !1;
  }, Ae.isContextConsumer = function(g) {
    return m(g) === a;
  }, Ae.isContextProvider = function(g) {
    return m(g) === i;
  }, Ae.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, Ae.isForwardRef = function(g) {
    return m(g) === s;
  }, Ae.isFragment = function(g) {
    return m(g) === r;
  }, Ae.isLazy = function(g) {
    return m(g) === f;
  }, Ae.isMemo = function(g) {
    return m(g) === d;
  }, Ae.isPortal = function(g) {
    return m(g) === t;
  }, Ae.isProfiler = function(g) {
    return m(g) === o;
  }, Ae.isStrictMode = function(g) {
    return m(g) === n;
  }, Ae.isSuspense = function(g) {
    return m(g) === u;
  }, Ae.isSuspenseList = function(g) {
    return m(g) === c;
  }, Ae.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === r || g === o || g === n || g === u || g === c || g === v || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === d || g.$$typeof === i || g.$$typeof === a || g.$$typeof === s || g.$$typeof === h || g.getModuleId !== void 0);
  }, Ae.typeOf = m, Ae;
}
var ke = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gs;
function lv() {
  return gs || (gs = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), h = !1, m = !1, g = !1, C = !1, x = !1, S;
    S = Symbol.for("react.module.reference");
    function w(F) {
      return !!(typeof F == "string" || typeof F == "function" || F === r || F === o || x || F === n || F === u || F === c || C || F === v || h || m || g || typeof F == "object" && F !== null && (F.$$typeof === f || F.$$typeof === d || F.$$typeof === i || F.$$typeof === a || F.$$typeof === s || F.$$typeof === S || F.getModuleId !== void 0));
    }
    function y(F) {
      if (typeof F == "object" && F !== null) {
        var Ke = F.$$typeof;
        switch (Ke) {
          case e:
            var qe = F.type;
            switch (qe) {
              case r:
              case o:
              case n:
              case u:
              case c:
                return qe;
              default:
                var ut = qe && qe.$$typeof;
                switch (ut) {
                  case l:
                  case a:
                  case s:
                  case f:
                  case d:
                  case i:
                    return ut;
                  default:
                    return Ke;
                }
            }
          case t:
            return Ke;
        }
      }
    }
    var O = a, P = i, M = e, I = s, k = r, R = f, A = d, L = t, B = o, W = n, U = u, X = c, D = !1, le = !1;
    function T(F) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(F) {
      return le || (le = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function z(F) {
      return y(F) === a;
    }
    function _(F) {
      return y(F) === i;
    }
    function H(F) {
      return typeof F == "object" && F !== null && F.$$typeof === e;
    }
    function te(F) {
      return y(F) === s;
    }
    function re(F) {
      return y(F) === r;
    }
    function ue(F) {
      return y(F) === f;
    }
    function ce(F) {
      return y(F) === d;
    }
    function Y(F) {
      return y(F) === t;
    }
    function J(F) {
      return y(F) === o;
    }
    function ye(F) {
      return y(F) === n;
    }
    function Q(F) {
      return y(F) === u;
    }
    function Ue(F) {
      return y(F) === c;
    }
    ke.ContextConsumer = O, ke.ContextProvider = P, ke.Element = M, ke.ForwardRef = I, ke.Fragment = k, ke.Lazy = R, ke.Memo = A, ke.Portal = L, ke.Profiler = B, ke.StrictMode = W, ke.Suspense = U, ke.SuspenseList = X, ke.isAsyncMode = T, ke.isConcurrentMode = j, ke.isContextConsumer = z, ke.isContextProvider = _, ke.isElement = H, ke.isForwardRef = te, ke.isFragment = re, ke.isLazy = ue, ke.isMemo = ce, ke.isPortal = Y, ke.isProfiler = J, ke.isStrictMode = ye, ke.isSuspense = Q, ke.isSuspenseList = Ue, ke.isValidElementType = w, ke.typeOf = y;
  }()), ke;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = av() : e.exports = lv();
})(da);
const sv = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function uv(e) {
  const t = `${e}`.match(sv);
  return t && t[1] || "";
}
function vc(e, t = "") {
  return e.displayName || e.name || uv(e) || t;
}
function vs(e, t, r) {
  const n = vc(t);
  return e.displayName || (n !== "" ? `${r}(${n})` : r);
}
function cv(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return vc(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case da.exports.ForwardRef:
          return vs(e, e.render, "ForwardRef");
        case da.exports.Memo:
          return vs(e, e.type, "memo");
        default:
          return;
      }
  }
}
function Ur(e, t, r, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], a = o || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${n} \`${a}\` supplied to \`${r}\`. Expected an HTMLElement.`) : null;
}
const dv = b.exports.oneOfType([b.exports.func, b.exports.object]), cl = dv;
function at(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : cr(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Nn(e) {
  return e && e.ownerDocument || document;
}
function fa(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const fv = typeof window < "u" ? N.useLayoutEffect : N.useEffect, Bn = fv;
function Lr(e) {
  const t = N.useRef(e);
  return Bn(() => {
    t.current = e;
  }), N.useCallback((...r) => (0, t.current)(...r), []);
}
function Wt(...e) {
  return N.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((r) => {
      fa(r, t);
    });
  }, e);
}
let ui = !0, pa = !1, ms;
const pv = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function gv(e) {
  const {
    type: t,
    tagName: r
  } = e;
  return !!(r === "INPUT" && pv[t] && !e.readOnly || r === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function vv(e) {
  e.metaKey || e.altKey || e.ctrlKey || (ui = !0);
}
function Zi() {
  ui = !1;
}
function mv() {
  this.visibilityState === "hidden" && pa && (ui = !0);
}
function hv(e) {
  e.addEventListener("keydown", vv, !0), e.addEventListener("mousedown", Zi, !0), e.addEventListener("pointerdown", Zi, !0), e.addEventListener("touchstart", Zi, !0), e.addEventListener("visibilitychange", mv, !0);
}
function bv(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return ui || gv(t);
}
function yv() {
  const e = N.useCallback((o) => {
    o != null && hv(o.ownerDocument);
  }, []), t = N.useRef(!1);
  function r() {
    return t.current ? (pa = !0, window.clearTimeout(ms), ms = window.setTimeout(() => {
      pa = !1;
    }, 100), t.current = !1, !0) : !1;
  }
  function n(o) {
    return bv(o) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: n,
    onBlur: r,
    ref: e
  };
}
function Cv(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
function xv(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function wv(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const Sv = Number.isInteger || wv;
function mc(e, t, r, n) {
  const o = e[t];
  if (o == null || !Sv(o)) {
    const i = xv(o);
    return new RangeError(`Invalid ${n} \`${t}\` of type \`${i}\` supplied to \`${r}\`, expected \`integer\`.`);
  }
  return null;
}
function hc(e, t, ...r) {
  return e[t] === void 0 ? null : mc(e, t, ...r);
}
function ga() {
  return null;
}
hc.isRequired = mc;
ga.isRequired = ga;
const Rv = process.env.NODE_ENV === "production" ? ga : hc;
function bc(e, t) {
  const r = ae({}, t);
  return Object.keys(e).forEach((n) => {
    if (n.toString().match(/^(components|slots)$/))
      r[n] = ae({}, e[n], r[n]);
    else if (n.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = e[n] || {}, i = t[n];
      r[n] = {}, !i || !Object.keys(i) ? r[n] = o : !o || !Object.keys(o) ? r[n] = i : (r[n] = ae({}, i), Object.keys(o).forEach((a) => {
        r[n][a] = bc(o[a], i[a]);
      }));
    } else
      r[n] === void 0 && (r[n] = e[n]);
  }), r;
}
function yr(e, t, r = void 0) {
  const n = {};
  return Object.keys(e).forEach(
    (o) => {
      n[o] = e[o].reduce((i, a) => {
        if (a) {
          const l = t(a);
          l !== "" && i.push(l), r && r[a] && i.push(r[a]);
        }
        return i;
      }, []).join(" ");
    }
  ), n;
}
const hs = (e) => e, Ev = () => {
  let e = hs;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = hs;
    }
  };
}, Ov = Ev(), Pv = Ov, Iv = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  readOnly: "readOnly",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  required: "required",
  selected: "selected"
};
function Rn(e, t, r = "Mui") {
  const n = Iv[t];
  return n ? `${r}-${n}` : `${Pv.generate(e)}-${t}`;
}
function Kt(e, t, r = "Mui") {
  const n = {};
  return t.forEach((o) => {
    n[o] = Rn(e, o, r);
  }), n;
}
function bs(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((r) => !(r.match(/^on[A-Z]/) && typeof e[r] == "function")).forEach((r) => {
    t[r] = e[r];
  }), t;
}
function Tv(e) {
  const {
    getSlotProps: t,
    additionalProps: r,
    externalSlotProps: n,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const v = q(o == null ? void 0 : o.className, n == null ? void 0 : n.className, i, r == null ? void 0 : r.className), h = ae({}, r == null ? void 0 : r.style, o == null ? void 0 : o.style, n == null ? void 0 : n.style), m = ae({}, r, o, n);
    return v.length > 0 && (m.className = v), Object.keys(h).length > 0 && (m.style = h), {
      props: m,
      internalRef: void 0
    };
  }
  const a = Qg(ae({}, o, n)), l = bs(n), s = bs(o), u = t(a), c = q(u == null ? void 0 : u.className, r == null ? void 0 : r.className, i, o == null ? void 0 : o.className, n == null ? void 0 : n.className), d = ae({}, u == null ? void 0 : u.style, r == null ? void 0 : r.style, o == null ? void 0 : o.style, n == null ? void 0 : n.style), f = ae({}, u, r, s, l);
  return c.length > 0 && (f.className = c), Object.keys(d).length > 0 && (f.style = d), {
    props: f,
    internalRef: u.ref
  };
}
const $v = ["elementType", "externalSlotProps", "ownerState"];
function Mv(e) {
  var t;
  const {
    elementType: r,
    externalSlotProps: n,
    ownerState: o
  } = e, i = Ze(e, $v), a = ev(n, o), {
    props: l,
    internalRef: s
  } = Tv(ae({}, i, {
    externalSlotProps: a
  })), u = Wt(s, a == null ? void 0 : a.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return Yg(r, ae({}, l, {
    ref: u
  }), o);
}
function ys(e) {
  return e.substring(2).toLowerCase();
}
function Lv(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function No(e) {
  const {
    children: t,
    disableReactTree: r = !1,
    mouseEvent: n = "onClick",
    onClickAway: o,
    touchEvent: i = "onTouchEnd"
  } = e, a = N.useRef(!1), l = N.useRef(null), s = N.useRef(!1), u = N.useRef(!1);
  N.useEffect(() => (setTimeout(() => {
    s.current = !0;
  }, 0), () => {
    s.current = !1;
  }), []);
  const c = Wt(
    t.ref,
    l
  ), d = Lr((h) => {
    const m = u.current;
    u.current = !1;
    const g = Nn(l.current);
    if (!s.current || !l.current || "clientX" in h && Lv(h, g))
      return;
    if (a.current) {
      a.current = !1;
      return;
    }
    let C;
    h.composedPath ? C = h.composedPath().indexOf(l.current) > -1 : C = !g.documentElement.contains(
      h.target
    ) || l.current.contains(
      h.target
    ), !C && (r || !m) && o(h);
  }), f = (h) => (m) => {
    u.current = !0;
    const g = t.props[h];
    g && g(m);
  }, v = {
    ref: c
  };
  return i !== !1 && (v[i] = f(i)), N.useEffect(() => {
    if (i !== !1) {
      const h = ys(i), m = Nn(l.current), g = () => {
        a.current = !0;
      };
      return m.addEventListener(h, d), m.addEventListener("touchmove", g), () => {
        m.removeEventListener(h, d), m.removeEventListener("touchmove", g);
      };
    }
  }, [d, i]), n !== !1 && (v[n] = f(n)), N.useEffect(() => {
    if (n !== !1) {
      const h = ys(n), m = Nn(l.current);
      return m.addEventListener(h, d), () => {
        m.removeEventListener(h, d);
      };
    }
  }, [d, n]), /* @__PURE__ */ p(N.Fragment, {
    children: /* @__PURE__ */ N.cloneElement(t, v)
  });
}
process.env.NODE_ENV !== "production" && (No.propTypes = {
  children: pc.isRequired,
  disableReactTree: b.exports.bool,
  mouseEvent: b.exports.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  onClickAway: b.exports.func.isRequired,
  touchEvent: b.exports.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (No["propTypes"] = gc(No.propTypes));
var vt = "top", Mt = "bottom", Lt = "right", mt = "left", ci = "auto", uo = [vt, Mt, Lt, mt], dr = "start", Wr = "end", Av = "clippingParents", yc = "viewport", Or = "popper", kv = "reference", Cs = /* @__PURE__ */ uo.reduce(function(e, t) {
  return e.concat([t + "-" + dr, t + "-" + Wr]);
}, []), Cc = /* @__PURE__ */ [].concat(uo, [ci]).reduce(function(e, t) {
  return e.concat([t, t + "-" + dr, t + "-" + Wr]);
}, []), _v = "beforeRead", Fv = "read", Nv = "afterRead", Vv = "beforeMain", Dv = "main", Hv = "afterMain", zv = "beforeWrite", Bv = "write", jv = "afterWrite", va = [_v, Fv, Nv, Vv, Dv, Hv, zv, Bv, jv];
function Zt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function At(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function jn(e) {
  var t = At(e).Element;
  return e instanceof t || e instanceof Element;
}
function wt(e) {
  var t = At(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function dl(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = At(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Gv(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, o = t.attributes[r] || {}, i = t.elements[r];
    !wt(i) || !Zt(i) || (Object.assign(i.style, n), Object.keys(o).forEach(function(a) {
      var l = o[a];
      l === !1 ? i.removeAttribute(a) : i.setAttribute(a, l === !0 ? "" : l);
    }));
  });
}
function Uv(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var o = t.elements[n], i = t.attributes[n] || {}, a = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), l = a.reduce(function(s, u) {
        return s[u] = "", s;
      }, {});
      !wt(o) || !Zt(o) || (Object.assign(o.style, l), Object.keys(i).forEach(function(s) {
        o.removeAttribute(s);
      }));
    });
  };
}
const Wv = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Gv,
  effect: Uv,
  requires: ["computeStyles"]
};
function Nt(e) {
  return e.split("-")[0];
}
var Vn = Math.max, Vo = Math.min, fr = Math.round;
function ma() {
  var e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function xc() {
  return !/^((?!chrome|android).)*safari/i.test(ma());
}
function pr(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), o = 1, i = 1;
  t && wt(e) && (o = e.offsetWidth > 0 && fr(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && fr(n.height) / e.offsetHeight || 1);
  var a = jn(e) ? At(e) : window, l = a.visualViewport, s = !xc() && r, u = (n.left + (s && l ? l.offsetLeft : 0)) / o, c = (n.top + (s && l ? l.offsetTop : 0)) / i, d = n.width / o, f = n.height / i;
  return {
    width: d,
    height: f,
    top: c,
    right: u + d,
    bottom: c + f,
    left: u,
    x: u,
    y: c
  };
}
function fl(e) {
  var t = pr(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function wc(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && dl(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Dt(e) {
  return At(e).getComputedStyle(e);
}
function Zv(e) {
  return ["table", "td", "th"].indexOf(Zt(e)) >= 0;
}
function En(e) {
  return ((jn(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function di(e) {
  return Zt(e) === "html" ? e : e.assignedSlot || e.parentNode || (dl(e) ? e.host : null) || En(e);
}
function xs(e) {
  return !wt(e) || Dt(e).position === "fixed" ? null : e.offsetParent;
}
function qv(e) {
  var t = /firefox/i.test(ma()), r = /Trident/i.test(ma());
  if (r && wt(e)) {
    var n = Dt(e);
    if (n.position === "fixed")
      return null;
  }
  var o = di(e);
  for (dl(o) && (o = o.host); wt(o) && ["html", "body"].indexOf(Zt(o)) < 0; ) {
    var i = Dt(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function co(e) {
  for (var t = At(e), r = xs(e); r && Zv(r) && Dt(r).position === "static"; )
    r = xs(r);
  return r && (Zt(r) === "html" || Zt(r) === "body" && Dt(r).position === "static") ? t : r || qv(e) || t;
}
function pl(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Dr(e, t, r) {
  return Vn(e, Vo(t, r));
}
function Yv(e, t, r) {
  var n = Dr(e, t, r);
  return n > r ? r : n;
}
function Sc() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Rc(e) {
  return Object.assign({}, Sc(), e);
}
function Ec(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var Kv = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Rc(typeof t != "number" ? t : Ec(t, uo));
};
function Xv(e) {
  var t, r = e.state, n = e.name, o = e.options, i = r.elements.arrow, a = r.modifiersData.popperOffsets, l = Nt(r.placement), s = pl(l), u = [mt, Lt].indexOf(l) >= 0, c = u ? "height" : "width";
  if (!(!i || !a)) {
    var d = Kv(o.padding, r), f = fl(i), v = s === "y" ? vt : mt, h = s === "y" ? Mt : Lt, m = r.rects.reference[c] + r.rects.reference[s] - a[s] - r.rects.popper[c], g = a[s] - r.rects.reference[s], C = co(i), x = C ? s === "y" ? C.clientHeight || 0 : C.clientWidth || 0 : 0, S = m / 2 - g / 2, w = d[v], y = x - f[c] - d[h], O = x / 2 - f[c] / 2 + S, P = Dr(w, O, y), M = s;
    r.modifiersData[n] = (t = {}, t[M] = P, t.centerOffset = P - O, t);
  }
}
function Jv(e) {
  var t = e.state, r = e.options, n = r.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  if (o != null && !(typeof o == "string" && (o = t.elements.popper.querySelector(o), !o))) {
    if (process.env.NODE_ENV !== "production" && (wt(o) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !wc(t.elements.popper, o)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    t.elements.arrow = o;
  }
}
const Qv = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Xv,
  effect: Jv,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function gr(e) {
  return e.split("-")[1];
}
var em = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function tm(e) {
  var t = e.x, r = e.y, n = window, o = n.devicePixelRatio || 1;
  return {
    x: fr(t * o) / o || 0,
    y: fr(r * o) / o || 0
  };
}
function ws(e) {
  var t, r = e.popper, n = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, l = e.position, s = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, d = e.isFixed, f = a.x, v = f === void 0 ? 0 : f, h = a.y, m = h === void 0 ? 0 : h, g = typeof c == "function" ? c({
    x: v,
    y: m
  }) : {
    x: v,
    y: m
  };
  v = g.x, m = g.y;
  var C = a.hasOwnProperty("x"), x = a.hasOwnProperty("y"), S = mt, w = vt, y = window;
  if (u) {
    var O = co(r), P = "clientHeight", M = "clientWidth";
    if (O === At(r) && (O = En(r), Dt(O).position !== "static" && l === "absolute" && (P = "scrollHeight", M = "scrollWidth")), O = O, o === vt || (o === mt || o === Lt) && i === Wr) {
      w = Mt;
      var I = d && O === y && y.visualViewport ? y.visualViewport.height : O[P];
      m -= I - n.height, m *= s ? 1 : -1;
    }
    if (o === mt || (o === vt || o === Mt) && i === Wr) {
      S = Lt;
      var k = d && O === y && y.visualViewport ? y.visualViewport.width : O[M];
      v -= k - n.width, v *= s ? 1 : -1;
    }
  }
  var R = Object.assign({
    position: l
  }, u && em), A = c === !0 ? tm({
    x: v,
    y: m
  }) : {
    x: v,
    y: m
  };
  if (v = A.x, m = A.y, s) {
    var L;
    return Object.assign({}, R, (L = {}, L[w] = x ? "0" : "", L[S] = C ? "0" : "", L.transform = (y.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + m + "px)" : "translate3d(" + v + "px, " + m + "px, 0)", L));
  }
  return Object.assign({}, R, (t = {}, t[w] = x ? m + "px" : "", t[S] = C ? v + "px" : "", t.transform = "", t));
}
function nm(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, o = n === void 0 ? !0 : n, i = r.adaptive, a = i === void 0 ? !0 : i, l = r.roundOffsets, s = l === void 0 ? !0 : l;
  if (process.env.NODE_ENV !== "production") {
    var u = Dt(t.elements.popper).transitionProperty || "";
    a && ["transform", "top", "right", "bottom", "left"].some(function(d) {
      return u.indexOf(d) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var c = {
    placement: Nt(t.placement),
    variation: gr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, ws(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, ws(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const rm = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: nm,
  data: {}
};
var Co = {
  passive: !0
};
function om(e) {
  var t = e.state, r = e.instance, n = e.options, o = n.scroll, i = o === void 0 ? !0 : o, a = n.resize, l = a === void 0 ? !0 : a, s = At(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(c) {
    c.addEventListener("scroll", r.update, Co);
  }), l && s.addEventListener("resize", r.update, Co), function() {
    i && u.forEach(function(c) {
      c.removeEventListener("scroll", r.update, Co);
    }), l && s.removeEventListener("resize", r.update, Co);
  };
}
const im = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: om,
  data: {}
};
var am = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function So(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return am[t];
  });
}
var lm = {
  start: "end",
  end: "start"
};
function Ss(e) {
  return e.replace(/start|end/g, function(t) {
    return lm[t];
  });
}
function gl(e) {
  var t = At(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function vl(e) {
  return pr(En(e)).left + gl(e).scrollLeft;
}
function sm(e, t) {
  var r = At(e), n = En(e), o = r.visualViewport, i = n.clientWidth, a = n.clientHeight, l = 0, s = 0;
  if (o) {
    i = o.width, a = o.height;
    var u = xc();
    (u || !u && t === "fixed") && (l = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l + vl(e),
    y: s
  };
}
function um(e) {
  var t, r = En(e), n = gl(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = Vn(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = Vn(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -n.scrollLeft + vl(e), s = -n.scrollTop;
  return Dt(o || r).direction === "rtl" && (l += Vn(r.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: l,
    y: s
  };
}
function ml(e) {
  var t = Dt(e), r = t.overflow, n = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + n);
}
function Oc(e) {
  return ["html", "body", "#document"].indexOf(Zt(e)) >= 0 ? e.ownerDocument.body : wt(e) && ml(e) ? e : Oc(di(e));
}
function Hr(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Oc(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = At(n), a = o ? [i].concat(i.visualViewport || [], ml(n) ? n : []) : n, l = t.concat(a);
  return o ? l : l.concat(Hr(di(a)));
}
function ha(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function cm(e, t) {
  var r = pr(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Rs(e, t, r) {
  return t === yc ? ha(sm(e, r)) : jn(t) ? cm(t, r) : ha(um(En(e)));
}
function dm(e) {
  var t = Hr(di(e)), r = ["absolute", "fixed"].indexOf(Dt(e).position) >= 0, n = r && wt(e) ? co(e) : e;
  return jn(n) ? t.filter(function(o) {
    return jn(o) && wc(o, n) && Zt(o) !== "body";
  }) : [];
}
function fm(e, t, r, n) {
  var o = t === "clippingParents" ? dm(e) : [].concat(t), i = [].concat(o, [r]), a = i[0], l = i.reduce(function(s, u) {
    var c = Rs(e, u, n);
    return s.top = Vn(c.top, s.top), s.right = Vo(c.right, s.right), s.bottom = Vo(c.bottom, s.bottom), s.left = Vn(c.left, s.left), s;
  }, Rs(e, a, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function Pc(e) {
  var t = e.reference, r = e.element, n = e.placement, o = n ? Nt(n) : null, i = n ? gr(n) : null, a = t.x + t.width / 2 - r.width / 2, l = t.y + t.height / 2 - r.height / 2, s;
  switch (o) {
    case vt:
      s = {
        x: a,
        y: t.y - r.height
      };
      break;
    case Mt:
      s = {
        x: a,
        y: t.y + t.height
      };
      break;
    case Lt:
      s = {
        x: t.x + t.width,
        y: l
      };
      break;
    case mt:
      s = {
        x: t.x - r.width,
        y: l
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var u = o ? pl(o) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (i) {
      case dr:
        s[u] = s[u] - (t[c] / 2 - r[c] / 2);
        break;
      case Wr:
        s[u] = s[u] + (t[c] / 2 - r[c] / 2);
        break;
    }
  }
  return s;
}
function Zr(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = n === void 0 ? e.placement : n, i = r.strategy, a = i === void 0 ? e.strategy : i, l = r.boundary, s = l === void 0 ? Av : l, u = r.rootBoundary, c = u === void 0 ? yc : u, d = r.elementContext, f = d === void 0 ? Or : d, v = r.altBoundary, h = v === void 0 ? !1 : v, m = r.padding, g = m === void 0 ? 0 : m, C = Rc(typeof g != "number" ? g : Ec(g, uo)), x = f === Or ? kv : Or, S = e.rects.popper, w = e.elements[h ? x : f], y = fm(jn(w) ? w : w.contextElement || En(e.elements.popper), s, c, a), O = pr(e.elements.reference), P = Pc({
    reference: O,
    element: S,
    strategy: "absolute",
    placement: o
  }), M = ha(Object.assign({}, S, P)), I = f === Or ? M : O, k = {
    top: y.top - I.top + C.top,
    bottom: I.bottom - y.bottom + C.bottom,
    left: y.left - I.left + C.left,
    right: I.right - y.right + C.right
  }, R = e.modifiersData.offset;
  if (f === Or && R) {
    var A = R[o];
    Object.keys(k).forEach(function(L) {
      var B = [Lt, Mt].indexOf(L) >= 0 ? 1 : -1, W = [vt, Mt].indexOf(L) >= 0 ? "y" : "x";
      k[L] += A[W] * B;
    });
  }
  return k;
}
function pm(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = r.boundary, i = r.rootBoundary, a = r.padding, l = r.flipVariations, s = r.allowedAutoPlacements, u = s === void 0 ? Cc : s, c = gr(n), d = c ? l ? Cs : Cs.filter(function(h) {
    return gr(h) === c;
  }) : uo, f = d.filter(function(h) {
    return u.indexOf(h) >= 0;
  });
  f.length === 0 && (f = d, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var v = f.reduce(function(h, m) {
    return h[m] = Zr(e, {
      placement: m,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[Nt(m)], h;
  }, {});
  return Object.keys(v).sort(function(h, m) {
    return v[h] - v[m];
  });
}
function gm(e) {
  if (Nt(e) === ci)
    return [];
  var t = So(e);
  return [Ss(e), t, Ss(t)];
}
function vm(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var o = r.mainAxis, i = o === void 0 ? !0 : o, a = r.altAxis, l = a === void 0 ? !0 : a, s = r.fallbackPlacements, u = r.padding, c = r.boundary, d = r.rootBoundary, f = r.altBoundary, v = r.flipVariations, h = v === void 0 ? !0 : v, m = r.allowedAutoPlacements, g = t.options.placement, C = Nt(g), x = C === g, S = s || (x || !h ? [So(g)] : gm(g)), w = [g].concat(S).reduce(function(H, te) {
      return H.concat(Nt(te) === ci ? pm(t, {
        placement: te,
        boundary: c,
        rootBoundary: d,
        padding: u,
        flipVariations: h,
        allowedAutoPlacements: m
      }) : te);
    }, []), y = t.rects.reference, O = t.rects.popper, P = /* @__PURE__ */ new Map(), M = !0, I = w[0], k = 0; k < w.length; k++) {
      var R = w[k], A = Nt(R), L = gr(R) === dr, B = [vt, Mt].indexOf(A) >= 0, W = B ? "width" : "height", U = Zr(t, {
        placement: R,
        boundary: c,
        rootBoundary: d,
        altBoundary: f,
        padding: u
      }), X = B ? L ? Lt : mt : L ? Mt : vt;
      y[W] > O[W] && (X = So(X));
      var D = So(X), le = [];
      if (i && le.push(U[A] <= 0), l && le.push(U[X] <= 0, U[D] <= 0), le.every(function(H) {
        return H;
      })) {
        I = R, M = !1;
        break;
      }
      P.set(R, le);
    }
    if (M)
      for (var T = h ? 3 : 1, j = function(te) {
        var re = w.find(function(ue) {
          var ce = P.get(ue);
          if (ce)
            return ce.slice(0, te).every(function(Y) {
              return Y;
            });
        });
        if (re)
          return I = re, "break";
      }, z = T; z > 0; z--) {
        var _ = j(z);
        if (_ === "break")
          break;
      }
    t.placement !== I && (t.modifiersData[n]._skip = !0, t.placement = I, t.reset = !0);
  }
}
const mm = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: vm,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Es(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Os(e) {
  return [vt, Lt, Mt, mt].some(function(t) {
    return e[t] >= 0;
  });
}
function hm(e) {
  var t = e.state, r = e.name, n = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = Zr(t, {
    elementContext: "reference"
  }), l = Zr(t, {
    altBoundary: !0
  }), s = Es(a, n), u = Es(l, o, i), c = Os(s), d = Os(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const bm = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hm
};
function ym(e, t, r) {
  var n = Nt(e), o = [mt, vt].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, a = i[0], l = i[1];
  return a = a || 0, l = (l || 0) * o, [mt, Lt].indexOf(n) >= 0 ? {
    x: l,
    y: a
  } : {
    x: a,
    y: l
  };
}
function Cm(e) {
  var t = e.state, r = e.options, n = e.name, o = r.offset, i = o === void 0 ? [0, 0] : o, a = Cc.reduce(function(c, d) {
    return c[d] = ym(d, t.rects, i), c;
  }, {}), l = a[t.placement], s = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = a;
}
const xm = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Cm
};
function wm(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Pc({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Sm = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: wm,
  data: {}
};
function Rm(e) {
  return e === "x" ? "y" : "x";
}
function Em(e) {
  var t = e.state, r = e.options, n = e.name, o = r.mainAxis, i = o === void 0 ? !0 : o, a = r.altAxis, l = a === void 0 ? !1 : a, s = r.boundary, u = r.rootBoundary, c = r.altBoundary, d = r.padding, f = r.tether, v = f === void 0 ? !0 : f, h = r.tetherOffset, m = h === void 0 ? 0 : h, g = Zr(t, {
    boundary: s,
    rootBoundary: u,
    padding: d,
    altBoundary: c
  }), C = Nt(t.placement), x = gr(t.placement), S = !x, w = pl(C), y = Rm(w), O = t.modifiersData.popperOffsets, P = t.rects.reference, M = t.rects.popper, I = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, k = typeof I == "number" ? {
    mainAxis: I,
    altAxis: I
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, I), R = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, A = {
    x: 0,
    y: 0
  };
  if (!!O) {
    if (i) {
      var L, B = w === "y" ? vt : mt, W = w === "y" ? Mt : Lt, U = w === "y" ? "height" : "width", X = O[w], D = X + g[B], le = X - g[W], T = v ? -M[U] / 2 : 0, j = x === dr ? P[U] : M[U], z = x === dr ? -M[U] : -P[U], _ = t.elements.arrow, H = v && _ ? fl(_) : {
        width: 0,
        height: 0
      }, te = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Sc(), re = te[B], ue = te[W], ce = Dr(0, P[U], H[U]), Y = S ? P[U] / 2 - T - ce - re - k.mainAxis : j - ce - re - k.mainAxis, J = S ? -P[U] / 2 + T + ce + ue + k.mainAxis : z + ce + ue + k.mainAxis, ye = t.elements.arrow && co(t.elements.arrow), Q = ye ? w === "y" ? ye.clientTop || 0 : ye.clientLeft || 0 : 0, Ue = (L = R == null ? void 0 : R[w]) != null ? L : 0, F = X + Y - Ue - Q, Ke = X + J - Ue, qe = Dr(v ? Vo(D, F) : D, X, v ? Vn(le, Ke) : le);
      O[w] = qe, A[w] = qe - X;
    }
    if (l) {
      var ut, ln = w === "x" ? vt : mt, Ee = w === "x" ? Mt : Lt, Ie = O[y], Se = y === "y" ? "height" : "width", et = Ie + g[ln], je = Ie - g[Ee], nt = [vt, mt].indexOf(C) !== -1, Xe = (ut = R == null ? void 0 : R[y]) != null ? ut : 0, it = nt ? et : Ie - P[Se] - M[Se] - Xe + k.altAxis, ct = nt ? Ie + P[Se] + M[Se] - Xe - k.altAxis : je, pt = v && nt ? Yv(it, Ie, ct) : Dr(v ? it : et, Ie, v ? ct : je);
      O[y] = pt, A[y] = pt - Ie;
    }
    t.modifiersData[n] = A;
  }
}
const Om = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Em,
  requiresIfExists: ["offset"]
};
function Pm(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Im(e) {
  return e === At(e) || !wt(e) ? gl(e) : Pm(e);
}
function Tm(e) {
  var t = e.getBoundingClientRect(), r = fr(t.width) / e.offsetWidth || 1, n = fr(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function $m(e, t, r) {
  r === void 0 && (r = !1);
  var n = wt(t), o = wt(t) && Tm(t), i = En(t), a = pr(e, o, r), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Zt(t) !== "body" || ml(i)) && (l = Im(t)), wt(t) ? (s = pr(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : i && (s.x = vl(i))), {
    x: a.left + l.scrollLeft - s.x,
    y: a.top + l.scrollTop - s.y,
    width: a.width,
    height: a.height
  };
}
function Mm(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    r.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(l) {
      if (!r.has(l)) {
        var s = t.get(l);
        s && o(s);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || o(i);
  }), n;
}
function Lm(e) {
  var t = Mm(e);
  return va.reduce(function(r, n) {
    return r.concat(t.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function Am(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function un(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return [].concat(r).reduce(function(o, i) {
    return o.replace(/%s/, i);
  }, e);
}
var $n = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', km = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', Ps = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function _m(e) {
  e.forEach(function(t) {
    [].concat(Object.keys(t), Ps).filter(function(r, n, o) {
      return o.indexOf(r) === n;
    }).forEach(function(r) {
      switch (r) {
        case "name":
          typeof t.name != "string" && console.error(un($n, String(t.name), '"name"', '"string"', '"' + String(t.name) + '"'));
          break;
        case "enabled":
          typeof t.enabled != "boolean" && console.error(un($n, t.name, '"enabled"', '"boolean"', '"' + String(t.enabled) + '"'));
          break;
        case "phase":
          va.indexOf(t.phase) < 0 && console.error(un($n, t.name, '"phase"', "either " + va.join(", "), '"' + String(t.phase) + '"'));
          break;
        case "fn":
          typeof t.fn != "function" && console.error(un($n, t.name, '"fn"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "effect":
          t.effect != null && typeof t.effect != "function" && console.error(un($n, t.name, '"effect"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "requires":
          t.requires != null && !Array.isArray(t.requires) && console.error(un($n, t.name, '"requires"', '"array"', '"' + String(t.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(t.requiresIfExists) || console.error(un($n, t.name, '"requiresIfExists"', '"array"', '"' + String(t.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + t.name + '" modifier, valid properties are ' + Ps.map(function(n) {
            return '"' + n + '"';
          }).join(", ") + '; but "' + r + '" was provided.');
      }
      t.requires && t.requires.forEach(function(n) {
        e.find(function(o) {
          return o.name === n;
        }) == null && console.error(un(km, String(t.name), n, n));
      });
    });
  });
}
function Fm(e, t) {
  var r = /* @__PURE__ */ new Set();
  return e.filter(function(n) {
    var o = t(n);
    if (!r.has(o))
      return r.add(o), !0;
  });
}
function Nm(e) {
  var t = e.reduce(function(r, n) {
    var o = r[n.name];
    return r[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Is = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", Vm = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", Ts = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function $s() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Dm(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, o = t.defaultOptions, i = o === void 0 ? Ts : o;
  return function(l, s, u) {
    u === void 0 && (u = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ts, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: s
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, v = {
      state: c,
      setOptions: function(C) {
        var x = typeof C == "function" ? C(c.options) : C;
        m(), c.options = Object.assign({}, i, c.options, x), c.scrollParents = {
          reference: jn(l) ? Hr(l) : l.contextElement ? Hr(l.contextElement) : [],
          popper: Hr(s)
        };
        var S = Lm(Nm([].concat(n, c.options.modifiers)));
        if (c.orderedModifiers = S.filter(function(R) {
          return R.enabled;
        }), process.env.NODE_ENV !== "production") {
          var w = Fm([].concat(S, c.options.modifiers), function(R) {
            var A = R.name;
            return A;
          });
          if (_m(w), Nt(c.options.placement) === ci) {
            var y = c.orderedModifiers.find(function(R) {
              var A = R.name;
              return A === "flip";
            });
            y || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var O = Dt(s), P = O.marginTop, M = O.marginRight, I = O.marginBottom, k = O.marginLeft;
          [P, M, I, k].some(function(R) {
            return parseFloat(R);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return h(), v.update();
      },
      forceUpdate: function() {
        if (!f) {
          var C = c.elements, x = C.reference, S = C.popper;
          if (!$s(x, S)) {
            process.env.NODE_ENV !== "production" && console.error(Is);
            return;
          }
          c.rects = {
            reference: $m(x, co(S), c.options.strategy === "fixed"),
            popper: fl(S)
          }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(R) {
            return c.modifiersData[R.name] = Object.assign({}, R.data);
          });
          for (var w = 0, y = 0; y < c.orderedModifiers.length; y++) {
            if (process.env.NODE_ENV !== "production" && (w += 1, w > 100)) {
              console.error(Vm);
              break;
            }
            if (c.reset === !0) {
              c.reset = !1, y = -1;
              continue;
            }
            var O = c.orderedModifiers[y], P = O.fn, M = O.options, I = M === void 0 ? {} : M, k = O.name;
            typeof P == "function" && (c = P({
              state: c,
              options: I,
              name: k,
              instance: v
            }) || c);
          }
        }
      },
      update: Am(function() {
        return new Promise(function(g) {
          v.forceUpdate(), g(c);
        });
      }),
      destroy: function() {
        m(), f = !0;
      }
    };
    if (!$s(l, s))
      return process.env.NODE_ENV !== "production" && console.error(Is), v;
    v.setOptions(u).then(function(g) {
      !f && u.onFirstUpdate && u.onFirstUpdate(g);
    });
    function h() {
      c.orderedModifiers.forEach(function(g) {
        var C = g.name, x = g.options, S = x === void 0 ? {} : x, w = g.effect;
        if (typeof w == "function") {
          var y = w({
            state: c,
            name: C,
            instance: v,
            options: S
          }), O = function() {
          };
          d.push(y || O);
        }
      });
    }
    function m() {
      d.forEach(function(g) {
        return g();
      }), d = [];
    }
    return v;
  };
}
var Hm = [im, Sm, rm, Wv, xm, mm, Om, Qv, bm], zm = /* @__PURE__ */ Dm({
  defaultModifiers: Hm
});
function Bm(e) {
  return typeof e == "function" ? e() : e;
}
const Do = /* @__PURE__ */ N.forwardRef(function(t, r) {
  const {
    children: n,
    container: o,
    disablePortal: i = !1
  } = t, [a, l] = N.useState(null), s = Wt(/* @__PURE__ */ N.isValidElement(n) ? n.ref : null, r);
  if (Bn(() => {
    i || l(Bm(o) || document.body);
  }, [o, i]), Bn(() => {
    if (a && !i)
      return fa(r, a), () => {
        fa(r, null);
      };
  }, [r, a, i]), i) {
    if (/* @__PURE__ */ N.isValidElement(n)) {
      const u = {
        ref: s
      };
      return /* @__PURE__ */ N.cloneElement(n, u);
    }
    return /* @__PURE__ */ p(N.Fragment, {
      children: n
    });
  }
  return /* @__PURE__ */ p(N.Fragment, {
    children: a && /* @__PURE__ */ eu.createPortal(n, a)
  });
});
process.env.NODE_ENV !== "production" && (Do.propTypes = {
  children: b.exports.node,
  container: b.exports.oneOfType([Ur, b.exports.func]),
  disablePortal: b.exports.bool
});
process.env.NODE_ENV !== "production" && (Do["propTypes"] = gc(Do.propTypes));
const jm = Do;
function Gm(e) {
  return Rn("MuiPopper", e);
}
Kt("MuiPopper", ["root"]);
const Um = ["anchorEl", "children", "component", "direction", "disablePortal", "modifiers", "open", "ownerState", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps"], Wm = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function Zm(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Ho(e) {
  return typeof e == "function" ? e() : e;
}
function fi(e) {
  return e.nodeType !== void 0;
}
function qm(e) {
  return !fi(e);
}
const Ym = () => yr({
  root: ["root"]
}, Jg(Gm)), Km = {}, Xm = /* @__PURE__ */ N.forwardRef(function(t, r) {
  var n;
  const {
    anchorEl: o,
    children: i,
    component: a,
    direction: l,
    disablePortal: s,
    modifiers: u,
    open: c,
    ownerState: d,
    placement: f,
    popperOptions: v,
    popperRef: h,
    slotProps: m = {},
    slots: g = {},
    TransitionProps: C
  } = t, x = Ze(t, Um), S = N.useRef(null), w = Wt(S, r), y = N.useRef(null), O = Wt(y, h), P = N.useRef(O);
  Bn(() => {
    P.current = O;
  }, [O]), N.useImperativeHandle(h, () => y.current, []);
  const M = Zm(f, l), [I, k] = N.useState(M), [R, A] = N.useState(Ho(o));
  N.useEffect(() => {
    y.current && y.current.forceUpdate();
  }), N.useEffect(() => {
    o && A(Ho(o));
  }, [o]), Bn(() => {
    if (!R || !c)
      return;
    const X = (T) => {
      k(T.placement);
    };
    if (process.env.NODE_ENV !== "production" && R && fi(R) && R.nodeType === 1) {
      const T = R.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && T.top === 0 && T.left === 0 && T.right === 0 && T.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let D = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: T
      }) => {
        X(T);
      }
    }];
    u != null && (D = D.concat(u)), v && v.modifiers != null && (D = D.concat(v.modifiers));
    const le = zm(R, S.current, ae({
      placement: M
    }, v, {
      modifiers: D
    }));
    return P.current(le), () => {
      le.destroy(), P.current(null);
    };
  }, [R, s, u, c, v, M]);
  const L = {
    placement: I
  };
  C !== null && (L.TransitionProps = C);
  const B = Ym(), W = (n = a != null ? a : g.root) != null ? n : "div", U = Mv({
    elementType: W,
    externalSlotProps: m.root,
    externalForwardedProps: x,
    additionalProps: {
      role: "tooltip",
      ref: w
    },
    ownerState: ae({}, t, d),
    className: B.root
  });
  return /* @__PURE__ */ p(W, ae({}, U, {
    children: typeof i == "function" ? i(L) : i
  }));
}), Ic = /* @__PURE__ */ N.forwardRef(function(t, r) {
  const {
    anchorEl: n,
    children: o,
    container: i,
    direction: a = "ltr",
    disablePortal: l = !1,
    keepMounted: s = !1,
    modifiers: u,
    open: c,
    placement: d = "bottom",
    popperOptions: f = Km,
    popperRef: v,
    style: h,
    transition: m = !1,
    slotProps: g = {},
    slots: C = {}
  } = t, x = Ze(t, Wm), [S, w] = N.useState(!0), y = () => {
    w(!1);
  }, O = () => {
    w(!0);
  };
  if (!s && !c && (!m || S))
    return null;
  let P;
  if (i)
    P = i;
  else if (n) {
    const k = Ho(n);
    P = k && fi(k) ? Nn(k).body : Nn(null).body;
  }
  const M = !c && s && (!m || S) ? "none" : void 0, I = m ? {
    in: c,
    onEnter: y,
    onExited: O
  } : void 0;
  return /* @__PURE__ */ p(jm, {
    disablePortal: l,
    container: P,
    children: /* @__PURE__ */ p(Xm, ae({
      anchorEl: n,
      direction: a,
      disablePortal: l,
      modifiers: u,
      ref: r,
      open: m ? !S : c,
      placement: d,
      popperOptions: f,
      popperRef: v,
      slotProps: g,
      slots: C
    }, x, {
      style: ae({
        position: "fixed",
        top: 0,
        left: 0,
        display: M
      }, h),
      TransitionProps: I,
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (Ic.propTypes = {
  anchorEl: so(b.exports.oneOfType([Ur, b.exports.object, b.exports.func]), (e) => {
    if (e.open) {
      const t = Ho(e.anchorEl);
      if (t && fi(t) && t.nodeType === 1) {
        const r = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || qm(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  children: b.exports.oneOfType([b.exports.node, b.exports.func]),
  container: b.exports.oneOfType([Ur, b.exports.func]),
  direction: b.exports.oneOf(["ltr", "rtl"]),
  disablePortal: b.exports.bool,
  keepMounted: b.exports.bool,
  modifiers: b.exports.arrayOf(b.exports.shape({
    data: b.exports.object,
    effect: b.exports.func,
    enabled: b.exports.bool,
    fn: b.exports.func,
    name: b.exports.any,
    options: b.exports.object,
    phase: b.exports.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: b.exports.arrayOf(b.exports.string),
    requiresIfExists: b.exports.arrayOf(b.exports.string)
  })),
  open: b.exports.bool.isRequired,
  placement: b.exports.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  popperOptions: b.exports.shape({
    modifiers: b.exports.array,
    onFirstUpdate: b.exports.func,
    placement: b.exports.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: b.exports.oneOf(["absolute", "fixed"])
  }),
  popperRef: cl,
  slotProps: b.exports.shape({
    root: b.exports.oneOfType([b.exports.func, b.exports.object])
  }),
  slots: b.exports.shape({
    root: b.exports.elementType
  }),
  style: b.exports.object,
  transition: b.exports.bool
});
const Jm = Ic;
/**
 * @mui/styled-engine v5.11.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function Qm(e, t) {
  const r = gd(e, t);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), r(...n);
  } : r;
}
const e2 = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, t2 = process.env.NODE_ENV !== "production" ? b.exports.oneOfType([b.exports.number, b.exports.string, b.exports.object, b.exports.array]) : {}, On = t2;
function zr(e, t) {
  return t ? tn(e, t, {
    clone: !1
  }) : e;
}
const hl = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
}, Ms = {
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${hl[e]}px)`
};
function qt(e, t, r) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const i = n.breakpoints || Ms;
    return t.reduce((a, l, s) => (a[i.up(i.keys[s])] = r(t[s]), a), {});
  }
  if (typeof t == "object") {
    const i = n.breakpoints || Ms;
    return Object.keys(t).reduce((a, l) => {
      if (Object.keys(i.values || hl).indexOf(l) !== -1) {
        const s = i.up(l);
        a[s] = r(t[l], l);
      } else {
        const s = l;
        a[s] = t[s];
      }
      return a;
    }, {});
  }
  return r(t);
}
function n2(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((n, o) => {
    const i = e.up(o);
    return n[i] = {}, n;
  }, {})) || {};
}
function r2(e, t) {
  return e.reduce((r, n) => {
    const o = r[n];
    return (!o || Object.keys(o).length === 0) && delete r[n], r;
  }, t);
}
function pi(e, t, r = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && r) {
    const n = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (n != null)
      return n;
  }
  return t.split(".").reduce((n, o) => n && n[o] != null ? n[o] : null, e);
}
function zo(e, t, r, n = r) {
  let o;
  return typeof e == "function" ? o = e(r) : Array.isArray(e) ? o = e[r] || n : o = pi(e, r) || n, t && (o = t(o, n, e)), o;
}
function Ne(e) {
  const {
    prop: t,
    cssProperty: r = e.prop,
    themeKey: n,
    transform: o
  } = e, i = (a) => {
    if (a[t] == null)
      return null;
    const l = a[t], s = a.theme, u = pi(s, n) || {};
    return qt(a, l, (d) => {
      let f = zo(u, o, d);
      return d === f && typeof d == "string" && (f = zo(u, o, `${t}${d === "default" ? "" : at(d)}`, d)), r === !1 ? f : {
        [r]: f
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: On
  } : {}, i.filterProps = [t], i;
}
function gi(...e) {
  const t = e.reduce((n, o) => (o.filterProps.forEach((i) => {
    n[i] = o;
  }), n), {}), r = (n) => Object.keys(n).reduce((o, i) => t[i] ? zr(o, t[i](n)) : o, {});
  return r.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, o) => Object.assign(n, o.propTypes), {}) : {}, r.filterProps = e.reduce((n, o) => n.concat(o.filterProps), []), r;
}
function o2(e) {
  const t = {};
  return (r) => (t[r] === void 0 && (t[r] = e(r)), t[r]);
}
const i2 = {
  m: "margin",
  p: "padding"
}, a2 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, Ls = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, l2 = o2((e) => {
  if (e.length > 2)
    if (Ls[e])
      e = Ls[e];
    else
      return [e];
  const [t, r] = e.split(""), n = i2[t], o = a2[r] || "";
  return Array.isArray(o) ? o.map((i) => n + i) : [n + o];
}), vi = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], mi = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], s2 = [...vi, ...mi];
function fo(e, t, r, n) {
  var o;
  const i = (o = pi(e, t, !1)) != null ? o : r;
  return typeof i == "number" ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && typeof a != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${a}.`), i * a) : Array.isArray(i) ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > i.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${a} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), i[a]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Tc(e) {
  return fo(e, "spacing", 8, "spacing");
}
function po(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const r = Math.abs(t), n = e(r);
  return t >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function u2(e, t) {
  return (r) => e.reduce((n, o) => (n[o] = po(t, r), n), {});
}
function c2(e, t, r, n) {
  if (t.indexOf(r) === -1)
    return null;
  const o = l2(r), i = u2(o, n), a = e[r];
  return qt(e, a, i);
}
function $c(e, t) {
  const r = Tc(e.theme);
  return Object.keys(e).map((n) => c2(e, t, n, r)).reduce(zr, {});
}
function Je(e) {
  return $c(e, vi);
}
Je.propTypes = process.env.NODE_ENV !== "production" ? vi.reduce((e, t) => (e[t] = On, e), {}) : {};
Je.filterProps = vi;
function Qe(e) {
  return $c(e, mi);
}
Qe.propTypes = process.env.NODE_ENV !== "production" ? mi.reduce((e, t) => (e[t] = On, e), {}) : {};
Qe.filterProps = mi;
process.env.NODE_ENV !== "production" && s2.reduce((e, t) => (e[t] = On, e), {});
function zt(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
const d2 = Ne({
  prop: "border",
  themeKey: "borders",
  transform: zt
}), f2 = Ne({
  prop: "borderTop",
  themeKey: "borders",
  transform: zt
}), p2 = Ne({
  prop: "borderRight",
  themeKey: "borders",
  transform: zt
}), g2 = Ne({
  prop: "borderBottom",
  themeKey: "borders",
  transform: zt
}), v2 = Ne({
  prop: "borderLeft",
  themeKey: "borders",
  transform: zt
}), m2 = Ne({
  prop: "borderColor",
  themeKey: "palette"
}), h2 = Ne({
  prop: "borderTopColor",
  themeKey: "palette"
}), b2 = Ne({
  prop: "borderRightColor",
  themeKey: "palette"
}), y2 = Ne({
  prop: "borderBottomColor",
  themeKey: "palette"
}), C2 = Ne({
  prop: "borderLeftColor",
  themeKey: "palette"
}), hi = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = fo(e.theme, "shape.borderRadius", 4, "borderRadius"), r = (n) => ({
      borderRadius: po(t, n)
    });
    return qt(e, e.borderRadius, r);
  }
  return null;
};
hi.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: On
} : {};
hi.filterProps = ["borderRadius"];
gi(d2, f2, p2, g2, v2, m2, h2, b2, y2, C2, hi);
const bi = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = fo(e.theme, "spacing", 8, "gap"), r = (n) => ({
      gap: po(t, n)
    });
    return qt(e, e.gap, r);
  }
  return null;
};
bi.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: On
} : {};
bi.filterProps = ["gap"];
const yi = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = fo(e.theme, "spacing", 8, "columnGap"), r = (n) => ({
      columnGap: po(t, n)
    });
    return qt(e, e.columnGap, r);
  }
  return null;
};
yi.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: On
} : {};
yi.filterProps = ["columnGap"];
const Ci = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = fo(e.theme, "spacing", 8, "rowGap"), r = (n) => ({
      rowGap: po(t, n)
    });
    return qt(e, e.rowGap, r);
  }
  return null;
};
Ci.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: On
} : {};
Ci.filterProps = ["rowGap"];
const x2 = Ne({
  prop: "gridColumn"
}), w2 = Ne({
  prop: "gridRow"
}), S2 = Ne({
  prop: "gridAutoFlow"
}), R2 = Ne({
  prop: "gridAutoColumns"
}), E2 = Ne({
  prop: "gridAutoRows"
}), O2 = Ne({
  prop: "gridTemplateColumns"
}), P2 = Ne({
  prop: "gridTemplateRows"
}), I2 = Ne({
  prop: "gridTemplateAreas"
}), T2 = Ne({
  prop: "gridArea"
});
gi(bi, yi, Ci, x2, w2, S2, R2, E2, O2, P2, I2, T2);
function ar(e, t) {
  return t === "grey" ? t : e;
}
const $2 = Ne({
  prop: "color",
  themeKey: "palette",
  transform: ar
}), M2 = Ne({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: ar
}), L2 = Ne({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: ar
});
gi($2, M2, L2);
function Ct(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const A2 = Ne({
  prop: "width",
  transform: Ct
}), bl = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (r) => {
      var n, o, i;
      return {
        maxWidth: ((n = e.theme) == null || (o = n.breakpoints) == null || (i = o.values) == null ? void 0 : i[r]) || hl[r] || Ct(r)
      };
    };
    return qt(e, e.maxWidth, t);
  }
  return null;
};
bl.filterProps = ["maxWidth"];
const k2 = Ne({
  prop: "minWidth",
  transform: Ct
}), _2 = Ne({
  prop: "height",
  transform: Ct
}), F2 = Ne({
  prop: "maxHeight",
  transform: Ct
}), N2 = Ne({
  prop: "minHeight",
  transform: Ct
});
Ne({
  prop: "size",
  cssProperty: "width",
  transform: Ct
});
Ne({
  prop: "size",
  cssProperty: "height",
  transform: Ct
});
const V2 = Ne({
  prop: "boxSizing"
});
gi(A2, bl, k2, _2, F2, N2, V2);
const qi = (e) => (t) => {
  if (t[e] !== void 0 && t[e] !== null) {
    const r = (n) => {
      var o, i;
      let a = (o = t.theme.typography) == null ? void 0 : o[`${e}${t[e] === "default" || t[e] === e ? "" : at((i = t[e]) == null ? void 0 : i.toString())}`];
      if (!a) {
        var l, s;
        a = (l = t.theme.typography) == null || (s = l[n]) == null ? void 0 : s[e];
      }
      return a || (a = n), {
        [e]: a
      };
    };
    return qt(t, t[e], r);
  }
  return null;
}, D2 = {
  border: {
    themeKey: "borders",
    transform: zt
  },
  borderTop: {
    themeKey: "borders",
    transform: zt
  },
  borderRight: {
    themeKey: "borders",
    transform: zt
  },
  borderBottom: {
    themeKey: "borders",
    transform: zt
  },
  borderLeft: {
    themeKey: "borders",
    transform: zt
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: hi
  },
  color: {
    themeKey: "palette",
    transform: ar
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: ar
  },
  backgroundColor: {
    themeKey: "palette",
    transform: ar
  },
  p: {
    style: Qe
  },
  pt: {
    style: Qe
  },
  pr: {
    style: Qe
  },
  pb: {
    style: Qe
  },
  pl: {
    style: Qe
  },
  px: {
    style: Qe
  },
  py: {
    style: Qe
  },
  padding: {
    style: Qe
  },
  paddingTop: {
    style: Qe
  },
  paddingRight: {
    style: Qe
  },
  paddingBottom: {
    style: Qe
  },
  paddingLeft: {
    style: Qe
  },
  paddingX: {
    style: Qe
  },
  paddingY: {
    style: Qe
  },
  paddingInline: {
    style: Qe
  },
  paddingInlineStart: {
    style: Qe
  },
  paddingInlineEnd: {
    style: Qe
  },
  paddingBlock: {
    style: Qe
  },
  paddingBlockStart: {
    style: Qe
  },
  paddingBlockEnd: {
    style: Qe
  },
  m: {
    style: Je
  },
  mt: {
    style: Je
  },
  mr: {
    style: Je
  },
  mb: {
    style: Je
  },
  ml: {
    style: Je
  },
  mx: {
    style: Je
  },
  my: {
    style: Je
  },
  margin: {
    style: Je
  },
  marginTop: {
    style: Je
  },
  marginRight: {
    style: Je
  },
  marginBottom: {
    style: Je
  },
  marginLeft: {
    style: Je
  },
  marginX: {
    style: Je
  },
  marginY: {
    style: Je
  },
  marginInline: {
    style: Je
  },
  marginInlineStart: {
    style: Je
  },
  marginInlineEnd: {
    style: Je
  },
  marginBlock: {
    style: Je
  },
  marginBlockStart: {
    style: Je
  },
  marginBlockEnd: {
    style: Je
  },
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  gap: {
    style: bi
  },
  rowGap: {
    style: Ci
  },
  columnGap: {
    style: yi
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  boxShadow: {
    themeKey: "shadows"
  },
  width: {
    transform: Ct
  },
  maxWidth: {
    style: bl
  },
  minWidth: {
    transform: Ct
  },
  height: {
    transform: Ct
  },
  maxHeight: {
    transform: Ct
  },
  minHeight: {
    transform: Ct
  },
  boxSizing: {},
  fontFamily: {
    themeKey: "typography",
    style: qi("fontFamily")
  },
  fontSize: {
    themeKey: "typography",
    style: qi("fontSize")
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography",
    style: qi("fontWeight")
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, yl = D2;
function H2(...e) {
  const t = e.reduce((n, o) => n.concat(Object.keys(o)), []), r = new Set(t);
  return e.every((n) => r.size === Object.keys(n).length);
}
function z2(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function B2() {
  function e(r, n, o, i) {
    const a = {
      [r]: n,
      theme: o
    }, l = i[r];
    if (!l)
      return {
        [r]: n
      };
    const {
      cssProperty: s = r,
      themeKey: u,
      transform: c,
      style: d
    } = l;
    if (n == null)
      return null;
    const f = pi(o, u) || {};
    return d ? d(a) : qt(a, n, (h) => {
      let m = zo(f, c, h);
      return h === m && typeof h == "string" && (m = zo(f, c, `${r}${h === "default" ? "" : at(h)}`, h)), s === !1 ? m : {
        [s]: m
      };
    });
  }
  function t(r) {
    var n;
    const {
      sx: o,
      theme: i = {}
    } = r || {};
    if (!o)
      return null;
    const a = (n = i.unstable_sxConfig) != null ? n : yl;
    function l(s) {
      let u = s;
      if (typeof s == "function")
        u = s(i);
      else if (typeof s != "object")
        return s;
      if (!u)
        return null;
      const c = n2(i.breakpoints), d = Object.keys(c);
      let f = c;
      return Object.keys(u).forEach((v) => {
        const h = z2(u[v], i);
        if (h != null)
          if (typeof h == "object")
            if (a[v])
              f = zr(f, e(v, h, i, a));
            else {
              const m = qt({
                theme: i
              }, h, (g) => ({
                [v]: g
              }));
              H2(m, h) ? f[v] = t({
                sx: h,
                theme: i
              }) : f = zr(f, m);
            }
          else
            f = zr(f, e(v, h, i, a));
      }), r2(d, f);
    }
    return Array.isArray(o) ? o.map(l) : l(o);
  }
  return t;
}
const Mc = B2();
Mc.filterProps = ["sx"];
const Cl = Mc, j2 = ["values", "unit", "step"], G2 = (e) => {
  const t = Object.keys(e).map((r) => ({
    key: r,
    val: e[r]
  })) || [];
  return t.sort((r, n) => r.val - n.val), t.reduce((r, n) => ae({}, r, {
    [n.key]: n.val
  }), {});
};
function U2(e) {
  const {
    values: t = {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    },
    unit: r = "px",
    step: n = 5
  } = e, o = Ze(e, j2), i = G2(t), a = Object.keys(i);
  function l(f) {
    return `@media (min-width:${typeof t[f] == "number" ? t[f] : f}${r})`;
  }
  function s(f) {
    return `@media (max-width:${(typeof t[f] == "number" ? t[f] : f) - n / 100}${r})`;
  }
  function u(f, v) {
    const h = a.indexOf(v);
    return `@media (min-width:${typeof t[f] == "number" ? t[f] : f}${r}) and (max-width:${(h !== -1 && typeof t[a[h]] == "number" ? t[a[h]] : v) - n / 100}${r})`;
  }
  function c(f) {
    return a.indexOf(f) + 1 < a.length ? u(f, a[a.indexOf(f) + 1]) : l(f);
  }
  function d(f) {
    const v = a.indexOf(f);
    return v === 0 ? l(a[1]) : v === a.length - 1 ? s(a[v]) : u(f, a[a.indexOf(f) + 1]).replace("@media", "@media not all and");
  }
  return ae({
    keys: a,
    values: i,
    up: l,
    down: s,
    between: u,
    only: c,
    not: d,
    unit: r
  }, o);
}
const W2 = {
  borderRadius: 4
}, Z2 = W2;
function q2(e = 8) {
  if (e.mui)
    return e;
  const t = Tc({
    spacing: e
  }), r = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((i) => {
    const a = t(i);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" "));
  return r.mui = !0, r;
}
const Y2 = ["breakpoints", "palette", "spacing", "shape"];
function xl(e = {}, ...t) {
  const {
    breakpoints: r = {},
    palette: n = {},
    spacing: o,
    shape: i = {}
  } = e, a = Ze(e, Y2), l = U2(r), s = q2(o);
  let u = tn({
    breakpoints: l,
    direction: "ltr",
    components: {},
    palette: ae({
      mode: "light"
    }, n),
    spacing: s,
    shape: ae({}, Z2, i)
  }, a);
  return u = t.reduce((c, d) => tn(c, d), u), u.unstable_sxConfig = ae({}, yl, a == null ? void 0 : a.unstable_sxConfig), u.unstable_sx = function(d) {
    return Cl({
      sx: d,
      theme: this
    });
  }, u;
}
const Lc = /* @__PURE__ */ N.createContext(null);
process.env.NODE_ENV !== "production" && (Lc.displayName = "ThemeContext");
const K2 = Lc;
function X2() {
  const e = N.useContext(K2);
  return process.env.NODE_ENV !== "production" && N.useDebugValue(e), e;
}
function J2(e) {
  return Object.keys(e).length === 0;
}
function Ac(e = null) {
  const t = X2();
  return !t || J2(t) ? e : t;
}
const Q2 = xl();
function kc(e = Q2) {
  return Ac(e);
}
const eh = ["variant"];
function As(e) {
  return e.length === 0;
}
function _c(e) {
  const {
    variant: t
  } = e, r = Ze(e, eh);
  let n = t || "";
  return Object.keys(r).sort().forEach((o) => {
    o === "color" ? n += As(n) ? e[o] : at(e[o]) : n += `${As(n) ? o : at(o)}${at(e[o].toString())}`;
  }), n;
}
const th = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"], nh = ["theme"], rh = ["theme"];
function Pr(e) {
  return Object.keys(e).length === 0;
}
function oh(e) {
  return typeof e == "string" && e.charCodeAt(0) > 96;
}
const ih = (e, t) => t.components && t.components[e] && t.components[e].styleOverrides ? t.components[e].styleOverrides : null, ah = (e, t) => {
  let r = [];
  t && t.components && t.components[e] && t.components[e].variants && (r = t.components[e].variants);
  const n = {};
  return r.forEach((o) => {
    const i = _c(o.props);
    n[i] = o.style;
  }), n;
}, lh = (e, t, r, n) => {
  var o, i;
  const {
    ownerState: a = {}
  } = e, l = [], s = r == null || (o = r.components) == null || (i = o[n]) == null ? void 0 : i.variants;
  return s && s.forEach((u) => {
    let c = !0;
    Object.keys(u.props).forEach((d) => {
      a[d] !== u.props[d] && e[d] !== u.props[d] && (c = !1);
    }), c && l.push(t[_c(u.props)]);
  }), l;
};
function Ro(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const sh = xl(), uh = (e) => e.charAt(0).toLowerCase() + e.slice(1);
function ch(e = {}) {
  const {
    defaultTheme: t = sh,
    rootShouldForwardProp: r = Ro,
    slotShouldForwardProp: n = Ro
  } = e, o = (i) => {
    const a = Pr(i.theme) ? t : i.theme;
    return Cl(ae({}, i, {
      theme: a
    }));
  };
  return o.__mui_systemSx = !0, (i, a = {}) => {
    e2(i, (S) => S.filter((w) => !(w != null && w.__mui_systemSx)));
    const {
      name: l,
      slot: s,
      skipVariantsResolver: u,
      skipSx: c,
      overridesResolver: d
    } = a, f = Ze(a, th), v = u !== void 0 ? u : s && s !== "Root" || !1, h = c || !1;
    let m;
    process.env.NODE_ENV !== "production" && l && (m = `${l}-${uh(s || "Root")}`);
    let g = Ro;
    s === "Root" ? g = r : s ? g = n : oh(i) && (g = void 0);
    const C = Qm(i, ae({
      shouldForwardProp: g,
      label: m
    }, f)), x = (S, ...w) => {
      const y = w ? w.map((I) => typeof I == "function" && I.__emotion_real !== I ? (k) => {
        let {
          theme: R
        } = k, A = Ze(k, nh);
        return I(ae({
          theme: Pr(R) ? t : R
        }, A));
      } : I) : [];
      let O = S;
      l && d && y.push((I) => {
        const k = Pr(I.theme) ? t : I.theme, R = ih(l, k);
        if (R) {
          const A = {};
          return Object.entries(R).forEach(([L, B]) => {
            A[L] = typeof B == "function" ? B(ae({}, I, {
              theme: k
            })) : B;
          }), d(I, A);
        }
        return null;
      }), l && !v && y.push((I) => {
        const k = Pr(I.theme) ? t : I.theme;
        return lh(I, ah(l, k), k, l);
      }), h || y.push(o);
      const P = y.length - w.length;
      if (Array.isArray(S) && P > 0) {
        const I = new Array(P).fill("");
        O = [...S, ...I], O.raw = [...S.raw, ...I];
      } else
        typeof S == "function" && S.__emotion_real !== S && (O = (I) => {
          let {
            theme: k
          } = I, R = Ze(I, rh);
          return S(ae({
            theme: Pr(k) ? t : k
          }, R));
        });
      const M = C(O, ...y);
      if (process.env.NODE_ENV !== "production") {
        let I;
        l && (I = `${l}${s || ""}`), I === void 0 && (I = `Styled(${cv(i)})`), M.displayName = I;
      }
      return M;
    };
    return C.withConfig && (x.withConfig = C.withConfig), x;
  };
}
function dh(e) {
  const {
    theme: t,
    name: r,
    props: n
  } = e;
  return !t || !t.components || !t.components[r] || !t.components[r].defaultProps ? n : bc(t.components[r].defaultProps, n);
}
function fh({
  props: e,
  name: t,
  defaultTheme: r
}) {
  const n = kc(r);
  return dh({
    theme: n,
    name: t,
    props: e
  });
}
function wl(e, t = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > r) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${r}].`), Math.min(Math.max(t, e), r);
}
function ph(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(t);
  return r && r[0].length === 1 && (r = r.map((n) => n + n)), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Gn(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Gn(ph(e));
  const t = e.indexOf("("), r = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(r) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : cr(9, e));
  let n = e.substring(t + 1, e.length - 1), o;
  if (r === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(o) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : cr(10, o));
  } else
    n = n.split(",");
  return n = n.map((i) => parseFloat(i)), {
    type: r,
    values: n,
    colorSpace: o
  };
}
function xi(e) {
  const {
    type: t,
    colorSpace: r
  } = e;
  let {
    values: n
  } = e;
  return t.indexOf("rgb") !== -1 ? n = n.map((o, i) => i < 3 ? parseInt(o, 10) : o) : t.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.indexOf("color") !== -1 ? n = `${r} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function gh(e) {
  e = Gn(e);
  const {
    values: t
  } = e, r = t[0], n = t[1] / 100, o = t[2] / 100, i = n * Math.min(o, 1 - o), a = (u, c = (u + r / 30) % 12) => o - i * Math.max(Math.min(c - 3, 9 - c, 1), -1);
  let l = "rgb";
  const s = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (l += "a", s.push(t[3])), xi({
    type: l,
    values: s
  });
}
function ks(e) {
  e = Gn(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Gn(gh(e)).values : e.values;
  return t = t.map((r) => (e.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function _s(e, t) {
  const r = ks(e), n = ks(t);
  return (Math.max(r, n) + 0.05) / (Math.min(r, n) + 0.05);
}
function _n(e, t) {
  return e = Gn(e), t = wl(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, xi(e);
}
function vh(e, t) {
  if (e = Gn(e), t = wl(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] *= 1 - t;
  return xi(e);
}
function mh(e, t) {
  if (e = Gn(e), t = wl(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (1 - e.values[r]) * t;
  return xi(e);
}
function hh(e, t) {
  return ae({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
const bh = {
  black: "#000",
  white: "#fff"
}, qr = bh, yh = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Ch = yh, xh = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Kn = xh, wh = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Xn = wh, Sh = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Ir = Sh, Rh = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Jn = Rh, Eh = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Qn = Eh, Oh = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, er = Oh, Ph = ["mode", "contrastThreshold", "tonalOffset"], Fs = {
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: qr.white,
    default: qr.white
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, Yi = {
  text: {
    primary: qr.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: qr.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function Ns(e, t, r, n) {
  const o = n.light || n, i = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : t === "light" ? e.light = mh(e.main, o) : t === "dark" && (e.dark = vh(e.main, i)));
}
function Ih(e = "light") {
  return e === "dark" ? {
    main: Jn[200],
    light: Jn[50],
    dark: Jn[400]
  } : {
    main: Jn[700],
    light: Jn[400],
    dark: Jn[800]
  };
}
function Th(e = "light") {
  return e === "dark" ? {
    main: Kn[200],
    light: Kn[50],
    dark: Kn[400]
  } : {
    main: Kn[500],
    light: Kn[300],
    dark: Kn[700]
  };
}
function $h(e = "light") {
  return e === "dark" ? {
    main: Xn[500],
    light: Xn[300],
    dark: Xn[700]
  } : {
    main: Xn[700],
    light: Xn[400],
    dark: Xn[800]
  };
}
function Mh(e = "light") {
  return e === "dark" ? {
    main: Qn[400],
    light: Qn[300],
    dark: Qn[700]
  } : {
    main: Qn[700],
    light: Qn[500],
    dark: Qn[900]
  };
}
function Lh(e = "light") {
  return e === "dark" ? {
    main: er[400],
    light: er[300],
    dark: er[700]
  } : {
    main: er[800],
    light: er[500],
    dark: er[900]
  };
}
function Ah(e = "light") {
  return e === "dark" ? {
    main: Ir[400],
    light: Ir[300],
    dark: Ir[700]
  } : {
    main: "#ed6c02",
    light: Ir[500],
    dark: Ir[900]
  };
}
function kh(e) {
  const {
    mode: t = "light",
    contrastThreshold: r = 3,
    tonalOffset: n = 0.2
  } = e, o = Ze(e, Ph), i = e.primary || Ih(t), a = e.secondary || Th(t), l = e.error || $h(t), s = e.info || Mh(t), u = e.success || Lh(t), c = e.warning || Ah(t);
  function d(m) {
    const g = _s(m, Yi.text.primary) >= r ? Yi.text.primary : Fs.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const C = _s(m, g);
      C < 3 && console.error([`MUI: The contrast ratio of ${C}:1 for ${g} on ${m}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return g;
  }
  const f = ({
    color: m,
    name: g,
    mainShade: C = 500,
    lightShade: x = 300,
    darkShade: S = 700
  }) => {
    if (m = ae({}, m), !m.main && m[C] && (m.main = m[C]), !m.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${g ? ` (${g})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${C}\` property.` : cr(11, g ? ` (${g})` : "", C));
    if (typeof m.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${g ? ` (${g})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(m.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : cr(12, g ? ` (${g})` : "", JSON.stringify(m.main)));
    return Ns(m, "light", x, n), Ns(m, "dark", S, n), m.contrastText || (m.contrastText = d(m.main)), m;
  }, v = {
    dark: Yi,
    light: Fs
  };
  return process.env.NODE_ENV !== "production" && (v[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), tn(ae({
    common: ae({}, qr),
    mode: t,
    primary: f({
      color: i,
      name: "primary"
    }),
    secondary: f({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    error: f({
      color: l,
      name: "error"
    }),
    warning: f({
      color: c,
      name: "warning"
    }),
    info: f({
      color: s,
      name: "info"
    }),
    success: f({
      color: u,
      name: "success"
    }),
    grey: Ch,
    contrastThreshold: r,
    getContrastText: d,
    augmentColor: f,
    tonalOffset: n
  }, v[t]), o);
}
const _h = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function Fh(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Vs = {
  textTransform: "uppercase"
}, Ds = '"Roboto", "Helvetica", "Arial", sans-serif';
function Nh(e, t) {
  const r = typeof t == "function" ? t(e) : t, {
    fontFamily: n = Ds,
    fontSize: o = 14,
    fontWeightLight: i = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: l = 500,
    fontWeightBold: s = 700,
    htmlFontSize: u = 16,
    allVariants: c,
    pxToRem: d
  } = r, f = Ze(r, _h);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof u != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const v = o / 14, h = d || ((C) => `${C / u * v}rem`), m = (C, x, S, w, y) => ae({
    fontFamily: n,
    fontWeight: C,
    fontSize: h(x),
    lineHeight: S
  }, n === Ds ? {
    letterSpacing: `${Fh(w / x)}em`
  } : {}, y, c), g = {
    h1: m(i, 96, 1.167, -1.5),
    h2: m(i, 60, 1.2, -0.5),
    h3: m(a, 48, 1.167, 0),
    h4: m(a, 34, 1.235, 0.25),
    h5: m(a, 24, 1.334, 0),
    h6: m(l, 20, 1.6, 0.15),
    subtitle1: m(a, 16, 1.75, 0.15),
    subtitle2: m(l, 14, 1.57, 0.1),
    body1: m(a, 16, 1.5, 0.15),
    body2: m(a, 14, 1.43, 0.15),
    button: m(l, 14, 1.75, 0.4, Vs),
    caption: m(a, 12, 1.66, 0.4),
    overline: m(a, 12, 2.66, 1, Vs),
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return tn(ae({
    htmlFontSize: u,
    pxToRem: h,
    fontFamily: n,
    fontSize: o,
    fontWeightLight: i,
    fontWeightRegular: a,
    fontWeightMedium: l,
    fontWeightBold: s
  }, g), f, {
    clone: !1
  });
}
const Vh = 0.2, Dh = 0.14, Hh = 0.12;
function We(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Vh})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Dh})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Hh})`].join(",");
}
const zh = ["none", We(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), We(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), We(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), We(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), We(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), We(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), We(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), We(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), We(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), We(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), We(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), We(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), We(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), We(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), We(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), We(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), We(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), We(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), We(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), We(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), We(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), We(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), We(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), We(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], Bh = zh, jh = ["duration", "easing", "delay"], Gh = {
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Uh = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195
};
function Hs(e) {
  return `${Math.round(e)}ms`;
}
function Wh(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function Zh(e) {
  const t = ae({}, Gh, e.easing), r = ae({}, Uh, e.duration);
  return ae({
    getAutoHeightDuration: Wh,
    create: (o = ["all"], i = {}) => {
      const {
        duration: a = r.standard,
        easing: l = t.easeInOut,
        delay: s = 0
      } = i, u = Ze(i, jh);
      if (process.env.NODE_ENV !== "production") {
        const c = (f) => typeof f == "string", d = (f) => !isNaN(parseFloat(f));
        !c(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !d(a) && !c(a) && console.error(`MUI: Argument "duration" must be a number or a string but found ${a}.`), c(l) || console.error('MUI: Argument "easing" must be a string.'), !d(s) && !c(s) && console.error('MUI: Argument "delay" must be a number or a string.'), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((c) => `${c} ${typeof a == "string" ? a : Hs(a)} ${l} ${typeof s == "string" ? s : Hs(s)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: r
  });
}
const qh = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Yh = qh, Kh = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Xh(e = {}, ...t) {
  const {
    mixins: r = {},
    palette: n = {},
    transitions: o = {},
    typography: i = {}
  } = e, a = Ze(e, Kh);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : cr(18));
  const l = kh(n), s = xl(e);
  let u = tn(s, {
    mixins: hh(s.breakpoints, r),
    palette: l,
    shadows: Bh.slice(),
    typography: Nh(l, i),
    transitions: Zh(o),
    zIndex: ae({}, Yh)
  });
  if (u = tn(u, a), u = t.reduce((c, d) => tn(c, d), u), process.env.NODE_ENV !== "production") {
    const c = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], d = (f, v) => {
      let h;
      for (h in f) {
        const m = f[h];
        if (c.indexOf(h) !== -1 && Object.keys(m).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const g = Rn("", h);
            console.error([`MUI: The \`${v}\` component increases the CSS specificity of the \`${h}\` internal state.`, "You can not override it like this: ", JSON.stringify(f, null, 2), "", `Instead, you need to use the '&.${g}' syntax:`, JSON.stringify({
              root: {
                [`&.${g}`]: m
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          f[h] = {};
        }
      }
    };
    Object.keys(u.components).forEach((f) => {
      const v = u.components[f].styleOverrides;
      v && f.indexOf("Mui") === 0 && d(v, f);
    });
  }
  return u.unstable_sxConfig = ae({}, yl, a == null ? void 0 : a.unstable_sxConfig), u.unstable_sx = function(d) {
    return Cl({
      sx: d,
      theme: this
    });
  }, u;
}
const Jh = Xh(), Sl = Jh, Fc = (e) => Ro(e) && e !== "classes", Qh = ch({
  defaultTheme: Sl,
  rootShouldForwardProp: Fc
}), Pn = Qh;
function Wn({
  props: e,
  name: t
}) {
  return fh({
    props: e,
    name: t,
    defaultTheme: Sl
  });
}
function e5(e) {
  return Rn("MuiButtonGroup", e);
}
const t5 = Kt("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "fullWidth", "vertical", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary"]), pn = t5, Nc = /* @__PURE__ */ N.createContext({});
process.env.NODE_ENV !== "production" && (Nc.displayName = "ButtonGroupContext");
const n5 = Nc, r5 = ["children", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"], o5 = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [{
    [`& .${pn.grouped}`]: t.grouped
  }, {
    [`& .${pn.grouped}`]: t[`grouped${at(r.orientation)}`]
  }, {
    [`& .${pn.grouped}`]: t[`grouped${at(r.variant)}`]
  }, {
    [`& .${pn.grouped}`]: t[`grouped${at(r.variant)}${at(r.orientation)}`]
  }, {
    [`& .${pn.grouped}`]: t[`grouped${at(r.variant)}${at(r.color)}`]
  }, t.root, t[r.variant], r.disableElevation === !0 && t.disableElevation, r.fullWidth && t.fullWidth, r.orientation === "vertical" && t.vertical];
}, i5 = (e) => {
  const {
    classes: t,
    color: r,
    disabled: n,
    disableElevation: o,
    fullWidth: i,
    orientation: a,
    variant: l
  } = e, s = {
    root: ["root", l, a === "vertical" && "vertical", i && "fullWidth", o && "disableElevation"],
    grouped: ["grouped", `grouped${at(a)}`, `grouped${at(l)}`, `grouped${at(l)}${at(a)}`, `grouped${at(l)}${at(r)}`, n && "disabled"]
  };
  return yr(s, e5, t);
}, a5 = Pn("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: o5
})(({
  theme: e,
  ownerState: t
}) => ae({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius
}, t.variant === "contained" && {
  boxShadow: (e.vars || e).shadows[2]
}, t.disableElevation && {
  boxShadow: "none"
}, t.fullWidth && {
  width: "100%"
}, t.orientation === "vertical" && {
  flexDirection: "column"
}, {
  [`& .${pn.grouped}`]: ae({
    minWidth: 40,
    "&:not(:first-of-type)": ae({}, t.orientation === "horizontal" && {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    }, t.orientation === "vertical" && {
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0
    }, t.variant === "outlined" && t.orientation === "horizontal" && {
      marginLeft: -1
    }, t.variant === "outlined" && t.orientation === "vertical" && {
      marginTop: -1
    }),
    "&:not(:last-of-type)": ae({}, t.orientation === "horizontal" && {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }, t.orientation === "vertical" && {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0
    }, t.variant === "text" && t.orientation === "horizontal" && {
      borderRight: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`
    }, t.variant === "text" && t.orientation === "vertical" && {
      borderBottom: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`
    }, t.variant === "text" && t.color !== "inherit" && {
      borderColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : _n(e.palette[t.color].main, 0.5)
    }, t.variant === "outlined" && t.orientation === "horizontal" && {
      borderRightColor: "transparent"
    }, t.variant === "outlined" && t.orientation === "vertical" && {
      borderBottomColor: "transparent"
    }, t.variant === "contained" && t.orientation === "horizontal" && {
      borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
      [`&.${pn.disabled}`]: {
        borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
      }
    }, t.variant === "contained" && t.orientation === "vertical" && {
      borderBottom: `1px solid ${(e.vars || e).palette.grey[400]}`,
      [`&.${pn.disabled}`]: {
        borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
      }
    }, t.variant === "contained" && t.color !== "inherit" && {
      borderColor: (e.vars || e).palette[t.color].dark
    }, {
      "&:hover": ae({}, t.variant === "outlined" && t.orientation === "horizontal" && {
        borderRightColor: "currentColor"
      }, t.variant === "outlined" && t.orientation === "vertical" && {
        borderBottomColor: "currentColor"
      })
    }),
    "&:hover": ae({}, t.variant === "contained" && {
      boxShadow: "none"
    })
  }, t.variant === "contained" && {
    boxShadow: "none"
  })
})), Vc = /* @__PURE__ */ N.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiButtonGroup"
  }), {
    children: o,
    className: i,
    color: a = "primary",
    component: l = "div",
    disabled: s = !1,
    disableElevation: u = !1,
    disableFocusRipple: c = !1,
    disableRipple: d = !1,
    fullWidth: f = !1,
    orientation: v = "horizontal",
    size: h = "medium",
    variant: m = "outlined"
  } = n, g = Ze(n, r5), C = ae({}, n, {
    color: a,
    component: l,
    disabled: s,
    disableElevation: u,
    disableFocusRipple: c,
    disableRipple: d,
    fullWidth: f,
    orientation: v,
    size: h,
    variant: m
  }), x = i5(C), S = N.useMemo(() => ({
    className: x.grouped,
    color: a,
    disabled: s,
    disableElevation: u,
    disableFocusRipple: c,
    disableRipple: d,
    fullWidth: f,
    size: h,
    variant: m
  }), [a, s, u, c, d, f, h, m, x.grouped]);
  return /* @__PURE__ */ p(a5, ae({
    as: l,
    role: "group",
    className: q(x.root, i),
    ref: r,
    ownerState: C
  }, g, {
    children: /* @__PURE__ */ p(n5.Provider, {
      value: S,
      children: o
    })
  }));
});
process.env.NODE_ENV !== "production" && (Vc.propTypes = {
  children: b.exports.node,
  classes: b.exports.object,
  className: b.exports.string,
  color: b.exports.oneOfType([b.exports.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), b.exports.string]),
  component: b.exports.elementType,
  disabled: b.exports.bool,
  disableElevation: b.exports.bool,
  disableFocusRipple: b.exports.bool,
  disableRipple: b.exports.bool,
  fullWidth: b.exports.bool,
  orientation: b.exports.oneOf(["horizontal", "vertical"]),
  size: b.exports.oneOfType([b.exports.oneOf(["small", "medium", "large"]), b.exports.string]),
  sx: b.exports.oneOfType([b.exports.arrayOf(b.exports.oneOfType([b.exports.func, b.exports.object, b.exports.bool])), b.exports.func, b.exports.object]),
  variant: b.exports.oneOfType([b.exports.oneOf(["contained", "outlined", "text"]), b.exports.string])
});
const l5 = Vc;
function ba(e, t) {
  return ba = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, ba(e, t);
}
function Dc(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ba(e, t);
}
const zs = {
  disabled: !1
};
var s5 = process.env.NODE_ENV !== "production" ? b.exports.oneOfType([b.exports.number, b.exports.shape({
  enter: b.exports.number,
  exit: b.exports.number,
  appear: b.exports.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && b.exports.oneOfType([b.exports.string, b.exports.shape({
  enter: b.exports.string,
  exit: b.exports.string,
  active: b.exports.string
}), b.exports.shape({
  enter: b.exports.string,
  enterDone: b.exports.string,
  enterActive: b.exports.string,
  exit: b.exports.string,
  exitDone: b.exports.string,
  exitActive: b.exports.string
})]);
const Bo = K.createContext(null);
var u5 = function(t) {
  return t.scrollTop;
}, Ar = "unmounted", Mn = "exited", Ln = "entering", rr = "entered", ya = "exiting", an = /* @__PURE__ */ function(e) {
  Dc(t, e);
  function t(n, o) {
    var i;
    i = e.call(this, n, o) || this;
    var a = o, l = a && !a.isMounting ? n.enter : n.appear, s;
    return i.appearStatus = null, n.in ? l ? (s = Mn, i.appearStatus = Ln) : s = rr : n.unmountOnExit || n.mountOnEnter ? s = Ar : s = Mn, i.state = {
      status: s
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(o, i) {
    var a = o.in;
    return a && i.status === Ar ? {
      status: Mn
    } : null;
  };
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, r.componentDidUpdate = function(o) {
    var i = null;
    if (o !== this.props) {
      var a = this.state.status;
      this.props.in ? a !== Ln && a !== rr && (i = Ln) : (a === Ln || a === rr) && (i = ya);
    }
    this.updateStatus(!1, i);
  }, r.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, r.getTimeouts = function() {
    var o = this.props.timeout, i, a, l;
    return i = a = l = o, o != null && typeof o != "number" && (i = o.exit, a = o.enter, l = o.appear !== void 0 ? o.appear : a), {
      exit: i,
      enter: a,
      appear: l
    };
  }, r.updateStatus = function(o, i) {
    if (o === void 0 && (o = !1), i !== null)
      if (this.cancelNextCallback(), i === Ln) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var a = this.props.nodeRef ? this.props.nodeRef.current : vo.findDOMNode(this);
          a && u5(a);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === Mn && this.setState({
        status: Ar
      });
  }, r.performEnter = function(o) {
    var i = this, a = this.props.enter, l = this.context ? this.context.isMounting : o, s = this.props.nodeRef ? [l] : [vo.findDOMNode(this), l], u = s[0], c = s[1], d = this.getTimeouts(), f = l ? d.appear : d.enter;
    if (!o && !a || zs.disabled) {
      this.safeSetState({
        status: rr
      }, function() {
        i.props.onEntered(u);
      });
      return;
    }
    this.props.onEnter(u, c), this.safeSetState({
      status: Ln
    }, function() {
      i.props.onEntering(u, c), i.onTransitionEnd(f, function() {
        i.safeSetState({
          status: rr
        }, function() {
          i.props.onEntered(u, c);
        });
      });
    });
  }, r.performExit = function() {
    var o = this, i = this.props.exit, a = this.getTimeouts(), l = this.props.nodeRef ? void 0 : vo.findDOMNode(this);
    if (!i || zs.disabled) {
      this.safeSetState({
        status: Mn
      }, function() {
        o.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: ya
    }, function() {
      o.props.onExiting(l), o.onTransitionEnd(a.exit, function() {
        o.safeSetState({
          status: Mn
        }, function() {
          o.props.onExited(l);
        });
      });
    });
  }, r.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, r.safeSetState = function(o, i) {
    i = this.setNextCallback(i), this.setState(o, i);
  }, r.setNextCallback = function(o) {
    var i = this, a = !0;
    return this.nextCallback = function(l) {
      a && (a = !1, i.nextCallback = null, o(l));
    }, this.nextCallback.cancel = function() {
      a = !1;
    }, this.nextCallback;
  }, r.onTransitionEnd = function(o, i) {
    this.setNextCallback(i);
    var a = this.props.nodeRef ? this.props.nodeRef.current : vo.findDOMNode(this), l = o == null && !this.props.addEndListener;
    if (!a || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var s = this.props.nodeRef ? [this.nextCallback] : [a, this.nextCallback], u = s[0], c = s[1];
      this.props.addEndListener(u, c);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, r.render = function() {
    var o = this.state.status;
    if (o === Ar)
      return null;
    var i = this.props, a = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var l = Ze(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /* @__PURE__ */ p(Bo.Provider, {
      value: null,
      children: typeof a == "function" ? a(o, l) : K.cloneElement(K.Children.only(a), l)
    });
  }, t;
}(K.Component);
an.contextType = Bo;
an.propTypes = process.env.NODE_ENV !== "production" ? {
  nodeRef: b.exports.shape({
    current: typeof Element > "u" ? b.exports.any : function(e, t, r, n, o, i) {
      var a = e[t];
      return b.exports.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(e, t, r, n, o, i);
    }
  }),
  children: b.exports.oneOfType([b.exports.func.isRequired, b.exports.element.isRequired]).isRequired,
  in: b.exports.bool,
  mountOnEnter: b.exports.bool,
  unmountOnExit: b.exports.bool,
  appear: b.exports.bool,
  enter: b.exports.bool,
  exit: b.exports.bool,
  timeout: function(t) {
    var r = s5;
    t.addEndListener || (r = r.isRequired);
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      o[i - 1] = arguments[i];
    return r.apply(void 0, [t].concat(o));
  },
  addEndListener: b.exports.func,
  onEnter: b.exports.func,
  onEntering: b.exports.func,
  onEntered: b.exports.func,
  onExit: b.exports.func,
  onExiting: b.exports.func,
  onExited: b.exports.func
} : {};
function tr() {
}
an.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: tr,
  onEntering: tr,
  onEntered: tr,
  onExit: tr,
  onExiting: tr,
  onExited: tr
};
an.UNMOUNTED = Ar;
an.EXITED = Mn;
an.ENTERING = Ln;
an.ENTERED = rr;
an.EXITING = ya;
const c5 = an;
function d5(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Rl(e, t) {
  var r = function(i) {
    return t && kr(i) ? t(i) : i;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && cd.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    n[o.key] = r(o);
  }), n;
}
function f5(e, t) {
  e = e || {}, t = t || {};
  function r(c) {
    return c in t ? t[c] : e[c];
  }
  var n = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in e)
    i in t ? o.length && (n[i] = o, o = []) : o.push(i);
  var a, l = {};
  for (var s in t) {
    if (n[s])
      for (a = 0; a < n[s].length; a++) {
        var u = n[s][a];
        l[n[s][a]] = r(u);
      }
    l[s] = r(s);
  }
  for (a = 0; a < o.length; a++)
    l[o[a]] = r(o[a]);
  return l;
}
function Fn(e, t, r) {
  return r[t] != null ? r[t] : e.props[t];
}
function p5(e, t) {
  return Rl(e.children, function(r) {
    return _r(r, {
      onExited: t.bind(null, r),
      in: !0,
      appear: Fn(r, "appear", e),
      enter: Fn(r, "enter", e),
      exit: Fn(r, "exit", e)
    });
  });
}
function g5(e, t, r) {
  var n = Rl(e.children), o = f5(t, n);
  return Object.keys(o).forEach(function(i) {
    var a = o[i];
    if (!!kr(a)) {
      var l = i in t, s = i in n, u = t[i], c = kr(u) && !u.props.in;
      s && (!l || c) ? o[i] = _r(a, {
        onExited: r.bind(null, a),
        in: !0,
        exit: Fn(a, "exit", e),
        enter: Fn(a, "enter", e)
      }) : !s && l && !c ? o[i] = _r(a, {
        in: !1
      }) : s && l && kr(u) && (o[i] = _r(a, {
        onExited: r.bind(null, a),
        in: u.props.in,
        exit: Fn(a, "exit", e),
        enter: Fn(a, "enter", e)
      }));
    }
  }), o;
}
var v5 = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, m5 = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, El = /* @__PURE__ */ function(e) {
  Dc(t, e);
  function t(n, o) {
    var i;
    i = e.call(this, n, o) || this;
    var a = i.handleExited.bind(d5(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, i;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, r.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, i) {
    var a = i.children, l = i.handleExited, s = i.firstRender;
    return {
      children: s ? p5(o, l) : g5(o, a, l),
      firstRender: !1
    };
  }, r.handleExited = function(o, i) {
    var a = Rl(this.props.children);
    o.key in a || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(l) {
      var s = ae({}, l.children);
      return delete s[o.key], {
        children: s
      };
    }));
  }, r.render = function() {
    var o = this.props, i = o.component, a = o.childFactory, l = Ze(o, ["component", "childFactory"]), s = this.state.contextValue, u = v5(this.state.children).map(a);
    return delete l.appear, delete l.enter, delete l.exit, i === null ? /* @__PURE__ */ p(Bo.Provider, {
      value: s,
      children: u
    }) : /* @__PURE__ */ p(Bo.Provider, {
      value: s,
      children: /* @__PURE__ */ p(i, {
        ...l,
        children: u
      })
    });
  }, t;
}(K.Component);
El.propTypes = process.env.NODE_ENV !== "production" ? {
  component: b.exports.any,
  children: b.exports.node,
  appear: b.exports.bool,
  enter: b.exports.bool,
  exit: b.exports.bool,
  childFactory: b.exports.func
} : {};
El.defaultProps = m5;
const h5 = El;
function Hc() {
  const e = kc(Sl);
  return process.env.NODE_ENV !== "production" && N.useDebugValue(e), e;
}
const b5 = (e) => e.scrollTop;
function Bs(e, t) {
  var r, n;
  const {
    timeout: o,
    easing: i,
    style: a = {}
  } = e;
  return {
    duration: (r = a.transitionDuration) != null ? r : typeof o == "number" ? o : o[t.mode] || 0,
    easing: (n = a.transitionTimingFunction) != null ? n : typeof i == "object" ? i[t.mode] : i,
    delay: a.transitionDelay
  };
}
const y5 = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function Ca(e) {
  return `scale(${e}, ${e ** 2})`;
}
const C5 = {
  entering: {
    opacity: 1,
    transform: Ca(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Ki = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Ol = /* @__PURE__ */ N.forwardRef(function(t, r) {
  const {
    addEndListener: n,
    appear: o = !0,
    children: i,
    easing: a,
    in: l,
    onEnter: s,
    onEntered: u,
    onEntering: c,
    onExit: d,
    onExited: f,
    onExiting: v,
    style: h,
    timeout: m = "auto",
    TransitionComponent: g = c5
  } = t, C = Ze(t, y5), x = N.useRef(), S = N.useRef(), w = Hc(), y = N.useRef(null), O = Wt(y, i.ref, r), P = (W) => (U) => {
    if (W) {
      const X = y.current;
      U === void 0 ? W(X) : W(X, U);
    }
  }, M = P(c), I = P((W, U) => {
    b5(W);
    const {
      duration: X,
      delay: D,
      easing: le
    } = Bs({
      style: h,
      timeout: m,
      easing: a
    }, {
      mode: "enter"
    });
    let T;
    m === "auto" ? (T = w.transitions.getAutoHeightDuration(W.clientHeight), S.current = T) : T = X, W.style.transition = [w.transitions.create("opacity", {
      duration: T,
      delay: D
    }), w.transitions.create("transform", {
      duration: Ki ? T : T * 0.666,
      delay: D,
      easing: le
    })].join(","), s && s(W, U);
  }), k = P(u), R = P(v), A = P((W) => {
    const {
      duration: U,
      delay: X,
      easing: D
    } = Bs({
      style: h,
      timeout: m,
      easing: a
    }, {
      mode: "exit"
    });
    let le;
    m === "auto" ? (le = w.transitions.getAutoHeightDuration(W.clientHeight), S.current = le) : le = U, W.style.transition = [w.transitions.create("opacity", {
      duration: le,
      delay: X
    }), w.transitions.create("transform", {
      duration: Ki ? le : le * 0.666,
      delay: Ki ? X : X || le * 0.333,
      easing: D
    })].join(","), W.style.opacity = 0, W.style.transform = Ca(0.75), d && d(W);
  }), L = P(f), B = (W) => {
    m === "auto" && (x.current = setTimeout(W, S.current || 0)), n && n(y.current, W);
  };
  return N.useEffect(() => () => {
    clearTimeout(x.current);
  }, []), /* @__PURE__ */ p(g, ae({
    appear: o,
    in: l,
    nodeRef: y,
    onEnter: I,
    onEntered: k,
    onEntering: M,
    onExit: A,
    onExited: L,
    onExiting: R,
    addEndListener: B,
    timeout: m === "auto" ? null : m
  }, C, {
    children: (W, U) => /* @__PURE__ */ N.cloneElement(i, ae({
      style: ae({
        opacity: 0,
        transform: Ca(0.75),
        visibility: W === "exited" && !l ? "hidden" : void 0
      }, C5[W], h, i.props.style),
      ref: O
    }, U))
  }));
});
process.env.NODE_ENV !== "production" && (Ol.propTypes = {
  addEndListener: b.exports.func,
  appear: b.exports.bool,
  children: pc.isRequired,
  easing: b.exports.oneOfType([b.exports.shape({
    enter: b.exports.string,
    exit: b.exports.string
  }), b.exports.string]),
  in: b.exports.bool,
  onEnter: b.exports.func,
  onEntered: b.exports.func,
  onEntering: b.exports.func,
  onExit: b.exports.func,
  onExited: b.exports.func,
  onExiting: b.exports.func,
  style: b.exports.object,
  timeout: b.exports.oneOfType([b.exports.oneOf(["auto"]), b.exports.number, b.exports.shape({
    appear: b.exports.number,
    enter: b.exports.number,
    exit: b.exports.number
  })])
});
Ol.muiSupportAuto = !0;
const x5 = Ol, w5 = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
}, js = w5;
function S5(e) {
  return Rn("MuiPaper", e);
}
Kt("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const R5 = ["className", "component", "elevation", "square", "variant"], E5 = (e) => {
  const {
    square: t,
    elevation: r,
    variant: n,
    classes: o
  } = e, i = {
    root: ["root", n, !t && "rounded", n === "elevation" && `elevation${r}`]
  };
  return yr(i, S5, o);
}, O5 = Pn("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], !r.square && t.rounded, r.variant === "elevation" && t[`elevation${r.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var r;
  return ae({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && ae({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${_n("#fff", js(t.elevation))}, ${_n("#fff", js(t.elevation))})`
  }, e.vars && {
    backgroundImage: (r = e.vars.overlays) == null ? void 0 : r[t.elevation]
  }));
}), zc = /* @__PURE__ */ N.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiPaper"
  }), {
    className: o,
    component: i = "div",
    elevation: a = 1,
    square: l = !1,
    variant: s = "elevation"
  } = n, u = Ze(n, R5), c = ae({}, n, {
    component: i,
    elevation: a,
    square: l,
    variant: s
  }), d = E5(c);
  return process.env.NODE_ENV !== "production" && Hc().shadows[a] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${a}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${a}]\` is defined.`].join(`
`)), /* @__PURE__ */ p(O5, ae({
    as: i,
    ownerState: c,
    className: q(d.root, o),
    ref: r
  }, u));
});
process.env.NODE_ENV !== "production" && (zc.propTypes = {
  children: b.exports.node,
  classes: b.exports.object,
  className: b.exports.string,
  component: b.exports.elementType,
  elevation: so(Rv, (e) => {
    const {
      elevation: t,
      variant: r
    } = e;
    return t > 0 && r === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${r}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  square: b.exports.bool,
  sx: b.exports.oneOfType([b.exports.arrayOf(b.exports.oneOfType([b.exports.func, b.exports.object, b.exports.bool])), b.exports.func, b.exports.object]),
  variant: b.exports.oneOfType([b.exports.oneOf(["elevation", "outlined"]), b.exports.string])
});
const P5 = zc, I5 = ["components", "componentsProps", "slots", "slotProps"], T5 = Pn(Jm, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Bc = /* @__PURE__ */ N.forwardRef(function(t, r) {
  var n;
  const o = Ac(), i = Wn({
    props: t,
    name: "MuiPopper"
  }), {
    components: a,
    componentsProps: l,
    slots: s,
    slotProps: u
  } = i, c = Ze(i, I5), d = (n = s == null ? void 0 : s.root) != null ? n : a == null ? void 0 : a.Root;
  return /* @__PURE__ */ p(T5, ae({
    direction: o == null ? void 0 : o.direction,
    slots: {
      root: d
    },
    slotProps: u != null ? u : l
  }, c, {
    ref: r
  }));
});
process.env.NODE_ENV !== "production" && (Bc.propTypes = {
  anchorEl: b.exports.oneOfType([Ur, b.exports.object, b.exports.func]),
  children: b.exports.oneOfType([b.exports.node, b.exports.func]),
  component: b.exports.elementType,
  components: b.exports.shape({
    Root: b.exports.elementType
  }),
  componentsProps: b.exports.shape({
    root: b.exports.oneOfType([b.exports.func, b.exports.object])
  }),
  container: b.exports.oneOfType([Ur, b.exports.func]),
  disablePortal: b.exports.bool,
  keepMounted: b.exports.bool,
  modifiers: b.exports.arrayOf(b.exports.shape({
    data: b.exports.object,
    effect: b.exports.func,
    enabled: b.exports.bool,
    fn: b.exports.func,
    name: b.exports.any,
    options: b.exports.object,
    phase: b.exports.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: b.exports.arrayOf(b.exports.string),
    requiresIfExists: b.exports.arrayOf(b.exports.string)
  })),
  open: b.exports.bool.isRequired,
  ownerState: b.exports.any,
  placement: b.exports.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  popperOptions: b.exports.shape({
    modifiers: b.exports.array,
    onFirstUpdate: b.exports.func,
    placement: b.exports.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: b.exports.oneOf(["absolute", "fixed"])
  }),
  popperRef: cl,
  slotProps: b.exports.shape({
    root: b.exports.oneOfType([b.exports.func, b.exports.object])
  }),
  slots: b.exports.shape({
    root: b.exports.elementType
  }),
  sx: b.exports.oneOfType([b.exports.arrayOf(b.exports.oneOfType([b.exports.func, b.exports.object, b.exports.bool])), b.exports.func, b.exports.object]),
  transition: b.exports.bool
});
const $5 = Bc, jc = /* @__PURE__ */ N.createContext({});
process.env.NODE_ENV !== "production" && (jc.displayName = "ListContext");
const xa = jc;
function Gc(e) {
  const {
    className: t,
    classes: r,
    pulsate: n = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: a,
    in: l,
    onExited: s,
    timeout: u
  } = e, [c, d] = N.useState(!1), f = q(t, r.ripple, r.rippleVisible, n && r.ripplePulsate), v = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + o
  }, h = q(r.child, c && r.childLeaving, n && r.childPulsate);
  return !l && !c && d(!0), N.useEffect(() => {
    if (!l && s != null) {
      const m = setTimeout(s, u);
      return () => {
        clearTimeout(m);
      };
    }
  }, [s, l, u]), /* @__PURE__ */ p("span", {
    className: f,
    style: v,
    children: /* @__PURE__ */ p("span", {
      className: h
    })
  });
}
process.env.NODE_ENV !== "production" && (Gc.propTypes = {
  classes: b.exports.object.isRequired,
  className: b.exports.string,
  in: b.exports.bool,
  onExited: b.exports.func,
  pulsate: b.exports.bool,
  rippleSize: b.exports.number,
  rippleX: b.exports.number,
  rippleY: b.exports.number,
  timeout: b.exports.number.isRequired
});
const M5 = Kt("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Rt = M5, L5 = ["center", "classes", "className"];
let wi = (e) => e, Gs, Us, Ws, Zs;
const wa = 550, A5 = 80, k5 = Ea(Gs || (Gs = wi`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), _5 = Ea(Us || (Us = wi`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), F5 = Ea(Ws || (Ws = wi`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), N5 = Pn("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), V5 = Pn(Gc, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(Zs || (Zs = wi`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), Rt.rippleVisible, k5, wa, ({
  theme: e
}) => e.transitions.easing.easeInOut, Rt.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, Rt.child, Rt.childLeaving, _5, wa, ({
  theme: e
}) => e.transitions.easing.easeInOut, Rt.childPulsate, F5, ({
  theme: e
}) => e.transitions.easing.easeInOut), Uc = /* @__PURE__ */ N.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: i = {},
    className: a
  } = n, l = Ze(n, L5), [s, u] = N.useState([]), c = N.useRef(0), d = N.useRef(null);
  N.useEffect(() => {
    d.current && (d.current(), d.current = null);
  }, [s]);
  const f = N.useRef(!1), v = N.useRef(null), h = N.useRef(null), m = N.useRef(null);
  N.useEffect(() => () => {
    clearTimeout(v.current);
  }, []);
  const g = N.useCallback((w) => {
    const {
      pulsate: y,
      rippleX: O,
      rippleY: P,
      rippleSize: M,
      cb: I
    } = w;
    u((k) => [...k, /* @__PURE__ */ p(V5, {
      classes: {
        ripple: q(i.ripple, Rt.ripple),
        rippleVisible: q(i.rippleVisible, Rt.rippleVisible),
        ripplePulsate: q(i.ripplePulsate, Rt.ripplePulsate),
        child: q(i.child, Rt.child),
        childLeaving: q(i.childLeaving, Rt.childLeaving),
        childPulsate: q(i.childPulsate, Rt.childPulsate)
      },
      timeout: wa,
      pulsate: y,
      rippleX: O,
      rippleY: P,
      rippleSize: M
    }, c.current)]), c.current += 1, d.current = I;
  }, [i]), C = N.useCallback((w = {}, y = {}, O = () => {
  }) => {
    const {
      pulsate: P = !1,
      center: M = o || y.pulsate,
      fakeElement: I = !1
    } = y;
    if ((w == null ? void 0 : w.type) === "mousedown" && f.current) {
      f.current = !1;
      return;
    }
    (w == null ? void 0 : w.type) === "touchstart" && (f.current = !0);
    const k = I ? null : m.current, R = k ? k.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let A, L, B;
    if (M || w === void 0 || w.clientX === 0 && w.clientY === 0 || !w.clientX && !w.touches)
      A = Math.round(R.width / 2), L = Math.round(R.height / 2);
    else {
      const {
        clientX: W,
        clientY: U
      } = w.touches && w.touches.length > 0 ? w.touches[0] : w;
      A = Math.round(W - R.left), L = Math.round(U - R.top);
    }
    if (M)
      B = Math.sqrt((2 * R.width ** 2 + R.height ** 2) / 3), B % 2 === 0 && (B += 1);
    else {
      const W = Math.max(Math.abs((k ? k.clientWidth : 0) - A), A) * 2 + 2, U = Math.max(Math.abs((k ? k.clientHeight : 0) - L), L) * 2 + 2;
      B = Math.sqrt(W ** 2 + U ** 2);
    }
    w != null && w.touches ? h.current === null && (h.current = () => {
      g({
        pulsate: P,
        rippleX: A,
        rippleY: L,
        rippleSize: B,
        cb: O
      });
    }, v.current = setTimeout(() => {
      h.current && (h.current(), h.current = null);
    }, A5)) : g({
      pulsate: P,
      rippleX: A,
      rippleY: L,
      rippleSize: B,
      cb: O
    });
  }, [o, g]), x = N.useCallback(() => {
    C({}, {
      pulsate: !0
    });
  }, [C]), S = N.useCallback((w, y) => {
    if (clearTimeout(v.current), (w == null ? void 0 : w.type) === "touchend" && h.current) {
      h.current(), h.current = null, v.current = setTimeout(() => {
        S(w, y);
      });
      return;
    }
    h.current = null, u((O) => O.length > 0 ? O.slice(1) : O), d.current = y;
  }, []);
  return N.useImperativeHandle(r, () => ({
    pulsate: x,
    start: C,
    stop: S
  }), [x, C, S]), /* @__PURE__ */ p(N5, ae({
    className: q(Rt.root, i.root, a),
    ref: m
  }, l, {
    children: /* @__PURE__ */ p(h5, {
      component: null,
      exit: !0,
      children: s
    })
  }));
});
process.env.NODE_ENV !== "production" && (Uc.propTypes = {
  center: b.exports.bool,
  classes: b.exports.object,
  className: b.exports.string
});
const D5 = Uc;
function H5(e) {
  return Rn("MuiButtonBase", e);
}
const z5 = Kt("MuiButtonBase", ["root", "disabled", "focusVisible"]), B5 = z5, j5 = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], G5 = (e) => {
  const {
    disabled: t,
    focusVisible: r,
    focusVisibleClassName: n,
    classes: o
  } = e, a = yr({
    root: ["root", t && "disabled", r && "focusVisible"]
  }, H5, o);
  return r && n && (a.root += ` ${n}`), a;
}, U5 = Pn("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  outline: 0,
  border: 0,
  margin: 0,
  borderRadius: 0,
  padding: 0,
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  WebkitAppearance: "none",
  textDecoration: "none",
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
  },
  [`&.${B5.disabled}`]: {
    pointerEvents: "none",
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Wc = /* @__PURE__ */ N.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: i = !1,
    children: a,
    className: l,
    component: s = "button",
    disabled: u = !1,
    disableRipple: c = !1,
    disableTouchRipple: d = !1,
    focusRipple: f = !1,
    LinkComponent: v = "a",
    onBlur: h,
    onClick: m,
    onContextMenu: g,
    onDragLeave: C,
    onFocus: x,
    onFocusVisible: S,
    onKeyDown: w,
    onKeyUp: y,
    onMouseDown: O,
    onMouseLeave: P,
    onMouseUp: M,
    onTouchEnd: I,
    onTouchMove: k,
    onTouchStart: R,
    tabIndex: A = 0,
    TouchRippleProps: L,
    touchRippleRef: B,
    type: W
  } = n, U = Ze(n, j5), X = N.useRef(null), D = N.useRef(null), le = Wt(D, B), {
    isFocusVisibleRef: T,
    onFocus: j,
    onBlur: z,
    ref: _
  } = yv(), [H, te] = N.useState(!1);
  u && H && te(!1), N.useImperativeHandle(o, () => ({
    focusVisible: () => {
      te(!0), X.current.focus();
    }
  }), []);
  const [re, ue] = N.useState(!1);
  N.useEffect(() => {
    ue(!0);
  }, []);
  const ce = re && !c && !u;
  N.useEffect(() => {
    H && f && !c && re && D.current.pulsate();
  }, [c, f, H, re]);
  function Y(de, Ht, Xt = d) {
    return Lr((In) => (Ht && Ht(In), !Xt && D.current && D.current[de](In), !0));
  }
  const J = Y("start", O), ye = Y("stop", g), Q = Y("stop", C), Ue = Y("stop", M), F = Y("stop", (de) => {
    H && de.preventDefault(), P && P(de);
  }), Ke = Y("start", R), qe = Y("stop", I), ut = Y("stop", k), ln = Y("stop", (de) => {
    z(de), T.current === !1 && te(!1), h && h(de);
  }, !1), Ee = Lr((de) => {
    X.current || (X.current = de.currentTarget), j(de), T.current === !0 && (te(!0), S && S(de)), x && x(de);
  }), Ie = () => {
    const de = X.current;
    return s && s !== "button" && !(de.tagName === "A" && de.href);
  }, Se = N.useRef(!1), et = Lr((de) => {
    f && !Se.current && H && D.current && de.key === " " && (Se.current = !0, D.current.stop(de, () => {
      D.current.start(de);
    })), de.target === de.currentTarget && Ie() && de.key === " " && de.preventDefault(), w && w(de), de.target === de.currentTarget && Ie() && de.key === "Enter" && !u && (de.preventDefault(), m && m(de));
  }), je = Lr((de) => {
    f && de.key === " " && D.current && H && !de.defaultPrevented && (Se.current = !1, D.current.stop(de, () => {
      D.current.pulsate(de);
    })), y && y(de), m && de.target === de.currentTarget && Ie() && de.key === " " && !de.defaultPrevented && m(de);
  });
  let nt = s;
  nt === "button" && (U.href || U.to) && (nt = v);
  const Xe = {};
  nt === "button" ? (Xe.type = W === void 0 ? "button" : W, Xe.disabled = u) : (!U.href && !U.to && (Xe.role = "button"), u && (Xe["aria-disabled"] = u));
  const it = Wt(r, _, X);
  process.env.NODE_ENV !== "production" && N.useEffect(() => {
    ce && !D.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [ce]);
  const ct = ae({}, n, {
    centerRipple: i,
    component: s,
    disabled: u,
    disableRipple: c,
    disableTouchRipple: d,
    focusRipple: f,
    tabIndex: A,
    focusVisible: H
  }), pt = G5(ct);
  return /* @__PURE__ */ G(U5, ae({
    as: nt,
    className: q(pt.root, l),
    ownerState: ct,
    onBlur: ln,
    onClick: m,
    onContextMenu: ye,
    onFocus: Ee,
    onKeyDown: et,
    onKeyUp: je,
    onMouseDown: J,
    onMouseLeave: F,
    onMouseUp: Ue,
    onDragLeave: Q,
    onTouchEnd: qe,
    onTouchMove: ut,
    onTouchStart: Ke,
    ref: it,
    tabIndex: u ? -1 : A,
    type: W
  }, Xe, U, {
    children: [a, ce ? /* @__PURE__ */ p(D5, ae({
      ref: le,
      center: i
    }, L)) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Wc.propTypes = {
  action: cl,
  centerRipple: b.exports.bool,
  children: b.exports.node,
  classes: b.exports.object,
  className: b.exports.string,
  component: ov,
  disabled: b.exports.bool,
  disableRipple: b.exports.bool,
  disableTouchRipple: b.exports.bool,
  focusRipple: b.exports.bool,
  focusVisibleClassName: b.exports.string,
  href: b.exports.any,
  LinkComponent: b.exports.elementType,
  onBlur: b.exports.func,
  onClick: b.exports.func,
  onContextMenu: b.exports.func,
  onDragLeave: b.exports.func,
  onFocus: b.exports.func,
  onFocusVisible: b.exports.func,
  onKeyDown: b.exports.func,
  onKeyUp: b.exports.func,
  onMouseDown: b.exports.func,
  onMouseLeave: b.exports.func,
  onMouseUp: b.exports.func,
  onTouchEnd: b.exports.func,
  onTouchMove: b.exports.func,
  onTouchStart: b.exports.func,
  sx: b.exports.oneOfType([b.exports.arrayOf(b.exports.oneOfType([b.exports.func, b.exports.object, b.exports.bool])), b.exports.func, b.exports.object]),
  tabIndex: b.exports.number,
  TouchRippleProps: b.exports.object,
  touchRippleRef: b.exports.oneOfType([b.exports.func, b.exports.shape({
    current: b.exports.shape({
      pulsate: b.exports.func.isRequired,
      start: b.exports.func.isRequired,
      stop: b.exports.func.isRequired
    })
  })]),
  type: b.exports.oneOfType([b.exports.oneOf(["button", "reset", "submit"]), b.exports.string])
});
const W5 = Wc, Z5 = Kt("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), qs = Z5, q5 = Kt("MuiListItemIcon", ["root", "alignItemsFlexStart"]), Ys = q5, Y5 = Kt("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), Ks = Y5;
function K5(e) {
  return Rn("MuiMenuItem", e);
}
const X5 = Kt("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), Tr = X5, J5 = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], Q5 = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, r.dense && t.dense, r.divider && t.divider, !r.disableGutters && t.gutters];
}, e3 = (e) => {
  const {
    disabled: t,
    dense: r,
    divider: n,
    disableGutters: o,
    selected: i,
    classes: a
  } = e, s = yr({
    root: ["root", r && "dense", t && "disabled", !o && "gutters", n && "divider", i && "selected"]
  }, K5, a);
  return ae({}, a, s);
}, t3 = Pn(W5, {
  shouldForwardProp: (e) => Fc(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: Q5
})(({
  theme: e,
  ownerState: t
}) => ae({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Tr.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _n(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Tr.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _n(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Tr.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : _n(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _n(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Tr.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Tr.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${qs.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${qs.inset}`]: {
    marginLeft: 52
  },
  [`& .${Ks.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${Ks.inset}`]: {
    paddingLeft: 36
  },
  [`& .${Ys.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && ae({
  minHeight: 32,
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${Ys.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), Zc = /* @__PURE__ */ N.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: o = !1,
    component: i = "li",
    dense: a = !1,
    divider: l = !1,
    disableGutters: s = !1,
    focusVisibleClassName: u,
    role: c = "menuitem",
    tabIndex: d,
    className: f
  } = n, v = Ze(n, J5), h = N.useContext(xa), m = N.useMemo(() => ({
    dense: a || h.dense || !1,
    disableGutters: s
  }), [h.dense, a, s]), g = N.useRef(null);
  Bn(() => {
    o && (g.current ? g.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [o]);
  const C = ae({}, n, {
    dense: m.dense,
    divider: l,
    disableGutters: s
  }), x = e3(n), S = Wt(g, r);
  let w;
  return n.disabled || (w = d !== void 0 ? d : -1), /* @__PURE__ */ p(xa.Provider, {
    value: m,
    children: /* @__PURE__ */ p(t3, ae({
      ref: S,
      role: c,
      tabIndex: w,
      component: i,
      focusVisibleClassName: q(x.focusVisible, u),
      className: q(x.root, f)
    }, v, {
      ownerState: C,
      classes: x
    }))
  });
});
process.env.NODE_ENV !== "production" && (Zc.propTypes = {
  autoFocus: b.exports.bool,
  children: b.exports.node,
  classes: b.exports.object,
  className: b.exports.string,
  component: b.exports.elementType,
  dense: b.exports.bool,
  disabled: b.exports.bool,
  disableGutters: b.exports.bool,
  divider: b.exports.bool,
  focusVisibleClassName: b.exports.string,
  role: b.exports.string,
  selected: b.exports.bool,
  sx: b.exports.oneOfType([b.exports.arrayOf(b.exports.oneOfType([b.exports.func, b.exports.object, b.exports.bool])), b.exports.func, b.exports.object]),
  tabIndex: b.exports.number
});
const n3 = Zc;
var qc = { exports: {} }, _e = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xs;
function r3() {
  if (Xs)
    return _e;
  Xs = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), h;
  h = Symbol.for("react.module.reference");
  function m(g) {
    if (typeof g == "object" && g !== null) {
      var C = g.$$typeof;
      switch (C) {
        case e:
          switch (g = g.type, g) {
            case r:
            case o:
            case n:
            case u:
            case c:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case l:
                case a:
                case s:
                case f:
                case d:
                case i:
                  return g;
                default:
                  return C;
              }
          }
        case t:
          return C;
      }
    }
  }
  return _e.ContextConsumer = a, _e.ContextProvider = i, _e.Element = e, _e.ForwardRef = s, _e.Fragment = r, _e.Lazy = f, _e.Memo = d, _e.Portal = t, _e.Profiler = o, _e.StrictMode = n, _e.Suspense = u, _e.SuspenseList = c, _e.isAsyncMode = function() {
    return !1;
  }, _e.isConcurrentMode = function() {
    return !1;
  }, _e.isContextConsumer = function(g) {
    return m(g) === a;
  }, _e.isContextProvider = function(g) {
    return m(g) === i;
  }, _e.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, _e.isForwardRef = function(g) {
    return m(g) === s;
  }, _e.isFragment = function(g) {
    return m(g) === r;
  }, _e.isLazy = function(g) {
    return m(g) === f;
  }, _e.isMemo = function(g) {
    return m(g) === d;
  }, _e.isPortal = function(g) {
    return m(g) === t;
  }, _e.isProfiler = function(g) {
    return m(g) === o;
  }, _e.isStrictMode = function(g) {
    return m(g) === n;
  }, _e.isSuspense = function(g) {
    return m(g) === u;
  }, _e.isSuspenseList = function(g) {
    return m(g) === c;
  }, _e.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === r || g === o || g === n || g === u || g === c || g === v || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === d || g.$$typeof === i || g.$$typeof === a || g.$$typeof === s || g.$$typeof === h || g.getModuleId !== void 0);
  }, _e.typeOf = m, _e;
}
var Fe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Js;
function o3() {
  return Js || (Js = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), h = !1, m = !1, g = !1, C = !1, x = !1, S;
    S = Symbol.for("react.module.reference");
    function w(F) {
      return !!(typeof F == "string" || typeof F == "function" || F === r || F === o || x || F === n || F === u || F === c || C || F === v || h || m || g || typeof F == "object" && F !== null && (F.$$typeof === f || F.$$typeof === d || F.$$typeof === i || F.$$typeof === a || F.$$typeof === s || F.$$typeof === S || F.getModuleId !== void 0));
    }
    function y(F) {
      if (typeof F == "object" && F !== null) {
        var Ke = F.$$typeof;
        switch (Ke) {
          case e:
            var qe = F.type;
            switch (qe) {
              case r:
              case o:
              case n:
              case u:
              case c:
                return qe;
              default:
                var ut = qe && qe.$$typeof;
                switch (ut) {
                  case l:
                  case a:
                  case s:
                  case f:
                  case d:
                  case i:
                    return ut;
                  default:
                    return Ke;
                }
            }
          case t:
            return Ke;
        }
      }
    }
    var O = a, P = i, M = e, I = s, k = r, R = f, A = d, L = t, B = o, W = n, U = u, X = c, D = !1, le = !1;
    function T(F) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(F) {
      return le || (le = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function z(F) {
      return y(F) === a;
    }
    function _(F) {
      return y(F) === i;
    }
    function H(F) {
      return typeof F == "object" && F !== null && F.$$typeof === e;
    }
    function te(F) {
      return y(F) === s;
    }
    function re(F) {
      return y(F) === r;
    }
    function ue(F) {
      return y(F) === f;
    }
    function ce(F) {
      return y(F) === d;
    }
    function Y(F) {
      return y(F) === t;
    }
    function J(F) {
      return y(F) === o;
    }
    function ye(F) {
      return y(F) === n;
    }
    function Q(F) {
      return y(F) === u;
    }
    function Ue(F) {
      return y(F) === c;
    }
    Fe.ContextConsumer = O, Fe.ContextProvider = P, Fe.Element = M, Fe.ForwardRef = I, Fe.Fragment = k, Fe.Lazy = R, Fe.Memo = A, Fe.Portal = L, Fe.Profiler = B, Fe.StrictMode = W, Fe.Suspense = U, Fe.SuspenseList = X, Fe.isAsyncMode = T, Fe.isConcurrentMode = j, Fe.isContextConsumer = z, Fe.isContextProvider = _, Fe.isElement = H, Fe.isForwardRef = te, Fe.isFragment = re, Fe.isLazy = ue, Fe.isMemo = ce, Fe.isPortal = Y, Fe.isProfiler = J, Fe.isStrictMode = ye, Fe.isSuspense = Q, Fe.isSuspenseList = Ue, Fe.isValidElementType = w, Fe.typeOf = y;
  }()), Fe;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = r3() : e.exports = o3();
})(qc);
function i3(e) {
  return Rn("MuiList", e);
}
Kt("MuiList", ["root", "padding", "dense", "subheader"]);
const a3 = ["children", "className", "component", "dense", "disablePadding", "subheader"], l3 = (e) => {
  const {
    classes: t,
    disablePadding: r,
    dense: n,
    subheader: o
  } = e;
  return yr({
    root: ["root", !r && "padding", n && "dense", o && "subheader"]
  }, i3, t);
}, s3 = Pn("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.disablePadding && t.padding, r.dense && t.dense, r.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => ae({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), Yc = /* @__PURE__ */ N.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiList"
  }), {
    children: o,
    className: i,
    component: a = "ul",
    dense: l = !1,
    disablePadding: s = !1,
    subheader: u
  } = n, c = Ze(n, a3), d = N.useMemo(() => ({
    dense: l
  }), [l]), f = ae({}, n, {
    component: a,
    dense: l,
    disablePadding: s
  }), v = l3(f);
  return /* @__PURE__ */ p(xa.Provider, {
    value: d,
    children: /* @__PURE__ */ G(s3, ae({
      as: a,
      className: q(v.root, i),
      ref: r,
      ownerState: f
    }, c, {
      children: [u, o]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Yc.propTypes = {
  children: b.exports.node,
  classes: b.exports.object,
  className: b.exports.string,
  component: b.exports.elementType,
  dense: b.exports.bool,
  disablePadding: b.exports.bool,
  subheader: b.exports.node,
  sx: b.exports.oneOfType([b.exports.arrayOf(b.exports.oneOfType([b.exports.func, b.exports.object, b.exports.bool])), b.exports.func, b.exports.object])
});
const u3 = Yc, c3 = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function Xi(e, t, r) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : r ? null : e.firstChild;
}
function Qs(e, t, r) {
  return e === t ? r ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : r ? null : e.lastChild;
}
function Kc(e, t) {
  if (t === void 0)
    return !0;
  let r = e.innerText;
  return r === void 0 && (r = e.textContent), r = r.trim().toLowerCase(), r.length === 0 ? !1 : t.repeating ? r[0] === t.keys[0] : r.indexOf(t.keys.join("")) === 0;
}
function $r(e, t, r, n, o, i) {
  let a = !1, l = o(e, t, t ? r : !1);
  for (; l; ) {
    if (l === e.firstChild) {
      if (a)
        return !1;
      a = !0;
    }
    const s = n ? !1 : l.disabled || l.getAttribute("aria-disabled") === "true";
    if (!l.hasAttribute("tabindex") || !Kc(l, i) || s)
      l = o(e, l, r);
    else
      return l.focus(), !0;
  }
  return !1;
}
const Xc = /* @__PURE__ */ N.forwardRef(function(t, r) {
  const {
    actions: n,
    autoFocus: o = !1,
    autoFocusItem: i = !1,
    children: a,
    className: l,
    disabledItemsFocusable: s = !1,
    disableListWrap: u = !1,
    onKeyDown: c,
    variant: d = "selectedMenu"
  } = t, f = Ze(t, c3), v = N.useRef(null), h = N.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Bn(() => {
    o && v.current.focus();
  }, [o]), N.useImperativeHandle(n, () => ({
    adjustStyleForScrollbar: (S, w) => {
      const y = !v.current.style.width;
      if (S.clientHeight < v.current.clientHeight && y) {
        const O = `${Cv(Nn(S))}px`;
        v.current.style[w.direction === "rtl" ? "paddingLeft" : "paddingRight"] = O, v.current.style.width = `calc(100% + ${O})`;
      }
      return v.current;
    }
  }), []);
  const m = (S) => {
    const w = v.current, y = S.key, O = Nn(w).activeElement;
    if (y === "ArrowDown")
      S.preventDefault(), $r(w, O, u, s, Xi);
    else if (y === "ArrowUp")
      S.preventDefault(), $r(w, O, u, s, Qs);
    else if (y === "Home")
      S.preventDefault(), $r(w, null, u, s, Xi);
    else if (y === "End")
      S.preventDefault(), $r(w, null, u, s, Qs);
    else if (y.length === 1) {
      const P = h.current, M = y.toLowerCase(), I = performance.now();
      P.keys.length > 0 && (I - P.lastTime > 500 ? (P.keys = [], P.repeating = !0, P.previousKeyMatched = !0) : P.repeating && M !== P.keys[0] && (P.repeating = !1)), P.lastTime = I, P.keys.push(M);
      const k = O && !P.repeating && Kc(O, P);
      P.previousKeyMatched && (k || $r(w, O, !1, s, Xi, P)) ? S.preventDefault() : P.previousKeyMatched = !1;
    }
    c && c(S);
  }, g = Wt(v, r);
  let C = -1;
  N.Children.forEach(a, (S, w) => {
    !/* @__PURE__ */ N.isValidElement(S) || (process.env.NODE_ENV !== "production" && qc.exports.isFragment(S) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), S.props.disabled || (d === "selectedMenu" && S.props.selected || C === -1) && (C = w), C === w && (S.props.disabled || S.props.muiSkipListHighlight || S.type.muiSkipListHighlight) && (C += 1, C >= a.length && (C = -1)));
  });
  const x = N.Children.map(a, (S, w) => {
    if (w === C) {
      const y = {};
      return i && (y.autoFocus = !0), S.props.tabIndex === void 0 && d === "selectedMenu" && (y.tabIndex = 0), /* @__PURE__ */ N.cloneElement(S, y);
    }
    return S;
  });
  return /* @__PURE__ */ p(u3, ae({
    role: "menu",
    ref: g,
    className: l,
    onKeyDown: m,
    tabIndex: o ? 0 : -1
  }, f, {
    children: x
  }));
});
process.env.NODE_ENV !== "production" && (Xc.propTypes = {
  autoFocus: b.exports.bool,
  autoFocusItem: b.exports.bool,
  children: b.exports.node,
  className: b.exports.string,
  disabledItemsFocusable: b.exports.bool,
  disableListWrap: b.exports.bool,
  onKeyDown: b.exports.func,
  variant: b.exports.oneOf(["menu", "selectedMenu"])
});
const d3 = Xc, f3 = {
  boxShadow: "none"
}, p3 = {
  background: "#FFFFFF",
  boxShadow: "0px 8px 24px -4px rgba(28, 50, 79, 0.38)",
  borderRadius: 4
}, K4 = ({
  options: e,
  onButtonClick: t,
  buttonLabel: r,
  onMenuItemClick: n
}) => {
  const [o, i] = N.useState(!1), a = N.useRef(null), l = (d, f) => {
    n(f), i(!1);
  }, s = () => {
    i((d) => !d);
  }, u = (d) => {
    a.current && a.current.contains(d.target) || i(!1);
  }, c = (d) => {
    d.code === "Escape" && i(!1);
  };
  return /* @__PURE__ */ G(N.Fragment, {
    children: [/* @__PURE__ */ G(l5, {
      variant: "contained",
      ref: a,
      "aria-label": "split button",
      style: f3,
      children: [/* @__PURE__ */ p(ft, {
        onClick: t,
        className: "rounded-r-none border-r border-[rgb(255,255,255,0.5)] py-1.5 px-2.5 text-base",
        children: r
      }), /* @__PURE__ */ p(ft, {
        "aria-controls": o ? "split-button-menu" : void 0,
        "aria-expanded": o ? "true" : void 0,
        "aria-label": "select merge strategy",
        "aria-haspopup": "menu",
        testId: "split-button-chevron",
        onClick: s,
        className: $`rounded-l-none min-h-full`,
        children: /* @__PURE__ */ p(ze, {
          icon: oi
        })
      })]
    }), /* @__PURE__ */ p($5, {
      sx: {
        zIndex: 1
      },
      open: o,
      anchorEl: a.current,
      role: void 0,
      transition: !0,
      disablePortal: !0,
      onKeyDown: (d) => c(d),
      children: ({
        TransitionProps: d
      }) => /* @__PURE__ */ p(x5, {
        ...d,
        style: {
          transformOrigin: "center top"
        },
        children: /* @__PURE__ */ p(P5, {
          style: p3,
          children: /* @__PURE__ */ p(No, {
            onClickAway: u,
            children: /* @__PURE__ */ p(d3, {
              id: "split-button-menu",
              autoFocusItem: !0,
              children: e.map((f, v) => /* @__PURE__ */ G(n3, {
                disabled: f.disabled,
                onClick: (h) => l(h, v),
                style: f.color === "red" ? {
                  color: "#FF0000"
                } : {
                  color: "#2745CE"
                },
                children: [/* @__PURE__ */ p(ze, {
                  icon: f.icon,
                  className: "mr-2"
                }), " ", f.label]
              }, f.label))
            })
          })
        })
      })
    })]
  });
}, X4 = ({
  className: e,
  height: t = 24,
  logo: r,
  testId: n,
  ...o
}) => /* @__PURE__ */ p("span", {
  className: e,
  "data-testid": n != null ? n : r.name,
  ...o,
  children: Ra(r, {
    height: t.toString() + "px"
  })
});
const g3 = ({
  icon: e,
  customIcon: t,
  content: r,
  width: n,
  popoverTitle: o,
  unreadIndicator: i = !1,
  onClose: a,
  closePopover: l
}) => {
  const [s, u] = K.useState(null), [c, d] = K.useState(!1), f = K.useCallback((h) => {
    u(h.currentTarget), d(!0);
  }, []), v = K.useCallback(() => {
    d(!1), a && a();
  }, [a]);
  return Ce(() => {
    l && v();
  }, [l, v]), /* @__PURE__ */ G(It, {
    children: [e && /* @__PURE__ */ p(Eo, {
      onClick: f,
      children: /* @__PURE__ */ p(dd, {
        color: "error",
        variant: "dot",
        invisible: !i,
        children: /* @__PURE__ */ p(ze, {
          icon: e.icon,
          scale: e.scale
        })
      })
    }), t && /* @__PURE__ */ p(Eo, {
      onClick: f,
      children: t
    }), /* @__PURE__ */ G(fd, {
      open: c,
      id: e ? `${e == null ? void 0 : e.icon}-popover` : "custom-icon-popover",
      anchorEl: s,
      onClose: v,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      classes: {
        paper: "flex flex-col p-[16px]"
      },
      className: "min-w-[300px] popover",
      children: [/* @__PURE__ */ p("div", {
        className: "flex flex-row items-center justify-between mr-4",
        style: {
          width: n || "auto"
        },
        children: o && /* @__PURE__ */ p(Ou, {
          titleSize: "small",
          className: "uppercase text-[#192434] p-3",
          children: o
        })
      }), /* @__PURE__ */ p("div", {
        className: "flex-1 overflow-y-auto",
        children: r
      })]
    })]
  });
}, J4 = ({
  logo: e,
  breadcrumbs: t,
  actions: r
}) => /* @__PURE__ */ G("div", {
  className: "w-full h-[48px] bg-white border-[#E5E7EB] border-b flex justify-between px-3",
  children: [/* @__PURE__ */ G("div", {
    className: "flex gap-5",
    children: [/* @__PURE__ */ p("div", {
      className: "self-center",
      children: e
    }), /* @__PURE__ */ p("div", {
      className: "w-[1px] bg-black mx-3 my-3"
    }), /* @__PURE__ */ p("div", {
      className: "self-center text-[14px] text-[#404040] flex items-center",
      children: t.map((n, o) => /* @__PURE__ */ G(It, {
        children: [/* @__PURE__ */ p("span", {
          children: n
        }, o), o < t.length - 1 ? /* @__PURE__ */ p(ze, {
          icon: Vp,
          scale: 0.8,
          className: "px-1"
        }) : ""]
      }))
    })]
  }), /* @__PURE__ */ p("div", {
    className: "flex self-center",
    children: r.map((n, o) => n.icon && n.customIcon ? null : n.icon && n.content || n.customIcon && n.content ? /* @__PURE__ */ p(g3, {
      popoverTitle: n.popoverTitle,
      icon: n.icon ? {
        icon: n.icon.icon,
        scale: n.icon.scale
      } : void 0,
      customIcon: n.customIcon ? n.customIcon : void 0,
      content: n.content,
      width: n.width,
      unreadIndicator: n.unreadIndicator,
      onClose: n.onClose,
      closePopover: n.closePopover
    }, o) : n.icon && n.link ? /* @__PURE__ */ p(Eo, {
      onClick: () => window.open(n.link, "_blank"),
      children: /* @__PURE__ */ p(ze, {
        icon: n.icon.icon,
        scale: n.icon.scale
      })
    }, o) : n.customIcon && n.link ? /* @__PURE__ */ p(Eo, {
      onClick: () => window.open(n.link, "_blank"),
      children: n.customIcon
    }, o) : null)
  })]
}), Q4 = ({
  icon: e,
  targetRef: t,
  className: r,
  onToggle: n,
  onClick: o
}) => {
  const [i, a] = $e(!0), l = () => {
    s(), o && o();
  }, s = () => {
    if (t.current) {
      const c = t.current;
      c.style.display = i ? "none" : "block", a(!i), n && n(i);
    }
  };
  return /* @__PURE__ */ p("button", {
    onClick: l,
    style: {
      borderRadius: "50%",
      backgroundColor: "#2845CE",
      padding: "5px",
      border: "none",
      color: "white",
      cursor: "pointer",
      transform: `rotate(${i ? "0deg" : "180deg"})`,
      transition: "transform 0.3s ease",
      boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2)"
    },
    className: r,
    children: /* @__PURE__ */ p(ze, {
      icon: e,
      testId: `${e.name}-icon`
    })
  });
}, e6 = ({
  selectedItems: e,
  onValueChange: t,
  multipleValuesText: r,
  selectAllText: n,
  allSelectedText: o,
  items: i,
  filterHandler: a,
  label: l,
  placeholder: s,
  emptySetLabel: u,
  loading: c = !1,
  width: d,
  className: f,
  testId: v,
  disabled: h = !1,
  disabledTooltip: m,
  limit: g,
  disableSelectAll: C = !1
}) => {
  const x = on(v), [S, w] = $e(!1), [y, O] = $e(!1), P = (L) => {
    a !== void 0 && a(L);
  }, M = (L, B) => (L == null ? void 0 : L.key) === (B == null ? void 0 : B.key), I = () => {
    if (e.length === i.length)
      t([]);
    else {
      const L = g ? i.slice(0, g) : i;
      t(L);
    }
  }, k = () => {
    h && m && w(!0);
  }, R = () => {
    w(!1);
  };
  return /* @__PURE__ */ p("div", {
    style: {
      width: d === void 0 ? "100%" : d
    },
    className: f,
    children: /* @__PURE__ */ G(yt, {
      value: e,
      onChange: (L) => {
        if (g && L.length === g && O(!0), g && L.length < g && O(!1), !(g && L.length > g)) {
          if (L.some((B) => B.key === "select-all")) {
            I();
            return;
          }
          t(L);
        }
      },
      by: M,
      disabled: h,
      multiple: !0,
      children: [l !== void 0 && /* @__PURE__ */ p(yt.Label, {
        className: "text-dark mb-1",
        children: `${l} ${g ? `(${e.length}/${g})` : ""}`
      }), /* @__PURE__ */ p(vr, {
        title: m,
        open: S,
        onClose: R,
        onOpen: k,
        children: /* @__PURE__ */ G("div", {
          children: [/* @__PURE__ */ G("div", {
            className: "relative w-full items-center cursor-default overflow-hidden rounded-md inline-flex pl-3 pr-1 py-1 mb-1 bg-grey-active focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300",
            children: [/* @__PURE__ */ p(yt.Input, {
              "data-testid": x("filter-input"),
              placeholder: s != null ? s : "",
              className: "w-full border-none bg-transparent text-gray-900 focus:outline-none focus:ring-0",
              displayValue: () => {
                var L, B;
                return e.length === i.length ? o : e.length > 0 && e.length <= 2 ? e.map((W) => W.label).join(", ") : e.length > 2 ? r : (B = (L = e[0]) == null ? void 0 : L.label) != null ? B : "";
              },
              onChange: (L) => P(L.target.value),
              onDoubleClick: (L) => {
                L.currentTarget.select();
              }
            }), e.length > 0 && /* @__PURE__ */ p(ft, {
              icon: Iu,
              variant: "text",
              color: "gray",
              onClick: () => {
                t([]);
              },
              testId: x("clear-button"),
              disabled: h
            }), /* @__PURE__ */ p(yt.Button, {
              as: Ge,
              children: /* @__PURE__ */ p(ft, {
                color: "gray",
                variant: "text",
                icon: oi,
                "data-testid": x("open-dropdown")
              })
            })]
          }), /* @__PURE__ */ p(hn, {
            as: Ge,
            enter: "transition duration-100 ease-out",
            enterFrom: "transform scale-95 opacity-0",
            enterTo: "transform scale-100 opacity-100",
            children: /* @__PURE__ */ p(yt.Options, {
              className: "relative w-full z-50",
              children: /* @__PURE__ */ G("div", {
                className: "overflow-y-auto w-full max-h-64 absolute shadow-lg rounded-md border py-2 px-2 bg-white border-grey-hover z-50",
                children: [u !== void 0 && /* @__PURE__ */ p("div", {
                  className: "relative cursor-default select-none py-2 px-4 text-gray-700",
                  children: u
                }), !C && /* @__PURE__ */ p(yt.Option, {
                  value: {
                    key: "select-all",
                    label: n
                  },
                  children: ({
                    active: L
                  }) => /* @__PURE__ */ p("div", {
                    className: q("inline-flex w-full items-center pl-3 py-2 rounded-md", ee(L)("bg-primary-active")),
                    children: /* @__PURE__ */ G("div", {
                      className: $`flex items-center justify-center`,
                      children: [/* @__PURE__ */ p(It, {
                        children: e.length === i.length ? /* @__PURE__ */ p(ze, {
                          className: "mr-2 text-primary group-hover:text-primary-filled-active",
                          scale: 1.6,
                          icon: To
                        }) : /* @__PURE__ */ p(ze, {
                          className: "inline-block rounded-md relative group-hover:bg-light peer-focus-visible:ring-4 text-light mr-2",
                          scale: 1.6,
                          icon: Io
                        })
                      }), n]
                    })
                  })
                }), i.map((L, B) => /* @__PURE__ */ p(yt.Option, {
                  value: L,
                  children: ({
                    active: W,
                    selected: U
                  }) => /* @__PURE__ */ p("div", {
                    className: q("inline-flex w-full items-center pl-3 py-2 rounded-md", ee(W)("bg-primary-active")),
                    children: /* @__PURE__ */ G("div", {
                      className: $`flex items-center justify-center`,
                      children: [/* @__PURE__ */ G(It, {
                        children: [U && /* @__PURE__ */ p(ze, {
                          className: "mr-2 text-primary group-hover:text-primary-filled-active",
                          scale: 1.6,
                          icon: To
                        }), !U && /* @__PURE__ */ p(ze, {
                          className: "inline-block rounded-md relative group-hover:bg-light peer-focus-visible:ring-4 text-light mr-2",
                          scale: 1.6,
                          icon: Io
                        })]
                      }), /* @__PURE__ */ p("span", {
                        className: q(ee(y && !U)("text-gray"), ee(!y || U)("text-black")),
                        children: L.label
                      })]
                    })
                  })
                }, B)), c && /* @__PURE__ */ p(ri, {})]
              })
            })
          })]
        })
      })]
    })
  });
}, t6 = (e) => /* @__PURE__ */ G("svg", {
  width: "181",
  height: "24",
  viewBox: "0 0 181 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: [/* @__PURE__ */ p("path", {
    d: "M11.9982 0C8.81609 0 5.76427 1.26411 3.51415 3.51423C1.26403 5.76435 4.6903e-07 8.81617 4.6903e-07 11.9983C-0.000440102 13.5742 0.309503 15.1348 0.912277 16.5909C1.51505 18.047 2.39881 19.37 3.513 20.4845C4.62719 21.599 5.95006 22.4832 7.40598 23.0863C8.8619 23.6895 10.4223 24 11.9982 24C15.1807 23.9991 18.2325 22.7342 20.4826 20.4836C22.7326 18.2329 23.9966 15.1808 23.9966 11.9983C23.9957 8.81644 22.7313 5.76514 20.4813 3.51521C18.2314 1.26529 15.1801 0.000889165 11.9982 0ZM18.3245 12.384C18.38 12.4183 18.4258 12.4662 18.4576 12.5232C18.4893 12.5801 18.5059 12.6443 18.5059 12.7095C18.5059 12.7747 18.4893 12.8387 18.4576 12.8957C18.4258 12.9526 18.38 13.0006 18.3245 13.0348L17.553 13.558L16.8083 14.0578L18.3245 15.0809C18.3799 15.1156 18.4256 15.1638 18.4573 15.221C18.489 15.2782 18.5057 15.3426 18.5057 15.408C18.5057 15.4734 18.489 15.5377 18.4573 15.5949C18.4256 15.6521 18.3799 15.7003 18.3245 15.735L17.553 16.2549L12.1861 19.8742C12.1283 19.9088 12.0622 19.927 11.9949 19.927C11.9275 19.927 11.8615 19.9088 11.8037 19.8742L11.0322 19.3543L5.66537 15.735C5.60913 15.7009 5.5626 15.653 5.53033 15.5957C5.49806 15.5384 5.48111 15.4737 5.48111 15.408C5.48111 15.3422 5.49806 15.2776 5.53033 15.2203C5.5626 15.163 5.60913 15.115 5.66537 15.0809L6.43687 14.561L7.17816 14.0578L5.66537 13.0515C5.60909 13.0179 5.56252 12.9702 5.53017 12.9132C5.49781 12.8562 5.48078 12.7917 5.48078 12.7262C5.48078 12.6606 5.49781 12.5962 5.53017 12.5391C5.56252 12.4821 5.60909 12.4345 5.66537 12.4008L6.43687 11.8809L7.17816 11.3777L5.66537 10.3715C5.60909 10.3378 5.56252 10.2902 5.53017 10.2331C5.49781 10.1761 5.48078 10.1117 5.48078 10.0461C5.48078 9.98053 5.49781 9.91609 5.53017 9.85906C5.56252 9.80203 5.60909 9.75438 5.66537 9.72074L6.43687 9.20081L11.7769 5.59494L11.8172 5.57152L11.8943 5.53123C11.9266 5.52774 11.9593 5.52774 11.9916 5.53123C12.0227 5.52616 12.0544 5.52616 12.0855 5.53123C12.1128 5.54124 12.1387 5.55481 12.1626 5.57152L12.2062 5.59494L12.9542 6.10144L18.3211 9.72074C18.3766 9.755 18.4224 9.80293 18.4542 9.85988C18.486 9.91682 18.5026 9.98089 18.5026 10.0461C18.5026 10.1113 18.486 10.1755 18.4542 10.2324C18.4224 10.2894 18.3766 10.3372 18.3211 10.3715L17.5496 10.8947L16.805 11.3945L18.3245 12.384Z",
    fill: "#E67200"
  }), /* @__PURE__ */ p("path", {
    d: "M12.1894 17.1773C12.1316 17.2119 12.0655 17.2301 11.9981 17.2301C11.9308 17.2301 11.8648 17.2119 11.807 17.1773L11.0355 16.6574L7.85899 14.514L6.51727 15.4096C6.61455 15.4733 6.71178 15.5371 6.8057 15.6042L11.9814 19.096L12.5617 18.7035L17.4422 15.4096L17.1537 15.2118L16.1172 14.514L12.1894 17.1773Z",
    fill: "#E67200"
  }), /* @__PURE__ */ p("path", {
    d: "M14.8092 12.7094L14.4738 12.9375L14.1383 13.1656L12.1895 14.4804C12.1317 14.515 12.0656 14.5333 11.9983 14.5333C11.9309 14.5333 11.8649 14.515 11.8071 14.4804L11.0356 13.9606L9.85826 13.1656L9.52283 12.9375L9.1874 12.7094L7.86247 11.8171L6.52075 12.7094L6.80918 12.9073L7.84568 13.605L8.18111 13.8331L8.51654 14.0578L11.9816 16.4058L12.5618 16.0134L15.4465 14.0645L15.7819 13.8398L16.1173 13.6117L17.4591 12.7161L17.1706 12.5216L16.1341 11.8239L14.8092 12.7094Z",
    fill: "#E67200"
  }), /* @__PURE__ */ p("path", {
    d: "M11.9983 6.32629L11.4146 6.71872L6.53418 10.0127L6.8226 10.2072L7.85911 10.9082L8.19454 11.1329L8.52997 11.3611L9.87169 12.2567L10.2071 12.4847L10.5425 12.7095L12.0117 13.7158L12.592 13.3233L13.4776 12.7262L13.813 12.5015L14.1484 12.2735L15.4733 11.3778L15.8088 11.1497L16.1442 10.925L17.4859 10.0294L17.1974 9.83487L11.9983 6.32629Z",
    fill: "#E67200"
  }), /* @__PURE__ */ p("path", {
    d: "M114.1 12.8094V19.2859H115.999V11.9629C115.999 10.8488 115.753 10.0518 115.263 9.57191C114.772 9.09205 114.128 8.85212 113.332 8.85212C112.644 8.86017 111.968 9.03067 111.359 9.34949C110.582 9.76087 109.851 10.2538 109.18 10.8199L109.628 12.1328C110.104 11.7558 110.619 11.4297 111.163 11.1597C111.623 10.912 112.135 10.774 112.658 10.7566C112.911 10.7521 113.163 10.805 113.393 10.9111C113.631 11.0451 113.812 11.2594 113.905 11.515C114.059 11.9308 114.128 12.373 114.107 12.8156M108.003 12.5808V19.289H109.924V11.9846C109.924 10.8519 109.686 10.0476 109.209 9.57191C108.733 9.09617 108.103 8.85624 107.321 8.85212C106.649 8.86581 105.987 9.02113 105.379 9.30778C104.543 9.70586 103.755 10.1993 103.033 10.7782L103.566 12.1328C104.046 11.7345 104.577 11.4001 105.144 11.1381C105.609 10.9057 106.119 10.7756 106.639 10.7566C106.907 10.7469 107.174 10.7998 107.417 10.9111C107.628 11.033 107.784 11.2294 107.855 11.4609C107.97 11.824 108.022 12.2036 108.011 12.5839M101.939 9.15487V19.2921H103.838V11.1798L103.517 9.12706C102.991 9.09763 102.464 9.10485 101.939 9.14869M84.3384 19.5824C84.9051 19.5795 85.4699 19.5158 86.0229 19.3924C86.6373 19.2532 87.2323 19.0401 87.7946 18.7576C87.7806 18.6222 87.7593 18.4876 87.7308 18.3545C87.6902 17.949 87.6258 17.5462 87.5377 17.1482C87.0827 17.3364 86.6144 17.4913 86.1366 17.6115C85.6508 17.7514 85.1491 17.8293 84.6435 17.8432C84.0228 17.8586 83.4088 17.7127 82.8624 17.42C82.3494 17.1309 81.9393 16.6911 81.6886 16.1612C81.3954 15.5283 81.2531 14.837 81.2729 14.1408C81.2559 13.4828 81.3945 12.83 81.6777 12.2348C81.9302 11.7179 82.336 11.2899 82.8406 11.0084C83.3731 10.7189 83.9727 10.573 84.5797 10.5852C84.8701 10.5886 85.1595 10.6202 85.4437 10.6794C85.7856 10.7493 86.1234 10.8375 86.4557 10.9435C86.8042 11.0349 87.1463 11.1484 87.4801 11.2833C87.5941 10.7449 87.6799 10.201 87.737 9.65377C87.1962 9.38593 86.6271 9.1787 86.04 9.03593C85.5409 8.91522 85.0295 8.85148 84.5158 8.84595C83.559 8.82315 82.6119 9.04157 81.7633 9.48077C80.9856 9.89924 80.3534 10.541 79.9495 11.3219C79.5056 12.2011 79.2859 13.1748 79.3097 14.1578C79.2828 15.1595 79.4962 16.1532 79.9324 17.057C80.3229 17.8454 80.9442 18.4984 81.715 18.9306C82.5174 19.37 83.422 19.5926 84.3384 19.5763M72.4579 11.0053L75.4657 10.5419L76.171 9.15177C75.7008 9.12397 75.0854 9.10956 74.3246 9.10853C73.5638 9.1075 72.941 9.12191 72.4563 9.15177C72.4143 9.772 72.4143 10.3943 72.4563 11.0146M74.2701 19.289H76.1695V9.14869L74.2701 9.48695V19.2859V19.289ZM67.8355 12.8094V19.2859H69.7349V11.9629C69.7349 10.8488 69.4894 10.0518 68.9985 9.57191C68.5076 9.09205 67.864 8.85212 67.068 8.85212C66.38 8.86017 65.7038 9.03067 65.0954 9.34949C64.3179 9.76087 63.5872 10.2538 62.9158 10.8199L63.3642 12.1328C63.84 11.7558 64.3545 11.4297 64.8993 11.1597C65.3591 10.912 65.8708 10.774 66.3938 10.7566C66.6474 10.7521 66.8987 10.805 67.1287 10.9111C67.3667 11.0451 67.5485 11.2594 67.6409 11.515C67.7953 11.9308 67.8641 12.373 67.8433 12.8156M61.7419 12.5839V19.2921H63.6631V11.9846C63.6631 10.8519 63.4249 10.0476 62.9485 9.57191C62.4721 9.09617 61.8426 8.85624 61.06 8.85212C60.3876 8.86581 59.7259 9.02113 59.1186 9.30778C58.2816 9.70586 57.4942 10.1993 56.7724 10.7782L57.3048 12.1328C57.7852 11.7345 58.3159 11.4001 58.8835 11.1381C59.3482 10.9057 59.858 10.7756 60.3781 10.7566C60.6462 10.7469 60.9128 10.7998 61.1565 10.9111C61.3671 11.033 61.5234 11.2294 61.594 11.4609C61.7086 11.824 61.7612 12.2036 61.7497 12.5839M55.6779 9.15487V19.2921H57.5773V11.1798L57.2566 9.12706C56.7305 9.09763 56.203 9.10485 55.6779 9.14869M50.6632 19.2859C50.9179 19.3157 51.1743 19.3302 51.4307 19.3291C51.709 19.3289 51.987 19.3145 52.2637 19.2859V4.47165C51.9661 4.43472 51.6667 4.41359 51.3669 4.40833C51.1536 4.40833 50.8205 4.4284 50.3643 4.47165V17.4663L50.6632 19.2859ZM47.1431 19.5824C47.7838 19.5591 48.4157 19.427 49.0114 19.1917C49.6911 18.953 50.3234 18.598 50.8796 18.1429L50.5807 16.7883C50.5442 16.8073 50.5088 16.8284 50.4748 16.8516C49.9746 17.1208 49.4541 17.3512 48.918 17.5405C48.4701 17.7121 47.9966 17.8087 47.5168 17.8262C47.1394 17.8394 46.7641 17.766 46.4201 17.6117C46.076 17.4574 45.7726 17.2263 45.5333 16.9365C45.0351 16.3444 44.786 15.5402 44.786 14.5239C44.7622 13.7644 44.8968 13.0082 45.1815 12.3028C45.412 11.7478 45.8108 11.2776 46.3226 10.9574C46.8726 10.6409 47.5009 10.4836 48.1364 10.5033C48.6412 10.5186 49.1424 10.5932 49.6295 10.7257C50.1503 10.8483 50.6577 11.0216 51.1443 11.2432L51.1863 9.63523C50.6319 9.40483 50.0591 9.2209 49.4738 9.08536C48.8703 8.93511 48.251 8.85681 47.6289 8.85212C46.7533 8.8381 45.891 9.06535 45.1379 9.50858C44.3915 9.95874 43.7958 10.6175 43.4253 11.4023C43.0003 12.3219 42.7926 13.3256 42.8181 14.337C42.8181 15.4944 42.9993 16.4644 43.3615 17.247C43.6756 17.9743 44.2084 18.5877 44.8872 19.0032C45.5726 19.3995 46.3547 19.6009 47.1478 19.5855M33.631 16.2878C33.63 16.0499 33.6482 15.8123 33.6855 15.5773C33.7244 15.3432 33.7848 15.1131 33.8661 14.89C35.1178 14.8488 36.6747 14.8843 38.5367 14.9965V16.5628C38.0219 16.953 37.4678 17.2895 36.8833 17.5667C36.3946 17.8034 35.8593 17.93 35.3156 17.9374C34.7457 17.9374 34.3238 17.7938 34.0451 17.5034C33.7665 17.213 33.6295 16.8083 33.6295 16.2878M38.6644 18.1073L38.8559 19.2921C39.1253 19.3203 39.3961 19.3348 39.667 19.3353C39.9168 19.3359 40.1663 19.3215 40.4143 19.2921V12.604C40.4143 11.7019 40.2685 10.9811 39.9768 10.4415C39.7121 9.9245 39.2801 9.51059 38.75 9.26607C38.1291 9.00825 37.4596 8.88553 36.7868 8.90619C36.0987 8.91428 35.4131 8.98877 34.7395 9.12861C33.9343 9.29118 33.1427 9.51423 32.3715 9.79587C32.5137 10.3324 32.6559 10.8683 32.7981 11.4038C33.4923 11.1557 34.2009 10.9494 34.9201 10.786C35.4622 10.6581 36.0164 10.5872 36.5735 10.5744C36.9912 10.5527 37.4053 10.6607 37.7583 10.8833C38.0502 11.0881 38.261 11.3874 38.3546 11.7297C38.4705 12.147 38.5317 12.5774 38.5367 13.0102V13.4967C37.257 13.4401 36.1547 13.4082 35.2299 13.401C34.3051 13.3938 33.4022 13.4113 32.521 13.4535C32.2842 13.9185 32.1014 14.4087 31.9761 14.9147C31.8562 15.4068 31.7955 15.9113 31.7955 16.4176C31.7955 17.4185 32.0762 18.198 32.6377 18.7561C33.1993 19.3142 33.9709 19.5927 34.9528 19.5917C35.6058 19.5825 36.2507 19.4461 36.8506 19.1901C37.5057 18.9205 38.1169 18.5562 38.6644 18.1089M98.9963 11.3451C98.6313 10.5672 98.0332 9.91991 97.2838 9.49159C96.475 9.04702 95.5614 8.82417 94.6371 8.84595C93.7194 8.82237 92.8125 9.04546 92.0122 9.49159C91.267 9.92516 90.6703 10.5709 90.2996 11.3451C89.882 12.2394 89.6779 13.2173 89.7033 14.2026C89.7033 15.3168 89.9021 16.276 90.2996 17.0802C90.6698 17.8547 91.2666 18.5006 92.0122 18.9337C92.8125 19.3798 93.7194 19.6029 94.6371 19.5793C95.5614 19.6011 96.475 19.3783 97.2838 18.9337C98.0332 18.5054 98.6313 17.8581 98.9963 17.0802C99.3866 16.277 99.5822 15.3178 99.5833 14.2026C99.6078 13.2183 99.4071 12.2414 98.9963 11.3451ZM97.2604 16.2708C97.0679 16.7849 96.7122 17.2229 96.2469 17.5188C95.753 17.806 95.1874 17.949 94.6153 17.9313C94.0564 17.949 93.5043 17.8058 93.0257 17.5188C92.5709 17.2168 92.2238 16.7801 92.034 16.2708C91.789 15.6108 91.6733 14.9104 91.693 14.2072C91.6725 13.5071 91.7883 12.8096 92.034 12.1529C92.226 11.6482 92.5729 11.216 93.0257 10.9172C93.5043 10.6303 94.0564 10.4871 94.6153 10.5048C95.1874 10.4871 95.753 10.6301 96.2469 10.9172C96.7102 11.2099 97.0657 11.6434 97.2604 12.1529C97.5061 12.8096 97.6219 13.5071 97.6013 14.2072C97.6211 14.9104 97.5054 15.6108 97.2604 16.2708Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M176.013 19.6323C175.226 19.6323 174.571 19.4937 174.048 19.2166C173.531 18.9394 173.144 18.574 172.886 18.1205C172.627 17.6607 172.498 17.163 172.498 16.6276C172.498 16.0481 172.618 15.5631 172.857 15.1725C173.103 14.782 173.427 14.467 173.83 14.2277C174.24 13.9883 174.69 13.8088 175.182 13.6891C175.742 13.5631 176.347 13.456 176.996 13.3678C177.645 13.2734 178.262 13.1915 178.848 13.1222C179.44 13.0529 179.922 12.993 180.293 12.9427L179.896 13.1789C179.922 12.0765 179.714 11.2576 179.273 10.7222C178.838 10.1805 178.07 9.90964 176.967 9.90964C176.193 9.90964 175.553 10.086 175.049 10.4388C174.552 10.7852 174.202 11.3238 174.001 12.0545L172.886 11.7427C173.119 10.8167 173.588 10.1049 174.293 9.60728C174.999 9.10965 175.903 8.86084 177.005 8.86084C177.944 8.86084 178.731 9.04351 179.367 9.40886C180.01 9.77421 180.457 10.2876 180.709 10.949C180.816 11.2199 180.889 11.538 180.926 11.9033C180.964 12.2624 180.983 12.6246 180.983 12.9899V19.3488H179.991V16.6654L180.359 16.7599C180.051 17.6796 179.512 18.3882 178.744 18.8859C177.975 19.3835 177.065 19.6323 176.013 19.6323ZM176.07 18.6307C176.763 18.6307 177.371 18.5079 177.893 18.2622C178.416 18.0103 178.838 17.6607 179.159 17.2134C179.487 16.7599 179.695 16.2276 179.783 15.6166C179.846 15.2765 179.881 14.908 179.887 14.5111C179.893 14.1143 179.896 13.8214 179.896 13.6324L180.369 13.9348C179.959 13.9852 179.468 14.0387 178.895 14.0954C178.328 14.1521 177.748 14.2214 177.156 14.3033C176.564 14.3851 176.029 14.4891 175.55 14.6151C175.254 14.697 174.955 14.8166 174.652 14.9741C174.356 15.1253 174.108 15.3363 173.906 15.6072C173.711 15.878 173.613 16.2213 173.613 16.6371C173.613 16.9457 173.689 17.2544 173.84 17.563C173.997 17.8717 174.256 18.1268 174.615 18.3284C174.974 18.53 175.459 18.6307 176.07 18.6307Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M169.502 19.3489L169.521 12.4892C169.521 11.664 169.285 11.0184 168.812 10.5522C168.346 10.0798 167.763 9.84357 167.064 9.84357C166.667 9.84357 166.274 9.93491 165.883 10.1176C165.499 10.3003 165.178 10.5963 164.919 11.0058C164.661 11.4152 164.532 11.9695 164.532 12.6687L163.767 12.5459C163.741 11.8026 163.877 11.1569 164.173 10.6089C164.475 10.0546 164.891 9.62625 165.42 9.3239C165.956 9.02154 166.563 8.87036 167.244 8.87036C168.245 8.87036 169.055 9.17902 169.672 9.79633C170.296 10.4136 170.607 11.2577 170.607 12.3286L170.589 19.3489H169.502ZM157.36 19.3489V9.14437H158.353V11.4404H158.447V19.3489H157.36ZM163.436 19.3489L163.455 12.5931C163.455 11.749 163.225 11.0813 162.765 10.59C162.305 10.0924 161.707 9.84357 160.97 9.84357C160.22 9.84357 159.612 10.1018 159.146 10.6184C158.68 11.1286 158.447 11.812 158.447 12.6687L157.691 12.2908C157.691 11.6294 157.842 11.0435 158.145 10.5333C158.447 10.0168 158.86 9.61051 159.382 9.31445C159.912 9.01839 160.516 8.87036 161.197 8.87036C161.808 8.87036 162.365 8.99949 162.869 9.25776C163.373 9.51602 163.776 9.90656 164.078 10.4294C164.381 10.9459 164.532 11.5947 164.532 12.3758L164.513 19.3489H163.436Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M153.434 7.08451V5.69556H154.521V7.08451H153.434ZM153.434 19.3489V9.14431H154.521V19.3489H153.434Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M151.296 19.3489C150.754 19.4686 150.219 19.5127 149.69 19.4812C149.16 19.456 148.688 19.3395 148.272 19.1316C147.863 18.9175 147.554 18.5899 147.346 18.149C147.176 17.7899 147.082 17.4277 147.063 17.0624C147.044 16.697 147.034 16.2781 147.034 15.8057V6.30981H148.13V15.7868C148.13 16.2151 148.134 16.571 148.14 16.8545C148.153 17.1317 148.219 17.3868 148.338 17.6198C148.565 18.0545 148.924 18.319 149.415 18.4135C149.907 18.5017 150.534 18.486 151.296 18.3663V19.3489ZM144.748 10.1365V9.14441H151.296V10.1365H144.748Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M139.834 19.6134C138.656 19.6134 137.683 19.3646 136.914 18.867C136.152 18.3693 135.68 17.6764 135.497 16.7883L136.612 16.5993C136.77 17.204 137.141 17.6859 137.727 18.0449C138.313 18.404 139.031 18.5835 139.881 18.5835C140.725 18.5835 141.396 18.404 141.894 18.0449C142.391 17.6859 142.64 17.1945 142.64 16.5709C142.64 16.2308 142.562 15.9536 142.404 15.7395C142.253 15.519 141.951 15.3174 141.497 15.1347C141.043 14.9521 140.369 14.7379 139.475 14.4922C138.53 14.2403 137.79 13.9883 137.255 13.7363C136.725 13.4844 136.351 13.1978 136.13 12.8765C135.916 12.5553 135.809 12.1616 135.809 11.6954C135.809 11.1348 135.97 10.6435 136.291 10.2214C136.612 9.79311 137.059 9.45925 137.633 9.21989C138.212 8.98052 138.88 8.86084 139.636 8.86084C140.392 8.86084 141.072 8.98682 141.677 9.23879C142.281 9.48445 142.769 9.8309 143.141 10.2781C143.513 10.7191 143.727 11.2324 143.784 11.8183L142.669 12.0261C142.562 11.371 142.231 10.8545 141.677 10.4766C141.122 10.0923 140.429 9.89704 139.598 9.89074C138.81 9.87814 138.168 10.0356 137.67 10.3632C137.173 10.6844 136.924 11.1096 136.924 11.6387C136.924 11.9411 137.009 12.1994 137.179 12.4135C137.355 12.6214 137.664 12.8135 138.105 12.9899C138.546 13.1663 139.17 13.3552 139.976 13.5568C140.958 13.8088 141.724 14.067 142.272 14.3316C142.826 14.5962 143.217 14.908 143.443 15.267C143.67 15.6198 143.784 16.0576 143.784 16.5804C143.784 17.5252 143.431 18.2685 142.725 18.8103C142.026 19.3457 141.062 19.6134 139.834 19.6134Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M129.325 19.6323C128.349 19.6323 127.505 19.415 126.793 18.9803C126.081 18.5394 125.53 17.9189 125.139 17.119C124.749 16.3127 124.554 15.3615 124.554 14.2655C124.554 13.1505 124.746 12.1899 125.13 11.3836C125.521 10.571 126.069 9.94743 126.774 9.5128C127.486 9.07816 128.33 8.86084 129.306 8.86084C130.295 8.86084 131.139 9.08761 131.839 9.54114C132.544 9.98838 133.079 10.6372 133.445 11.4876C133.816 12.3379 133.993 13.3615 133.974 14.5584H132.84V14.1804C132.809 12.782 132.494 11.7175 131.895 10.9868C131.297 10.2561 130.44 9.89074 129.325 9.89074C128.172 9.89074 127.281 10.2718 126.651 11.034C126.028 11.7899 125.716 12.8608 125.716 14.2466C125.716 15.6198 126.028 16.6843 126.651 17.4402C127.281 18.1961 128.166 18.574 129.306 18.574C130.094 18.574 130.78 18.3914 131.366 18.026C131.958 17.6544 132.428 17.1253 132.774 16.4387L133.757 16.8733C133.347 17.7552 132.755 18.4355 131.98 18.9142C131.205 19.3929 130.32 19.6323 129.325 19.6323ZM125.3 14.5584V13.5757H133.36V14.5584H125.3Z",
    fill: "#191919"
  })]
}), n6 = (e) => /* @__PURE__ */ G("svg", {
  width: "181",
  height: "24",
  viewBox: "0 0 603 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: [/* @__PURE__ */ G("g", {
    children: [/* @__PURE__ */ p("path", {
      d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
      fill: "#E67200"
    }), /* @__PURE__ */ p("path", {
      d: "M62.969 29.3316V18.7082C62.9653 18.4509 62.9032 18.198 62.7874 17.9681C62.6716 17.7382 62.5052 17.5375 62.3006 17.3814C62.096 17.2252 61.8586 17.1176 61.6063 17.0666C61.354 17.0156 61.0934 17.0224 60.8442 17.0868L23.5505 26.4132L18.2611 27.7326C17.9095 27.8356 17.6002 28.0487 17.3788 28.3406C17.1573 28.6325 17.0354 28.9877 17.031 29.354V61.3139C17.0337 61.5885 17.1034 61.8582 17.2339 62.0999C17.3645 62.3415 17.552 62.5477 17.7803 62.7005C18.051 62.8947 18.3752 63.0002 18.7084 63.0024H61.2916C61.499 63.0033 61.7045 62.9632 61.8964 62.8845C62.0883 62.8058 62.2627 62.6903 62.4098 62.5441C62.5581 62.3985 62.6752 62.2241 62.754 62.0319C62.8329 61.8396 62.8717 61.6335 62.8683 61.4258V29.3316H62.969ZM59.6142 56.0805V59.6029H48.7783V31.0314H59.6142V56.0805ZM45.4235 57.2992V59.6029H34.5876V41.7108H45.4235V57.2992ZM31.2329 58.6525V59.6029H20.3858V48.7671H31.2329V58.6525ZM56.4495 21.6382L59.6142 20.8555V27.6767H47.1009C46.6578 27.6824 46.2346 27.861 45.9212 28.1744C45.6079 28.4877 45.4293 28.911 45.4235 29.354V38.3001H32.9102C32.4672 38.3059 32.0439 38.4845 31.7306 38.7978C31.4172 39.1111 31.2387 39.5344 31.2329 39.9775V45.3899H20.3858V30.6402L56.4495 21.6382Z",
      fill: "white"
    })]
  }), /* @__PURE__ */ p("path", {
    d: "M380.386 42.6983V64.2896H386.718V39.8764C386.718 36.162 385.9 33.5049 384.263 31.9051C382.627 30.3054 380.481 29.5055 377.827 29.5055C375.534 29.5323 373.28 30.1007 371.251 31.1636C368.659 32.5351 366.223 34.1786 363.985 36.0658L365.48 40.4428C367.066 39.1859 368.781 38.0986 370.597 37.1987C372.13 36.3727 373.836 35.9125 375.58 35.8547C376.425 35.8398 377.263 36.0159 378.03 36.3697C378.823 36.8166 379.429 37.5309 379.737 38.3831C380.252 39.7691 380.481 41.2434 380.412 42.7189M360.061 41.9362V64.3H366.466V39.9485C366.466 36.1723 365.672 33.4912 364.083 31.9051C362.495 30.3191 360.397 29.5192 357.788 29.5055C355.546 29.5511 353.34 30.0689 351.315 31.0246C348.525 32.3517 345.9 33.9969 343.493 35.9268L345.269 40.4428C346.87 39.1148 348.639 38 350.531 37.1266C352.081 36.3519 353.78 35.9181 355.514 35.8547C356.408 35.8223 357.297 35.9987 358.109 36.3697C358.811 36.776 359.333 37.431 359.568 38.2028C359.95 39.4133 360.125 40.6786 360.087 41.9465M339.845 30.5148V64.3103H346.177V37.2657L345.108 30.4221C343.354 30.324 341.595 30.3481 339.845 30.4942M281.168 65.2784C283.058 65.2686 284.94 65.0562 286.784 64.645C288.832 64.1809 290.816 63.4702 292.691 62.5286C292.644 62.0771 292.573 61.6285 292.478 61.1846C292.343 59.8327 292.128 58.4899 291.834 57.1629C290.317 57.7904 288.756 58.3068 287.163 58.7077C285.544 59.1741 283.871 59.4337 282.185 59.4801C280.116 59.5315 278.069 59.0451 276.248 58.0692C274.537 57.1053 273.17 55.6391 272.334 53.8724C271.357 51.7628 270.882 49.458 270.948 47.137C270.892 44.9434 271.354 42.7672 272.298 40.7827C273.14 39.0594 274.492 37.6327 276.175 36.6941C277.95 35.7292 279.949 35.2427 281.973 35.2831C282.941 35.2947 283.906 35.3999 284.853 35.5973C285.993 35.8304 287.119 36.1244 288.227 36.4778C289.389 36.7825 290.529 37.1609 291.642 37.6107C292.022 35.8157 292.308 34.0024 292.499 32.178C290.696 31.2851 288.798 30.5943 286.841 30.1183C285.177 29.7159 283.472 29.5034 281.76 29.4849C278.57 29.4089 275.412 30.1371 272.583 31.6013C269.991 32.9964 267.883 35.1358 266.537 37.7394C265.057 40.6702 264.324 43.9166 264.403 47.1937C264.314 50.5332 265.025 53.846 266.479 56.8591C267.781 59.4873 269.853 61.6644 272.422 63.1053C275.097 64.57 278.113 65.3123 281.168 65.2577M241.561 36.6838L251.588 35.1389L253.94 30.5045C252.372 30.4118 250.32 30.3638 247.784 30.3603C245.248 30.3569 243.171 30.4049 241.556 30.5045C241.415 32.5722 241.415 34.6469 241.556 36.7147M247.602 64.3H253.934V30.4942L247.602 31.6219V64.2896V64.3ZM226.151 42.6983V64.2896H232.483V39.8764C232.483 36.162 231.665 33.5049 230.028 31.9051C228.391 30.3054 226.246 29.5055 223.592 29.5055C221.298 29.5323 219.044 30.1007 217.016 31.1636C214.424 32.5351 211.988 34.1786 209.749 36.0658L211.244 40.4428C212.83 39.1859 214.546 38.0986 216.362 37.1987C217.895 36.3727 219.601 35.9125 221.344 35.8547C222.19 35.8398 223.028 36.0159 223.794 36.3697C224.588 36.8166 225.194 37.5309 225.502 38.3831C226.016 39.7691 226.246 41.2434 226.177 42.7189M205.836 41.9465V64.3103H212.241V39.9485C212.241 36.1723 211.447 33.4912 209.858 31.9051C208.27 30.3191 206.171 29.5192 203.562 29.5055C201.321 29.5511 199.115 30.0689 197.09 31.0246C194.3 32.3517 191.675 33.9969 189.268 35.9268L191.043 40.4428C192.645 39.1148 194.414 38 196.306 37.1266C197.856 36.3519 199.555 35.9181 201.289 35.8547C202.183 35.8223 203.072 35.9987 203.884 36.3697C204.586 36.776 205.107 37.431 205.343 38.2028C205.725 39.4133 205.9 40.6786 205.862 41.9465M185.62 30.5148V64.3103H191.952V37.2657L190.882 30.4221C189.129 30.324 187.37 30.3481 185.62 30.4942M168.901 64.2896C169.751 64.3893 170.605 64.4374 171.46 64.4338C172.388 64.4333 173.315 64.3851 174.237 64.2896V14.9018C173.245 14.7787 172.247 14.7083 171.247 14.6907C170.536 14.6907 169.426 14.7577 167.905 14.9018V58.2237L168.901 64.2896ZM157.166 65.2784C159.302 65.2007 161.409 64.76 163.395 63.9755C165.66 63.1798 167.768 61.9964 169.623 60.4791L168.626 55.9631C168.505 56.0266 168.387 56.0971 168.273 56.1742C166.606 57.0719 164.871 57.8397 163.083 58.4708C161.59 59.0432 160.011 59.3651 158.412 59.4235C157.154 59.4676 155.903 59.2228 154.756 58.7083C153.609 58.1938 152.597 57.4235 151.799 56.4574C150.138 54.4835 149.308 51.8024 149.308 48.4141C149.229 45.8821 149.677 43.3611 150.626 41.0093C151.395 39.159 152.725 37.5916 154.431 36.5241C156.264 35.4691 158.359 34.9446 160.478 35.0102C162.16 35.0612 163.831 35.3101 165.455 35.7517C167.192 36.1604 168.883 36.7382 170.505 37.4768L170.645 32.1163C168.797 31.3481 166.887 30.7349 164.936 30.2831C162.924 29.7822 160.86 29.5211 158.786 29.5055C155.867 29.4588 152.992 30.2164 150.481 31.694C147.993 33.1948 146.007 35.391 144.772 38.0072C143.355 41.0729 142.662 44.4193 142.747 47.791C142.747 51.6496 143.351 54.8835 144.559 57.4925C145.606 59.9173 147.383 61.962 149.645 63.3473C151.93 64.6684 154.538 65.34 157.182 65.2886M112.119 54.2947C112.116 53.5016 112.177 52.7095 112.301 51.926C112.431 51.1455 112.632 50.3784 112.903 49.6345C117.076 49.4972 122.266 49.6156 128.474 49.9898V55.2113C126.758 56.5124 124.911 57.634 122.962 58.5584C121.333 59.3474 119.548 59.7694 117.735 59.7942C115.836 59.7942 114.429 59.3153 113.5 58.3473C112.571 57.3792 112.114 56.03 112.114 54.2947M128.9 60.3607L129.538 64.3103C130.436 64.4045 131.339 64.4526 132.242 64.4544C133.075 64.4566 133.907 64.4084 134.734 64.3103V42.0134C134.734 39.0062 134.247 36.6031 133.275 34.8043C132.392 33.0806 130.952 31.7007 129.185 30.8855C127.115 30.026 124.883 29.6169 122.64 29.6858C120.346 29.7127 118.06 29.9611 115.815 30.4273C113.13 30.9692 110.491 31.7129 107.92 32.6518C108.394 34.4403 108.868 36.2272 109.343 38.0123C111.657 37.1852 114.019 36.4974 116.417 35.9526C118.224 35.5264 120.072 35.29 121.929 35.2471C123.322 35.175 124.702 35.5349 125.879 36.277C126.852 36.9598 127.555 37.9576 127.867 39.0988C128.253 40.49 128.457 41.9248 128.474 43.3677V44.9897C124.208 44.8009 120.533 44.6945 117.45 44.6705C114.367 44.6464 111.356 44.7048 108.419 44.8456C107.629 46.396 107.02 48.0302 106.602 49.7169C106.202 51.3575 106 53.0394 106 54.7273C106 58.0641 106.936 60.6628 108.808 62.5234C110.68 64.3841 113.253 65.3127 116.526 65.3093C118.703 65.2787 120.853 64.8238 122.853 63.9704C125.037 63.0717 127.075 61.8569 128.9 60.3658M330.035 37.8166C328.818 35.2232 326.824 33.0653 324.326 31.6374C321.629 30.1553 318.584 29.4123 315.502 29.4849C312.443 29.4063 309.419 30.1501 306.751 31.6374C304.267 33.0828 302.278 35.2357 301.042 37.8166C299.649 40.7981 298.969 44.0581 299.054 47.343C299.054 51.0574 299.717 54.2552 301.042 56.9363C302.276 59.5184 304.266 61.6717 306.751 63.1156C309.419 64.6029 312.443 65.3466 315.502 65.268C318.584 65.3407 321.629 64.5977 324.326 63.1156C326.824 61.6876 328.818 59.5298 330.035 56.9363C331.336 54.2587 331.988 51.0609 331.992 47.343C332.073 44.0617 331.404 40.8046 330.035 37.8166ZM324.248 54.2381C323.606 55.9518 322.42 57.412 320.869 58.3987C319.222 59.3562 317.337 59.8328 315.429 59.7737C313.566 59.8329 311.726 59.3553 310.13 58.3987C308.614 57.3919 307.457 55.9358 306.824 54.2381C306.007 52.0375 305.621 49.7025 305.687 47.3585C305.619 45.0243 306.005 42.6989 306.824 40.5098C307.464 38.827 308.62 37.3861 310.13 36.3902C311.726 35.4337 313.566 34.9562 315.429 35.0154C317.337 34.9563 319.222 35.4328 320.869 36.3902C322.413 37.3661 323.599 38.8111 324.248 40.5098C325.067 42.6989 325.453 45.0243 325.384 47.3585C325.45 49.7025 325.064 52.0375 324.248 54.2381Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M551.486 65.445C548.231 65.445 545.417 64.7205 543.044 63.2715C540.671 61.8015 538.833 59.733 537.531 57.066C536.229 54.378 535.578 51.207 535.578 47.553C535.578 43.836 536.219 40.6335 537.5 37.9455C538.802 35.2365 540.629 33.1575 542.981 31.7085C545.354 30.2595 548.168 29.535 551.423 29.535C554.72 29.535 557.534 30.291 559.865 31.803C562.217 33.294 564.002 35.457 565.22 38.292C566.459 41.127 567.047 44.5395 566.984 48.5295H563.204V47.2695C563.099 42.6075 562.049 39.0585 560.054 36.6225C558.059 34.1865 555.203 32.9685 551.486 32.9685C547.643 32.9685 544.671 34.239 542.571 36.78C540.492 39.3 539.453 42.87 539.453 47.49C539.453 52.068 540.492 55.617 542.571 58.137C544.671 60.657 547.622 61.917 551.423 61.917C554.048 61.917 556.337 61.308 558.29 60.09C560.264 58.851 561.828 57.087 562.983 54.798L566.259 56.247C564.894 59.187 562.92 61.455 560.337 63.051C557.754 64.647 554.804 65.445 551.486 65.445ZM538.067 48.5295V45.2535H564.936V48.5295H538.067Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M532.077 64.5C530.271 64.899 528.486 65.046 526.722 64.941C524.958 64.857 523.383 64.4685 521.997 63.7755C520.632 63.0615 519.603 61.9695 518.91 60.4995C518.343 59.3025 518.028 58.095 517.965 56.877C517.902 55.659 517.871 54.2625 517.871 52.6875V21.03H521.525V52.6245C521.525 54.0525 521.535 55.239 521.556 56.184C521.598 57.108 521.819 57.9585 522.218 58.7355C522.974 60.1845 524.171 61.0665 525.809 61.3815C527.447 61.6755 529.536 61.623 532.077 61.224V64.5ZM510.248 33.7875V30.48H532.077V33.7875H510.248Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M500.938 23.613V18.9825H504.561V23.613H500.938ZM500.938 64.5V30.48H504.561V64.5H500.938Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M480.146 65.382C476.219 65.382 472.975 64.5525 470.413 62.8935C467.872 61.2345 466.297 58.9245 465.688 55.9635L469.405 55.3335C469.93 57.3495 471.169 58.956 473.122 60.153C475.075 61.35 477.469 61.9485 480.304 61.9485C483.118 61.9485 485.354 61.35 487.013 60.153C488.672 58.956 489.502 57.318 489.502 55.239C489.502 54.105 489.239 53.181 488.714 52.467C488.21 51.732 487.202 51.06 485.69 50.451C484.178 49.842 481.931 49.128 478.949 48.309C475.799 47.469 473.332 46.629 471.547 45.789C469.783 44.949 468.533 43.9935 467.798 42.9225C467.084 41.8515 466.727 40.539 466.727 38.985C466.727 37.116 467.263 35.478 468.334 34.071C469.405 32.643 470.896 31.53 472.807 30.732C474.739 29.934 476.965 29.535 479.485 29.535C482.005 29.535 484.273 29.955 486.289 30.795C488.305 31.614 489.932 32.769 491.171 34.26C492.41 35.73 493.124 37.4415 493.313 39.3945L489.596 40.0875C489.239 37.9035 488.137 36.1815 486.289 34.9215C484.441 33.6405 482.131 32.9895 479.359 32.9685C476.734 32.9265 474.592 33.4515 472.933 34.5435C471.274 35.6145 470.444 37.032 470.444 38.796C470.444 39.804 470.728 40.665 471.295 41.379C471.883 42.072 472.912 42.7125 474.382 43.3005C475.852 43.8885 477.931 44.5185 480.619 45.1905C483.895 46.0305 486.446 46.8915 488.273 47.7735C490.121 48.6555 491.423 49.695 492.179 50.892C492.935 52.068 493.313 53.5275 493.313 55.2705C493.313 58.4205 492.137 60.8985 489.785 62.7045C487.454 64.4895 484.241 65.382 480.146 65.382Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M455.765 64.5V46.797C455.765 44.655 455.544 42.744 455.103 41.064C454.683 39.384 454.032 37.956 453.15 36.78C452.289 35.604 451.197 34.7115 449.874 34.1025C448.572 33.4935 447.029 33.189 445.244 33.189C443.396 33.189 441.789 33.5145 440.424 34.1655C439.08 34.7955 437.967 35.688 437.085 36.843C436.224 37.998 435.573 39.3735 435.132 40.9695C434.712 42.5445 434.502 44.2665 434.502 46.1355L431.636 45.789C431.636 42.114 432.255 39.09 433.494 36.717C434.754 34.323 436.445 32.559 438.566 31.425C440.687 30.27 443.07 29.6925 445.716 29.6925C447.585 29.6925 449.255 29.9655 450.725 30.5115C452.216 31.0575 453.507 31.8345 454.599 32.8425C455.691 33.8295 456.594 35.0055 457.308 36.3705C458.022 37.7145 458.547 39.195 458.883 40.812C459.24 42.429 459.419 44.1195 459.419 45.8835V64.5H455.765ZM430.848 64.5V30.48H434.156V38.1345H434.502V64.5H430.848Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("path", {
    d: "M417.758 23.613V18.9825H421.381V23.613H417.758ZM417.758 64.5V30.48H421.381V64.5H417.758Z",
    fill: "#191919"
  }), /* @__PURE__ */ p("defs", {
    children: /* @__PURE__ */ p("clipPath", {
      id: "clip0_191_230",
      children: /* @__PURE__ */ p("rect", {
        width: "80",
        height: "80",
        fill: "white"
      })
    })
  })]
});
export {
  x3 as Accordion,
  ft as Button,
  ia as Checkbox,
  w3 as Chip,
  S3 as Combobox,
  R3 as ConfirmationModal,
  Pp as FileSelect,
  E3 as FileUpload,
  Ou as Header,
  ze as Icon,
  P3 as IconAccountCircle24Px,
  I3 as IconAddPlusV1,
  T3 as IconArchive,
  $3 as IconArea,
  _3 as IconArrow,
  M3 as IconArrowDown,
  O4 as IconArrowIndicator45Deg,
  L3 as IconArrowLeft,
  A3 as IconArrowRight,
  k3 as IconArrowUp,
  F3 as IconBoxSelect24Px,
  Mp as IconBurgerMenuV1,
  ol as IconCheck24Px,
  V3 as IconCheckBox24Px,
  H3 as IconCheckCircleBlueV1,
  D3 as IconCheckCircleV1,
  N3 as IconCheckCircleV2,
  To as IconCheckboxCheckedV2,
  Ap as IconCheckboxIndeterminateV2,
  B3 as IconCheckboxSelectedDisabledV1,
  z3 as IconCheckboxSelectedV1,
  Io as IconCheckboxUncheckedV2,
  oi as IconChevronDownV1,
  _p as IconChevronRightV1,
  Fp as IconChevronUpV1,
  Iu as IconClose24Px,
  Tu as IconCloseCrossV1,
  j3 as IconCopyToProjectV1,
  G3 as IconDelete24Px,
  W3 as IconDot,
  U3 as IconDot2,
  q3 as IconEditInactiveV1,
  Z3 as IconEditV1,
  Y3 as IconExclamation,
  K3 as IconFetch,
  X3 as IconFileDownloadV1,
  Np as IconFileUploadV1,
  J3 as IconFilterListV1,
  Q3 as IconFlagV1,
  e4 as IconGetApp24Px,
  t4 as IconGetAppV1,
  F4 as IconGlobe,
  T4 as IconGrid,
  n4 as IconGt24Px,
  Vp as IconGtDisabledV1,
  r4 as IconGtLight24Px,
  o4 as IconGtV1,
  i4 as IconGtWhite24Px,
  M4 as IconHelp,
  a4 as IconInfoWhite,
  l4 as IconInvoiceImageV1,
  s4 as IconLine,
  u4 as IconLogout,
  _4 as IconLogoutV2,
  d4 as IconLtDisabledV1,
  c4 as IconLtV1,
  P4 as IconMemoIndicatorV1,
  f4 as IconMenuV2,
  p4 as IconMove,
  $4 as IconNotifications,
  V4 as IconOrganization,
  L4 as IconPencil,
  N4 as IconPlay,
  g4 as IconPolyline,
  v4 as IconRectangle,
  m4 as IconRefresh,
  Dp as IconReset,
  k4 as IconRocket,
  h4 as IconRotate90,
  b4 as IconSearch24Px,
  A4 as IconSettings,
  y4 as IconSortIndicatorActiveReversedV1,
  Hp as IconSortIndicatorActiveReversedV2,
  C4 as IconSortIndicatorActiveV1,
  zp as IconSortIndicatorActiveV2,
  x4 as IconSortIndicatorInactiveV1,
  Bp as IconSortIndicatorInactiveV2,
  w4 as IconSubtractV1,
  S4 as IconTocV1,
  R4 as IconTriangle,
  E4 as IconUnarchive,
  I4 as IconUser,
  Pu as Input,
  O3 as Link,
  ri as Loader,
  X4 as Logo,
  t6 as LogoEstima,
  n6 as LogoInsite,
  fn as Menu,
  Eu as Modal,
  e6 as MultivalueCombobox,
  D4 as Navbar,
  J4 as NavigationBar,
  H4 as Notification,
  z4 as Popover,
  Y4 as RadioGroup,
  B4 as Select,
  K4 as SplitButton,
  j4 as Switch,
  W4 as Table,
  Z4 as Tabs,
  q4 as Text,
  Q4 as ToggleVisibilityButton,
  U4 as WindowedList,
  kt as buttonStyles,
  G4 as createTable,
  ee as guard,
  on as mkTestIdFactory,
  C3 as sizes,
  $ as tw
};
